/*! For license information please see react-help-centre.js.LICENSE.txt */
(() => {
  "use strict";
  var e = {
      221: (e, t, n) => {
        var r = n(540);
        function a(e) {
          var t = "https://react.dev/errors/" + e;
          if (1 < arguments.length) {
            t += "?args[]=" + encodeURIComponent(arguments[1]);
            for (var n = 2; n < arguments.length; n++)
              t += "&args[]=" + encodeURIComponent(arguments[n]);
          }
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        function o() {}
        var i = {
            d: {
              f: o,
              r: function () {
                throw Error(a(522));
              },
              D: o,
              C: o,
              L: o,
              m: o,
              X: o,
              S: o,
              M: o,
            },
            p: 0,
            findDOMNode: null,
          },
          s = Symbol.for("react.portal"),
          l = r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
        function u(e, t) {
          return "font" === e
            ? ""
            : "string" == typeof t
            ? "use-credentials" === t
              ? t
              : ""
            : void 0;
        }
        (t.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i),
          (t.createPortal = function (e, t) {
            var n =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            if (
              !t ||
              (1 !== t.nodeType && 9 !== t.nodeType && 11 !== t.nodeType)
            )
              throw Error(a(299));
            return (function (e, t, n) {
              var r =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return {
                $$typeof: s,
                key: null == r ? null : "" + r,
                children: e,
                containerInfo: t,
                implementation: n,
              };
            })(e, t, null, n);
          }),
          (t.flushSync = function (e) {
            var t = l.T,
              n = i.p;
            try {
              if (((l.T = null), (i.p = 2), e)) return e();
            } finally {
              (l.T = t), (i.p = n), i.d.f();
            }
          }),
          (t.preconnect = function (e, t) {
            "string" == typeof e &&
              ((t = t
                ? "string" == typeof (t = t.crossOrigin)
                  ? "use-credentials" === t
                    ? t
                    : ""
                  : void 0
                : null),
              i.d.C(e, t));
          }),
          (t.prefetchDNS = function (e) {
            "string" == typeof e && i.d.D(e);
          }),
          (t.preinit = function (e, t) {
            if ("string" == typeof e && t && "string" == typeof t.as) {
              var n = t.as,
                r = u(n, t.crossOrigin),
                a = "string" == typeof t.integrity ? t.integrity : void 0,
                o =
                  "string" == typeof t.fetchPriority ? t.fetchPriority : void 0;
              "style" === n
                ? i.d.S(
                    e,
                    "string" == typeof t.precedence ? t.precedence : void 0,
                    { crossOrigin: r, integrity: a, fetchPriority: o }
                  )
                : "script" === n &&
                  i.d.X(e, {
                    crossOrigin: r,
                    integrity: a,
                    fetchPriority: o,
                    nonce: "string" == typeof t.nonce ? t.nonce : void 0,
                  });
            }
          }),
          (t.preinitModule = function (e, t) {
            if ("string" == typeof e)
              if ("object" == typeof t && null !== t) {
                if (null == t.as || "script" === t.as) {
                  var n = u(t.as, t.crossOrigin);
                  i.d.M(e, {
                    crossOrigin: n,
                    integrity:
                      "string" == typeof t.integrity ? t.integrity : void 0,
                    nonce: "string" == typeof t.nonce ? t.nonce : void 0,
                  });
                }
              } else null == t && i.d.M(e);
          }),
          (t.preload = function (e, t) {
            if (
              "string" == typeof e &&
              "object" == typeof t &&
              null !== t &&
              "string" == typeof t.as
            ) {
              var n = t.as,
                r = u(n, t.crossOrigin);
              i.d.L(e, n, {
                crossOrigin: r,
                integrity:
                  "string" == typeof t.integrity ? t.integrity : void 0,
                nonce: "string" == typeof t.nonce ? t.nonce : void 0,
                type: "string" == typeof t.type ? t.type : void 0,
                fetchPriority:
                  "string" == typeof t.fetchPriority ? t.fetchPriority : void 0,
                referrerPolicy:
                  "string" == typeof t.referrerPolicy
                    ? t.referrerPolicy
                    : void 0,
                imageSrcSet:
                  "string" == typeof t.imageSrcSet ? t.imageSrcSet : void 0,
                imageSizes:
                  "string" == typeof t.imageSizes ? t.imageSizes : void 0,
                media: "string" == typeof t.media ? t.media : void 0,
              });
            }
          }),
          (t.preloadModule = function (e, t) {
            if ("string" == typeof e)
              if (t) {
                var n = u(t.as, t.crossOrigin);
                i.d.m(e, {
                  as:
                    "string" == typeof t.as && "script" !== t.as
                      ? t.as
                      : void 0,
                  crossOrigin: n,
                  integrity:
                    "string" == typeof t.integrity ? t.integrity : void 0,
                });
              } else i.d.m(e);
          }),
          (t.requestFormReset = function (e) {
            i.d.r(e);
          }),
          (t.unstable_batchedUpdates = function (e, t) {
            return e(t);
          }),
          (t.useFormState = function (e, t, n) {
            return l.H.useFormState(e, t, n);
          }),
          (t.useFormStatus = function () {
            return l.H.useHostTransitionStatus();
          }),
          (t.version = "19.1.0");
      },
      247: (e, t, n) => {
        var r = n(982),
          a = n(540),
          o = n(961);
        function i(e) {
          var t = "https://react.dev/errors/" + e;
          if (1 < arguments.length) {
            t += "?args[]=" + encodeURIComponent(arguments[1]);
            for (var n = 2; n < arguments.length; n++)
              t += "&args[]=" + encodeURIComponent(arguments[n]);
          }
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        function s(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do {
              !!(4098 & (t = e).flags) && (n = t.return), (e = t.return);
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function l(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if (
              (null === t &&
                null !== (e = e.alternate) &&
                (t = e.memoizedState),
              null !== t)
            )
              return t.dehydrated;
          }
          return null;
        }
        function u(e) {
          if (s(e) !== e) throw Error(i(188));
        }
        function c(e) {
          var t = e.tag;
          if (5 === t || 26 === t || 27 === t || 6 === t) return e;
          for (e = e.child; null !== e; ) {
            if (null !== (t = c(e))) return t;
            e = e.sibling;
          }
          return null;
        }
        var d = Object.assign,
          f = Symbol.for("react.element"),
          p = Symbol.for("react.transitional.element"),
          h = Symbol.for("react.portal"),
          m = Symbol.for("react.fragment"),
          y = Symbol.for("react.strict_mode"),
          g = Symbol.for("react.profiler"),
          v = Symbol.for("react.provider"),
          b = Symbol.for("react.consumer"),
          w = Symbol.for("react.context"),
          k = Symbol.for("react.forward_ref"),
          S = Symbol.for("react.suspense"),
          x = Symbol.for("react.suspense_list"),
          P = Symbol.for("react.memo"),
          E = Symbol.for("react.lazy");
        Symbol.for("react.scope");
        var C = Symbol.for("react.activity");
        Symbol.for("react.legacy_hidden"), Symbol.for("react.tracing_marker");
        var T = Symbol.for("react.memo_cache_sentinel");
        Symbol.for("react.view_transition");
        var A = Symbol.iterator;
        function M(e) {
          return null === e || "object" != typeof e
            ? null
            : "function" == typeof (e = (A && e[A]) || e["@@iterator"])
            ? e
            : null;
        }
        var L = Symbol.for("react.client.reference");
        function D(e) {
          if (null == e) return null;
          if ("function" == typeof e)
            return e.$$typeof === L ? null : e.displayName || e.name || null;
          if ("string" == typeof e) return e;
          switch (e) {
            case m:
              return "Fragment";
            case g:
              return "Profiler";
            case y:
              return "StrictMode";
            case S:
              return "Suspense";
            case x:
              return "SuspenseList";
            case C:
              return "Activity";
          }
          if ("object" == typeof e)
            switch (e.$$typeof) {
              case h:
                return "Portal";
              case w:
                return (e.displayName || "Context") + ".Provider";
              case b:
                return (e._context.displayName || "Context") + ".Consumer";
              case k:
                var t = e.render;
                return (
                  (e = e.displayName) ||
                    (e =
                      "" !== (e = t.displayName || t.name || "")
                        ? "ForwardRef(" + e + ")"
                        : "ForwardRef"),
                  e
                );
              case P:
                return null !== (t = e.displayName || null)
                  ? t
                  : D(e.type) || "Memo";
              case E:
                (t = e._payload), (e = e._init);
                try {
                  return D(e(t));
                } catch (e) {}
            }
          return null;
        }
        var R = Array.isArray,
          z = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          N = o.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          F = { pending: !1, data: null, method: null, action: null },
          O = [],
          _ = -1;
        function I(e) {
          return { current: e };
        }
        function V(e) {
          0 > _ || ((e.current = O[_]), (O[_] = null), _--);
        }
        function j(e, t) {
          _++, (O[_] = e.current), (e.current = t);
        }
        var U = I(null),
          B = I(null),
          W = I(null),
          H = I(null);
        function $(e, t) {
          switch ((j(W, t), j(B, e), j(U, null), t.nodeType)) {
            case 9:
            case 11:
              e = (e = t.documentElement) && (e = e.namespaceURI) ? rd(e) : 0;
              break;
            default:
              if (((e = t.tagName), (t = t.namespaceURI)))
                e = ad((t = rd(t)), e);
              else
                switch (e) {
                  case "svg":
                    e = 1;
                    break;
                  case "math":
                    e = 2;
                    break;
                  default:
                    e = 0;
                }
          }
          V(U), j(U, e);
        }
        function q() {
          V(U), V(B), V(W);
        }
        function Y(e) {
          null !== e.memoizedState && j(H, e);
          var t = U.current,
            n = ad(t, e.type);
          t !== n && (j(B, e), j(U, n));
        }
        function K(e) {
          B.current === e && (V(U), V(B)),
            H.current === e && (V(H), (Yd._currentValue = F));
        }
        var Q = Object.prototype.hasOwnProperty,
          X = r.unstable_scheduleCallback,
          G = r.unstable_cancelCallback,
          Z = r.unstable_shouldYield,
          J = r.unstable_requestPaint,
          ee = r.unstable_now,
          te = r.unstable_getCurrentPriorityLevel,
          ne = r.unstable_ImmediatePriority,
          re = r.unstable_UserBlockingPriority,
          ae = r.unstable_NormalPriority,
          oe = r.unstable_LowPriority,
          ie = r.unstable_IdlePriority,
          se = r.log,
          le = r.unstable_setDisableYieldValue,
          ue = null,
          ce = null;
        function de(e) {
          if (
            ("function" == typeof se && le(e),
            ce && "function" == typeof ce.setStrictMode)
          )
            try {
              ce.setStrictMode(ue, e);
            } catch (e) {}
        }
        var fe = Math.clz32
            ? Math.clz32
            : function (e) {
                return 0 == (e >>>= 0) ? 32 : (31 - ((pe(e) / he) | 0)) | 0;
              },
          pe = Math.log,
          he = Math.LN2,
          me = 256,
          ye = 4194304;
        function ge(e) {
          var t = 42 & e;
          if (0 !== t) return t;
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
              return 64;
            case 128:
              return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return 4194048 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return 62914560 & e;
            case 67108864:
              return 67108864;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 0;
            default:
              return e;
          }
        }
        function ve(e, t, n) {
          var r = e.pendingLanes;
          if (0 === r) return 0;
          var a = 0,
            o = e.suspendedLanes,
            i = e.pingedLanes;
          e = e.warmLanes;
          var s = 134217727 & r;
          return (
            0 !== s
              ? 0 != (r = s & ~o)
                ? (a = ge(r))
                : 0 != (i &= s)
                ? (a = ge(i))
                : n || (0 != (n = s & ~e) && (a = ge(n)))
              : 0 != (s = r & ~o)
              ? (a = ge(s))
              : 0 !== i
              ? (a = ge(i))
              : n || (0 != (n = r & ~e) && (a = ge(n))),
            0 === a
              ? 0
              : 0 === t ||
                t === a ||
                t & o ||
                !((o = a & -a) >= (n = t & -t) || (32 === o && 4194048 & n))
              ? a
              : t
          );
        }
        function be(e, t) {
          return !(e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t);
        }
        function we(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
              return t + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            default:
              return -1;
          }
        }
        function ke() {
          var e = me;
          return !(4194048 & (me <<= 1)) && (me = 256), e;
        }
        function Se() {
          var e = ye;
          return !(62914560 & (ye <<= 1)) && (ye = 4194304), e;
        }
        function xe(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function Pe(e, t) {
          (e.pendingLanes |= t),
            268435456 !== t &&
              ((e.suspendedLanes = 0), (e.pingedLanes = 0), (e.warmLanes = 0));
        }
        function Ee(e, t, n) {
          (e.pendingLanes |= t), (e.suspendedLanes &= ~t);
          var r = 31 - fe(t);
          (e.entangledLanes |= t),
            (e.entanglements[r] =
              1073741824 | e.entanglements[r] | (4194090 & n));
        }
        function Ce(e, t) {
          var n = (e.entangledLanes |= t);
          for (e = e.entanglements; n; ) {
            var r = 31 - fe(n),
              a = 1 << r;
            (a & t) | (e[r] & t) && (e[r] |= t), (n &= ~a);
          }
        }
        function Te(e) {
          switch (e) {
            case 2:
              e = 1;
              break;
            case 8:
              e = 4;
              break;
            case 32:
              e = 16;
              break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              e = 128;
              break;
            case 268435456:
              e = 134217728;
              break;
            default:
              e = 0;
          }
          return e;
        }
        function Ae(e) {
          return 2 < (e &= -e)
            ? 8 < e
              ? 134217727 & e
                ? 32
                : 268435456
              : 8
            : 2;
        }
        function Me() {
          var e = N.p;
          return 0 !== e ? e : void 0 === (e = window.event) ? 32 : sf(e.type);
        }
        var Le = Math.random().toString(36).slice(2),
          De = "__reactFiber$" + Le,
          Re = "__reactProps$" + Le,
          ze = "__reactContainer$" + Le,
          Ne = "__reactEvents$" + Le,
          Fe = "__reactListeners$" + Le,
          Oe = "__reactHandles$" + Le,
          _e = "__reactResources$" + Le,
          Ie = "__reactMarker$" + Le;
        function Ve(e) {
          delete e[De], delete e[Re], delete e[Ne], delete e[Fe], delete e[Oe];
        }
        function je(e) {
          var t = e[De];
          if (t) return t;
          for (var n = e.parentNode; n; ) {
            if ((t = n[ze] || n[De])) {
              if (
                ((n = t.alternate),
                null !== t.child || (null !== n && null !== n.child))
              )
                for (e = vd(e); null !== e; ) {
                  if ((n = e[De])) return n;
                  e = vd(e);
                }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function Ue(e) {
          if ((e = e[De] || e[ze])) {
            var t = e.tag;
            if (
              5 === t ||
              6 === t ||
              13 === t ||
              26 === t ||
              27 === t ||
              3 === t
            )
              return e;
          }
          return null;
        }
        function Be(e) {
          var t = e.tag;
          if (5 === t || 26 === t || 27 === t || 6 === t) return e.stateNode;
          throw Error(i(33));
        }
        function We(e) {
          var t = e[_e];
          return (
            t ||
              (t = e[_e] =
                { hoistableStyles: new Map(), hoistableScripts: new Map() }),
            t
          );
        }
        function He(e) {
          e[Ie] = !0;
        }
        var $e = new Set(),
          qe = {};
        function Ye(e, t) {
          Ke(e, t), Ke(e + "Capture", t);
        }
        function Ke(e, t) {
          for (qe[e] = t, e = 0; e < t.length; e++) $e.add(t[e]);
        }
        var Qe,
          Xe,
          Ge = RegExp(
            "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
          ),
          Ze = {},
          Je = {};
        function et(e, t, n) {
          if (
            ((a = t),
            Q.call(Je, a) ||
              (!Q.call(Ze, a) &&
                (Ge.test(a) ? (Je[a] = !0) : ((Ze[a] = !0), 0))))
          )
            if (null === n) e.removeAttribute(t);
            else {
              switch (typeof n) {
                case "undefined":
                case "function":
                case "symbol":
                  return void e.removeAttribute(t);
                case "boolean":
                  var r = t.toLowerCase().slice(0, 5);
                  if ("data-" !== r && "aria-" !== r)
                    return void e.removeAttribute(t);
              }
              e.setAttribute(t, "" + n);
            }
          var a;
        }
        function tt(e, t, n) {
          if (null === n) e.removeAttribute(t);
          else {
            switch (typeof n) {
              case "undefined":
              case "function":
              case "symbol":
              case "boolean":
                return void e.removeAttribute(t);
            }
            e.setAttribute(t, "" + n);
          }
        }
        function nt(e, t, n, r) {
          if (null === r) e.removeAttribute(n);
          else {
            switch (typeof r) {
              case "undefined":
              case "function":
              case "symbol":
              case "boolean":
                return void e.removeAttribute(n);
            }
            e.setAttributeNS(t, n, "" + r);
          }
        }
        function rt(e) {
          if (void 0 === Qe)
            try {
              throw Error();
            } catch (e) {
              var t = e.stack.trim().match(/\n( *(at )?)/);
              (Qe = (t && t[1]) || ""),
                (Xe =
                  -1 < e.stack.indexOf("\n    at")
                    ? " (<anonymous>)"
                    : -1 < e.stack.indexOf("@")
                    ? "@unknown:0:0"
                    : "");
            }
          return "\n" + Qe + e + Xe;
        }
        var at = !1;
        function ot(e, t) {
          if (!e || at) return "";
          at = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            var r = {
              DetermineComponentFrameRoot: function () {
                try {
                  if (t) {
                    var n = function () {
                      throw Error();
                    };
                    if (
                      (Object.defineProperty(n.prototype, "props", {
                        set: function () {
                          throw Error();
                        },
                      }),
                      "object" == typeof Reflect && Reflect.construct)
                    ) {
                      try {
                        Reflect.construct(n, []);
                      } catch (e) {
                        var r = e;
                      }
                      Reflect.construct(e, [], n);
                    } else {
                      try {
                        n.call();
                      } catch (e) {
                        r = e;
                      }
                      e.call(n.prototype);
                    }
                  } else {
                    try {
                      throw Error();
                    } catch (e) {
                      r = e;
                    }
                    (n = e()) &&
                      "function" == typeof n.catch &&
                      n.catch(function () {});
                  }
                } catch (e) {
                  if (e && r && "string" == typeof e.stack)
                    return [e.stack, r.stack];
                }
                return [null, null];
              },
            };
            r.DetermineComponentFrameRoot.displayName =
              "DetermineComponentFrameRoot";
            var a = Object.getOwnPropertyDescriptor(
              r.DetermineComponentFrameRoot,
              "name"
            );
            a &&
              a.configurable &&
              Object.defineProperty(r.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot",
              });
            var o = r.DetermineComponentFrameRoot(),
              i = o[0],
              s = o[1];
            if (i && s) {
              var l = i.split("\n"),
                u = s.split("\n");
              for (
                a = r = 0;
                r < l.length && !l[r].includes("DetermineComponentFrameRoot");

              )
                r++;
              for (
                ;
                a < u.length && !u[a].includes("DetermineComponentFrameRoot");

              )
                a++;
              if (r === l.length || a === u.length)
                for (
                  r = l.length - 1, a = u.length - 1;
                  1 <= r && 0 <= a && l[r] !== u[a];

                )
                  a--;
              for (; 1 <= r && 0 <= a; r--, a--)
                if (l[r] !== u[a]) {
                  if (1 !== r || 1 !== a)
                    do {
                      if ((r--, 0 > --a || l[r] !== u[a])) {
                        var c = "\n" + l[r].replace(" at new ", " at ");
                        return (
                          e.displayName &&
                            c.includes("<anonymous>") &&
                            (c = c.replace("<anonymous>", e.displayName)),
                          c
                        );
                      }
                    } while (1 <= r && 0 <= a);
                  break;
                }
            }
          } finally {
            (at = !1), (Error.prepareStackTrace = n);
          }
          return (n = e ? e.displayName || e.name : "") ? rt(n) : "";
        }
        function it(e) {
          switch (e.tag) {
            case 26:
            case 27:
            case 5:
              return rt(e.type);
            case 16:
              return rt("Lazy");
            case 13:
              return rt("Suspense");
            case 19:
              return rt("SuspenseList");
            case 0:
            case 15:
              return ot(e.type, !1);
            case 11:
              return ot(e.type.render, !1);
            case 1:
              return ot(e.type, !0);
            case 31:
              return rt("Activity");
            default:
              return "";
          }
        }
        function st(e) {
          try {
            var t = "";
            do {
              (t += it(e)), (e = e.return);
            } while (e);
            return t;
          } catch (e) {
            return "\nError generating stack: " + e.message + "\n" + e.stack;
          }
        }
        function lt(e) {
          switch (typeof e) {
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
            case "object":
              return e;
            default:
              return "";
          }
        }
        function ut(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            "input" === e.toLowerCase() &&
            ("checkbox" === t || "radio" === t)
          );
        }
        function ct(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var t = ut(e) ? "checked" : "value",
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                r = "" + e[t];
              if (
                !e.hasOwnProperty(t) &&
                void 0 !== n &&
                "function" == typeof n.get &&
                "function" == typeof n.set
              ) {
                var a = n.get,
                  o = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return a.call(this);
                    },
                    set: function (e) {
                      (r = "" + e), o.call(this, e);
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = "" + e;
                    },
                    stopTracking: function () {
                      (e._valueTracker = null), delete e[t];
                    },
                  }
                );
              }
            })(e));
        }
        function dt(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = "";
          return (
            e && (r = ut(e) ? (e.checked ? "true" : "false") : e.value),
            (e = r) !== n && (t.setValue(e), !0)
          );
        }
        function ft(e) {
          if (
            void 0 ===
            (e = e || ("undefined" != typeof document ? document : void 0))
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        var pt = /[\n"\\]/g;
        function ht(e) {
          return e.replace(pt, function (e) {
            return "\\" + e.charCodeAt(0).toString(16) + " ";
          });
        }
        function mt(e, t, n, r, a, o, i, s) {
          (e.name = ""),
            null != i &&
            "function" != typeof i &&
            "symbol" != typeof i &&
            "boolean" != typeof i
              ? (e.type = i)
              : e.removeAttribute("type"),
            null != t
              ? "number" === i
                ? ((0 === t && "" === e.value) || e.value != t) &&
                  (e.value = "" + lt(t))
                : e.value !== "" + lt(t) && (e.value = "" + lt(t))
              : ("submit" !== i && "reset" !== i) || e.removeAttribute("value"),
            null != t
              ? gt(e, i, lt(t))
              : null != n
              ? gt(e, i, lt(n))
              : null != r && e.removeAttribute("value"),
            null == a && null != o && (e.defaultChecked = !!o),
            null != a &&
              (e.checked = a && "function" != typeof a && "symbol" != typeof a),
            null != s &&
            "function" != typeof s &&
            "symbol" != typeof s &&
            "boolean" != typeof s
              ? (e.name = "" + lt(s))
              : e.removeAttribute("name");
        }
        function yt(e, t, n, r, a, o, i, s) {
          if (
            (null != o &&
              "function" != typeof o &&
              "symbol" != typeof o &&
              "boolean" != typeof o &&
              (e.type = o),
            null != t || null != n)
          ) {
            if (("submit" === o || "reset" === o) && null == t) return;
            (n = null != n ? "" + lt(n) : ""),
              (t = null != t ? "" + lt(t) : n),
              s || t === e.value || (e.value = t),
              (e.defaultValue = t);
          }
          (r =
            "function" != typeof (r = null != r ? r : a) &&
            "symbol" != typeof r &&
            !!r),
            (e.checked = s ? e.checked : !!r),
            (e.defaultChecked = !!r),
            null != i &&
              "function" != typeof i &&
              "symbol" != typeof i &&
              "boolean" != typeof i &&
              (e.name = i);
        }
        function gt(e, t, n) {
          ("number" === t && ft(e.ownerDocument) === e) ||
            e.defaultValue === "" + n ||
            (e.defaultValue = "" + n);
        }
        function vt(e, t, n, r) {
          if (((e = e.options), t)) {
            t = {};
            for (var a = 0; a < n.length; a++) t["$" + n[a]] = !0;
            for (n = 0; n < e.length; n++)
              (a = t.hasOwnProperty("$" + e[n].value)),
                e[n].selected !== a && (e[n].selected = a),
                a && r && (e[n].defaultSelected = !0);
          } else {
            for (n = "" + lt(n), t = null, a = 0; a < e.length; a++) {
              if (e[a].value === n)
                return (
                  (e[a].selected = !0), void (r && (e[a].defaultSelected = !0))
                );
              null !== t || e[a].disabled || (t = e[a]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function bt(e, t, n) {
          null == t ||
          ((t = "" + lt(t)) !== e.value && (e.value = t), null != n)
            ? (e.defaultValue = null != n ? "" + lt(n) : "")
            : e.defaultValue !== t && (e.defaultValue = t);
        }
        function wt(e, t, n, r) {
          if (null == t) {
            if (null != r) {
              if (null != n) throw Error(i(92));
              if (R(r)) {
                if (1 < r.length) throw Error(i(93));
                r = r[0];
              }
              n = r;
            }
            null == n && (n = ""), (t = n);
          }
          (n = lt(t)),
            (e.defaultValue = n),
            (r = e.textContent) === n &&
              "" !== r &&
              null !== r &&
              (e.value = r);
        }
        function kt(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType)
              return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var St = new Set(
          "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
            " "
          )
        );
        function xt(e, t, n) {
          var r = 0 === t.indexOf("--");
          null == n || "boolean" == typeof n || "" === n
            ? r
              ? e.setProperty(t, "")
              : "float" === t
              ? (e.cssFloat = "")
              : (e[t] = "")
            : r
            ? e.setProperty(t, n)
            : "number" != typeof n || 0 === n || St.has(t)
            ? "float" === t
              ? (e.cssFloat = n)
              : (e[t] = ("" + n).trim())
            : (e[t] = n + "px");
        }
        function Pt(e, t, n) {
          if (null != t && "object" != typeof t) throw Error(i(62));
          if (((e = e.style), null != n)) {
            for (var r in n)
              !n.hasOwnProperty(r) ||
                (null != t && t.hasOwnProperty(r)) ||
                (0 === r.indexOf("--")
                  ? e.setProperty(r, "")
                  : "float" === r
                  ? (e.cssFloat = "")
                  : (e[r] = ""));
            for (var a in t)
              (r = t[a]), t.hasOwnProperty(a) && n[a] !== r && xt(e, a, r);
          } else for (var o in t) t.hasOwnProperty(o) && xt(e, o, t[o]);
        }
        function Et(e) {
          if (-1 === e.indexOf("-")) return !1;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        var Ct = new Map([
            ["acceptCharset", "accept-charset"],
            ["htmlFor", "for"],
            ["httpEquiv", "http-equiv"],
            ["crossOrigin", "crossorigin"],
            ["accentHeight", "accent-height"],
            ["alignmentBaseline", "alignment-baseline"],
            ["arabicForm", "arabic-form"],
            ["baselineShift", "baseline-shift"],
            ["capHeight", "cap-height"],
            ["clipPath", "clip-path"],
            ["clipRule", "clip-rule"],
            ["colorInterpolation", "color-interpolation"],
            ["colorInterpolationFilters", "color-interpolation-filters"],
            ["colorProfile", "color-profile"],
            ["colorRendering", "color-rendering"],
            ["dominantBaseline", "dominant-baseline"],
            ["enableBackground", "enable-background"],
            ["fillOpacity", "fill-opacity"],
            ["fillRule", "fill-rule"],
            ["floodColor", "flood-color"],
            ["floodOpacity", "flood-opacity"],
            ["fontFamily", "font-family"],
            ["fontSize", "font-size"],
            ["fontSizeAdjust", "font-size-adjust"],
            ["fontStretch", "font-stretch"],
            ["fontStyle", "font-style"],
            ["fontVariant", "font-variant"],
            ["fontWeight", "font-weight"],
            ["glyphName", "glyph-name"],
            ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
            ["glyphOrientationVertical", "glyph-orientation-vertical"],
            ["horizAdvX", "horiz-adv-x"],
            ["horizOriginX", "horiz-origin-x"],
            ["imageRendering", "image-rendering"],
            ["letterSpacing", "letter-spacing"],
            ["lightingColor", "lighting-color"],
            ["markerEnd", "marker-end"],
            ["markerMid", "marker-mid"],
            ["markerStart", "marker-start"],
            ["overlinePosition", "overline-position"],
            ["overlineThickness", "overline-thickness"],
            ["paintOrder", "paint-order"],
            ["panose-1", "panose-1"],
            ["pointerEvents", "pointer-events"],
            ["renderingIntent", "rendering-intent"],
            ["shapeRendering", "shape-rendering"],
            ["stopColor", "stop-color"],
            ["stopOpacity", "stop-opacity"],
            ["strikethroughPosition", "strikethrough-position"],
            ["strikethroughThickness", "strikethrough-thickness"],
            ["strokeDasharray", "stroke-dasharray"],
            ["strokeDashoffset", "stroke-dashoffset"],
            ["strokeLinecap", "stroke-linecap"],
            ["strokeLinejoin", "stroke-linejoin"],
            ["strokeMiterlimit", "stroke-miterlimit"],
            ["strokeOpacity", "stroke-opacity"],
            ["strokeWidth", "stroke-width"],
            ["textAnchor", "text-anchor"],
            ["textDecoration", "text-decoration"],
            ["textRendering", "text-rendering"],
            ["transformOrigin", "transform-origin"],
            ["underlinePosition", "underline-position"],
            ["underlineThickness", "underline-thickness"],
            ["unicodeBidi", "unicode-bidi"],
            ["unicodeRange", "unicode-range"],
            ["unitsPerEm", "units-per-em"],
            ["vAlphabetic", "v-alphabetic"],
            ["vHanging", "v-hanging"],
            ["vIdeographic", "v-ideographic"],
            ["vMathematical", "v-mathematical"],
            ["vectorEffect", "vector-effect"],
            ["vertAdvY", "vert-adv-y"],
            ["vertOriginX", "vert-origin-x"],
            ["vertOriginY", "vert-origin-y"],
            ["wordSpacing", "word-spacing"],
            ["writingMode", "writing-mode"],
            ["xmlnsXlink", "xmlns:xlink"],
            ["xHeight", "x-height"],
          ]),
          Tt =
            /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
        function At(e) {
          return Tt.test("" + e)
            ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
            : e;
        }
        var Mt = null;
        function Lt(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement &&
              (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var Dt = null,
          Rt = null;
        function zt(e) {
          var t = Ue(e);
          if (t && (e = t.stateNode)) {
            var n = e[Re] || null;
            e: switch (((e = t.stateNode), t.type)) {
              case "input":
                if (
                  (mt(
                    e,
                    n.value,
                    n.defaultValue,
                    n.defaultValue,
                    n.checked,
                    n.defaultChecked,
                    n.type,
                    n.name
                  ),
                  (t = n.name),
                  "radio" === n.type && null != t)
                ) {
                  for (n = e; n.parentNode; ) n = n.parentNode;
                  for (
                    n = n.querySelectorAll(
                      'input[name="' + ht("" + t) + '"][type="radio"]'
                    ),
                      t = 0;
                    t < n.length;
                    t++
                  ) {
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                      var a = r[Re] || null;
                      if (!a) throw Error(i(90));
                      mt(
                        r,
                        a.value,
                        a.defaultValue,
                        a.defaultValue,
                        a.checked,
                        a.defaultChecked,
                        a.type,
                        a.name
                      );
                    }
                  }
                  for (t = 0; t < n.length; t++)
                    (r = n[t]).form === e.form && dt(r);
                }
                break e;
              case "textarea":
                bt(e, n.value, n.defaultValue);
                break e;
              case "select":
                null != (t = n.value) && vt(e, !!n.multiple, t, !1);
            }
          }
        }
        var Nt = !1;
        function Ft(e, t, n) {
          if (Nt) return e(t, n);
          Nt = !0;
          try {
            return e(t);
          } finally {
            if (
              ((Nt = !1),
              (null !== Dt || null !== Rt) &&
                (ju(), Dt && ((t = Dt), (e = Rt), (Rt = Dt = null), zt(t), e)))
            )
              for (t = 0; t < e.length; t++) zt(e[t]);
          }
        }
        function Ot(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = n[Re] || null;
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (r = !r.disabled) ||
                (r = !(
                  "button" === (e = e.type) ||
                  "input" === e ||
                  "select" === e ||
                  "textarea" === e
                )),
                (e = !r);
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && "function" != typeof n) throw Error(i(231, t, typeof n));
          return n;
        }
        var _t = !(
            "undefined" == typeof window ||
            void 0 === window.document ||
            void 0 === window.document.createElement
          ),
          It = !1;
        if (_t)
          try {
            var Vt = {};
            Object.defineProperty(Vt, "passive", {
              get: function () {
                It = !0;
              },
            }),
              window.addEventListener("test", Vt, Vt),
              window.removeEventListener("test", Vt, Vt);
          } catch (e) {
            It = !1;
          }
        var jt = null,
          Ut = null,
          Bt = null;
        function Wt() {
          if (Bt) return Bt;
          var e,
            t,
            n = Ut,
            r = n.length,
            a = "value" in jt ? jt.value : jt.textContent,
            o = a.length;
          for (e = 0; e < r && n[e] === a[e]; e++);
          var i = r - e;
          for (t = 1; t <= i && n[r - t] === a[o - t]; t++);
          return (Bt = a.slice(e, 1 < t ? 1 - t : void 0));
        }
        function Ht(e) {
          var t = e.keyCode;
          return (
            "charCode" in e
              ? 0 === (e = e.charCode) && 13 === t && (e = 13)
              : (e = t),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function $t() {
          return !0;
        }
        function qt() {
          return !1;
        }
        function Yt(e) {
          function t(t, n, r, a, o) {
            for (var i in ((this._reactName = t),
            (this._targetInst = r),
            (this.type = n),
            (this.nativeEvent = a),
            (this.target = o),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(a) : a[i]));
            return (
              (this.isDefaultPrevented = (
                null != a.defaultPrevented
                  ? a.defaultPrevented
                  : !1 === a.returnValue
              )
                ? $t
                : qt),
              (this.isPropagationStopped = qt),
              this
            );
          }
          return (
            d(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault
                    ? e.preventDefault()
                    : "unknown" != typeof e.returnValue && (e.returnValue = !1),
                  (this.isDefaultPrevented = $t));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : "unknown" != typeof e.cancelBubble &&
                      (e.cancelBubble = !0),
                  (this.isPropagationStopped = $t));
              },
              persist: function () {},
              isPersistent: $t,
            }),
            t
          );
        }
        var Kt,
          Qt,
          Xt,
          Gt = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          Zt = Yt(Gt),
          Jt = d({}, Gt, { view: 0, detail: 0 }),
          en = Yt(Jt),
          tn = d({}, Jt, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: pn,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e
                ? e.movementX
                : (e !== Xt &&
                    (Xt && "mousemove" === e.type
                      ? ((Kt = e.screenX - Xt.screenX),
                        (Qt = e.screenY - Xt.screenY))
                      : (Qt = Kt = 0),
                    (Xt = e)),
                  Kt);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : Qt;
            },
          }),
          nn = Yt(tn),
          rn = Yt(d({}, tn, { dataTransfer: 0 })),
          an = Yt(d({}, Jt, { relatedTarget: 0 })),
          on = Yt(
            d({}, Gt, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          sn = Yt(
            d({}, Gt, {
              clipboardData: function (e) {
                return "clipboardData" in e
                  ? e.clipboardData
                  : window.clipboardData;
              },
            })
          ),
          ln = Yt(d({}, Gt, { data: 0 })),
          un = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified",
          },
          cn = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta",
          },
          dn = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          };
        function fn(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : !!(e = dn[e]) && !!t[e];
        }
        function pn() {
          return fn;
        }
        var hn = Yt(
            d({}, Jt, {
              key: function (e) {
                if (e.key) {
                  var t = un[e.key] || e.key;
                  if ("Unidentified" !== t) return t;
                }
                return "keypress" === e.type
                  ? 13 === (e = Ht(e))
                    ? "Enter"
                    : String.fromCharCode(e)
                  : "keydown" === e.type || "keyup" === e.type
                  ? cn[e.keyCode] || "Unidentified"
                  : "";
              },
              code: 0,
              location: 0,
              ctrlKey: 0,
              shiftKey: 0,
              altKey: 0,
              metaKey: 0,
              repeat: 0,
              locale: 0,
              getModifierState: pn,
              charCode: function (e) {
                return "keypress" === e.type ? Ht(e) : 0;
              },
              keyCode: function (e) {
                return "keydown" === e.type || "keyup" === e.type
                  ? e.keyCode
                  : 0;
              },
              which: function (e) {
                return "keypress" === e.type
                  ? Ht(e)
                  : "keydown" === e.type || "keyup" === e.type
                  ? e.keyCode
                  : 0;
              },
            })
          ),
          mn = Yt(
            d({}, tn, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            })
          ),
          yn = Yt(
            d({}, Jt, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: pn,
            })
          ),
          gn = Yt(
            d({}, Gt, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          vn = Yt(
            d({}, tn, {
              deltaX: function (e) {
                return "deltaX" in e
                  ? e.deltaX
                  : "wheelDeltaX" in e
                  ? -e.wheelDeltaX
                  : 0;
              },
              deltaY: function (e) {
                return "deltaY" in e
                  ? e.deltaY
                  : "wheelDeltaY" in e
                  ? -e.wheelDeltaY
                  : "wheelDelta" in e
                  ? -e.wheelDelta
                  : 0;
              },
              deltaZ: 0,
              deltaMode: 0,
            })
          ),
          bn = Yt(d({}, Gt, { newState: 0, oldState: 0 })),
          wn = [9, 13, 27, 32],
          kn = _t && "CompositionEvent" in window,
          Sn = null;
        _t && "documentMode" in document && (Sn = document.documentMode);
        var xn = _t && "TextEvent" in window && !Sn,
          Pn = _t && (!kn || (Sn && 8 < Sn && 11 >= Sn)),
          En = String.fromCharCode(32),
          Cn = !1;
        function Tn(e, t) {
          switch (e) {
            case "keyup":
              return -1 !== wn.indexOf(t.keyCode);
            case "keydown":
              return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function An(e) {
          return "object" == typeof (e = e.detail) && "data" in e
            ? e.data
            : null;
        }
        var Mn = !1,
          Ln = {
            color: !0,
            date: !0,
            datetime: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            password: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
          };
        function Dn(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === t ? !!Ln[e.type] : "textarea" === t;
        }
        function Rn(e, t, n, r) {
          Dt ? (Rt ? Rt.push(r) : (Rt = [r])) : (Dt = r),
            0 < (t = Wc(t, "onChange")).length &&
              ((n = new Zt("onChange", "change", null, n, r)),
              e.push({ event: n, listeners: t }));
        }
        var zn = null,
          Nn = null;
        function Fn(e) {
          Fc(e, 0);
        }
        function On(e) {
          if (dt(Be(e))) return e;
        }
        function _n(e, t) {
          if ("change" === e) return t;
        }
        var In = !1;
        if (_t) {
          var Vn;
          if (_t) {
            var jn = "oninput" in document;
            if (!jn) {
              var Un = document.createElement("div");
              Un.setAttribute("oninput", "return;"),
                (jn = "function" == typeof Un.oninput);
            }
            Vn = jn;
          } else Vn = !1;
          In = Vn && (!document.documentMode || 9 < document.documentMode);
        }
        function Bn() {
          zn && (zn.detachEvent("onpropertychange", Wn), (Nn = zn = null));
        }
        function Wn(e) {
          if ("value" === e.propertyName && On(Nn)) {
            var t = [];
            Rn(t, Nn, e, Lt(e)), Ft(Fn, t);
          }
        }
        function Hn(e, t, n) {
          "focusin" === e
            ? (Bn(), (Nn = n), (zn = t).attachEvent("onpropertychange", Wn))
            : "focusout" === e && Bn();
        }
        function $n(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e)
            return On(Nn);
        }
        function qn(e, t) {
          if ("click" === e) return On(t);
        }
        function Yn(e, t) {
          if ("input" === e || "change" === e) return On(t);
        }
        var Kn =
          "function" == typeof Object.is
            ? Object.is
            : function (e, t) {
                return (
                  (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t)
                );
              };
        function Qn(e, t) {
          if (Kn(e, t)) return !0;
          if (
            "object" != typeof e ||
            null === e ||
            "object" != typeof t ||
            null === t
          )
            return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) {
            var a = n[r];
            if (!Q.call(t, a) || !Kn(e[a], t[a])) return !1;
          }
          return !0;
        }
        function Xn(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function Gn(e, t) {
          var n,
            r = Xn(e);
          for (e = 0; r; ) {
            if (3 === r.nodeType) {
              if (((n = e + r.textContent.length), e <= t && n >= t))
                return { node: r, offset: t - e };
              e = n;
            }
            e: {
              for (; r; ) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = Xn(r);
          }
        }
        function Zn(e, t) {
          return (
            !(!e || !t) &&
            (e === t ||
              ((!e || 3 !== e.nodeType) &&
                (t && 3 === t.nodeType
                  ? Zn(e, t.parentNode)
                  : "contains" in e
                  ? e.contains(t)
                  : !!e.compareDocumentPosition &&
                    !!(16 & e.compareDocumentPosition(t)))))
          );
        }
        function Jn(e) {
          for (
            var t = ft(
              (e =
                null != e &&
                null != e.ownerDocument &&
                null != e.ownerDocument.defaultView
                  ? e.ownerDocument.defaultView
                  : window).document
            );
            t instanceof e.HTMLIFrameElement;

          ) {
            try {
              var n = "string" == typeof t.contentWindow.location.href;
            } catch (e) {
              n = !1;
            }
            if (!n) break;
            t = ft((e = t.contentWindow).document);
          }
          return t;
        }
        function er(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            (("input" === t &&
              ("text" === e.type ||
                "search" === e.type ||
                "tel" === e.type ||
                "url" === e.type ||
                "password" === e.type)) ||
              "textarea" === t ||
              "true" === e.contentEditable)
          );
        }
        var tr =
            _t && "documentMode" in document && 11 >= document.documentMode,
          nr = null,
          rr = null,
          ar = null,
          or = !1;
        function ir(e, t, n) {
          var r =
            n.window === n
              ? n.document
              : 9 === n.nodeType
              ? n
              : n.ownerDocument;
          or ||
            null == nr ||
            nr !== ft(r) ||
            ((r =
              "selectionStart" in (r = nr) && er(r)
                ? { start: r.selectionStart, end: r.selectionEnd }
                : {
                    anchorNode: (r = (
                      (r.ownerDocument && r.ownerDocument.defaultView) ||
                      window
                    ).getSelection()).anchorNode,
                    anchorOffset: r.anchorOffset,
                    focusNode: r.focusNode,
                    focusOffset: r.focusOffset,
                  }),
            (ar && Qn(ar, r)) ||
              ((ar = r),
              0 < (r = Wc(rr, "onSelect")).length &&
                ((t = new Zt("onSelect", "select", null, t, n)),
                e.push({ event: t, listeners: r }),
                (t.target = nr))));
        }
        function sr(e, t) {
          var n = {};
          return (
            (n[e.toLowerCase()] = t.toLowerCase()),
            (n["Webkit" + e] = "webkit" + t),
            (n["Moz" + e] = "moz" + t),
            n
          );
        }
        var lr = {
            animationend: sr("Animation", "AnimationEnd"),
            animationiteration: sr("Animation", "AnimationIteration"),
            animationstart: sr("Animation", "AnimationStart"),
            transitionrun: sr("Transition", "TransitionRun"),
            transitionstart: sr("Transition", "TransitionStart"),
            transitioncancel: sr("Transition", "TransitionCancel"),
            transitionend: sr("Transition", "TransitionEnd"),
          },
          ur = {},
          cr = {};
        function dr(e) {
          if (ur[e]) return ur[e];
          if (!lr[e]) return e;
          var t,
            n = lr[e];
          for (t in n)
            if (n.hasOwnProperty(t) && t in cr) return (ur[e] = n[t]);
          return e;
        }
        _t &&
          ((cr = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete lr.animationend.animation,
            delete lr.animationiteration.animation,
            delete lr.animationstart.animation),
          "TransitionEvent" in window || delete lr.transitionend.transition);
        var fr = dr("animationend"),
          pr = dr("animationiteration"),
          hr = dr("animationstart"),
          mr = dr("transitionrun"),
          yr = dr("transitionstart"),
          gr = dr("transitioncancel"),
          vr = dr("transitionend"),
          br = new Map(),
          wr =
            "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
              " "
            );
        function kr(e, t) {
          br.set(e, t), Ye(t, [e]);
        }
        wr.push("scrollEnd");
        var Sr = new WeakMap();
        function xr(e, t) {
          if ("object" == typeof e && null !== e) {
            var n = Sr.get(e);
            return void 0 !== n
              ? n
              : ((t = { value: e, source: t, stack: st(t) }), Sr.set(e, t), t);
          }
          return { value: e, source: t, stack: st(t) };
        }
        var Pr = [],
          Er = 0,
          Cr = 0;
        function Tr() {
          for (var e = Er, t = (Cr = Er = 0); t < e; ) {
            var n = Pr[t];
            Pr[t++] = null;
            var r = Pr[t];
            Pr[t++] = null;
            var a = Pr[t];
            Pr[t++] = null;
            var o = Pr[t];
            if (((Pr[t++] = null), null !== r && null !== a)) {
              var i = r.pending;
              null === i ? (a.next = a) : ((a.next = i.next), (i.next = a)),
                (r.pending = a);
            }
            0 !== o && Dr(n, a, o);
          }
        }
        function Ar(e, t, n, r) {
          (Pr[Er++] = e),
            (Pr[Er++] = t),
            (Pr[Er++] = n),
            (Pr[Er++] = r),
            (Cr |= r),
            (e.lanes |= r),
            null !== (e = e.alternate) && (e.lanes |= r);
        }
        function Mr(e, t, n, r) {
          return Ar(e, t, n, r), Rr(e);
        }
        function Lr(e, t) {
          return Ar(e, null, null, t), Rr(e);
        }
        function Dr(e, t, n) {
          e.lanes |= n;
          var r = e.alternate;
          null !== r && (r.lanes |= n);
          for (var a = !1, o = e.return; null !== o; )
            (o.childLanes |= n),
              null !== (r = o.alternate) && (r.childLanes |= n),
              22 === o.tag &&
                (null === (e = o.stateNode) || 1 & e._visibility || (a = !0)),
              (e = o),
              (o = o.return);
          return 3 === e.tag
            ? ((o = e.stateNode),
              a &&
                null !== t &&
                ((a = 31 - fe(n)),
                null === (r = (e = o.hiddenUpdates)[a])
                  ? (e[a] = [t])
                  : r.push(t),
                (t.lane = 536870912 | n)),
              o)
            : null;
        }
        function Rr(e) {
          if (50 < Du) throw ((Du = 0), (Ru = null), Error(i(185)));
          for (var t = e.return; null !== t; ) t = (e = t).return;
          return 3 === e.tag ? e.stateNode : null;
        }
        var zr = {};
        function Nr(e, t, n, r) {
          (this.tag = e),
            (this.key = n),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.refCleanup = this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = r),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null);
        }
        function Fr(e, t, n, r) {
          return new Nr(e, t, n, r);
        }
        function Or(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function _r(e, t) {
          var n = e.alternate;
          return (
            null === n
              ? (((n = Fr(e.tag, t, e.key, e.mode)).elementType =
                  e.elementType),
                (n.type = e.type),
                (n.stateNode = e.stateNode),
                (n.alternate = e),
                (e.alternate = n))
              : ((n.pendingProps = t),
                (n.type = e.type),
                (n.flags = 0),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
            (n.flags = 65011712 & e.flags),
            (n.childLanes = e.childLanes),
            (n.lanes = e.lanes),
            (n.child = e.child),
            (n.memoizedProps = e.memoizedProps),
            (n.memoizedState = e.memoizedState),
            (n.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (n.dependencies =
              null === t
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (n.sibling = e.sibling),
            (n.index = e.index),
            (n.ref = e.ref),
            (n.refCleanup = e.refCleanup),
            n
          );
        }
        function Ir(e, t) {
          e.flags &= 65011714;
          var n = e.alternate;
          return (
            null === n
              ? ((e.childLanes = 0),
                (e.lanes = t),
                (e.child = null),
                (e.subtreeFlags = 0),
                (e.memoizedProps = null),
                (e.memoizedState = null),
                (e.updateQueue = null),
                (e.dependencies = null),
                (e.stateNode = null))
              : ((e.childLanes = n.childLanes),
                (e.lanes = n.lanes),
                (e.child = n.child),
                (e.subtreeFlags = 0),
                (e.deletions = null),
                (e.memoizedProps = n.memoizedProps),
                (e.memoizedState = n.memoizedState),
                (e.updateQueue = n.updateQueue),
                (e.type = n.type),
                (t = n.dependencies),
                (e.dependencies =
                  null === t
                    ? null
                    : { lanes: t.lanes, firstContext: t.firstContext })),
            e
          );
        }
        function Vr(e, t, n, r, a, o) {
          var s = 0;
          if (((r = e), "function" == typeof e)) Or(e) && (s = 1);
          else if ("string" == typeof e)
            s = (function (e, t, n) {
              if (1 === n || null != t.itemProp) return !1;
              switch (e) {
                case "meta":
                case "title":
                  return !0;
                case "style":
                  if (
                    "string" != typeof t.precedence ||
                    "string" != typeof t.href ||
                    "" === t.href
                  )
                    break;
                  return !0;
                case "link":
                  if (
                    "string" != typeof t.rel ||
                    "string" != typeof t.href ||
                    "" === t.href ||
                    t.onLoad ||
                    t.onError
                  )
                    break;
                  return (
                    "stylesheet" !== t.rel ||
                    ((e = t.disabled),
                    "string" == typeof t.precedence && null == e)
                  );
                case "script":
                  if (
                    t.async &&
                    "function" != typeof t.async &&
                    "symbol" != typeof t.async &&
                    !t.onLoad &&
                    !t.onError &&
                    t.src &&
                    "string" == typeof t.src
                  )
                    return !0;
              }
              return !1;
            })(e, n, U.current)
              ? 26
              : "html" === e || "head" === e || "body" === e
              ? 27
              : 5;
          else
            e: switch (e) {
              case C:
                return (
                  ((e = Fr(31, n, t, a)).elementType = C), (e.lanes = o), e
                );
              case m:
                return jr(n.children, a, o, t);
              case y:
                (s = 8), (a |= 24);
                break;
              case g:
                return (
                  ((e = Fr(12, n, t, 2 | a)).elementType = g), (e.lanes = o), e
                );
              case S:
                return (
                  ((e = Fr(13, n, t, a)).elementType = S), (e.lanes = o), e
                );
              case x:
                return (
                  ((e = Fr(19, n, t, a)).elementType = x), (e.lanes = o), e
                );
              default:
                if ("object" == typeof e && null !== e)
                  switch (e.$$typeof) {
                    case v:
                    case w:
                      s = 10;
                      break e;
                    case b:
                      s = 9;
                      break e;
                    case k:
                      s = 11;
                      break e;
                    case P:
                      s = 14;
                      break e;
                    case E:
                      (s = 16), (r = null);
                      break e;
                  }
                (s = 29),
                  (n = Error(i(130, null === e ? "null" : typeof e, ""))),
                  (r = null);
            }
          return (
            ((t = Fr(s, n, t, a)).elementType = e),
            (t.type = r),
            (t.lanes = o),
            t
          );
        }
        function jr(e, t, n, r) {
          return ((e = Fr(7, e, r, t)).lanes = n), e;
        }
        function Ur(e, t, n) {
          return ((e = Fr(6, e, null, t)).lanes = n), e;
        }
        function Br(e, t, n) {
          return (
            ((t = Fr(
              4,
              null !== e.children ? e.children : [],
              e.key,
              t
            )).lanes = n),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        var Wr = [],
          Hr = 0,
          $r = null,
          qr = 0,
          Yr = [],
          Kr = 0,
          Qr = null,
          Xr = 1,
          Gr = "";
        function Zr(e, t) {
          (Wr[Hr++] = qr), (Wr[Hr++] = $r), ($r = e), (qr = t);
        }
        function Jr(e, t, n) {
          (Yr[Kr++] = Xr), (Yr[Kr++] = Gr), (Yr[Kr++] = Qr), (Qr = e);
          var r = Xr;
          e = Gr;
          var a = 32 - fe(r) - 1;
          (r &= ~(1 << a)), (n += 1);
          var o = 32 - fe(t) + a;
          if (30 < o) {
            var i = a - (a % 5);
            (o = (r & ((1 << i) - 1)).toString(32)),
              (r >>= i),
              (a -= i),
              (Xr = (1 << (32 - fe(t) + a)) | (n << a) | r),
              (Gr = o + e);
          } else (Xr = (1 << o) | (n << a) | r), (Gr = e);
        }
        function ea(e) {
          null !== e.return && (Zr(e, 1), Jr(e, 1, 0));
        }
        function ta(e) {
          for (; e === $r; )
            ($r = Wr[--Hr]), (Wr[Hr] = null), (qr = Wr[--Hr]), (Wr[Hr] = null);
          for (; e === Qr; )
            (Qr = Yr[--Kr]),
              (Yr[Kr] = null),
              (Gr = Yr[--Kr]),
              (Yr[Kr] = null),
              (Xr = Yr[--Kr]),
              (Yr[Kr] = null);
        }
        var na = null,
          ra = null,
          aa = !1,
          oa = null,
          ia = !1,
          sa = Error(i(519));
        function la(e) {
          throw (ha(xr(Error(i(418, "")), e)), sa);
        }
        function ua(e) {
          var t = e.stateNode,
            n = e.type,
            r = e.memoizedProps;
          switch (((t[De] = e), (t[Re] = r), n)) {
            case "dialog":
              Oc("cancel", t), Oc("close", t);
              break;
            case "iframe":
            case "object":
            case "embed":
              Oc("load", t);
              break;
            case "video":
            case "audio":
              for (n = 0; n < zc.length; n++) Oc(zc[n], t);
              break;
            case "source":
              Oc("error", t);
              break;
            case "img":
            case "image":
            case "link":
              Oc("error", t), Oc("load", t);
              break;
            case "details":
              Oc("toggle", t);
              break;
            case "input":
              Oc("invalid", t),
                yt(
                  t,
                  r.value,
                  r.defaultValue,
                  r.checked,
                  r.defaultChecked,
                  r.type,
                  r.name,
                  !0
                ),
                ct(t);
              break;
            case "select":
              Oc("invalid", t);
              break;
            case "textarea":
              Oc("invalid", t),
                wt(t, r.value, r.defaultValue, r.children),
                ct(t);
          }
          ("string" != typeof (n = r.children) &&
            "number" != typeof n &&
            "bigint" != typeof n) ||
          t.textContent === "" + n ||
          !0 === r.suppressHydrationWarning ||
          Qc(t.textContent, n)
            ? (null != r.popover && (Oc("beforetoggle", t), Oc("toggle", t)),
              null != r.onScroll && Oc("scroll", t),
              null != r.onScrollEnd && Oc("scrollend", t),
              null != r.onClick && (t.onclick = Xc),
              (t = !0))
            : (t = !1),
            t || la(e);
        }
        function ca(e) {
          for (na = e.return; na; )
            switch (na.tag) {
              case 5:
              case 13:
                return void (ia = !1);
              case 27:
              case 3:
                return void (ia = !0);
              default:
                na = na.return;
            }
        }
        function da(e) {
          if (e !== na) return !1;
          if (!aa) return ca(e), (aa = !0), !1;
          var t,
            n = e.tag;
          if (
            ((t = 3 !== n && 27 !== n) &&
              ((t = 5 === n) &&
                (t =
                  !("form" !== (t = e.type) && "button" !== t) ||
                  od(e.type, e.memoizedProps)),
              (t = !t)),
            t && ra && la(e),
            ca(e),
            13 === n)
          ) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
              throw Error(i(317));
            e: {
              for (e = e.nextSibling, n = 0; e; ) {
                if (8 === e.nodeType)
                  if ("/$" === (t = e.data)) {
                    if (0 === n) {
                      ra = yd(e.nextSibling);
                      break e;
                    }
                    n--;
                  } else ("$" !== t && "$!" !== t && "$?" !== t) || n++;
                e = e.nextSibling;
              }
              ra = null;
            }
          } else
            27 === n
              ? ((n = ra),
                fd(e.type) ? ((e = gd), (gd = null), (ra = e)) : (ra = n))
              : (ra = na ? yd(e.stateNode.nextSibling) : null);
          return !0;
        }
        function fa() {
          (ra = na = null), (aa = !1);
        }
        function pa() {
          var e = oa;
          return (
            null !== e &&
              (null === vu ? (vu = e) : vu.push.apply(vu, e), (oa = null)),
            e
          );
        }
        function ha(e) {
          null === oa ? (oa = [e]) : oa.push(e);
        }
        var ma = I(null),
          ya = null,
          ga = null;
        function va(e, t, n) {
          j(ma, t._currentValue), (t._currentValue = n);
        }
        function ba(e) {
          (e._currentValue = ma.current), V(ma);
        }
        function wa(e, t, n) {
          for (; null !== e; ) {
            var r = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
                : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
              e === n)
            )
              break;
            e = e.return;
          }
        }
        function ka(e, t, n, r) {
          var a = e.child;
          for (null !== a && (a.return = e); null !== a; ) {
            var o = a.dependencies;
            if (null !== o) {
              var s = a.child;
              o = o.firstContext;
              e: for (; null !== o; ) {
                var l = o;
                o = a;
                for (var u = 0; u < t.length; u++)
                  if (l.context === t[u]) {
                    (o.lanes |= n),
                      null !== (l = o.alternate) && (l.lanes |= n),
                      wa(o.return, n, e),
                      r || (s = null);
                    break e;
                  }
                o = l.next;
              }
            } else if (18 === a.tag) {
              if (null === (s = a.return)) throw Error(i(341));
              (s.lanes |= n),
                null !== (o = s.alternate) && (o.lanes |= n),
                wa(s, n, e),
                (s = null);
            } else s = a.child;
            if (null !== s) s.return = a;
            else
              for (s = a; null !== s; ) {
                if (s === e) {
                  s = null;
                  break;
                }
                if (null !== (a = s.sibling)) {
                  (a.return = s.return), (s = a);
                  break;
                }
                s = s.return;
              }
            a = s;
          }
        }
        function Sa(e, t, n, r) {
          e = null;
          for (var a = t, o = !1; null !== a; ) {
            if (!o)
              if (524288 & a.flags) o = !0;
              else if (262144 & a.flags) break;
            if (10 === a.tag) {
              var s = a.alternate;
              if (null === s) throw Error(i(387));
              if (null !== (s = s.memoizedProps)) {
                var l = a.type;
                Kn(a.pendingProps.value, s.value) ||
                  (null !== e ? e.push(l) : (e = [l]));
              }
            } else if (a === H.current) {
              if (null === (s = a.alternate)) throw Error(i(387));
              s.memoizedState.memoizedState !== a.memoizedState.memoizedState &&
                (null !== e ? e.push(Yd) : (e = [Yd]));
            }
            a = a.return;
          }
          null !== e && ka(t, e, n, r), (t.flags |= 262144);
        }
        function xa(e) {
          for (e = e.firstContext; null !== e; ) {
            if (!Kn(e.context._currentValue, e.memoizedValue)) return !0;
            e = e.next;
          }
          return !1;
        }
        function Pa(e) {
          (ya = e),
            (ga = null),
            null !== (e = e.dependencies) && (e.firstContext = null);
        }
        function Ea(e) {
          return Ta(ya, e);
        }
        function Ca(e, t) {
          return null === ya && Pa(e), Ta(e, t);
        }
        function Ta(e, t) {
          var n = t._currentValue;
          if (
            ((t = { context: t, memoizedValue: n, next: null }), null === ga)
          ) {
            if (null === e) throw Error(i(308));
            (ga = t),
              (e.dependencies = { lanes: 0, firstContext: t }),
              (e.flags |= 524288);
          } else ga = ga.next = t;
          return n;
        }
        var Aa =
            "undefined" != typeof AbortController
              ? AbortController
              : function () {
                  var e = [],
                    t = (this.signal = {
                      aborted: !1,
                      addEventListener: function (t, n) {
                        e.push(n);
                      },
                    });
                  this.abort = function () {
                    (t.aborted = !0),
                      e.forEach(function (e) {
                        return e();
                      });
                  };
                },
          Ma = r.unstable_scheduleCallback,
          La = r.unstable_NormalPriority,
          Da = {
            $$typeof: w,
            Consumer: null,
            Provider: null,
            _currentValue: null,
            _currentValue2: null,
            _threadCount: 0,
          };
        function Ra() {
          return { controller: new Aa(), data: new Map(), refCount: 0 };
        }
        function za(e) {
          e.refCount--,
            0 === e.refCount &&
              Ma(La, function () {
                e.controller.abort();
              });
        }
        var Na = null,
          Fa = 0,
          Oa = 0,
          _a = null;
        function Ia() {
          if (0 == --Fa && null !== Na) {
            null !== _a && (_a.status = "fulfilled");
            var e = Na;
            (Na = null), (Oa = 0), (_a = null);
            for (var t = 0; t < e.length; t++) (0, e[t])();
          }
        }
        var Va = z.S;
        z.S = function (e, t) {
          "object" == typeof t &&
            null !== t &&
            "function" == typeof t.then &&
            (function (e, t) {
              if (null === Na) {
                var n = (Na = []);
                (Fa = 0),
                  (Oa = Ac()),
                  (_a = {
                    status: "pending",
                    value: void 0,
                    then: function (e) {
                      n.push(e);
                    },
                  });
              }
              Fa++, t.then(Ia, Ia);
            })(0, t),
            null !== Va && Va(e, t);
        };
        var ja = I(null);
        function Ua() {
          var e = ja.current;
          return null !== e ? e : nu.pooledCache;
        }
        function Ba(e, t) {
          j(ja, null === t ? ja.current : t.pool);
        }
        function Wa() {
          var e = Ua();
          return null === e ? null : { parent: Da._currentValue, pool: e };
        }
        var Ha = Error(i(460)),
          $a = Error(i(474)),
          qa = Error(i(542)),
          Ya = { then: function () {} };
        function Ka(e) {
          return "fulfilled" === (e = e.status) || "rejected" === e;
        }
        function Qa() {}
        function Xa(e, t, n) {
          switch (
            (void 0 === (n = e[n])
              ? e.push(t)
              : n !== t && (t.then(Qa, Qa), (t = n)),
            t.status)
          ) {
            case "fulfilled":
              return t.value;
            case "rejected":
              throw (Ja((e = t.reason)), e);
            default:
              if ("string" == typeof t.status) t.then(Qa, Qa);
              else {
                if (null !== (e = nu) && 100 < e.shellSuspendCounter)
                  throw Error(i(482));
                ((e = t).status = "pending"),
                  e.then(
                    function (e) {
                      if ("pending" === t.status) {
                        var n = t;
                        (n.status = "fulfilled"), (n.value = e);
                      }
                    },
                    function (e) {
                      if ("pending" === t.status) {
                        var n = t;
                        (n.status = "rejected"), (n.reason = e);
                      }
                    }
                  );
              }
              switch (t.status) {
                case "fulfilled":
                  return t.value;
                case "rejected":
                  throw (Ja((e = t.reason)), e);
              }
              throw ((Ga = t), Ha);
          }
        }
        var Ga = null;
        function Za() {
          if (null === Ga) throw Error(i(459));
          var e = Ga;
          return (Ga = null), e;
        }
        function Ja(e) {
          if (e === Ha || e === qa) throw Error(i(483));
        }
        var eo = !1;
        function to(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, lanes: 0, hiddenCallbacks: null },
            callbacks: null,
          };
        }
        function no(e, t) {
          (e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                callbacks: null,
              });
        }
        function ro(e) {
          return { lane: e, tag: 0, payload: null, callback: null, next: null };
        }
        function ao(e, t, n) {
          var r = e.updateQueue;
          if (null === r) return null;
          if (((r = r.shared), 2 & tu)) {
            var a = r.pending;
            return (
              null === a ? (t.next = t) : ((t.next = a.next), (a.next = t)),
              (r.pending = t),
              (t = Rr(e)),
              Dr(e, null, n),
              t
            );
          }
          return Ar(e, r, t, n), Rr(e);
        }
        function oo(e, t, n) {
          if (null !== (t = t.updateQueue) && ((t = t.shared), 4194048 & n)) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), Ce(e, n);
          }
        }
        function io(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var a = null,
              o = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var i = {
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: null,
                  next: null,
                };
                null === o ? (a = o = i) : (o = o.next = i), (n = n.next);
              } while (null !== n);
              null === o ? (a = o = t) : (o = o.next = t);
            } else a = o = t;
            return (
              (n = {
                baseState: r.baseState,
                firstBaseUpdate: a,
                lastBaseUpdate: o,
                shared: r.shared,
                callbacks: r.callbacks,
              }),
              void (e.updateQueue = n)
            );
          }
          null === (e = n.lastBaseUpdate)
            ? (n.firstBaseUpdate = t)
            : (e.next = t),
            (n.lastBaseUpdate = t);
        }
        var so = !1;
        function lo() {
          if (so && null !== _a) throw _a;
        }
        function uo(e, t, n, r) {
          so = !1;
          var a = e.updateQueue;
          eo = !1;
          var o = a.firstBaseUpdate,
            i = a.lastBaseUpdate,
            s = a.shared.pending;
          if (null !== s) {
            a.shared.pending = null;
            var l = s,
              u = l.next;
            (l.next = null), null === i ? (o = u) : (i.next = u), (i = l);
            var c = e.alternate;
            null !== c &&
              (s = (c = c.updateQueue).lastBaseUpdate) !== i &&
              (null === s ? (c.firstBaseUpdate = u) : (s.next = u),
              (c.lastBaseUpdate = l));
          }
          if (null !== o) {
            var f = a.baseState;
            for (i = 0, c = u = l = null, s = o; ; ) {
              var p = -536870913 & s.lane,
                h = p !== s.lane;
              if (h ? (au & p) === p : (r & p) === p) {
                0 !== p && p === Oa && (so = !0),
                  null !== c &&
                    (c = c.next =
                      {
                        lane: 0,
                        tag: s.tag,
                        payload: s.payload,
                        callback: null,
                        next: null,
                      });
                e: {
                  var m = e,
                    y = s;
                  p = t;
                  var g = n;
                  switch (y.tag) {
                    case 1:
                      if ("function" == typeof (m = y.payload)) {
                        f = m.call(g, f, p);
                        break e;
                      }
                      f = m;
                      break e;
                    case 3:
                      m.flags = (-65537 & m.flags) | 128;
                    case 0:
                      if (
                        null ==
                        (p =
                          "function" == typeof (m = y.payload)
                            ? m.call(g, f, p)
                            : m)
                      )
                        break e;
                      f = d({}, f, p);
                      break e;
                    case 2:
                      eo = !0;
                  }
                }
                null !== (p = s.callback) &&
                  ((e.flags |= 64),
                  h && (e.flags |= 8192),
                  null === (h = a.callbacks) ? (a.callbacks = [p]) : h.push(p));
              } else
                (h = {
                  lane: p,
                  tag: s.tag,
                  payload: s.payload,
                  callback: s.callback,
                  next: null,
                }),
                  null === c ? ((u = c = h), (l = f)) : (c = c.next = h),
                  (i |= p);
              if (null === (s = s.next)) {
                if (null === (s = a.shared.pending)) break;
                (s = (h = s).next),
                  (h.next = null),
                  (a.lastBaseUpdate = h),
                  (a.shared.pending = null);
              }
            }
            null === c && (l = f),
              (a.baseState = l),
              (a.firstBaseUpdate = u),
              (a.lastBaseUpdate = c),
              null === o && (a.shared.lanes = 0),
              (fu |= i),
              (e.lanes = i),
              (e.memoizedState = f);
          }
        }
        function co(e, t) {
          if ("function" != typeof e) throw Error(i(191, e));
          e.call(t);
        }
        function fo(e, t) {
          var n = e.callbacks;
          if (null !== n)
            for (e.callbacks = null, e = 0; e < n.length; e++) co(n[e], t);
        }
        var po = I(null),
          ho = I(0);
        function mo(e, t) {
          j(ho, (e = cu)), j(po, t), (cu = e | t.baseLanes);
        }
        function yo() {
          j(ho, cu), j(po, po.current);
        }
        function go() {
          (cu = ho.current), V(po), V(ho);
        }
        var vo = 0,
          bo = null,
          wo = null,
          ko = null,
          So = !1,
          xo = !1,
          Po = !1,
          Eo = 0,
          Co = 0,
          To = null,
          Ao = 0;
        function Mo() {
          throw Error(i(321));
        }
        function Lo(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++)
            if (!Kn(e[n], t[n])) return !1;
          return !0;
        }
        function Do(e, t, n, r, a, o) {
          return (
            (vo = o),
            (bo = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (z.H = null === e || null === e.memoizedState ? $i : qi),
            (Po = !1),
            (o = n(r, a)),
            (Po = !1),
            xo && (o = zo(t, n, r, a)),
            Ro(e),
            o
          );
        }
        function Ro(e) {
          z.H = Hi;
          var t = null !== wo && null !== wo.next;
          if (
            ((vo = 0),
            (ko = wo = bo = null),
            (So = !1),
            (Co = 0),
            (To = null),
            t)
          )
            throw Error(i(300));
          null === e ||
            Cs ||
            (null !== (e = e.dependencies) && xa(e) && (Cs = !0));
        }
        function zo(e, t, n, r) {
          bo = e;
          var a = 0;
          do {
            if ((xo && (To = null), (Co = 0), (xo = !1), 25 <= a))
              throw Error(i(301));
            if (((a += 1), (ko = wo = null), null != e.updateQueue)) {
              var o = e.updateQueue;
              (o.lastEffect = null),
                (o.events = null),
                (o.stores = null),
                null != o.memoCache && (o.memoCache.index = 0);
            }
            (z.H = Yi), (o = t(n, r));
          } while (xo);
          return o;
        }
        function No() {
          var e = z.H,
            t = e.useState()[0];
          return (
            (t = "function" == typeof t.then ? jo(t) : t),
            (e = e.useState()[0]),
            (null !== wo ? wo.memoizedState : null) !== e && (bo.flags |= 1024),
            t
          );
        }
        function Fo() {
          var e = 0 !== Eo;
          return (Eo = 0), e;
        }
        function Oo(e, t, n) {
          (t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~n);
        }
        function _o(e) {
          if (So) {
            for (e = e.memoizedState; null !== e; ) {
              var t = e.queue;
              null !== t && (t.pending = null), (e = e.next);
            }
            So = !1;
          }
          (vo = 0),
            (ko = wo = bo = null),
            (xo = !1),
            (Co = Eo = 0),
            (To = null);
        }
        function Io() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            null === ko ? (bo.memoizedState = ko = e) : (ko = ko.next = e), ko
          );
        }
        function Vo() {
          if (null === wo) {
            var e = bo.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = wo.next;
          var t = null === ko ? bo.memoizedState : ko.next;
          if (null !== t) (ko = t), (wo = e);
          else {
            if (null === e) {
              if (null === bo.alternate) throw Error(i(467));
              throw Error(i(310));
            }
            (e = {
              memoizedState: (wo = e).memoizedState,
              baseState: wo.baseState,
              baseQueue: wo.baseQueue,
              queue: wo.queue,
              next: null,
            }),
              null === ko ? (bo.memoizedState = ko = e) : (ko = ko.next = e);
          }
          return ko;
        }
        function jo(e) {
          var t = Co;
          return (
            (Co += 1),
            null === To && (To = []),
            (e = Xa(To, e, t)),
            (t = bo),
            null === (null === ko ? t.memoizedState : ko.next) &&
              ((t = t.alternate),
              (z.H = null === t || null === t.memoizedState ? $i : qi)),
            e
          );
        }
        function Uo(e) {
          if (null !== e && "object" == typeof e) {
            if ("function" == typeof e.then) return jo(e);
            if (e.$$typeof === w) return Ea(e);
          }
          throw Error(i(438, String(e)));
        }
        function Bo(e) {
          var t = null,
            n = bo.updateQueue;
          if ((null !== n && (t = n.memoCache), null == t)) {
            var r = bo.alternate;
            null !== r &&
              null !== (r = r.updateQueue) &&
              null != (r = r.memoCache) &&
              (t = {
                data: r.data.map(function (e) {
                  return e.slice();
                }),
                index: 0,
              });
          }
          if (
            (null == t && (t = { data: [], index: 0 }),
            null === n &&
              ((n = {
                lastEffect: null,
                events: null,
                stores: null,
                memoCache: null,
              }),
              (bo.updateQueue = n)),
            (n.memoCache = t),
            void 0 === (n = t.data[t.index]))
          )
            for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = T;
          return t.index++, n;
        }
        function Wo(e, t) {
          return "function" == typeof t ? t(e) : t;
        }
        function Ho(e) {
          return $o(Vo(), wo, e);
        }
        function $o(e, t, n) {
          var r = e.queue;
          if (null === r) throw Error(i(311));
          r.lastRenderedReducer = n;
          var a = e.baseQueue,
            o = r.pending;
          if (null !== o) {
            if (null !== a) {
              var s = a.next;
              (a.next = o.next), (o.next = s);
            }
            (t.baseQueue = a = o), (r.pending = null);
          }
          if (((o = e.baseState), null === a)) e.memoizedState = o;
          else {
            var l = (s = null),
              u = null,
              c = (t = a.next),
              d = !1;
            do {
              var f = -536870913 & c.lane;
              if (f !== c.lane ? (au & f) === f : (vo & f) === f) {
                var p = c.revertLane;
                if (0 === p)
                  null !== u &&
                    (u = u.next =
                      {
                        lane: 0,
                        revertLane: 0,
                        action: c.action,
                        hasEagerState: c.hasEagerState,
                        eagerState: c.eagerState,
                        next: null,
                      }),
                    f === Oa && (d = !0);
                else {
                  if ((vo & p) === p) {
                    (c = c.next), p === Oa && (d = !0);
                    continue;
                  }
                  (f = {
                    lane: 0,
                    revertLane: c.revertLane,
                    action: c.action,
                    hasEagerState: c.hasEagerState,
                    eagerState: c.eagerState,
                    next: null,
                  }),
                    null === u ? ((l = u = f), (s = o)) : (u = u.next = f),
                    (bo.lanes |= p),
                    (fu |= p);
                }
                (f = c.action),
                  Po && n(o, f),
                  (o = c.hasEagerState ? c.eagerState : n(o, f));
              } else
                (p = {
                  lane: f,
                  revertLane: c.revertLane,
                  action: c.action,
                  hasEagerState: c.hasEagerState,
                  eagerState: c.eagerState,
                  next: null,
                }),
                  null === u ? ((l = u = p), (s = o)) : (u = u.next = p),
                  (bo.lanes |= f),
                  (fu |= f);
              c = c.next;
            } while (null !== c && c !== t);
            if (
              (null === u ? (s = o) : (u.next = l),
              !Kn(o, e.memoizedState) && ((Cs = !0), d && null !== (n = _a)))
            )
              throw n;
            (e.memoizedState = o),
              (e.baseState = s),
              (e.baseQueue = u),
              (r.lastRenderedState = o);
          }
          return null === a && (r.lanes = 0), [e.memoizedState, r.dispatch];
        }
        function qo(e) {
          var t = Vo(),
            n = t.queue;
          if (null === n) throw Error(i(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            a = n.pending,
            o = t.memoizedState;
          if (null !== a) {
            n.pending = null;
            var s = (a = a.next);
            do {
              (o = e(o, s.action)), (s = s.next);
            } while (s !== a);
            Kn(o, t.memoizedState) || (Cs = !0),
              (t.memoizedState = o),
              null === t.baseQueue && (t.baseState = o),
              (n.lastRenderedState = o);
          }
          return [o, r];
        }
        function Yo(e, t, n) {
          var r = bo,
            a = Vo(),
            o = aa;
          if (o) {
            if (void 0 === n) throw Error(i(407));
            n = n();
          } else n = t();
          var s = !Kn((wo || a).memoizedState, n);
          if (
            (s && ((a.memoizedState = n), (Cs = !0)),
            (a = a.queue),
            yi(2048, 8, Xo.bind(null, r, a, e), [e]),
            a.getSnapshot !== t ||
              s ||
              (null !== ko && 1 & ko.memoizedState.tag))
          ) {
            if (
              ((r.flags |= 2048),
              pi(
                9,
                { destroy: void 0, resource: void 0 },
                Qo.bind(null, r, a, n, t),
                null
              ),
              null === nu)
            )
              throw Error(i(349));
            o || 124 & vo || Ko(r, t, n);
          }
          return n;
        }
        function Ko(e, t, n) {
          (e.flags |= 16384),
            (e = { getSnapshot: t, value: n }),
            null === (t = bo.updateQueue)
              ? ((t = {
                  lastEffect: null,
                  events: null,
                  stores: null,
                  memoCache: null,
                }),
                (bo.updateQueue = t),
                (t.stores = [e]))
              : null === (n = t.stores)
              ? (t.stores = [e])
              : n.push(e);
        }
        function Qo(e, t, n, r) {
          (t.value = n), (t.getSnapshot = r), Go(t) && Zo(e);
        }
        function Xo(e, t, n) {
          return n(function () {
            Go(t) && Zo(e);
          });
        }
        function Go(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !Kn(e, n);
          } catch (e) {
            return !0;
          }
        }
        function Zo(e) {
          var t = Lr(e, 2);
          null !== t && Fu(t, 0, 2);
        }
        function Jo(e) {
          var t = Io();
          if ("function" == typeof e) {
            var n = e;
            if (((e = n()), Po)) {
              de(!0);
              try {
                n();
              } finally {
                de(!1);
              }
            }
          }
          return (
            (t.memoizedState = t.baseState = e),
            (t.queue = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Wo,
              lastRenderedState: e,
            }),
            t
          );
        }
        function ei(e, t, n, r) {
          return (e.baseState = n), $o(e, wo, "function" == typeof r ? r : Wo);
        }
        function ti(e, t, n, r, a) {
          if (Ui(e)) throw Error(i(485));
          if (null !== (e = t.action)) {
            var o = {
              payload: a,
              action: e,
              next: null,
              isTransition: !0,
              status: "pending",
              value: null,
              reason: null,
              listeners: [],
              then: function (e) {
                o.listeners.push(e);
              },
            };
            null !== z.T ? n(!0) : (o.isTransition = !1),
              r(o),
              null === (n = t.pending)
                ? ((o.next = t.pending = o), ni(t, o))
                : ((o.next = n.next), (t.pending = n.next = o));
          }
        }
        function ni(e, t) {
          var n = t.action,
            r = t.payload,
            a = e.state;
          if (t.isTransition) {
            var o = z.T,
              i = {};
            z.T = i;
            try {
              var s = n(a, r),
                l = z.S;
              null !== l && l(i, s), ri(e, t, s);
            } catch (n) {
              oi(e, t, n);
            } finally {
              z.T = o;
            }
          } else
            try {
              ri(e, t, (o = n(a, r)));
            } catch (n) {
              oi(e, t, n);
            }
        }
        function ri(e, t, n) {
          null !== n && "object" == typeof n && "function" == typeof n.then
            ? n.then(
                function (n) {
                  ai(e, t, n);
                },
                function (n) {
                  return oi(e, t, n);
                }
              )
            : ai(e, t, n);
        }
        function ai(e, t, n) {
          (t.status = "fulfilled"),
            (t.value = n),
            ii(t),
            (e.state = n),
            null !== (t = e.pending) &&
              ((n = t.next) === t
                ? (e.pending = null)
                : ((n = n.next), (t.next = n), ni(e, n)));
        }
        function oi(e, t, n) {
          var r = e.pending;
          if (((e.pending = null), null !== r)) {
            r = r.next;
            do {
              (t.status = "rejected"), (t.reason = n), ii(t), (t = t.next);
            } while (t !== r);
          }
          e.action = null;
        }
        function ii(e) {
          e = e.listeners;
          for (var t = 0; t < e.length; t++) (0, e[t])();
        }
        function si(e, t) {
          return t;
        }
        function li(e, t) {
          if (aa) {
            var n = nu.formState;
            if (null !== n) {
              e: {
                var r = bo;
                if (aa) {
                  if (ra) {
                    t: {
                      for (var a = ra, o = ia; 8 !== a.nodeType; ) {
                        if (!o) {
                          a = null;
                          break t;
                        }
                        if (null === (a = yd(a.nextSibling))) {
                          a = null;
                          break t;
                        }
                      }
                      a = "F!" === (o = a.data) || "F" === o ? a : null;
                    }
                    if (a) {
                      (ra = yd(a.nextSibling)), (r = "F!" === a.data);
                      break e;
                    }
                  }
                  la(r);
                }
                r = !1;
              }
              r && (t = n[0]);
            }
          }
          return (
            ((n = Io()).memoizedState = n.baseState = t),
            (r = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: si,
              lastRenderedState: t,
            }),
            (n.queue = r),
            (n = Ii.bind(null, bo, r)),
            (r.dispatch = n),
            (r = Jo(!1)),
            (o = ji.bind(null, bo, !1, r.queue)),
            (a = { state: t, dispatch: null, action: e, pending: null }),
            ((r = Io()).queue = a),
            (n = ti.bind(null, bo, a, o, n)),
            (a.dispatch = n),
            (r.memoizedState = e),
            [t, n, !1]
          );
        }
        function ui(e) {
          return ci(Vo(), wo, e);
        }
        function ci(e, t, n) {
          if (
            ((t = $o(e, t, si)[0]),
            (e = Ho(Wo)[0]),
            "object" == typeof t && null !== t && "function" == typeof t.then)
          )
            try {
              var r = jo(t);
            } catch (e) {
              if (e === Ha) throw qa;
              throw e;
            }
          else r = t;
          var a = (t = Vo()).queue,
            o = a.dispatch;
          return (
            n !== t.memoizedState &&
              ((bo.flags |= 2048),
              pi(
                9,
                { destroy: void 0, resource: void 0 },
                di.bind(null, a, n),
                null
              )),
            [r, o, e]
          );
        }
        function di(e, t) {
          e.action = t;
        }
        function fi(e) {
          var t = Vo(),
            n = wo;
          if (null !== n) return ci(t, n, e);
          Vo(), (t = t.memoizedState);
          var r = (n = Vo()).queue.dispatch;
          return (n.memoizedState = e), [t, r, !1];
        }
        function pi(e, t, n, r) {
          return (
            (e = { tag: e, create: n, deps: r, inst: t, next: null }),
            null === (t = bo.updateQueue) &&
              ((t = {
                lastEffect: null,
                events: null,
                stores: null,
                memoCache: null,
              }),
              (bo.updateQueue = t)),
            null === (n = t.lastEffect)
              ? (t.lastEffect = e.next = e)
              : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e)),
            e
          );
        }
        function hi() {
          return Vo().memoizedState;
        }
        function mi(e, t, n, r) {
          var a = Io();
          (r = void 0 === r ? null : r),
            (bo.flags |= e),
            (a.memoizedState = pi(
              1 | t,
              { destroy: void 0, resource: void 0 },
              n,
              r
            ));
        }
        function yi(e, t, n, r) {
          var a = Vo();
          r = void 0 === r ? null : r;
          var o = a.memoizedState.inst;
          null !== wo && null !== r && Lo(r, wo.memoizedState.deps)
            ? (a.memoizedState = pi(t, o, n, r))
            : ((bo.flags |= e), (a.memoizedState = pi(1 | t, o, n, r)));
        }
        function gi(e, t) {
          mi(8390656, 8, e, t);
        }
        function vi(e, t) {
          yi(2048, 8, e, t);
        }
        function bi(e, t) {
          return yi(4, 2, e, t);
        }
        function wi(e, t) {
          return yi(4, 4, e, t);
        }
        function ki(e, t) {
          if ("function" == typeof t) {
            e = e();
            var n = t(e);
            return function () {
              "function" == typeof n ? n() : t(null);
            };
          }
          if (null != t)
            return (
              (e = e()),
              (t.current = e),
              function () {
                t.current = null;
              }
            );
        }
        function Si(e, t, n) {
          (n = null != n ? n.concat([e]) : null),
            yi(4, 4, ki.bind(null, t, e), n);
        }
        function xi() {}
        function Pi(e, t) {
          var n = Vo();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== t && Lo(t, r[1])
            ? r[0]
            : ((n.memoizedState = [e, t]), e);
        }
        function Ei(e, t) {
          var n = Vo();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          if (null !== t && Lo(t, r[1])) return r[0];
          if (((r = e()), Po)) {
            de(!0);
            try {
              e();
            } finally {
              de(!1);
            }
          }
          return (n.memoizedState = [r, t]), r;
        }
        function Ci(e, t, n) {
          return void 0 === n || 1073741824 & vo
            ? (e.memoizedState = t)
            : ((e.memoizedState = n),
              (e = Nu()),
              (bo.lanes |= e),
              (fu |= e),
              n);
        }
        function Ti(e, t, n, r) {
          return Kn(n, t)
            ? n
            : null !== po.current
            ? ((e = Ci(e, n, r)), Kn(e, t) || (Cs = !0), e)
            : 42 & vo
            ? ((e = Nu()), (bo.lanes |= e), (fu |= e), t)
            : ((Cs = !0), (e.memoizedState = n));
        }
        function Ai(e, t, n, r, a) {
          var o = N.p;
          N.p = 0 !== o && 8 > o ? o : 8;
          var i,
            s,
            l,
            u = z.T,
            c = {};
          (z.T = c), ji(e, !1, t, n);
          try {
            var d = a(),
              f = z.S;
            null !== f && f(c, d),
              null !== d && "object" == typeof d && "function" == typeof d.then
                ? Vi(
                    e,
                    t,
                    ((i = r),
                    (s = []),
                    (l = {
                      status: "pending",
                      value: null,
                      reason: null,
                      then: function (e) {
                        s.push(e);
                      },
                    }),
                    d.then(
                      function () {
                        (l.status = "fulfilled"), (l.value = i);
                        for (var e = 0; e < s.length; e++) (0, s[e])(i);
                      },
                      function (e) {
                        for (
                          l.status = "rejected", l.reason = e, e = 0;
                          e < s.length;
                          e++
                        )
                          (0, s[e])(void 0);
                      }
                    ),
                    l),
                    zu()
                  )
                : Vi(e, t, r, zu());
          } catch (n) {
            Vi(
              e,
              t,
              { then: function () {}, status: "rejected", reason: n },
              zu()
            );
          } finally {
            (N.p = o), (z.T = u);
          }
        }
        function Mi() {}
        function Li(e, t, n, r) {
          if (5 !== e.tag) throw Error(i(476));
          var a = Di(e).queue;
          Ai(
            e,
            a,
            t,
            F,
            null === n
              ? Mi
              : function () {
                  return Ri(e), n(r);
                }
          );
        }
        function Di(e) {
          var t = e.memoizedState;
          if (null !== t) return t;
          var n = {};
          return (
            ((t = {
              memoizedState: F,
              baseState: F,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Wo,
                lastRenderedState: F,
              },
              next: null,
            }).next = {
              memoizedState: n,
              baseState: n,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Wo,
                lastRenderedState: n,
              },
              next: null,
            }),
            (e.memoizedState = t),
            null !== (e = e.alternate) && (e.memoizedState = t),
            t
          );
        }
        function Ri(e) {
          Vi(e, Di(e).next.queue, {}, zu());
        }
        function zi() {
          return Ea(Yd);
        }
        function Ni() {
          return Vo().memoizedState;
        }
        function Fi() {
          return Vo().memoizedState;
        }
        function Oi(e) {
          for (var t = e.return; null !== t; ) {
            switch (t.tag) {
              case 24:
              case 3:
                var n = zu(),
                  r = ao(t, (e = ro(n)), n);
                return (
                  null !== r && (Fu(r, 0, n), oo(r, t, n)),
                  (t = { cache: Ra() }),
                  void (e.payload = t)
                );
            }
            t = t.return;
          }
        }
        function _i(e, t, n) {
          var r = zu();
          (n = {
            lane: r,
            revertLane: 0,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            Ui(e)
              ? Bi(t, n)
              : null !== (n = Mr(e, t, n, r)) && (Fu(n, 0, r), Wi(n, t, r));
        }
        function Ii(e, t, n) {
          Vi(e, t, n, zu());
        }
        function Vi(e, t, n, r) {
          var a = {
            lane: r,
            revertLane: 0,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
          if (Ui(e)) Bi(t, a);
          else {
            var o = e.alternate;
            if (
              0 === e.lanes &&
              (null === o || 0 === o.lanes) &&
              null !== (o = t.lastRenderedReducer)
            )
              try {
                var i = t.lastRenderedState,
                  s = o(i, n);
                if (((a.hasEagerState = !0), (a.eagerState = s), Kn(s, i)))
                  return Ar(e, t, a, 0), null === nu && Tr(), !1;
              } catch (e) {}
            if (null !== (n = Mr(e, t, a, r)))
              return Fu(n, 0, r), Wi(n, t, r), !0;
          }
          return !1;
        }
        function ji(e, t, n, r) {
          if (
            ((r = {
              lane: 2,
              revertLane: Ac(),
              action: r,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            Ui(e))
          ) {
            if (t) throw Error(i(479));
          } else null !== (t = Mr(e, n, r, 2)) && Fu(t, 0, 2);
        }
        function Ui(e) {
          var t = e.alternate;
          return e === bo || (null !== t && t === bo);
        }
        function Bi(e, t) {
          xo = So = !0;
          var n = e.pending;
          null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)),
            (e.pending = t);
        }
        function Wi(e, t, n) {
          if (4194048 & n) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), Ce(e, n);
          }
        }
        var Hi = {
            readContext: Ea,
            use: Uo,
            useCallback: Mo,
            useContext: Mo,
            useEffect: Mo,
            useImperativeHandle: Mo,
            useLayoutEffect: Mo,
            useInsertionEffect: Mo,
            useMemo: Mo,
            useReducer: Mo,
            useRef: Mo,
            useState: Mo,
            useDebugValue: Mo,
            useDeferredValue: Mo,
            useTransition: Mo,
            useSyncExternalStore: Mo,
            useId: Mo,
            useHostTransitionStatus: Mo,
            useFormState: Mo,
            useActionState: Mo,
            useOptimistic: Mo,
            useMemoCache: Mo,
            useCacheRefresh: Mo,
          },
          $i = {
            readContext: Ea,
            use: Uo,
            useCallback: function (e, t) {
              return (Io().memoizedState = [e, void 0 === t ? null : t]), e;
            },
            useContext: Ea,
            useEffect: gi,
            useImperativeHandle: function (e, t, n) {
              (n = null != n ? n.concat([e]) : null),
                mi(4194308, 4, ki.bind(null, t, e), n);
            },
            useLayoutEffect: function (e, t) {
              return mi(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              mi(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var n = Io();
              t = void 0 === t ? null : t;
              var r = e();
              if (Po) {
                de(!0);
                try {
                  e();
                } finally {
                  de(!1);
                }
              }
              return (n.memoizedState = [r, t]), r;
            },
            useReducer: function (e, t, n) {
              var r = Io();
              if (void 0 !== n) {
                var a = n(t);
                if (Po) {
                  de(!0);
                  try {
                    n(t);
                  } finally {
                    de(!1);
                  }
                }
              } else a = t;
              return (
                (r.memoizedState = r.baseState = a),
                (e = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: a,
                }),
                (r.queue = e),
                (e = e.dispatch = _i.bind(null, bo, e)),
                [r.memoizedState, e]
              );
            },
            useRef: function (e) {
              return (e = { current: e }), (Io().memoizedState = e);
            },
            useState: function (e) {
              var t = (e = Jo(e)).queue,
                n = Ii.bind(null, bo, t);
              return (t.dispatch = n), [e.memoizedState, n];
            },
            useDebugValue: xi,
            useDeferredValue: function (e, t) {
              return Ci(Io(), e, t);
            },
            useTransition: function () {
              var e = Jo(!1);
              return (
                (e = Ai.bind(null, bo, e.queue, !0, !1)),
                (Io().memoizedState = e),
                [!1, e]
              );
            },
            useSyncExternalStore: function (e, t, n) {
              var r = bo,
                a = Io();
              if (aa) {
                if (void 0 === n) throw Error(i(407));
                n = n();
              } else {
                if (((n = t()), null === nu)) throw Error(i(349));
                124 & au || Ko(r, t, n);
              }
              a.memoizedState = n;
              var o = { value: n, getSnapshot: t };
              return (
                (a.queue = o),
                gi(Xo.bind(null, r, o, e), [e]),
                (r.flags |= 2048),
                pi(
                  9,
                  { destroy: void 0, resource: void 0 },
                  Qo.bind(null, r, o, n, t),
                  null
                ),
                n
              );
            },
            useId: function () {
              var e = Io(),
                t = nu.identifierPrefix;
              if (aa) {
                var n = Gr;
                (t =
                  "«" +
                  t +
                  "R" +
                  (n = (Xr & ~(1 << (32 - fe(Xr) - 1))).toString(32) + n)),
                  0 < (n = Eo++) && (t += "H" + n.toString(32)),
                  (t += "»");
              } else t = "«" + t + "r" + (n = Ao++).toString(32) + "»";
              return (e.memoizedState = t);
            },
            useHostTransitionStatus: zi,
            useFormState: li,
            useActionState: li,
            useOptimistic: function (e) {
              var t = Io();
              t.memoizedState = t.baseState = e;
              var n = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null,
              };
              return (
                (t.queue = n),
                (t = ji.bind(null, bo, !0, n)),
                (n.dispatch = t),
                [e, t]
              );
            },
            useMemoCache: Bo,
            useCacheRefresh: function () {
              return (Io().memoizedState = Oi.bind(null, bo));
            },
          },
          qi = {
            readContext: Ea,
            use: Uo,
            useCallback: Pi,
            useContext: Ea,
            useEffect: vi,
            useImperativeHandle: Si,
            useInsertionEffect: bi,
            useLayoutEffect: wi,
            useMemo: Ei,
            useReducer: Ho,
            useRef: hi,
            useState: function () {
              return Ho(Wo);
            },
            useDebugValue: xi,
            useDeferredValue: function (e, t) {
              return Ti(Vo(), wo.memoizedState, e, t);
            },
            useTransition: function () {
              var e = Ho(Wo)[0],
                t = Vo().memoizedState;
              return ["boolean" == typeof e ? e : jo(e), t];
            },
            useSyncExternalStore: Yo,
            useId: Ni,
            useHostTransitionStatus: zi,
            useFormState: ui,
            useActionState: ui,
            useOptimistic: function (e, t) {
              return ei(Vo(), 0, e, t);
            },
            useMemoCache: Bo,
            useCacheRefresh: Fi,
          },
          Yi = {
            readContext: Ea,
            use: Uo,
            useCallback: Pi,
            useContext: Ea,
            useEffect: vi,
            useImperativeHandle: Si,
            useInsertionEffect: bi,
            useLayoutEffect: wi,
            useMemo: Ei,
            useReducer: qo,
            useRef: hi,
            useState: function () {
              return qo(Wo);
            },
            useDebugValue: xi,
            useDeferredValue: function (e, t) {
              var n = Vo();
              return null === wo ? Ci(n, e, t) : Ti(n, wo.memoizedState, e, t);
            },
            useTransition: function () {
              var e = qo(Wo)[0],
                t = Vo().memoizedState;
              return ["boolean" == typeof e ? e : jo(e), t];
            },
            useSyncExternalStore: Yo,
            useId: Ni,
            useHostTransitionStatus: zi,
            useFormState: fi,
            useActionState: fi,
            useOptimistic: function (e, t) {
              var n = Vo();
              return null !== wo
                ? ei(n, 0, e, t)
                : ((n.baseState = e), [e, n.queue.dispatch]);
            },
            useMemoCache: Bo,
            useCacheRefresh: Fi,
          },
          Ki = null,
          Qi = 0;
        function Xi(e) {
          var t = Qi;
          return (Qi += 1), null === Ki && (Ki = []), Xa(Ki, e, t);
        }
        function Gi(e, t) {
          (t = t.props.ref), (e.ref = void 0 !== t ? t : null);
        }
        function Zi(e, t) {
          if (t.$$typeof === f) throw Error(i(525));
          throw (
            ((e = Object.prototype.toString.call(t)),
            Error(
              i(
                31,
                "[object Object]" === e
                  ? "object with keys {" + Object.keys(t).join(", ") + "}"
                  : e
              )
            ))
          );
        }
        function Ji(e) {
          return (0, e._init)(e._payload);
        }
        function es(e) {
          function t(t, n) {
            if (e) {
              var r = t.deletions;
              null === r ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n);
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r; ) t(n, r), (r = r.sibling);
            return null;
          }
          function r(e) {
            for (var t = new Map(); null !== e; )
              null !== e.key ? t.set(e.key, e) : t.set(e.index, e),
                (e = e.sibling);
            return t;
          }
          function a(e, t) {
            return ((e = _r(e, t)).index = 0), (e.sibling = null), e;
          }
          function o(t, n, r) {
            return (
              (t.index = r),
              e
                ? null !== (r = t.alternate)
                  ? (r = r.index) < n
                    ? ((t.flags |= 67108866), n)
                    : r
                  : ((t.flags |= 67108866), n)
                : ((t.flags |= 1048576), n)
            );
          }
          function s(t) {
            return e && null === t.alternate && (t.flags |= 67108866), t;
          }
          function l(e, t, n, r) {
            return null === t || 6 !== t.tag
              ? (((t = Ur(n, e.mode, r)).return = e), t)
              : (((t = a(t, n)).return = e), t);
          }
          function u(e, t, n, r) {
            var o = n.type;
            return o === m
              ? d(e, t, n.props.children, r, n.key)
              : null !== t &&
                (t.elementType === o ||
                  ("object" == typeof o &&
                    null !== o &&
                    o.$$typeof === E &&
                    Ji(o) === t.type))
              ? (Gi((t = a(t, n.props)), n), (t.return = e), t)
              : (Gi((t = Vr(n.type, n.key, n.props, null, e.mode, r)), n),
                (t.return = e),
                t);
          }
          function c(e, t, n, r) {
            return null === t ||
              4 !== t.tag ||
              t.stateNode.containerInfo !== n.containerInfo ||
              t.stateNode.implementation !== n.implementation
              ? (((t = Br(n, e.mode, r)).return = e), t)
              : (((t = a(t, n.children || [])).return = e), t);
          }
          function d(e, t, n, r, o) {
            return null === t || 7 !== t.tag
              ? (((t = jr(n, e.mode, r, o)).return = e), t)
              : (((t = a(t, n)).return = e), t);
          }
          function f(e, t, n) {
            if (
              ("string" == typeof t && "" !== t) ||
              "number" == typeof t ||
              "bigint" == typeof t
            )
              return ((t = Ur("" + t, e.mode, n)).return = e), t;
            if ("object" == typeof t && null !== t) {
              switch (t.$$typeof) {
                case p:
                  return (
                    Gi((n = Vr(t.type, t.key, t.props, null, e.mode, n)), t),
                    (n.return = e),
                    n
                  );
                case h:
                  return ((t = Br(t, e.mode, n)).return = e), t;
                case E:
                  return f(e, (t = (0, t._init)(t._payload)), n);
              }
              if (R(t) || M(t))
                return ((t = jr(t, e.mode, n, null)).return = e), t;
              if ("function" == typeof t.then) return f(e, Xi(t), n);
              if (t.$$typeof === w) return f(e, Ca(e, t), n);
              Zi(e, t);
            }
            return null;
          }
          function y(e, t, n, r) {
            var a = null !== t ? t.key : null;
            if (
              ("string" == typeof n && "" !== n) ||
              "number" == typeof n ||
              "bigint" == typeof n
            )
              return null !== a ? null : l(e, t, "" + n, r);
            if ("object" == typeof n && null !== n) {
              switch (n.$$typeof) {
                case p:
                  return n.key === a ? u(e, t, n, r) : null;
                case h:
                  return n.key === a ? c(e, t, n, r) : null;
                case E:
                  return y(e, t, (n = (a = n._init)(n._payload)), r);
              }
              if (R(n) || M(n)) return null !== a ? null : d(e, t, n, r, null);
              if ("function" == typeof n.then) return y(e, t, Xi(n), r);
              if (n.$$typeof === w) return y(e, t, Ca(e, n), r);
              Zi(e, n);
            }
            return null;
          }
          function g(e, t, n, r, a) {
            if (
              ("string" == typeof r && "" !== r) ||
              "number" == typeof r ||
              "bigint" == typeof r
            )
              return l(t, (e = e.get(n) || null), "" + r, a);
            if ("object" == typeof r && null !== r) {
              switch (r.$$typeof) {
                case p:
                  return u(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    a
                  );
                case h:
                  return c(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    a
                  );
                case E:
                  return g(e, t, n, (r = (0, r._init)(r._payload)), a);
              }
              if (R(r) || M(r)) return d(t, (e = e.get(n) || null), r, a, null);
              if ("function" == typeof r.then) return g(e, t, n, Xi(r), a);
              if (r.$$typeof === w) return g(e, t, n, Ca(t, r), a);
              Zi(t, r);
            }
            return null;
          }
          function v(l, u, c, d) {
            if (
              ("object" == typeof c &&
                null !== c &&
                c.type === m &&
                null === c.key &&
                (c = c.props.children),
              "object" == typeof c && null !== c)
            ) {
              switch (c.$$typeof) {
                case p:
                  e: {
                    for (var b = c.key; null !== u; ) {
                      if (u.key === b) {
                        if ((b = c.type) === m) {
                          if (7 === u.tag) {
                            n(l, u.sibling),
                              ((d = a(u, c.props.children)).return = l),
                              (l = d);
                            break e;
                          }
                        } else if (
                          u.elementType === b ||
                          ("object" == typeof b &&
                            null !== b &&
                            b.$$typeof === E &&
                            Ji(b) === u.type)
                        ) {
                          n(l, u.sibling),
                            Gi((d = a(u, c.props)), c),
                            (d.return = l),
                            (l = d);
                          break e;
                        }
                        n(l, u);
                        break;
                      }
                      t(l, u), (u = u.sibling);
                    }
                    c.type === m
                      ? (((d = jr(c.props.children, l.mode, d, c.key)).return =
                          l),
                        (l = d))
                      : (Gi(
                          (d = Vr(c.type, c.key, c.props, null, l.mode, d)),
                          c
                        ),
                        (d.return = l),
                        (l = d));
                  }
                  return s(l);
                case h:
                  e: {
                    for (b = c.key; null !== u; ) {
                      if (u.key === b) {
                        if (
                          4 === u.tag &&
                          u.stateNode.containerInfo === c.containerInfo &&
                          u.stateNode.implementation === c.implementation
                        ) {
                          n(l, u.sibling),
                            ((d = a(u, c.children || [])).return = l),
                            (l = d);
                          break e;
                        }
                        n(l, u);
                        break;
                      }
                      t(l, u), (u = u.sibling);
                    }
                    ((d = Br(c, l.mode, d)).return = l), (l = d);
                  }
                  return s(l);
                case E:
                  return v(l, u, (c = (b = c._init)(c._payload)), d);
              }
              if (R(c))
                return (function (a, i, s, l) {
                  for (
                    var u = null, c = null, d = i, p = (i = 0), h = null;
                    null !== d && p < s.length;
                    p++
                  ) {
                    d.index > p ? ((h = d), (d = null)) : (h = d.sibling);
                    var m = y(a, d, s[p], l);
                    if (null === m) {
                      null === d && (d = h);
                      break;
                    }
                    e && d && null === m.alternate && t(a, d),
                      (i = o(m, i, p)),
                      null === c ? (u = m) : (c.sibling = m),
                      (c = m),
                      (d = h);
                  }
                  if (p === s.length) return n(a, d), aa && Zr(a, p), u;
                  if (null === d) {
                    for (; p < s.length; p++)
                      null !== (d = f(a, s[p], l)) &&
                        ((i = o(d, i, p)),
                        null === c ? (u = d) : (c.sibling = d),
                        (c = d));
                    return aa && Zr(a, p), u;
                  }
                  for (d = r(d); p < s.length; p++)
                    null !== (h = g(d, a, p, s[p], l)) &&
                      (e &&
                        null !== h.alternate &&
                        d.delete(null === h.key ? p : h.key),
                      (i = o(h, i, p)),
                      null === c ? (u = h) : (c.sibling = h),
                      (c = h));
                  return (
                    e &&
                      d.forEach(function (e) {
                        return t(a, e);
                      }),
                    aa && Zr(a, p),
                    u
                  );
                })(l, u, c, d);
              if (M(c)) {
                if ("function" != typeof (b = M(c))) throw Error(i(150));
                return (function (a, s, l, u) {
                  if (null == l) throw Error(i(151));
                  for (
                    var c = null,
                      d = null,
                      p = s,
                      h = (s = 0),
                      m = null,
                      v = l.next();
                    null !== p && !v.done;
                    h++, v = l.next()
                  ) {
                    p.index > h ? ((m = p), (p = null)) : (m = p.sibling);
                    var b = y(a, p, v.value, u);
                    if (null === b) {
                      null === p && (p = m);
                      break;
                    }
                    e && p && null === b.alternate && t(a, p),
                      (s = o(b, s, h)),
                      null === d ? (c = b) : (d.sibling = b),
                      (d = b),
                      (p = m);
                  }
                  if (v.done) return n(a, p), aa && Zr(a, h), c;
                  if (null === p) {
                    for (; !v.done; h++, v = l.next())
                      null !== (v = f(a, v.value, u)) &&
                        ((s = o(v, s, h)),
                        null === d ? (c = v) : (d.sibling = v),
                        (d = v));
                    return aa && Zr(a, h), c;
                  }
                  for (p = r(p); !v.done; h++, v = l.next())
                    null !== (v = g(p, a, h, v.value, u)) &&
                      (e &&
                        null !== v.alternate &&
                        p.delete(null === v.key ? h : v.key),
                      (s = o(v, s, h)),
                      null === d ? (c = v) : (d.sibling = v),
                      (d = v));
                  return (
                    e &&
                      p.forEach(function (e) {
                        return t(a, e);
                      }),
                    aa && Zr(a, h),
                    c
                  );
                })(l, u, (c = b.call(c)), d);
              }
              if ("function" == typeof c.then) return v(l, u, Xi(c), d);
              if (c.$$typeof === w) return v(l, u, Ca(l, c), d);
              Zi(l, c);
            }
            return ("string" == typeof c && "" !== c) ||
              "number" == typeof c ||
              "bigint" == typeof c
              ? ((c = "" + c),
                null !== u && 6 === u.tag
                  ? (n(l, u.sibling), ((d = a(u, c)).return = l), (l = d))
                  : (n(l, u), ((d = Ur(c, l.mode, d)).return = l), (l = d)),
                s(l))
              : n(l, u);
          }
          return function (e, t, n, r) {
            try {
              Qi = 0;
              var a = v(e, t, n, r);
              return (Ki = null), a;
            } catch (t) {
              if (t === Ha || t === qa) throw t;
              var o = Fr(29, t, null, e.mode);
              return (o.lanes = r), (o.return = e), o;
            }
          };
        }
        var ts = es(!0),
          ns = es(!1),
          rs = I(null),
          as = null;
        function os(e) {
          var t = e.alternate;
          j(us, 1 & us.current),
            j(rs, e),
            null === as &&
              (null === t || null !== po.current || null !== t.memoizedState) &&
              (as = e);
        }
        function is(e) {
          if (22 === e.tag) {
            if ((j(us, us.current), j(rs, e), null === as)) {
              var t = e.alternate;
              null !== t && null !== t.memoizedState && (as = e);
            }
          } else ss();
        }
        function ss() {
          j(us, us.current), j(rs, rs.current);
        }
        function ls(e) {
          V(rs), as === e && (as = null), V(us);
        }
        var us = I(0);
        function cs(e) {
          for (var t = e; null !== t; ) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (
                null !== n &&
                (null === (n = n.dehydrated) || "$?" === n.data || md(n))
              )
                return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (128 & t.flags) return t;
            } else if (null !== t.child) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
          return null;
        }
        function ds(e, t, n, r) {
          (n = null == (n = n(r, (t = e.memoizedState))) ? t : d({}, t, n)),
            (e.memoizedState = n),
            0 === e.lanes && (e.updateQueue.baseState = n);
        }
        var fs = {
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = zu(),
              a = ro(r);
            (a.payload = t),
              null != n && (a.callback = n),
              null !== (t = ao(e, a, r)) && (Fu(t, 0, r), oo(t, e, r));
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = zu(),
              a = ro(r);
            (a.tag = 1),
              (a.payload = t),
              null != n && (a.callback = n),
              null !== (t = ao(e, a, r)) && (Fu(t, 0, r), oo(t, e, r));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = zu(),
              r = ro(n);
            (r.tag = 2),
              null != t && (r.callback = t),
              null !== (t = ao(e, r, n)) && (Fu(t, 0, n), oo(t, e, n));
          },
        };
        function ps(e, t, n, r, a, o, i) {
          return "function" == typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, o, i)
            : !(
                t.prototype &&
                t.prototype.isPureReactComponent &&
                Qn(n, r) &&
                Qn(a, o)
              );
        }
        function hs(e, t, n, r) {
          (e = t.state),
            "function" == typeof t.componentWillReceiveProps &&
              t.componentWillReceiveProps(n, r),
            "function" == typeof t.UNSAFE_componentWillReceiveProps &&
              t.UNSAFE_componentWillReceiveProps(n, r),
            t.state !== e && fs.enqueueReplaceState(t, t.state, null);
        }
        function ms(e, t) {
          var n = t;
          if ("ref" in t)
            for (var r in ((n = {}), t)) "ref" !== r && (n[r] = t[r]);
          if ((e = e.defaultProps))
            for (var a in (n === t && (n = d({}, n)), e))
              void 0 === n[a] && (n[a] = e[a]);
          return n;
        }
        var ys =
          "function" == typeof reportError
            ? reportError
            : function (e) {
                if (
                  "object" == typeof window &&
                  "function" == typeof window.ErrorEvent
                ) {
                  var t = new window.ErrorEvent("error", {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      "object" == typeof e &&
                      null !== e &&
                      "string" == typeof e.message
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  "object" == typeof process &&
                  "function" == typeof process.emit
                )
                  return void process.emit("uncaughtException", e);
                console.error(e);
              };
        function gs(e) {
          ys(e);
        }
        function vs(e) {
          console.error(e);
        }
        function bs(e) {
          ys(e);
        }
        function ws(e, t) {
          try {
            (0, e.onUncaughtError)(t.value, { componentStack: t.stack });
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }
        function ks(e, t, n) {
          try {
            (0, e.onCaughtError)(n.value, {
              componentStack: n.stack,
              errorBoundary: 1 === t.tag ? t.stateNode : null,
            });
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }
        function Ss(e, t, n) {
          return (
            ((n = ro(n)).tag = 3),
            (n.payload = { element: null }),
            (n.callback = function () {
              ws(e, t);
            }),
            n
          );
        }
        function xs(e) {
          return ((e = ro(e)).tag = 3), e;
        }
        function Ps(e, t, n, r) {
          var a = n.type.getDerivedStateFromError;
          if ("function" == typeof a) {
            var o = r.value;
            (e.payload = function () {
              return a(o);
            }),
              (e.callback = function () {
                ks(t, n, r);
              });
          }
          var i = n.stateNode;
          null !== i &&
            "function" == typeof i.componentDidCatch &&
            (e.callback = function () {
              ks(t, n, r),
                "function" != typeof a &&
                  (null === xu ? (xu = new Set([this])) : xu.add(this));
              var e = r.stack;
              this.componentDidCatch(r.value, {
                componentStack: null !== e ? e : "",
              });
            });
        }
        var Es = Error(i(461)),
          Cs = !1;
        function Ts(e, t, n, r) {
          t.child = null === e ? ns(t, null, n, r) : ts(t, e.child, n, r);
        }
        function As(e, t, n, r, a) {
          n = n.render;
          var o = t.ref;
          if ("ref" in r) {
            var i = {};
            for (var s in r) "ref" !== s && (i[s] = r[s]);
          } else i = r;
          return (
            Pa(t),
            (r = Do(e, t, n, i, o, a)),
            (s = Fo()),
            null === e || Cs
              ? (aa && s && ea(t), (t.flags |= 1), Ts(e, t, r, a), t.child)
              : (Oo(e, t, a), Ks(e, t, a))
          );
        }
        function Ms(e, t, n, r, a) {
          if (null === e) {
            var o = n.type;
            return "function" != typeof o ||
              Or(o) ||
              void 0 !== o.defaultProps ||
              null !== n.compare
              ? (((e = Vr(n.type, null, r, t, t.mode, a)).ref = t.ref),
                (e.return = t),
                (t.child = e))
              : ((t.tag = 15), (t.type = o), Ls(e, t, o, r, a));
          }
          if (((o = e.child), !Qs(e, a))) {
            var i = o.memoizedProps;
            if (
              (n = null !== (n = n.compare) ? n : Qn)(i, r) &&
              e.ref === t.ref
            )
              return Ks(e, t, a);
          }
          return (
            (t.flags |= 1),
            ((e = _r(o, r)).ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function Ls(e, t, n, r, a) {
          if (null !== e) {
            var o = e.memoizedProps;
            if (Qn(o, r) && e.ref === t.ref) {
              if (((Cs = !1), (t.pendingProps = r = o), !Qs(e, a)))
                return (t.lanes = e.lanes), Ks(e, t, a);
              131072 & e.flags && (Cs = !0);
            }
          }
          return Ns(e, t, n, r, a);
        }
        function Ds(e, t, n) {
          var r = t.pendingProps,
            a = r.children,
            o = null !== e ? e.memoizedState : null;
          if ("hidden" === r.mode) {
            if (128 & t.flags) {
              if (((r = null !== o ? o.baseLanes | n : n), null !== e)) {
                for (a = t.child = e.child, o = 0; null !== a; )
                  (o = o | a.lanes | a.childLanes), (a = a.sibling);
                t.childLanes = o & ~r;
              } else (t.childLanes = 0), (t.child = null);
              return Rs(e, t, r, n);
            }
            if (!(536870912 & n))
              return (
                (t.lanes = t.childLanes = 536870912),
                Rs(e, t, null !== o ? o.baseLanes | n : n, n)
              );
            (t.memoizedState = { baseLanes: 0, cachePool: null }),
              null !== e && Ba(0, null !== o ? o.cachePool : null),
              null !== o ? mo(t, o) : yo(),
              is(t);
          } else
            null !== o
              ? (Ba(0, o.cachePool), mo(t, o), ss(), (t.memoizedState = null))
              : (null !== e && Ba(0, null), yo(), ss());
          return Ts(e, t, a, n), t.child;
        }
        function Rs(e, t, n, r) {
          var a = Ua();
          return (
            (a = null === a ? null : { parent: Da._currentValue, pool: a }),
            (t.memoizedState = { baseLanes: n, cachePool: a }),
            null !== e && Ba(0, null),
            yo(),
            is(t),
            null !== e && Sa(e, t, r, !0),
            null
          );
        }
        function zs(e, t) {
          var n = t.ref;
          if (null === n) null !== e && null !== e.ref && (t.flags |= 4194816);
          else {
            if ("function" != typeof n && "object" != typeof n)
              throw Error(i(284));
            (null !== e && e.ref === n) || (t.flags |= 4194816);
          }
        }
        function Ns(e, t, n, r, a) {
          return (
            Pa(t),
            (n = Do(e, t, n, r, void 0, a)),
            (r = Fo()),
            null === e || Cs
              ? (aa && r && ea(t), (t.flags |= 1), Ts(e, t, n, a), t.child)
              : (Oo(e, t, a), Ks(e, t, a))
          );
        }
        function Fs(e, t, n, r, a, o) {
          return (
            Pa(t),
            (t.updateQueue = null),
            (n = zo(t, r, n, a)),
            Ro(e),
            (r = Fo()),
            null === e || Cs
              ? (aa && r && ea(t), (t.flags |= 1), Ts(e, t, n, o), t.child)
              : (Oo(e, t, o), Ks(e, t, o))
          );
        }
        function Os(e, t, n, r, a) {
          if ((Pa(t), null === t.stateNode)) {
            var o = zr,
              i = n.contextType;
            "object" == typeof i && null !== i && (o = Ea(i)),
              (o = new n(r, o)),
              (t.memoizedState =
                null !== o.state && void 0 !== o.state ? o.state : null),
              (o.updater = fs),
              (t.stateNode = o),
              (o._reactInternals = t),
              ((o = t.stateNode).props = r),
              (o.state = t.memoizedState),
              (o.refs = {}),
              to(t),
              (i = n.contextType),
              (o.context = "object" == typeof i && null !== i ? Ea(i) : zr),
              (o.state = t.memoizedState),
              "function" == typeof (i = n.getDerivedStateFromProps) &&
                (ds(t, n, i, r), (o.state = t.memoizedState)),
              "function" == typeof n.getDerivedStateFromProps ||
                "function" == typeof o.getSnapshotBeforeUpdate ||
                ("function" != typeof o.UNSAFE_componentWillMount &&
                  "function" != typeof o.componentWillMount) ||
                ((i = o.state),
                "function" == typeof o.componentWillMount &&
                  o.componentWillMount(),
                "function" == typeof o.UNSAFE_componentWillMount &&
                  o.UNSAFE_componentWillMount(),
                i !== o.state && fs.enqueueReplaceState(o, o.state, null),
                uo(t, r, o, a),
                lo(),
                (o.state = t.memoizedState)),
              "function" == typeof o.componentDidMount && (t.flags |= 4194308),
              (r = !0);
          } else if (null === e) {
            o = t.stateNode;
            var s = t.memoizedProps,
              l = ms(n, s);
            o.props = l;
            var u = o.context,
              c = n.contextType;
            (i = zr), "object" == typeof c && null !== c && (i = Ea(c));
            var d = n.getDerivedStateFromProps;
            (c =
              "function" == typeof d ||
              "function" == typeof o.getSnapshotBeforeUpdate),
              (s = t.pendingProps !== s),
              c ||
                ("function" != typeof o.UNSAFE_componentWillReceiveProps &&
                  "function" != typeof o.componentWillReceiveProps) ||
                ((s || u !== i) && hs(t, o, r, i)),
              (eo = !1);
            var f = t.memoizedState;
            (o.state = f),
              uo(t, r, o, a),
              lo(),
              (u = t.memoizedState),
              s || f !== u || eo
                ? ("function" == typeof d &&
                    (ds(t, n, d, r), (u = t.memoizedState)),
                  (l = eo || ps(t, n, l, r, f, u, i))
                    ? (c ||
                        ("function" != typeof o.UNSAFE_componentWillMount &&
                          "function" != typeof o.componentWillMount) ||
                        ("function" == typeof o.componentWillMount &&
                          o.componentWillMount(),
                        "function" == typeof o.UNSAFE_componentWillMount &&
                          o.UNSAFE_componentWillMount()),
                      "function" == typeof o.componentDidMount &&
                        (t.flags |= 4194308))
                    : ("function" == typeof o.componentDidMount &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = u)),
                  (o.props = r),
                  (o.state = u),
                  (o.context = i),
                  (r = l))
                : ("function" == typeof o.componentDidMount &&
                    (t.flags |= 4194308),
                  (r = !1));
          } else {
            (o = t.stateNode),
              no(e, t),
              (c = ms(n, (i = t.memoizedProps))),
              (o.props = c),
              (d = t.pendingProps),
              (f = o.context),
              (u = n.contextType),
              (l = zr),
              "object" == typeof u && null !== u && (l = Ea(u)),
              (u =
                "function" == typeof (s = n.getDerivedStateFromProps) ||
                "function" == typeof o.getSnapshotBeforeUpdate) ||
                ("function" != typeof o.UNSAFE_componentWillReceiveProps &&
                  "function" != typeof o.componentWillReceiveProps) ||
                ((i !== d || f !== l) && hs(t, o, r, l)),
              (eo = !1),
              (f = t.memoizedState),
              (o.state = f),
              uo(t, r, o, a),
              lo();
            var p = t.memoizedState;
            i !== d ||
            f !== p ||
            eo ||
            (null !== e && null !== e.dependencies && xa(e.dependencies))
              ? ("function" == typeof s &&
                  (ds(t, n, s, r), (p = t.memoizedState)),
                (c =
                  eo ||
                  ps(t, n, c, r, f, p, l) ||
                  (null !== e && null !== e.dependencies && xa(e.dependencies)))
                  ? (u ||
                      ("function" != typeof o.UNSAFE_componentWillUpdate &&
                        "function" != typeof o.componentWillUpdate) ||
                      ("function" == typeof o.componentWillUpdate &&
                        o.componentWillUpdate(r, p, l),
                      "function" == typeof o.UNSAFE_componentWillUpdate &&
                        o.UNSAFE_componentWillUpdate(r, p, l)),
                    "function" == typeof o.componentDidUpdate && (t.flags |= 4),
                    "function" == typeof o.getSnapshotBeforeUpdate &&
                      (t.flags |= 1024))
                  : ("function" != typeof o.componentDidUpdate ||
                      (i === e.memoizedProps && f === e.memoizedState) ||
                      (t.flags |= 4),
                    "function" != typeof o.getSnapshotBeforeUpdate ||
                      (i === e.memoizedProps && f === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = p)),
                (o.props = r),
                (o.state = p),
                (o.context = l),
                (r = c))
              : ("function" != typeof o.componentDidUpdate ||
                  (i === e.memoizedProps && f === e.memoizedState) ||
                  (t.flags |= 4),
                "function" != typeof o.getSnapshotBeforeUpdate ||
                  (i === e.memoizedProps && f === e.memoizedState) ||
                  (t.flags |= 1024),
                (r = !1));
          }
          return (
            (o = r),
            zs(e, t),
            (r = !!(128 & t.flags)),
            o || r
              ? ((o = t.stateNode),
                (n =
                  r && "function" != typeof n.getDerivedStateFromError
                    ? null
                    : o.render()),
                (t.flags |= 1),
                null !== e && r
                  ? ((t.child = ts(t, e.child, null, a)),
                    (t.child = ts(t, null, n, a)))
                  : Ts(e, t, n, a),
                (t.memoizedState = o.state),
                (e = t.child))
              : (e = Ks(e, t, a)),
            e
          );
        }
        function _s(e, t, n, r) {
          return fa(), (t.flags |= 256), Ts(e, t, n, r), t.child;
        }
        var Is = {
          dehydrated: null,
          treeContext: null,
          retryLane: 0,
          hydrationErrors: null,
        };
        function Vs(e) {
          return { baseLanes: e, cachePool: Wa() };
        }
        function js(e, t, n) {
          return (e = null !== e ? e.childLanes & ~n : 0), t && (e |= mu), e;
        }
        function Us(e, t, n) {
          var r,
            a = t.pendingProps,
            o = !1,
            s = !!(128 & t.flags);
          if (
            ((r = s) ||
              (r =
                (null === e || null !== e.memoizedState) && !!(2 & us.current)),
            r && ((o = !0), (t.flags &= -129)),
            (r = !!(32 & t.flags)),
            (t.flags &= -33),
            null === e)
          ) {
            if (aa) {
              if ((o ? os(t) : ss(), aa)) {
                var l,
                  u = ra;
                if ((l = u)) {
                  e: {
                    for (l = u, u = ia; 8 !== l.nodeType; ) {
                      if (!u) {
                        u = null;
                        break e;
                      }
                      if (null === (l = yd(l.nextSibling))) {
                        u = null;
                        break e;
                      }
                    }
                    u = l;
                  }
                  null !== u
                    ? ((t.memoizedState = {
                        dehydrated: u,
                        treeContext:
                          null !== Qr ? { id: Xr, overflow: Gr } : null,
                        retryLane: 536870912,
                        hydrationErrors: null,
                      }),
                      ((l = Fr(18, null, null, 0)).stateNode = u),
                      (l.return = t),
                      (t.child = l),
                      (na = t),
                      (ra = null),
                      (l = !0))
                    : (l = !1);
                }
                l || la(t);
              }
              if (null !== (u = t.memoizedState) && null !== (u = u.dehydrated))
                return md(u) ? (t.lanes = 32) : (t.lanes = 536870912), null;
              ls(t);
            }
            return (
              (u = a.children),
              (a = a.fallback),
              o
                ? (ss(),
                  (u = Ws({ mode: "hidden", children: u }, (o = t.mode))),
                  (a = jr(a, o, n, null)),
                  (u.return = t),
                  (a.return = t),
                  (u.sibling = a),
                  (t.child = u),
                  ((o = t.child).memoizedState = Vs(n)),
                  (o.childLanes = js(e, r, n)),
                  (t.memoizedState = Is),
                  a)
                : (os(t), Bs(t, u))
            );
          }
          if (null !== (l = e.memoizedState) && null !== (u = l.dehydrated)) {
            if (s)
              256 & t.flags
                ? (os(t), (t.flags &= -257), (t = Hs(e, t, n)))
                : null !== t.memoizedState
                ? (ss(), (t.child = e.child), (t.flags |= 128), (t = null))
                : (ss(),
                  (o = a.fallback),
                  (u = t.mode),
                  (a = Ws({ mode: "visible", children: a.children }, u)),
                  ((o = jr(o, u, n, null)).flags |= 2),
                  (a.return = t),
                  (o.return = t),
                  (a.sibling = o),
                  (t.child = a),
                  ts(t, e.child, null, n),
                  ((a = t.child).memoizedState = Vs(n)),
                  (a.childLanes = js(e, r, n)),
                  (t.memoizedState = Is),
                  (t = o));
            else if ((os(t), md(u))) {
              if ((r = u.nextSibling && u.nextSibling.dataset)) var c = r.dgst;
              (r = c),
                ((a = Error(i(419))).stack = ""),
                (a.digest = r),
                ha({ value: a, source: null, stack: null }),
                (t = Hs(e, t, n));
            } else if (
              (Cs || Sa(e, t, n, !1), (r = !!(n & e.childLanes)), Cs || r)
            ) {
              if (
                null !== (r = nu) &&
                0 !==
                  (a =
                    (a = 42 & (a = n & -n) ? 1 : Te(a)) & (r.suspendedLanes | n)
                      ? 0
                      : a) &&
                a !== l.retryLane
              )
                throw ((l.retryLane = a), Lr(e, a), Fu(r, 0, a), Es);
              "$?" === u.data || qu(), (t = Hs(e, t, n));
            } else
              "$?" === u.data
                ? ((t.flags |= 192), (t.child = e.child), (t = null))
                : ((e = l.treeContext),
                  (ra = yd(u.nextSibling)),
                  (na = t),
                  (aa = !0),
                  (oa = null),
                  (ia = !1),
                  null !== e &&
                    ((Yr[Kr++] = Xr),
                    (Yr[Kr++] = Gr),
                    (Yr[Kr++] = Qr),
                    (Xr = e.id),
                    (Gr = e.overflow),
                    (Qr = t)),
                  ((t = Bs(t, a.children)).flags |= 4096));
            return t;
          }
          return o
            ? (ss(),
              (o = a.fallback),
              (u = t.mode),
              (c = (l = e.child).sibling),
              ((a = _r(l, {
                mode: "hidden",
                children: a.children,
              })).subtreeFlags = 65011712 & l.subtreeFlags),
              null !== c
                ? (o = _r(c, o))
                : ((o = jr(o, u, n, null)).flags |= 2),
              (o.return = t),
              (a.return = t),
              (a.sibling = o),
              (t.child = a),
              (a = o),
              (o = t.child),
              null === (u = e.child.memoizedState)
                ? (u = Vs(n))
                : (null !== (l = u.cachePool)
                    ? ((c = Da._currentValue),
                      (l = l.parent !== c ? { parent: c, pool: c } : l))
                    : (l = Wa()),
                  (u = { baseLanes: u.baseLanes | n, cachePool: l })),
              (o.memoizedState = u),
              (o.childLanes = js(e, r, n)),
              (t.memoizedState = Is),
              a)
            : (os(t),
              (e = (n = e.child).sibling),
              ((n = _r(n, { mode: "visible", children: a.children })).return =
                t),
              (n.sibling = null),
              null !== e &&
                (null === (r = t.deletions)
                  ? ((t.deletions = [e]), (t.flags |= 16))
                  : r.push(e)),
              (t.child = n),
              (t.memoizedState = null),
              n);
        }
        function Bs(e, t) {
          return (
            ((t = Ws({ mode: "visible", children: t }, e.mode)).return = e),
            (e.child = t)
          );
        }
        function Ws(e, t) {
          return (
            ((e = Fr(22, e, null, t)).lanes = 0),
            (e.stateNode = {
              _visibility: 1,
              _pendingMarkers: null,
              _retryCache: null,
              _transitions: null,
            }),
            e
          );
        }
        function Hs(e, t, n) {
          return (
            ts(t, e.child, null, n),
            ((e = Bs(t, t.pendingProps.children)).flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function $s(e, t, n) {
          e.lanes |= t;
          var r = e.alternate;
          null !== r && (r.lanes |= t), wa(e.return, t, n);
        }
        function qs(e, t, n, r, a) {
          var o = e.memoizedState;
          null === o
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: a,
              })
            : ((o.isBackwards = t),
              (o.rendering = null),
              (o.renderingStartTime = 0),
              (o.last = r),
              (o.tail = n),
              (o.tailMode = a));
        }
        function Ys(e, t, n) {
          var r = t.pendingProps,
            a = r.revealOrder,
            o = r.tail;
          if ((Ts(e, t, r.children, n), 2 & (r = us.current)))
            (r = (1 & r) | 2), (t.flags |= 128);
          else {
            if (null !== e && 128 & e.flags)
              e: for (e = t.child; null !== e; ) {
                if (13 === e.tag) null !== e.memoizedState && $s(e, n, t);
                else if (19 === e.tag) $s(e, n, t);
                else if (null !== e.child) {
                  (e.child.return = e), (e = e.child);
                  continue;
                }
                if (e === t) break e;
                for (; null === e.sibling; ) {
                  if (null === e.return || e.return === t) break e;
                  e = e.return;
                }
                (e.sibling.return = e.return), (e = e.sibling);
              }
            r &= 1;
          }
          switch ((j(us, r), a)) {
            case "forwards":
              for (n = t.child, a = null; null !== n; )
                null !== (e = n.alternate) && null === cs(e) && (a = n),
                  (n = n.sibling);
              null === (n = a)
                ? ((a = t.child), (t.child = null))
                : ((a = n.sibling), (n.sibling = null)),
                qs(t, !1, a, n, o);
              break;
            case "backwards":
              for (n = null, a = t.child, t.child = null; null !== a; ) {
                if (null !== (e = a.alternate) && null === cs(e)) {
                  t.child = a;
                  break;
                }
                (e = a.sibling), (a.sibling = n), (n = a), (a = e);
              }
              qs(t, !0, n, null, o);
              break;
            case "together":
              qs(t, !1, null, null, void 0);
              break;
            default:
              t.memoizedState = null;
          }
          return t.child;
        }
        function Ks(e, t, n) {
          if (
            (null !== e && (t.dependencies = e.dependencies),
            (fu |= t.lanes),
            !(n & t.childLanes))
          ) {
            if (null === e) return null;
            if ((Sa(e, t, n, !1), !(n & t.childLanes))) return null;
          }
          if (null !== e && t.child !== e.child) throw Error(i(153));
          if (null !== t.child) {
            for (
              n = _r((e = t.child), e.pendingProps), t.child = n, n.return = t;
              null !== e.sibling;

            )
              (e = e.sibling),
                ((n = n.sibling = _r(e, e.pendingProps)).return = t);
            n.sibling = null;
          }
          return t.child;
        }
        function Qs(e, t) {
          return !!(e.lanes & t) || !(null === (e = e.dependencies) || !xa(e));
        }
        function Xs(e, t, n) {
          if (null !== e)
            if (e.memoizedProps !== t.pendingProps) Cs = !0;
            else {
              if (!(Qs(e, n) || 128 & t.flags))
                return (
                  (Cs = !1),
                  (function (e, t, n) {
                    switch (t.tag) {
                      case 3:
                        $(t, t.stateNode.containerInfo),
                          va(0, Da, e.memoizedState.cache),
                          fa();
                        break;
                      case 27:
                      case 5:
                        Y(t);
                        break;
                      case 4:
                        $(t, t.stateNode.containerInfo);
                        break;
                      case 10:
                        va(0, t.type, t.memoizedProps.value);
                        break;
                      case 13:
                        var r = t.memoizedState;
                        if (null !== r)
                          return null !== r.dehydrated
                            ? (os(t), (t.flags |= 128), null)
                            : n & t.child.childLanes
                            ? Us(e, t, n)
                            : (os(t),
                              null !== (e = Ks(e, t, n)) ? e.sibling : null);
                        os(t);
                        break;
                      case 19:
                        var a = !!(128 & e.flags);
                        if (
                          ((r = !!(n & t.childLanes)) ||
                            (Sa(e, t, n, !1), (r = !!(n & t.childLanes))),
                          a)
                        ) {
                          if (r) return Ys(e, t, n);
                          t.flags |= 128;
                        }
                        if (
                          (null !== (a = t.memoizedState) &&
                            ((a.rendering = null),
                            (a.tail = null),
                            (a.lastEffect = null)),
                          j(us, us.current),
                          r)
                        )
                          break;
                        return null;
                      case 22:
                      case 23:
                        return (t.lanes = 0), Ds(e, t, n);
                      case 24:
                        va(0, Da, e.memoizedState.cache);
                    }
                    return Ks(e, t, n);
                  })(e, t, n)
                );
              Cs = !!(131072 & e.flags);
            }
          else (Cs = !1), aa && 1048576 & t.flags && Jr(t, qr, t.index);
          switch (((t.lanes = 0), t.tag)) {
            case 16:
              e: {
                e = t.pendingProps;
                var r = t.elementType,
                  a = r._init;
                if (
                  ((r = a(r._payload)), (t.type = r), "function" != typeof r)
                ) {
                  if (null != r) {
                    if ((a = r.$$typeof) === k) {
                      (t.tag = 11), (t = As(null, t, r, e, n));
                      break e;
                    }
                    if (a === P) {
                      (t.tag = 14), (t = Ms(null, t, r, e, n));
                      break e;
                    }
                  }
                  throw ((t = D(r) || r), Error(i(306, t, "")));
                }
                Or(r)
                  ? ((e = ms(r, e)), (t.tag = 1), (t = Os(null, t, r, e, n)))
                  : ((t.tag = 0), (t = Ns(null, t, r, e, n)));
              }
              return t;
            case 0:
              return Ns(e, t, t.type, t.pendingProps, n);
            case 1:
              return Os(e, t, (r = t.type), (a = ms(r, t.pendingProps)), n);
            case 3:
              e: {
                if (($(t, t.stateNode.containerInfo), null === e))
                  throw Error(i(387));
                r = t.pendingProps;
                var o = t.memoizedState;
                (a = o.element), no(e, t), uo(t, r, null, n);
                var s = t.memoizedState;
                if (
                  ((r = s.cache),
                  va(0, Da, r),
                  r !== o.cache && ka(t, [Da], n, !0),
                  lo(),
                  (r = s.element),
                  o.isDehydrated)
                ) {
                  if (
                    ((o = { element: r, isDehydrated: !1, cache: s.cache }),
                    (t.updateQueue.baseState = o),
                    (t.memoizedState = o),
                    256 & t.flags)
                  ) {
                    t = _s(e, t, r, n);
                    break e;
                  }
                  if (r !== a) {
                    ha((a = xr(Error(i(424)), t))), (t = _s(e, t, r, n));
                    break e;
                  }
                  for (
                    e =
                      9 === (e = t.stateNode.containerInfo).nodeType
                        ? e.body
                        : "HTML" === e.nodeName
                        ? e.ownerDocument.body
                        : e,
                      ra = yd(e.firstChild),
                      na = t,
                      aa = !0,
                      oa = null,
                      ia = !0,
                      n = ns(t, null, r, n),
                      t.child = n;
                    n;

                  )
                    (n.flags = (-3 & n.flags) | 4096), (n = n.sibling);
                } else {
                  if ((fa(), r === a)) {
                    t = Ks(e, t, n);
                    break e;
                  }
                  Ts(e, t, r, n);
                }
                t = t.child;
              }
              return t;
            case 26:
              return (
                zs(e, t),
                null === e
                  ? (n = Td(t.type, null, t.pendingProps, null))
                    ? (t.memoizedState = n)
                    : aa ||
                      ((n = t.type),
                      (e = t.pendingProps),
                      ((r = nd(W.current).createElement(n))[De] = t),
                      (r[Re] = e),
                      Jc(r, n, e),
                      He(r),
                      (t.stateNode = r))
                  : (t.memoizedState = Td(
                      t.type,
                      e.memoizedProps,
                      t.pendingProps,
                      e.memoizedState
                    )),
                null
              );
            case 27:
              return (
                Y(t),
                null === e &&
                  aa &&
                  ((r = t.stateNode = bd(t.type, t.pendingProps, W.current)),
                  (na = t),
                  (ia = !0),
                  (a = ra),
                  fd(t.type) ? ((gd = a), (ra = yd(r.firstChild))) : (ra = a)),
                Ts(e, t, t.pendingProps.children, n),
                zs(e, t),
                null === e && (t.flags |= 4194304),
                t.child
              );
            case 5:
              return (
                null === e &&
                  aa &&
                  ((a = r = ra) &&
                    (null !==
                    (r = (function (e, t, n, r) {
                      for (; 1 === e.nodeType; ) {
                        var a = n;
                        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
                          if (
                            !r &&
                            ("INPUT" !== e.nodeName || "hidden" !== e.type)
                          )
                            break;
                        } else if (r) {
                          if (!e[Ie])
                            switch (t) {
                              case "meta":
                                if (!e.hasAttribute("itemprop")) break;
                                return e;
                              case "link":
                                if (
                                  "stylesheet" ===
                                    (o = e.getAttribute("rel")) &&
                                  e.hasAttribute("data-precedence")
                                )
                                  break;
                                if (
                                  o !== a.rel ||
                                  e.getAttribute("href") !==
                                    (null == a.href || "" === a.href
                                      ? null
                                      : a.href) ||
                                  e.getAttribute("crossorigin") !==
                                    (null == a.crossOrigin
                                      ? null
                                      : a.crossOrigin) ||
                                  e.getAttribute("title") !==
                                    (null == a.title ? null : a.title)
                                )
                                  break;
                                return e;
                              case "style":
                                if (e.hasAttribute("data-precedence")) break;
                                return e;
                              case "script":
                                if (
                                  ((o = e.getAttribute("src")) !==
                                    (null == a.src ? null : a.src) ||
                                    e.getAttribute("type") !==
                                      (null == a.type ? null : a.type) ||
                                    e.getAttribute("crossorigin") !==
                                      (null == a.crossOrigin
                                        ? null
                                        : a.crossOrigin)) &&
                                  o &&
                                  e.hasAttribute("async") &&
                                  !e.hasAttribute("itemprop")
                                )
                                  break;
                                return e;
                              default:
                                return e;
                            }
                        } else {
                          if ("input" !== t || "hidden" !== e.type) return e;
                          var o = null == a.name ? null : "" + a.name;
                          if (
                            "hidden" === a.type &&
                            e.getAttribute("name") === o
                          )
                            return e;
                        }
                        if (null === (e = yd(e.nextSibling))) break;
                      }
                      return null;
                    })(r, t.type, t.pendingProps, ia))
                      ? ((t.stateNode = r),
                        (na = t),
                        (ra = yd(r.firstChild)),
                        (ia = !1),
                        (a = !0))
                      : (a = !1)),
                  a || la(t)),
                Y(t),
                (a = t.type),
                (o = t.pendingProps),
                (s = null !== e ? e.memoizedProps : null),
                (r = o.children),
                od(a, o)
                  ? (r = null)
                  : null !== s && od(a, s) && (t.flags |= 32),
                null !== t.memoizedState &&
                  ((a = Do(e, t, No, null, null, n)), (Yd._currentValue = a)),
                zs(e, t),
                Ts(e, t, r, n),
                t.child
              );
            case 6:
              return (
                null === e &&
                  aa &&
                  ((e = n = ra) &&
                    (null !==
                    (n = (function (e, t, n) {
                      if ("" === t) return null;
                      for (; 3 !== e.nodeType; ) {
                        if (
                          (1 !== e.nodeType ||
                            "INPUT" !== e.nodeName ||
                            "hidden" !== e.type) &&
                          !n
                        )
                          return null;
                        if (null === (e = yd(e.nextSibling))) return null;
                      }
                      return e;
                    })(n, t.pendingProps, ia))
                      ? ((t.stateNode = n), (na = t), (ra = null), (e = !0))
                      : (e = !1)),
                  e || la(t)),
                null
              );
            case 13:
              return Us(e, t, n);
            case 4:
              return (
                $(t, t.stateNode.containerInfo),
                (r = t.pendingProps),
                null === e ? (t.child = ts(t, null, r, n)) : Ts(e, t, r, n),
                t.child
              );
            case 11:
              return As(e, t, t.type, t.pendingProps, n);
            case 7:
              return Ts(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return Ts(e, t, t.pendingProps.children, n), t.child;
            case 10:
              return (
                (r = t.pendingProps),
                va(0, t.type, r.value),
                Ts(e, t, r.children, n),
                t.child
              );
            case 9:
              return (
                (a = t.type._context),
                (r = t.pendingProps.children),
                Pa(t),
                (r = r((a = Ea(a)))),
                (t.flags |= 1),
                Ts(e, t, r, n),
                t.child
              );
            case 14:
              return Ms(e, t, t.type, t.pendingProps, n);
            case 15:
              return Ls(e, t, t.type, t.pendingProps, n);
            case 19:
              return Ys(e, t, n);
            case 31:
              return (
                (r = t.pendingProps),
                (n = t.mode),
                (r = { mode: r.mode, children: r.children }),
                null === e
                  ? (((n = Ws(r, n)).ref = t.ref),
                    (t.child = n),
                    (n.return = t),
                    (t = n))
                  : (((n = _r(e.child, r)).ref = t.ref),
                    (t.child = n),
                    (n.return = t),
                    (t = n)),
                t
              );
            case 22:
              return Ds(e, t, n);
            case 24:
              return (
                Pa(t),
                (r = Ea(Da)),
                null === e
                  ? (null === (a = Ua()) &&
                      ((a = nu),
                      (o = Ra()),
                      (a.pooledCache = o),
                      o.refCount++,
                      null !== o && (a.pooledCacheLanes |= n),
                      (a = o)),
                    (t.memoizedState = { parent: r, cache: a }),
                    to(t),
                    va(0, Da, a))
                  : (!!(e.lanes & n) && (no(e, t), uo(t, null, null, n), lo()),
                    (a = e.memoizedState),
                    (o = t.memoizedState),
                    a.parent !== r
                      ? ((a = { parent: r, cache: r }),
                        (t.memoizedState = a),
                        0 === t.lanes &&
                          (t.memoizedState = t.updateQueue.baseState = a),
                        va(0, Da, r))
                      : ((r = o.cache),
                        va(0, Da, r),
                        r !== a.cache && ka(t, [Da], n, !0))),
                Ts(e, t, t.pendingProps.children, n),
                t.child
              );
            case 29:
              throw t.pendingProps;
          }
          throw Error(i(156, t.tag));
        }
        function Gs(e) {
          e.flags |= 4;
        }
        function Zs(e, t) {
          if ("stylesheet" !== t.type || 4 & t.state.loading)
            e.flags &= -16777217;
          else if (((e.flags |= 16777216), !jd(t))) {
            if (
              null !== (t = rs.current) &&
              ((4194048 & au) === au
                ? null !== as
                : ((62914560 & au) !== au && !(536870912 & au)) || t !== as)
            )
              throw ((Ga = Ya), $a);
            e.flags |= 8192;
          }
        }
        function Js(e, t) {
          null !== t && (e.flags |= 4),
            16384 & e.flags &&
              ((t = 22 !== e.tag ? Se() : 536870912),
              (e.lanes |= t),
              (yu |= t));
        }
        function el(e, t) {
          if (!aa)
            switch (e.tailMode) {
              case "hidden":
                t = e.tail;
                for (var n = null; null !== t; )
                  null !== t.alternate && (n = t), (t = t.sibling);
                null === n ? (e.tail = null) : (n.sibling = null);
                break;
              case "collapsed":
                n = e.tail;
                for (var r = null; null !== n; )
                  null !== n.alternate && (r = n), (n = n.sibling);
                null === r
                  ? t || null === e.tail
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (r.sibling = null);
            }
        }
        function tl(e) {
          var t = null !== e.alternate && e.alternate.child === e.child,
            n = 0,
            r = 0;
          if (t)
            for (var a = e.child; null !== a; )
              (n |= a.lanes | a.childLanes),
                (r |= 65011712 & a.subtreeFlags),
                (r |= 65011712 & a.flags),
                (a.return = e),
                (a = a.sibling);
          else
            for (a = e.child; null !== a; )
              (n |= a.lanes | a.childLanes),
                (r |= a.subtreeFlags),
                (r |= a.flags),
                (a.return = e),
                (a = a.sibling);
          return (e.subtreeFlags |= r), (e.childLanes = n), t;
        }
        function nl(e, t, n) {
          var r = t.pendingProps;
          switch ((ta(t), t.tag)) {
            case 31:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
            case 1:
              return tl(t), null;
            case 3:
              return (
                (n = t.stateNode),
                (r = null),
                null !== e && (r = e.memoizedState.cache),
                t.memoizedState.cache !== r && (t.flags |= 2048),
                ba(Da),
                q(),
                n.pendingContext &&
                  ((n.context = n.pendingContext), (n.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (da(t)
                    ? Gs(t)
                    : null === e ||
                      (e.memoizedState.isDehydrated && !(256 & t.flags)) ||
                      ((t.flags |= 1024), pa())),
                tl(t),
                null
              );
            case 26:
              return (
                (n = t.memoizedState),
                null === e
                  ? (Gs(t),
                    null !== n
                      ? (tl(t), Zs(t, n))
                      : (tl(t), (t.flags &= -16777217)))
                  : n
                  ? n !== e.memoizedState
                    ? (Gs(t), tl(t), Zs(t, n))
                    : (tl(t), (t.flags &= -16777217))
                  : (e.memoizedProps !== r && Gs(t),
                    tl(t),
                    (t.flags &= -16777217)),
                null
              );
            case 27:
              K(t), (n = W.current);
              var a = t.type;
              if (null !== e && null != t.stateNode)
                e.memoizedProps !== r && Gs(t);
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(i(166));
                  return tl(t), null;
                }
                (e = U.current),
                  da(t) ? ua(t) : ((e = bd(a, r, n)), (t.stateNode = e), Gs(t));
              }
              return tl(t), null;
            case 5:
              if ((K(t), (n = t.type), null !== e && null != t.stateNode))
                e.memoizedProps !== r && Gs(t);
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(i(166));
                  return tl(t), null;
                }
                if (((e = U.current), da(t))) ua(t);
                else {
                  switch (((a = nd(W.current)), e)) {
                    case 1:
                      e = a.createElementNS("http://www.w3.org/2000/svg", n);
                      break;
                    case 2:
                      e = a.createElementNS(
                        "http://www.w3.org/1998/Math/MathML",
                        n
                      );
                      break;
                    default:
                      switch (n) {
                        case "svg":
                          e = a.createElementNS(
                            "http://www.w3.org/2000/svg",
                            n
                          );
                          break;
                        case "math":
                          e = a.createElementNS(
                            "http://www.w3.org/1998/Math/MathML",
                            n
                          );
                          break;
                        case "script":
                          ((e = a.createElement("div")).innerHTML =
                            "<script></script>"),
                            (e = e.removeChild(e.firstChild));
                          break;
                        case "select":
                          (e =
                            "string" == typeof r.is
                              ? a.createElement("select", { is: r.is })
                              : a.createElement("select")),
                            r.multiple
                              ? (e.multiple = !0)
                              : r.size && (e.size = r.size);
                          break;
                        default:
                          e =
                            "string" == typeof r.is
                              ? a.createElement(n, { is: r.is })
                              : a.createElement(n);
                      }
                  }
                  (e[De] = t), (e[Re] = r);
                  e: for (a = t.child; null !== a; ) {
                    if (5 === a.tag || 6 === a.tag) e.appendChild(a.stateNode);
                    else if (4 !== a.tag && 27 !== a.tag && null !== a.child) {
                      (a.child.return = a), (a = a.child);
                      continue;
                    }
                    if (a === t) break e;
                    for (; null === a.sibling; ) {
                      if (null === a.return || a.return === t) break e;
                      a = a.return;
                    }
                    (a.sibling.return = a.return), (a = a.sibling);
                  }
                  t.stateNode = e;
                  e: switch ((Jc(e, n, r), n)) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      e = !!r.autoFocus;
                      break e;
                    case "img":
                      e = !0;
                      break e;
                    default:
                      e = !1;
                  }
                  e && Gs(t);
                }
              }
              return tl(t), (t.flags &= -16777217), null;
            case 6:
              if (e && null != t.stateNode) e.memoizedProps !== r && Gs(t);
              else {
                if ("string" != typeof r && null === t.stateNode)
                  throw Error(i(166));
                if (((e = W.current), da(t))) {
                  if (
                    ((e = t.stateNode),
                    (n = t.memoizedProps),
                    (r = null),
                    null !== (a = na))
                  )
                    switch (a.tag) {
                      case 27:
                      case 5:
                        r = a.memoizedProps;
                    }
                  (e[De] = t),
                    (e = !!(
                      e.nodeValue === n ||
                      (null !== r && !0 === r.suppressHydrationWarning) ||
                      Qc(e.nodeValue, n)
                    )) || la(t);
                } else
                  ((e = nd(e).createTextNode(r))[De] = t), (t.stateNode = e);
              }
              return tl(t), null;
            case 13:
              if (
                ((r = t.memoizedState),
                null === e ||
                  (null !== e.memoizedState &&
                    null !== e.memoizedState.dehydrated))
              ) {
                if (((a = da(t)), null !== r && null !== r.dehydrated)) {
                  if (null === e) {
                    if (!a) throw Error(i(318));
                    if (
                      !(a =
                        null !== (a = t.memoizedState) ? a.dehydrated : null)
                    )
                      throw Error(i(317));
                    a[De] = t;
                  } else
                    fa(),
                      !(128 & t.flags) && (t.memoizedState = null),
                      (t.flags |= 4);
                  tl(t), (a = !1);
                } else
                  (a = pa()),
                    null !== e &&
                      null !== e.memoizedState &&
                      (e.memoizedState.hydrationErrors = a),
                    (a = !0);
                if (!a) return 256 & t.flags ? (ls(t), t) : (ls(t), null);
              }
              if ((ls(t), 128 & t.flags)) return (t.lanes = n), t;
              if (
                ((n = null !== r),
                (e = null !== e && null !== e.memoizedState),
                n)
              ) {
                (a = null),
                  null !== (r = t.child).alternate &&
                    null !== r.alternate.memoizedState &&
                    null !== r.alternate.memoizedState.cachePool &&
                    (a = r.alternate.memoizedState.cachePool.pool);
                var o = null;
                null !== r.memoizedState &&
                  null !== r.memoizedState.cachePool &&
                  (o = r.memoizedState.cachePool.pool),
                  o !== a && (r.flags |= 2048);
              }
              return (
                n !== e && n && (t.child.flags |= 8192),
                Js(t, t.updateQueue),
                tl(t),
                null
              );
            case 4:
              return (
                q(), null === e && Vc(t.stateNode.containerInfo), tl(t), null
              );
            case 10:
              return ba(t.type), tl(t), null;
            case 19:
              if ((V(us), null === (a = t.memoizedState))) return tl(t), null;
              if (((r = !!(128 & t.flags)), null === (o = a.rendering)))
                if (r) el(a, !1);
                else {
                  if (0 !== du || (null !== e && 128 & e.flags))
                    for (e = t.child; null !== e; ) {
                      if (null !== (o = cs(e))) {
                        for (
                          t.flags |= 128,
                            el(a, !1),
                            e = o.updateQueue,
                            t.updateQueue = e,
                            Js(t, e),
                            t.subtreeFlags = 0,
                            e = n,
                            n = t.child;
                          null !== n;

                        )
                          Ir(n, e), (n = n.sibling);
                        return j(us, (1 & us.current) | 2), t.child;
                      }
                      e = e.sibling;
                    }
                  null !== a.tail &&
                    ee() > ku &&
                    ((t.flags |= 128),
                    (r = !0),
                    el(a, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!r)
                  if (null !== (e = cs(o))) {
                    if (
                      ((t.flags |= 128),
                      (r = !0),
                      (e = e.updateQueue),
                      (t.updateQueue = e),
                      Js(t, e),
                      el(a, !0),
                      null === a.tail &&
                        "hidden" === a.tailMode &&
                        !o.alternate &&
                        !aa)
                    )
                      return tl(t), null;
                  } else
                    2 * ee() - a.renderingStartTime > ku &&
                      536870912 !== n &&
                      ((t.flags |= 128),
                      (r = !0),
                      el(a, !1),
                      (t.lanes = 4194304));
                a.isBackwards
                  ? ((o.sibling = t.child), (t.child = o))
                  : (null !== (e = a.last) ? (e.sibling = o) : (t.child = o),
                    (a.last = o));
              }
              return null !== a.tail
                ? ((t = a.tail),
                  (a.rendering = t),
                  (a.tail = t.sibling),
                  (a.renderingStartTime = ee()),
                  (t.sibling = null),
                  (e = us.current),
                  j(us, r ? (1 & e) | 2 : 1 & e),
                  t)
                : (tl(t), null);
            case 22:
            case 23:
              return (
                ls(t),
                go(),
                (r = null !== t.memoizedState),
                null !== e
                  ? (null !== e.memoizedState) !== r && (t.flags |= 8192)
                  : r && (t.flags |= 8192),
                r
                  ? !!(536870912 & n) &&
                    !(128 & t.flags) &&
                    (tl(t), 6 & t.subtreeFlags && (t.flags |= 8192))
                  : tl(t),
                null !== (n = t.updateQueue) && Js(t, n.retryQueue),
                (n = null),
                null !== e &&
                  null !== e.memoizedState &&
                  null !== e.memoizedState.cachePool &&
                  (n = e.memoizedState.cachePool.pool),
                (r = null),
                null !== t.memoizedState &&
                  null !== t.memoizedState.cachePool &&
                  (r = t.memoizedState.cachePool.pool),
                r !== n && (t.flags |= 2048),
                null !== e && V(ja),
                null
              );
            case 24:
              return (
                (n = null),
                null !== e && (n = e.memoizedState.cache),
                t.memoizedState.cache !== n && (t.flags |= 2048),
                ba(Da),
                tl(t),
                null
              );
            case 25:
            case 30:
              return null;
          }
          throw Error(i(156, t.tag));
        }
        function rl(e, t) {
          switch ((ta(t), t.tag)) {
            case 1:
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 3:
              return (
                ba(Da),
                q(),
                65536 & (e = t.flags) && !(128 & e)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 26:
            case 27:
            case 5:
              return K(t), null;
            case 13:
              if (
                (ls(t), null !== (e = t.memoizedState) && null !== e.dehydrated)
              ) {
                if (null === t.alternate) throw Error(i(340));
                fa();
              }
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 19:
              return V(us), null;
            case 4:
              return q(), null;
            case 10:
              return ba(t.type), null;
            case 22:
            case 23:
              return (
                ls(t),
                go(),
                null !== e && V(ja),
                65536 & (e = t.flags)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 24:
              return ba(Da), null;
            default:
              return null;
          }
        }
        function al(e, t) {
          switch ((ta(t), t.tag)) {
            case 3:
              ba(Da), q();
              break;
            case 26:
            case 27:
            case 5:
              K(t);
              break;
            case 4:
              q();
              break;
            case 13:
              ls(t);
              break;
            case 19:
              V(us);
              break;
            case 10:
              ba(t.type);
              break;
            case 22:
            case 23:
              ls(t), go(), null !== e && V(ja);
              break;
            case 24:
              ba(Da);
          }
        }
        function ol(e, t) {
          try {
            var n = t.updateQueue,
              r = null !== n ? n.lastEffect : null;
            if (null !== r) {
              var a = r.next;
              n = a;
              do {
                if ((n.tag & e) === e) {
                  r = void 0;
                  var o = n.create,
                    i = n.inst;
                  (r = o()), (i.destroy = r);
                }
                n = n.next;
              } while (n !== a);
            }
          } catch (e) {
            uc(t, t.return, e);
          }
        }
        function il(e, t, n) {
          try {
            var r = t.updateQueue,
              a = null !== r ? r.lastEffect : null;
            if (null !== a) {
              var o = a.next;
              r = o;
              do {
                if ((r.tag & e) === e) {
                  var i = r.inst,
                    s = i.destroy;
                  if (void 0 !== s) {
                    (i.destroy = void 0), (a = t);
                    var l = n,
                      u = s;
                    try {
                      u();
                    } catch (e) {
                      uc(a, l, e);
                    }
                  }
                }
                r = r.next;
              } while (r !== o);
            }
          } catch (e) {
            uc(t, t.return, e);
          }
        }
        function sl(e) {
          var t = e.updateQueue;
          if (null !== t) {
            var n = e.stateNode;
            try {
              fo(t, n);
            } catch (t) {
              uc(e, e.return, t);
            }
          }
        }
        function ll(e, t, n) {
          (n.props = ms(e.type, e.memoizedProps)), (n.state = e.memoizedState);
          try {
            n.componentWillUnmount();
          } catch (n) {
            uc(e, t, n);
          }
        }
        function ul(e, t) {
          try {
            var n = e.ref;
            if (null !== n) {
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  var r = e.stateNode;
                  break;
                default:
                  r = e.stateNode;
              }
              "function" == typeof n ? (e.refCleanup = n(r)) : (n.current = r);
            }
          } catch (n) {
            uc(e, t, n);
          }
        }
        function cl(e, t) {
          var n = e.ref,
            r = e.refCleanup;
          if (null !== n)
            if ("function" == typeof r)
              try {
                r();
              } catch (n) {
                uc(e, t, n);
              } finally {
                (e.refCleanup = null),
                  null != (e = e.alternate) && (e.refCleanup = null);
              }
            else if ("function" == typeof n)
              try {
                n(null);
              } catch (n) {
                uc(e, t, n);
              }
            else n.current = null;
        }
        function dl(e) {
          var t = e.type,
            n = e.memoizedProps,
            r = e.stateNode;
          try {
            e: switch (t) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                n.autoFocus && r.focus();
                break e;
              case "img":
                n.src ? (r.src = n.src) : n.srcSet && (r.srcset = n.srcSet);
            }
          } catch (t) {
            uc(e, e.return, t);
          }
        }
        function fl(e, t, n) {
          try {
            var r = e.stateNode;
            !(function (e, t, n, r) {
              switch (t) {
                case "div":
                case "span":
                case "svg":
                case "path":
                case "a":
                case "g":
                case "p":
                case "li":
                  break;
                case "input":
                  var a = null,
                    o = null,
                    s = null,
                    l = null,
                    u = null,
                    c = null,
                    d = null;
                  for (h in n) {
                    var f = n[h];
                    if (n.hasOwnProperty(h) && null != f)
                      switch (h) {
                        case "checked":
                        case "value":
                          break;
                        case "defaultValue":
                          u = f;
                        default:
                          r.hasOwnProperty(h) || Gc(e, t, h, null, r, f);
                      }
                  }
                  for (var p in r) {
                    var h = r[p];
                    if (
                      ((f = n[p]),
                      r.hasOwnProperty(p) && (null != h || null != f))
                    )
                      switch (p) {
                        case "type":
                          o = h;
                          break;
                        case "name":
                          a = h;
                          break;
                        case "checked":
                          c = h;
                          break;
                        case "defaultChecked":
                          d = h;
                          break;
                        case "value":
                          s = h;
                          break;
                        case "defaultValue":
                          l = h;
                          break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                          if (null != h) throw Error(i(137, t));
                          break;
                        default:
                          h !== f && Gc(e, t, p, h, r, f);
                      }
                  }
                  return void mt(e, s, l, u, c, d, o, a);
                case "select":
                  for (o in ((h = s = l = p = null), n))
                    if (((u = n[o]), n.hasOwnProperty(o) && null != u))
                      switch (o) {
                        case "value":
                          break;
                        case "multiple":
                          h = u;
                        default:
                          r.hasOwnProperty(o) || Gc(e, t, o, null, r, u);
                      }
                  for (a in r)
                    if (
                      ((o = r[a]),
                      (u = n[a]),
                      r.hasOwnProperty(a) && (null != o || null != u))
                    )
                      switch (a) {
                        case "value":
                          p = o;
                          break;
                        case "defaultValue":
                          l = o;
                          break;
                        case "multiple":
                          s = o;
                        default:
                          o !== u && Gc(e, t, a, o, r, u);
                      }
                  return (
                    (t = l),
                    (n = s),
                    (r = h),
                    void (null != p
                      ? vt(e, !!n, p, !1)
                      : !!r != !!n &&
                        (null != t
                          ? vt(e, !!n, t, !0)
                          : vt(e, !!n, n ? [] : "", !1)))
                  );
                case "textarea":
                  for (l in ((h = p = null), n))
                    if (
                      ((a = n[l]),
                      n.hasOwnProperty(l) && null != a && !r.hasOwnProperty(l))
                    )
                      switch (l) {
                        case "value":
                        case "children":
                          break;
                        default:
                          Gc(e, t, l, null, r, a);
                      }
                  for (s in r)
                    if (
                      ((a = r[s]),
                      (o = n[s]),
                      r.hasOwnProperty(s) && (null != a || null != o))
                    )
                      switch (s) {
                        case "value":
                          p = a;
                          break;
                        case "defaultValue":
                          h = a;
                          break;
                        case "children":
                          break;
                        case "dangerouslySetInnerHTML":
                          if (null != a) throw Error(i(91));
                          break;
                        default:
                          a !== o && Gc(e, t, s, a, r, o);
                      }
                  return void bt(e, p, h);
                case "option":
                  for (var m in n)
                    (p = n[m]),
                      n.hasOwnProperty(m) &&
                        null != p &&
                        !r.hasOwnProperty(m) &&
                        ("selected" === m
                          ? (e.selected = !1)
                          : Gc(e, t, m, null, r, p));
                  for (u in r)
                    (p = r[u]),
                      (h = n[u]),
                      !r.hasOwnProperty(u) ||
                        p === h ||
                        (null == p && null == h) ||
                        ("selected" === u
                          ? (e.selected =
                              p &&
                              "function" != typeof p &&
                              "symbol" != typeof p)
                          : Gc(e, t, u, p, r, h));
                  return;
                case "img":
                case "link":
                case "area":
                case "base":
                case "br":
                case "col":
                case "embed":
                case "hr":
                case "keygen":
                case "meta":
                case "param":
                case "source":
                case "track":
                case "wbr":
                case "menuitem":
                  for (var y in n)
                    (p = n[y]),
                      n.hasOwnProperty(y) &&
                        null != p &&
                        !r.hasOwnProperty(y) &&
                        Gc(e, t, y, null, r, p);
                  for (c in r)
                    if (
                      ((p = r[c]),
                      (h = n[c]),
                      r.hasOwnProperty(c) &&
                        p !== h &&
                        (null != p || null != h))
                    )
                      switch (c) {
                        case "children":
                        case "dangerouslySetInnerHTML":
                          if (null != p) throw Error(i(137, t));
                          break;
                        default:
                          Gc(e, t, c, p, r, h);
                      }
                  return;
                default:
                  if (Et(t)) {
                    for (var g in n)
                      (p = n[g]),
                        n.hasOwnProperty(g) &&
                          void 0 !== p &&
                          !r.hasOwnProperty(g) &&
                          Zc(e, t, g, void 0, r, p);
                    for (d in r)
                      (p = r[d]),
                        (h = n[d]),
                        !r.hasOwnProperty(d) ||
                          p === h ||
                          (void 0 === p && void 0 === h) ||
                          Zc(e, t, d, p, r, h);
                    return;
                  }
              }
              for (var v in n)
                (p = n[v]),
                  n.hasOwnProperty(v) &&
                    null != p &&
                    !r.hasOwnProperty(v) &&
                    Gc(e, t, v, null, r, p);
              for (f in r)
                (p = r[f]),
                  (h = n[f]),
                  !r.hasOwnProperty(f) ||
                    p === h ||
                    (null == p && null == h) ||
                    Gc(e, t, f, p, r, h);
            })(r, e.type, n, t),
              (r[Re] = t);
          } catch (t) {
            uc(e, e.return, t);
          }
        }
        function pl(e) {
          return (
            5 === e.tag ||
            3 === e.tag ||
            26 === e.tag ||
            (27 === e.tag && fd(e.type)) ||
            4 === e.tag
          );
        }
        function hl(e) {
          e: for (;;) {
            for (; null === e.sibling; ) {
              if (null === e.return || pl(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              5 !== e.tag && 6 !== e.tag && 18 !== e.tag;

            ) {
              if (27 === e.tag && fd(e.type)) continue e;
              if (2 & e.flags) continue e;
              if (null === e.child || 4 === e.tag) continue e;
              (e.child.return = e), (e = e.child);
            }
            if (!(2 & e.flags)) return e.stateNode;
          }
        }
        function ml(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode),
              t
                ? (9 === n.nodeType
                    ? n.body
                    : "HTML" === n.nodeName
                    ? n.ownerDocument.body
                    : n
                  ).insertBefore(e, t)
                : ((t =
                    9 === n.nodeType
                      ? n.body
                      : "HTML" === n.nodeName
                      ? n.ownerDocument.body
                      : n).appendChild(e),
                  null != (n = n._reactRootContainer) ||
                    null !== t.onclick ||
                    (t.onclick = Xc));
          else if (
            4 !== r &&
            (27 === r && fd(e.type) && ((n = e.stateNode), (t = null)),
            null !== (e = e.child))
          )
            for (ml(e, t, n), e = e.sibling; null !== e; )
              ml(e, t, n), (e = e.sibling);
        }
        function yl(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
          else if (
            4 !== r &&
            (27 === r && fd(e.type) && (n = e.stateNode),
            null !== (e = e.child))
          )
            for (yl(e, t, n), e = e.sibling; null !== e; )
              yl(e, t, n), (e = e.sibling);
        }
        function gl(e) {
          var t = e.stateNode,
            n = e.memoizedProps;
          try {
            for (var r = e.type, a = t.attributes; a.length; )
              t.removeAttributeNode(a[0]);
            Jc(t, r, n), (t[De] = e), (t[Re] = n);
          } catch (t) {
            uc(e, e.return, t);
          }
        }
        var vl = !1,
          bl = !1,
          wl = !1,
          kl = "function" == typeof WeakSet ? WeakSet : Set,
          Sl = null;
        function xl(e, t, n) {
          var r = n.flags;
          switch (n.tag) {
            case 0:
            case 11:
            case 15:
              Ol(e, n), 4 & r && ol(5, n);
              break;
            case 1:
              if ((Ol(e, n), 4 & r))
                if (((e = n.stateNode), null === t))
                  try {
                    e.componentDidMount();
                  } catch (e) {
                    uc(n, n.return, e);
                  }
                else {
                  var a = ms(n.type, t.memoizedProps);
                  t = t.memoizedState;
                  try {
                    e.componentDidUpdate(
                      a,
                      t,
                      e.__reactInternalSnapshotBeforeUpdate
                    );
                  } catch (e) {
                    uc(n, n.return, e);
                  }
                }
              64 & r && sl(n), 512 & r && ul(n, n.return);
              break;
            case 3:
              if ((Ol(e, n), 64 & r && null !== (e = n.updateQueue))) {
                if (((t = null), null !== n.child))
                  switch (n.child.tag) {
                    case 27:
                    case 5:
                    case 1:
                      t = n.child.stateNode;
                  }
                try {
                  fo(e, t);
                } catch (e) {
                  uc(n, n.return, e);
                }
              }
              break;
            case 27:
              null === t && 4 & r && gl(n);
            case 26:
            case 5:
              Ol(e, n),
                null === t && 4 & r && dl(n),
                512 & r && ul(n, n.return);
              break;
            case 12:
              Ol(e, n);
              break;
            case 13:
              Ol(e, n),
                4 & r && Ml(e, n),
                64 & r &&
                  null !== (e = n.memoizedState) &&
                  null !== (e = e.dehydrated) &&
                  (function (e, t) {
                    var n = e.ownerDocument;
                    if ("$?" !== e.data || "complete" === n.readyState) t();
                    else {
                      var r = function () {
                        t(), n.removeEventListener("DOMContentLoaded", r);
                      };
                      n.addEventListener("DOMContentLoaded", r),
                        (e._reactRetry = r);
                    }
                  })(e, (n = pc.bind(null, n)));
              break;
            case 22:
              if (!(r = null !== n.memoizedState || vl)) {
                (t = (null !== t && null !== t.memoizedState) || bl), (a = vl);
                var o = bl;
                (vl = r),
                  (bl = t) && !o
                    ? Il(e, n, !!(8772 & n.subtreeFlags))
                    : Ol(e, n),
                  (vl = a),
                  (bl = o);
              }
              break;
            case 30:
              break;
            default:
              Ol(e, n);
          }
        }
        function Pl(e) {
          var t = e.alternate;
          null !== t && ((e.alternate = null), Pl(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            5 === e.tag && null !== (t = e.stateNode) && Ve(t),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null);
        }
        var El = null,
          Cl = !1;
        function Tl(e, t, n) {
          for (n = n.child; null !== n; ) Al(e, t, n), (n = n.sibling);
        }
        function Al(e, t, n) {
          if (ce && "function" == typeof ce.onCommitFiberUnmount)
            try {
              ce.onCommitFiberUnmount(ue, n);
            } catch (e) {}
          switch (n.tag) {
            case 26:
              bl || cl(n, t),
                Tl(e, t, n),
                n.memoizedState
                  ? n.memoizedState.count--
                  : n.stateNode && (n = n.stateNode).parentNode.removeChild(n);
              break;
            case 27:
              bl || cl(n, t);
              var r = El,
                a = Cl;
              fd(n.type) && ((El = n.stateNode), (Cl = !1)),
                Tl(e, t, n),
                wd(n.stateNode),
                (El = r),
                (Cl = a);
              break;
            case 5:
              bl || cl(n, t);
            case 6:
              if (
                ((r = El),
                (a = Cl),
                (El = null),
                Tl(e, t, n),
                (Cl = a),
                null !== (El = r))
              )
                if (Cl)
                  try {
                    (9 === El.nodeType
                      ? El.body
                      : "HTML" === El.nodeName
                      ? El.ownerDocument.body
                      : El
                    ).removeChild(n.stateNode);
                  } catch (e) {
                    uc(n, t, e);
                  }
                else
                  try {
                    El.removeChild(n.stateNode);
                  } catch (e) {
                    uc(n, t, e);
                  }
              break;
            case 18:
              null !== El &&
                (Cl
                  ? (pd(
                      9 === (e = El).nodeType
                        ? e.body
                        : "HTML" === e.nodeName
                        ? e.ownerDocument.body
                        : e,
                      n.stateNode
                    ),
                    Ef(e))
                  : pd(El, n.stateNode));
              break;
            case 4:
              (r = El),
                (a = Cl),
                (El = n.stateNode.containerInfo),
                (Cl = !0),
                Tl(e, t, n),
                (El = r),
                (Cl = a);
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              bl || il(2, n, t), bl || il(4, n, t), Tl(e, t, n);
              break;
            case 1:
              bl ||
                (cl(n, t),
                "function" == typeof (r = n.stateNode).componentWillUnmount &&
                  ll(n, t, r)),
                Tl(e, t, n);
              break;
            case 21:
              Tl(e, t, n);
              break;
            case 22:
              (bl = (r = bl) || null !== n.memoizedState),
                Tl(e, t, n),
                (bl = r);
              break;
            default:
              Tl(e, t, n);
          }
        }
        function Ml(e, t) {
          if (
            null === t.memoizedState &&
            null !== (e = t.alternate) &&
            null !== (e = e.memoizedState) &&
            null !== (e = e.dehydrated)
          )
            try {
              Ef(e);
            } catch (e) {
              uc(t, t.return, e);
            }
        }
        function Ll(e, t) {
          var n = (function (e) {
            switch (e.tag) {
              case 13:
              case 19:
                var t = e.stateNode;
                return null === t && (t = e.stateNode = new kl()), t;
              case 22:
                return (
                  null === (t = (e = e.stateNode)._retryCache) &&
                    (t = e._retryCache = new kl()),
                  t
                );
              default:
                throw Error(i(435, e.tag));
            }
          })(e);
          t.forEach(function (t) {
            var r = hc.bind(null, e, t);
            n.has(t) || (n.add(t), t.then(r, r));
          });
        }
        function Dl(e, t) {
          var n = t.deletions;
          if (null !== n)
            for (var r = 0; r < n.length; r++) {
              var a = n[r],
                o = e,
                s = t,
                l = s;
              e: for (; null !== l; ) {
                switch (l.tag) {
                  case 27:
                    if (fd(l.type)) {
                      (El = l.stateNode), (Cl = !1);
                      break e;
                    }
                    break;
                  case 5:
                    (El = l.stateNode), (Cl = !1);
                    break e;
                  case 3:
                  case 4:
                    (El = l.stateNode.containerInfo), (Cl = !0);
                    break e;
                }
                l = l.return;
              }
              if (null === El) throw Error(i(160));
              Al(o, s, a),
                (El = null),
                (Cl = !1),
                null !== (o = a.alternate) && (o.return = null),
                (a.return = null);
            }
          if (13878 & t.subtreeFlags)
            for (t = t.child; null !== t; ) zl(t, e), (t = t.sibling);
        }
        var Rl = null;
        function zl(e, t) {
          var n = e.alternate,
            r = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              Dl(t, e),
                Nl(e),
                4 & r && (il(3, e, e.return), ol(3, e), il(5, e, e.return));
              break;
            case 1:
              Dl(t, e),
                Nl(e),
                512 & r && (bl || null === n || cl(n, n.return)),
                64 & r &&
                  vl &&
                  null !== (e = e.updateQueue) &&
                  null !== (r = e.callbacks) &&
                  ((n = e.shared.hiddenCallbacks),
                  (e.shared.hiddenCallbacks = null === n ? r : n.concat(r)));
              break;
            case 26:
              var a = Rl;
              if (
                (Dl(t, e),
                Nl(e),
                512 & r && (bl || null === n || cl(n, n.return)),
                4 & r)
              ) {
                var o = null !== n ? n.memoizedState : null;
                if (((r = e.memoizedState), null === n))
                  if (null === r)
                    if (null === e.stateNode) {
                      e: {
                        (r = e.type),
                          (n = e.memoizedProps),
                          (a = a.ownerDocument || a);
                        t: switch (r) {
                          case "title":
                            (!(o = a.getElementsByTagName("title")[0]) ||
                              o[Ie] ||
                              o[De] ||
                              "http://www.w3.org/2000/svg" === o.namespaceURI ||
                              o.hasAttribute("itemprop")) &&
                              ((o = a.createElement(r)),
                              a.head.insertBefore(
                                o,
                                a.querySelector("head > title")
                              )),
                              Jc(o, r, n),
                              (o[De] = e),
                              He(o),
                              (r = o);
                            break e;
                          case "link":
                            var s = Id("link", "href", a).get(
                              r + (n.href || "")
                            );
                            if (s)
                              for (var l = 0; l < s.length; l++)
                                if (
                                  (o = s[l]).getAttribute("href") ===
                                    (null == n.href || "" === n.href
                                      ? null
                                      : n.href) &&
                                  o.getAttribute("rel") ===
                                    (null == n.rel ? null : n.rel) &&
                                  o.getAttribute("title") ===
                                    (null == n.title ? null : n.title) &&
                                  o.getAttribute("crossorigin") ===
                                    (null == n.crossOrigin
                                      ? null
                                      : n.crossOrigin)
                                ) {
                                  s.splice(l, 1);
                                  break t;
                                }
                            Jc((o = a.createElement(r)), r, n),
                              a.head.appendChild(o);
                            break;
                          case "meta":
                            if (
                              (s = Id("meta", "content", a).get(
                                r + (n.content || "")
                              ))
                            )
                              for (l = 0; l < s.length; l++)
                                if (
                                  (o = s[l]).getAttribute("content") ===
                                    (null == n.content
                                      ? null
                                      : "" + n.content) &&
                                  o.getAttribute("name") ===
                                    (null == n.name ? null : n.name) &&
                                  o.getAttribute("property") ===
                                    (null == n.property ? null : n.property) &&
                                  o.getAttribute("http-equiv") ===
                                    (null == n.httpEquiv
                                      ? null
                                      : n.httpEquiv) &&
                                  o.getAttribute("charset") ===
                                    (null == n.charSet ? null : n.charSet)
                                ) {
                                  s.splice(l, 1);
                                  break t;
                                }
                            Jc((o = a.createElement(r)), r, n),
                              a.head.appendChild(o);
                            break;
                          default:
                            throw Error(i(468, r));
                        }
                        (o[De] = e), He(o), (r = o);
                      }
                      e.stateNode = r;
                    } else Vd(a, e.type, e.stateNode);
                  else e.stateNode = zd(a, r, e.memoizedProps);
                else
                  o !== r
                    ? (null === o
                        ? null !== n.stateNode &&
                          (n = n.stateNode).parentNode.removeChild(n)
                        : o.count--,
                      null === r
                        ? Vd(a, e.type, e.stateNode)
                        : zd(a, r, e.memoizedProps))
                    : null === r &&
                      null !== e.stateNode &&
                      fl(e, e.memoizedProps, n.memoizedProps);
              }
              break;
            case 27:
              Dl(t, e),
                Nl(e),
                512 & r && (bl || null === n || cl(n, n.return)),
                null !== n && 4 & r && fl(e, e.memoizedProps, n.memoizedProps);
              break;
            case 5:
              if (
                (Dl(t, e),
                Nl(e),
                512 & r && (bl || null === n || cl(n, n.return)),
                32 & e.flags)
              ) {
                a = e.stateNode;
                try {
                  kt(a, "");
                } catch (t) {
                  uc(e, e.return, t);
                }
              }
              4 & r &&
                null != e.stateNode &&
                fl(e, (a = e.memoizedProps), null !== n ? n.memoizedProps : a),
                1024 & r && (wl = !0);
              break;
            case 6:
              if ((Dl(t, e), Nl(e), 4 & r)) {
                if (null === e.stateNode) throw Error(i(162));
                (r = e.memoizedProps), (n = e.stateNode);
                try {
                  n.nodeValue = r;
                } catch (t) {
                  uc(e, e.return, t);
                }
              }
              break;
            case 3:
              if (
                ((_d = null),
                (a = Rl),
                (Rl = xd(t.containerInfo)),
                Dl(t, e),
                (Rl = a),
                Nl(e),
                4 & r && null !== n && n.memoizedState.isDehydrated)
              )
                try {
                  Ef(t.containerInfo);
                } catch (t) {
                  uc(e, e.return, t);
                }
              wl && ((wl = !1), Fl(e));
              break;
            case 4:
              (r = Rl),
                (Rl = xd(e.stateNode.containerInfo)),
                Dl(t, e),
                Nl(e),
                (Rl = r);
              break;
            case 12:
            default:
              Dl(t, e), Nl(e);
              break;
            case 13:
              Dl(t, e),
                Nl(e),
                8192 & e.child.flags &&
                  (null !== e.memoizedState) !=
                    (null !== n && null !== n.memoizedState) &&
                  (wu = ee()),
                4 & r &&
                  null !== (r = e.updateQueue) &&
                  ((e.updateQueue = null), Ll(e, r));
              break;
            case 22:
              a = null !== e.memoizedState;
              var u = null !== n && null !== n.memoizedState,
                c = vl,
                d = bl;
              if (
                ((vl = c || a),
                (bl = d || u),
                Dl(t, e),
                (bl = d),
                (vl = c),
                Nl(e),
                8192 & r)
              )
                e: for (
                  t = e.stateNode,
                    t._visibility = a ? -2 & t._visibility : 1 | t._visibility,
                    a && (null === n || u || vl || bl || _l(e)),
                    n = null,
                    t = e;
                  ;

                ) {
                  if (5 === t.tag || 26 === t.tag) {
                    if (null === n) {
                      u = n = t;
                      try {
                        if (((o = u.stateNode), a))
                          "function" == typeof (s = o.style).setProperty
                            ? s.setProperty("display", "none", "important")
                            : (s.display = "none");
                        else {
                          l = u.stateNode;
                          var f = u.memoizedProps.style,
                            p =
                              null != f && f.hasOwnProperty("display")
                                ? f.display
                                : null;
                          l.style.display =
                            null == p || "boolean" == typeof p
                              ? ""
                              : ("" + p).trim();
                        }
                      } catch (e) {
                        uc(u, u.return, e);
                      }
                    }
                  } else if (6 === t.tag) {
                    if (null === n) {
                      u = t;
                      try {
                        u.stateNode.nodeValue = a ? "" : u.memoizedProps;
                      } catch (e) {
                        uc(u, u.return, e);
                      }
                    }
                  } else if (
                    ((22 !== t.tag && 23 !== t.tag) ||
                      null === t.memoizedState ||
                      t === e) &&
                    null !== t.child
                  ) {
                    (t.child.return = t), (t = t.child);
                    continue;
                  }
                  if (t === e) break e;
                  for (; null === t.sibling; ) {
                    if (null === t.return || t.return === e) break e;
                    n === t && (n = null), (t = t.return);
                  }
                  n === t && (n = null),
                    (t.sibling.return = t.return),
                    (t = t.sibling);
                }
              4 & r &&
                null !== (r = e.updateQueue) &&
                null !== (n = r.retryQueue) &&
                ((r.retryQueue = null), Ll(e, n));
              break;
            case 19:
              Dl(t, e),
                Nl(e),
                4 & r &&
                  null !== (r = e.updateQueue) &&
                  ((e.updateQueue = null), Ll(e, r));
            case 30:
            case 21:
          }
        }
        function Nl(e) {
          var t = e.flags;
          if (2 & t) {
            try {
              for (var n, r = e.return; null !== r; ) {
                if (pl(r)) {
                  n = r;
                  break;
                }
                r = r.return;
              }
              if (null == n) throw Error(i(160));
              switch (n.tag) {
                case 27:
                  var a = n.stateNode;
                  yl(e, hl(e), a);
                  break;
                case 5:
                  var o = n.stateNode;
                  32 & n.flags && (kt(o, ""), (n.flags &= -33)),
                    yl(e, hl(e), o);
                  break;
                case 3:
                case 4:
                  var s = n.stateNode.containerInfo;
                  ml(e, hl(e), s);
                  break;
                default:
                  throw Error(i(161));
              }
            } catch (t) {
              uc(e, e.return, t);
            }
            e.flags &= -3;
          }
          4096 & t && (e.flags &= -4097);
        }
        function Fl(e) {
          if (1024 & e.subtreeFlags)
            for (e = e.child; null !== e; ) {
              var t = e;
              Fl(t),
                5 === t.tag && 1024 & t.flags && t.stateNode.reset(),
                (e = e.sibling);
            }
        }
        function Ol(e, t) {
          if (8772 & t.subtreeFlags)
            for (t = t.child; null !== t; )
              xl(e, t.alternate, t), (t = t.sibling);
        }
        function _l(e) {
          for (e = e.child; null !== e; ) {
            var t = e;
            switch (t.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                il(4, t, t.return), _l(t);
                break;
              case 1:
                cl(t, t.return);
                var n = t.stateNode;
                "function" == typeof n.componentWillUnmount &&
                  ll(t, t.return, n),
                  _l(t);
                break;
              case 27:
                wd(t.stateNode);
              case 26:
              case 5:
                cl(t, t.return), _l(t);
                break;
              case 22:
                null === t.memoizedState && _l(t);
                break;
              default:
                _l(t);
            }
            e = e.sibling;
          }
        }
        function Il(e, t, n) {
          for (n = n && !!(8772 & t.subtreeFlags), t = t.child; null !== t; ) {
            var r = t.alternate,
              a = e,
              o = t,
              i = o.flags;
            switch (o.tag) {
              case 0:
              case 11:
              case 15:
                Il(a, o, n), ol(4, o);
                break;
              case 1:
                if (
                  (Il(a, o, n),
                  "function" ==
                    typeof (a = (r = o).stateNode).componentDidMount)
                )
                  try {
                    a.componentDidMount();
                  } catch (e) {
                    uc(r, r.return, e);
                  }
                if (null !== (a = (r = o).updateQueue)) {
                  var s = r.stateNode;
                  try {
                    var l = a.shared.hiddenCallbacks;
                    if (null !== l)
                      for (
                        a.shared.hiddenCallbacks = null, a = 0;
                        a < l.length;
                        a++
                      )
                        co(l[a], s);
                  } catch (e) {
                    uc(r, r.return, e);
                  }
                }
                n && 64 & i && sl(o), ul(o, o.return);
                break;
              case 27:
                gl(o);
              case 26:
              case 5:
                Il(a, o, n), n && null === r && 4 & i && dl(o), ul(o, o.return);
                break;
              case 12:
                Il(a, o, n);
                break;
              case 13:
                Il(a, o, n), n && 4 & i && Ml(a, o);
                break;
              case 22:
                null === o.memoizedState && Il(a, o, n), ul(o, o.return);
                break;
              case 30:
                break;
              default:
                Il(a, o, n);
            }
            t = t.sibling;
          }
        }
        function Vl(e, t) {
          var n = null;
          null !== e &&
            null !== e.memoizedState &&
            null !== e.memoizedState.cachePool &&
            (n = e.memoizedState.cachePool.pool),
            (e = null),
            null !== t.memoizedState &&
              null !== t.memoizedState.cachePool &&
              (e = t.memoizedState.cachePool.pool),
            e !== n && (null != e && e.refCount++, null != n && za(n));
        }
        function jl(e, t) {
          (e = null),
            null !== t.alternate && (e = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache) !== e &&
              (t.refCount++, null != e && za(e));
        }
        function Ul(e, t, n, r) {
          if (10256 & t.subtreeFlags)
            for (t = t.child; null !== t; ) Bl(e, t, n, r), (t = t.sibling);
        }
        function Bl(e, t, n, r) {
          var a = t.flags;
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              Ul(e, t, n, r), 2048 & a && ol(9, t);
              break;
            case 1:
            case 13:
            default:
              Ul(e, t, n, r);
              break;
            case 3:
              Ul(e, t, n, r),
                2048 & a &&
                  ((e = null),
                  null !== t.alternate && (e = t.alternate.memoizedState.cache),
                  (t = t.memoizedState.cache) !== e &&
                    (t.refCount++, null != e && za(e)));
              break;
            case 12:
              if (2048 & a) {
                Ul(e, t, n, r), (e = t.stateNode);
                try {
                  var o = t.memoizedProps,
                    i = o.id,
                    s = o.onPostCommit;
                  "function" == typeof s &&
                    s(
                      i,
                      null === t.alternate ? "mount" : "update",
                      e.passiveEffectDuration,
                      -0
                    );
                } catch (e) {
                  uc(t, t.return, e);
                }
              } else Ul(e, t, n, r);
              break;
            case 23:
              break;
            case 22:
              (o = t.stateNode),
                (i = t.alternate),
                null !== t.memoizedState
                  ? 2 & o._visibility
                    ? Ul(e, t, n, r)
                    : Hl(e, t)
                  : 2 & o._visibility
                  ? Ul(e, t, n, r)
                  : ((o._visibility |= 2),
                    Wl(e, t, n, r, !!(10256 & t.subtreeFlags))),
                2048 & a && Vl(i, t);
              break;
            case 24:
              Ul(e, t, n, r), 2048 & a && jl(t.alternate, t);
          }
        }
        function Wl(e, t, n, r, a) {
          for (a = a && !!(10256 & t.subtreeFlags), t = t.child; null !== t; ) {
            var o = e,
              i = t,
              s = n,
              l = r,
              u = i.flags;
            switch (i.tag) {
              case 0:
              case 11:
              case 15:
                Wl(o, i, s, l, a), ol(8, i);
                break;
              case 23:
                break;
              case 22:
                var c = i.stateNode;
                null !== i.memoizedState
                  ? 2 & c._visibility
                    ? Wl(o, i, s, l, a)
                    : Hl(o, i)
                  : ((c._visibility |= 2), Wl(o, i, s, l, a)),
                  a && 2048 & u && Vl(i.alternate, i);
                break;
              case 24:
                Wl(o, i, s, l, a), a && 2048 & u && jl(i.alternate, i);
                break;
              default:
                Wl(o, i, s, l, a);
            }
            t = t.sibling;
          }
        }
        function Hl(e, t) {
          if (10256 & t.subtreeFlags)
            for (t = t.child; null !== t; ) {
              var n = e,
                r = t,
                a = r.flags;
              switch (r.tag) {
                case 22:
                  Hl(n, r), 2048 & a && Vl(r.alternate, r);
                  break;
                case 24:
                  Hl(n, r), 2048 & a && jl(r.alternate, r);
                  break;
                default:
                  Hl(n, r);
              }
              t = t.sibling;
            }
        }
        var $l = 8192;
        function ql(e) {
          if (e.subtreeFlags & $l)
            for (e = e.child; null !== e; ) Yl(e), (e = e.sibling);
        }
        function Yl(e) {
          switch (e.tag) {
            case 26:
              ql(e),
                e.flags & $l &&
                  null !== e.memoizedState &&
                  (function (e, t, n) {
                    if (null === Ud) throw Error(i(475));
                    var r = Ud;
                    if (
                      !(
                        "stylesheet" !== t.type ||
                        ("string" == typeof n.media &&
                          !1 === matchMedia(n.media).matches) ||
                        4 & t.state.loading
                      )
                    ) {
                      if (null === t.instance) {
                        var a = Ad(n.href),
                          o = e.querySelector(Md(a));
                        if (o)
                          return (
                            null !== (e = o._p) &&
                              "object" == typeof e &&
                              "function" == typeof e.then &&
                              (r.count++, (r = Wd.bind(r)), e.then(r, r)),
                            (t.state.loading |= 4),
                            (t.instance = o),
                            void He(o)
                          );
                        (o = e.ownerDocument || e),
                          (n = Ld(n)),
                          (a = kd.get(a)) && Fd(n, a),
                          He((o = o.createElement("link")));
                        var s = o;
                        (s._p = new Promise(function (e, t) {
                          (s.onload = e), (s.onerror = t);
                        })),
                          Jc(o, "link", n),
                          (t.instance = o);
                      }
                      null === r.stylesheets && (r.stylesheets = new Map()),
                        r.stylesheets.set(t, e),
                        (e = t.state.preload) &&
                          !(3 & t.state.loading) &&
                          (r.count++,
                          (t = Wd.bind(r)),
                          e.addEventListener("load", t),
                          e.addEventListener("error", t));
                    }
                  })(Rl, e.memoizedState, e.memoizedProps);
              break;
            case 5:
            default:
              ql(e);
              break;
            case 3:
            case 4:
              var t = Rl;
              (Rl = xd(e.stateNode.containerInfo)), ql(e), (Rl = t);
              break;
            case 22:
              null === e.memoizedState &&
                (null !== (t = e.alternate) && null !== t.memoizedState
                  ? ((t = $l), ($l = 16777216), ql(e), ($l = t))
                  : ql(e));
          }
        }
        function Kl(e) {
          var t = e.alternate;
          if (null !== t && null !== (e = t.child)) {
            t.child = null;
            do {
              (t = e.sibling), (e.sibling = null), (e = t);
            } while (null !== e);
          }
        }
        function Ql(e) {
          var t = e.deletions;
          if (16 & e.flags) {
            if (null !== t)
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                (Sl = r), Zl(r, e);
              }
            Kl(e);
          }
          if (10256 & e.subtreeFlags)
            for (e = e.child; null !== e; ) Xl(e), (e = e.sibling);
        }
        function Xl(e) {
          switch (e.tag) {
            case 0:
            case 11:
            case 15:
              Ql(e), 2048 & e.flags && il(9, e, e.return);
              break;
            case 3:
            case 12:
            default:
              Ql(e);
              break;
            case 22:
              var t = e.stateNode;
              null !== e.memoizedState &&
              2 & t._visibility &&
              (null === e.return || 13 !== e.return.tag)
                ? ((t._visibility &= -3), Gl(e))
                : Ql(e);
          }
        }
        function Gl(e) {
          var t = e.deletions;
          if (16 & e.flags) {
            if (null !== t)
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                (Sl = r), Zl(r, e);
              }
            Kl(e);
          }
          for (e = e.child; null !== e; ) {
            switch ((t = e).tag) {
              case 0:
              case 11:
              case 15:
                il(8, t, t.return), Gl(t);
                break;
              case 22:
                2 & (n = t.stateNode)._visibility &&
                  ((n._visibility &= -3), Gl(t));
                break;
              default:
                Gl(t);
            }
            e = e.sibling;
          }
        }
        function Zl(e, t) {
          for (; null !== Sl; ) {
            var n = Sl;
            switch (n.tag) {
              case 0:
              case 11:
              case 15:
                il(8, n, t);
                break;
              case 23:
              case 22:
                if (
                  null !== n.memoizedState &&
                  null !== n.memoizedState.cachePool
                ) {
                  var r = n.memoizedState.cachePool.pool;
                  null != r && r.refCount++;
                }
                break;
              case 24:
                za(n.memoizedState.cache);
            }
            if (null !== (r = n.child)) (r.return = n), (Sl = r);
            else
              e: for (n = e; null !== Sl; ) {
                var a = (r = Sl).sibling,
                  o = r.return;
                if ((Pl(r), r === n)) {
                  Sl = null;
                  break e;
                }
                if (null !== a) {
                  (a.return = o), (Sl = a);
                  break e;
                }
                Sl = o;
              }
          }
        }
        var Jl = {
            getCacheForType: function (e) {
              var t = Ea(Da),
                n = t.data.get(e);
              return void 0 === n && ((n = e()), t.data.set(e, n)), n;
            },
          },
          eu = "function" == typeof WeakMap ? WeakMap : Map,
          tu = 0,
          nu = null,
          ru = null,
          au = 0,
          ou = 0,
          iu = null,
          su = !1,
          lu = !1,
          uu = !1,
          cu = 0,
          du = 0,
          fu = 0,
          pu = 0,
          hu = 0,
          mu = 0,
          yu = 0,
          gu = null,
          vu = null,
          bu = !1,
          wu = 0,
          ku = 1 / 0,
          Su = null,
          xu = null,
          Pu = 0,
          Eu = null,
          Cu = null,
          Tu = 0,
          Au = 0,
          Mu = null,
          Lu = null,
          Du = 0,
          Ru = null;
        function zu() {
          return 2 & tu && 0 !== au
            ? au & -au
            : null !== z.T
            ? 0 !== Oa
              ? Oa
              : Ac()
            : Me();
        }
        function Nu() {
          0 === mu && (mu = 536870912 & au && !aa ? 536870912 : ke());
          var e = rs.current;
          return null !== e && (e.flags |= 32), mu;
        }
        function Fu(e, t, n) {
          ((e !== nu || (2 !== ou && 9 !== ou)) &&
            null === e.cancelPendingCommit) ||
            (Bu(e, 0), Vu(e, au, mu, !1)),
            Pe(e, n),
            (2 & tu && e === nu) ||
              (e === nu &&
                (!(2 & tu) && (pu |= n), 4 === du && Vu(e, au, mu, !1)),
              kc(e));
        }
        function Ou(e, t, n) {
          if (6 & tu) throw Error(i(327));
          for (
            var r = (!n && !(124 & t) && !(t & e.expiredLanes)) || be(e, t),
              a = r
                ? (function (e, t) {
                    var n = tu;
                    tu |= 2;
                    var r = Hu(),
                      a = $u();
                    nu !== e || au !== t
                      ? ((Su = null), (ku = ee() + 500), Bu(e, t))
                      : (lu = be(e, t));
                    e: for (;;)
                      try {
                        if (0 !== ou && null !== ru) {
                          t = ru;
                          var o = iu;
                          t: switch (ou) {
                            case 1:
                              (ou = 0), (iu = null), Zu(e, t, o, 1);
                              break;
                            case 2:
                            case 9:
                              if (Ka(o)) {
                                (ou = 0), (iu = null), Gu(t);
                                break;
                              }
                              (t = function () {
                                (2 !== ou && 9 !== ou) || nu !== e || (ou = 7),
                                  kc(e);
                              }),
                                o.then(t, t);
                              break e;
                            case 3:
                              ou = 7;
                              break e;
                            case 4:
                              ou = 5;
                              break e;
                            case 7:
                              Ka(o)
                                ? ((ou = 0), (iu = null), Gu(t))
                                : ((ou = 0), (iu = null), Zu(e, t, o, 7));
                              break;
                            case 5:
                              var s = null;
                              switch (ru.tag) {
                                case 26:
                                  s = ru.memoizedState;
                                case 5:
                                case 27:
                                  var l = ru;
                                  if (!s || jd(s)) {
                                    (ou = 0), (iu = null);
                                    var u = l.sibling;
                                    if (null !== u) ru = u;
                                    else {
                                      var c = l.return;
                                      null !== c
                                        ? ((ru = c), Ju(c))
                                        : (ru = null);
                                    }
                                    break t;
                                  }
                              }
                              (ou = 0), (iu = null), Zu(e, t, o, 5);
                              break;
                            case 6:
                              (ou = 0), (iu = null), Zu(e, t, o, 6);
                              break;
                            case 8:
                              Uu(), (du = 6);
                              break e;
                            default:
                              throw Error(i(462));
                          }
                        }
                        Qu();
                        break;
                      } catch (t) {
                        Wu(e, t);
                      }
                    return (
                      (ga = ya = null),
                      (z.H = r),
                      (z.A = a),
                      (tu = n),
                      null !== ru ? 0 : ((nu = null), (au = 0), Tr(), du)
                    );
                  })(e, t)
                : Yu(e, t, !0),
              o = r;
            ;

          ) {
            if (0 === a) {
              lu && !r && Vu(e, t, 0, !1);
              break;
            }
            if (((n = e.current.alternate), !o || Iu(n))) {
              if (2 === a) {
                if (((o = t), e.errorRecoveryDisabledLanes & o)) var s = 0;
                else
                  s =
                    0 != (s = -536870913 & e.pendingLanes)
                      ? s
                      : 536870912 & s
                      ? 536870912
                      : 0;
                if (0 !== s) {
                  t = s;
                  e: {
                    var l = e;
                    a = gu;
                    var u = l.current.memoizedState.isDehydrated;
                    if (
                      (u && (Bu(l, s).flags |= 256), 2 !== (s = Yu(l, s, !1)))
                    ) {
                      if (uu && !u) {
                        (l.errorRecoveryDisabledLanes |= o), (pu |= o), (a = 4);
                        break e;
                      }
                      (o = vu),
                        (vu = a),
                        null !== o &&
                          (null === vu ? (vu = o) : vu.push.apply(vu, o));
                    }
                    a = s;
                  }
                  if (((o = !1), 2 !== a)) continue;
                }
              }
              if (1 === a) {
                Bu(e, 0), Vu(e, t, 0, !0);
                break;
              }
              e: {
                switch (((r = e), (o = a))) {
                  case 0:
                  case 1:
                    throw Error(i(345));
                  case 4:
                    if ((4194048 & t) !== t) break;
                  case 6:
                    Vu(r, t, mu, !su);
                    break e;
                  case 2:
                    vu = null;
                    break;
                  case 3:
                  case 5:
                    break;
                  default:
                    throw Error(i(329));
                }
                if ((62914560 & t) === t && 10 < (a = wu + 300 - ee())) {
                  if ((Vu(r, t, mu, !su), 0 !== ve(r, 0, !0))) break e;
                  r.timeoutHandle = sd(
                    _u.bind(
                      null,
                      r,
                      n,
                      vu,
                      Su,
                      bu,
                      t,
                      mu,
                      pu,
                      yu,
                      su,
                      o,
                      2,
                      -0,
                      0
                    ),
                    a
                  );
                } else _u(r, n, vu, Su, bu, t, mu, pu, yu, su, o, 0, -0, 0);
              }
              break;
            }
            (a = Yu(e, t, !1)), (o = !1);
          }
          kc(e);
        }
        function _u(e, t, n, r, a, o, s, l, u, c, d, f, p, h) {
          if (
            ((e.timeoutHandle = -1),
            (8192 & (f = t.subtreeFlags) || !(16785408 & ~f)) &&
              ((Ud = { stylesheets: null, count: 0, unsuspend: Bd }),
              Yl(t),
              null !==
                (f = (function () {
                  if (null === Ud) throw Error(i(475));
                  var e = Ud;
                  return (
                    e.stylesheets && 0 === e.count && $d(e, e.stylesheets),
                    0 < e.count
                      ? function (t) {
                          var n = setTimeout(function () {
                            if (
                              (e.stylesheets && $d(e, e.stylesheets),
                              e.unsuspend)
                            ) {
                              var t = e.unsuspend;
                              (e.unsuspend = null), t();
                            }
                          }, 6e4);
                          return (
                            (e.unsuspend = t),
                            function () {
                              (e.unsuspend = null), clearTimeout(n);
                            }
                          );
                        }
                      : null
                  );
                })())))
          )
            return (
              (e.cancelPendingCommit = f(
                tc.bind(null, e, t, o, n, r, a, s, l, u, d, 1, p, h)
              )),
              void Vu(e, o, s, !c)
            );
          tc(e, t, o, n, r, a, s, l, u);
        }
        function Iu(e) {
          for (var t = e; ; ) {
            var n = t.tag;
            if (
              (0 === n || 11 === n || 15 === n) &&
              16384 & t.flags &&
              null !== (n = t.updateQueue) &&
              null !== (n = n.stores)
            )
              for (var r = 0; r < n.length; r++) {
                var a = n[r],
                  o = a.getSnapshot;
                a = a.value;
                try {
                  if (!Kn(o(), a)) return !1;
                } catch (e) {
                  return !1;
                }
              }
            if (((n = t.child), 16384 & t.subtreeFlags && null !== n))
              (n.return = t), (t = n);
            else {
              if (t === e) break;
              for (; null === t.sibling; ) {
                if (null === t.return || t.return === e) return !0;
                t = t.return;
              }
              (t.sibling.return = t.return), (t = t.sibling);
            }
          }
          return !0;
        }
        function Vu(e, t, n, r) {
          (t &= ~hu),
            (t &= ~pu),
            (e.suspendedLanes |= t),
            (e.pingedLanes &= ~t),
            r && (e.warmLanes |= t),
            (r = e.expirationTimes);
          for (var a = t; 0 < a; ) {
            var o = 31 - fe(a),
              i = 1 << o;
            (r[o] = -1), (a &= ~i);
          }
          0 !== n && Ee(e, n, t);
        }
        function ju() {
          return !!(6 & tu) || (Sc(0, !1), !1);
        }
        function Uu() {
          if (null !== ru) {
            if (0 === ou) var e = ru.return;
            else
              (ga = ya = null), _o((e = ru)), (Ki = null), (Qi = 0), (e = ru);
            for (; null !== e; ) al(e.alternate, e), (e = e.return);
            ru = null;
          }
        }
        function Bu(e, t) {
          var n = e.timeoutHandle;
          -1 !== n && ((e.timeoutHandle = -1), ld(n)),
            null !== (n = e.cancelPendingCommit) &&
              ((e.cancelPendingCommit = null), n()),
            Uu(),
            (nu = e),
            (ru = n = _r(e.current, null)),
            (au = t),
            (ou = 0),
            (iu = null),
            (su = !1),
            (lu = be(e, t)),
            (uu = !1),
            (yu = mu = hu = pu = fu = du = 0),
            (vu = gu = null),
            (bu = !1),
            8 & t && (t |= 32 & t);
          var r = e.entangledLanes;
          if (0 !== r)
            for (e = e.entanglements, r &= t; 0 < r; ) {
              var a = 31 - fe(r),
                o = 1 << a;
              (t |= e[a]), (r &= ~o);
            }
          return (cu = t), Tr(), n;
        }
        function Wu(e, t) {
          (bo = null),
            (z.H = Hi),
            t === Ha || t === qa
              ? ((t = Za()), (ou = 3))
              : t === $a
              ? ((t = Za()), (ou = 4))
              : (ou =
                  t === Es
                    ? 8
                    : null !== t &&
                      "object" == typeof t &&
                      "function" == typeof t.then
                    ? 6
                    : 1),
            (iu = t),
            null === ru && ((du = 1), ws(e, xr(t, e.current)));
        }
        function Hu() {
          var e = z.H;
          return (z.H = Hi), null === e ? Hi : e;
        }
        function $u() {
          var e = z.A;
          return (z.A = Jl), e;
        }
        function qu() {
          (du = 4),
            su || ((4194048 & au) !== au && null !== rs.current) || (lu = !0),
            (!(134217727 & fu) && !(134217727 & pu)) ||
              null === nu ||
              Vu(nu, au, mu, !1);
        }
        function Yu(e, t, n) {
          var r = tu;
          tu |= 2;
          var a = Hu(),
            o = $u();
          (nu === e && au === t) || ((Su = null), Bu(e, t)), (t = !1);
          var i = du;
          e: for (;;)
            try {
              if (0 !== ou && null !== ru) {
                var s = ru,
                  l = iu;
                switch (ou) {
                  case 8:
                    Uu(), (i = 6);
                    break e;
                  case 3:
                  case 2:
                  case 9:
                  case 6:
                    null === rs.current && (t = !0);
                    var u = ou;
                    if (((ou = 0), (iu = null), Zu(e, s, l, u), n && lu)) {
                      i = 0;
                      break e;
                    }
                    break;
                  default:
                    (u = ou), (ou = 0), (iu = null), Zu(e, s, l, u);
                }
              }
              Ku(), (i = du);
              break;
            } catch (t) {
              Wu(e, t);
            }
          return (
            t && e.shellSuspendCounter++,
            (ga = ya = null),
            (tu = r),
            (z.H = a),
            (z.A = o),
            null === ru && ((nu = null), (au = 0), Tr()),
            i
          );
        }
        function Ku() {
          for (; null !== ru; ) Xu(ru);
        }
        function Qu() {
          for (; null !== ru && !Z(); ) Xu(ru);
        }
        function Xu(e) {
          var t = Xs(e.alternate, e, cu);
          (e.memoizedProps = e.pendingProps), null === t ? Ju(e) : (ru = t);
        }
        function Gu(e) {
          var t = e,
            n = t.alternate;
          switch (t.tag) {
            case 15:
            case 0:
              t = Fs(n, t, t.pendingProps, t.type, void 0, au);
              break;
            case 11:
              t = Fs(n, t, t.pendingProps, t.type.render, t.ref, au);
              break;
            case 5:
              _o(t);
            default:
              al(n, t), (t = Xs(n, (t = ru = Ir(t, cu)), cu));
          }
          (e.memoizedProps = e.pendingProps), null === t ? Ju(e) : (ru = t);
        }
        function Zu(e, t, n, r) {
          (ga = ya = null), _o(t), (Ki = null), (Qi = 0);
          var a = t.return;
          try {
            if (
              (function (e, t, n, r, a) {
                if (
                  ((n.flags |= 32768),
                  null !== r &&
                    "object" == typeof r &&
                    "function" == typeof r.then)
                ) {
                  if (
                    (null !== (t = n.alternate) && Sa(t, n, a, !0),
                    null !== (n = rs.current))
                  ) {
                    switch (n.tag) {
                      case 13:
                        return (
                          null === as
                            ? qu()
                            : null === n.alternate && 0 === du && (du = 3),
                          (n.flags &= -257),
                          (n.flags |= 65536),
                          (n.lanes = a),
                          r === Ya
                            ? (n.flags |= 16384)
                            : (null === (t = n.updateQueue)
                                ? (n.updateQueue = new Set([r]))
                                : t.add(r),
                              cc(e, r, a)),
                          !1
                        );
                      case 22:
                        return (
                          (n.flags |= 65536),
                          r === Ya
                            ? (n.flags |= 16384)
                            : (null === (t = n.updateQueue)
                                ? ((t = {
                                    transitions: null,
                                    markerInstances: null,
                                    retryQueue: new Set([r]),
                                  }),
                                  (n.updateQueue = t))
                                : null === (n = t.retryQueue)
                                ? (t.retryQueue = new Set([r]))
                                : n.add(r),
                              cc(e, r, a)),
                          !1
                        );
                    }
                    throw Error(i(435, n.tag));
                  }
                  return cc(e, r, a), qu(), !1;
                }
                if (aa)
                  return (
                    null !== (t = rs.current)
                      ? (!(65536 & t.flags) && (t.flags |= 256),
                        (t.flags |= 65536),
                        (t.lanes = a),
                        r !== sa &&
                          ha(xr((e = Error(i(422), { cause: r })), n)))
                      : (r !== sa &&
                          ha(xr((t = Error(i(423), { cause: r })), n)),
                        ((e = e.current.alternate).flags |= 65536),
                        (a &= -a),
                        (e.lanes |= a),
                        (r = xr(r, n)),
                        io(e, (a = Ss(e.stateNode, r, a))),
                        4 !== du && (du = 2)),
                    !1
                  );
                var o = Error(i(520), { cause: r });
                if (
                  ((o = xr(o, n)),
                  null === gu ? (gu = [o]) : gu.push(o),
                  4 !== du && (du = 2),
                  null === t)
                )
                  return !0;
                (r = xr(r, n)), (n = t);
                do {
                  switch (n.tag) {
                    case 3:
                      return (
                        (n.flags |= 65536),
                        (e = a & -a),
                        (n.lanes |= e),
                        io(n, (e = Ss(n.stateNode, r, e))),
                        !1
                      );
                    case 1:
                      if (
                        ((t = n.type),
                        (o = n.stateNode),
                        !(
                          128 & n.flags ||
                          ("function" != typeof t.getDerivedStateFromError &&
                            (null === o ||
                              "function" != typeof o.componentDidCatch ||
                              (null !== xu && xu.has(o))))
                        ))
                      )
                        return (
                          (n.flags |= 65536),
                          (a &= -a),
                          (n.lanes |= a),
                          Ps((a = xs(a)), e, n, r),
                          io(n, a),
                          !1
                        );
                  }
                  n = n.return;
                } while (null !== n);
                return !1;
              })(e, a, t, n, au)
            )
              return (du = 1), ws(e, xr(n, e.current)), void (ru = null);
          } catch (t) {
            if (null !== a) throw ((ru = a), t);
            return (du = 1), ws(e, xr(n, e.current)), void (ru = null);
          }
          32768 & t.flags
            ? (aa || 1 === r
                ? (e = !0)
                : lu || 536870912 & au
                ? (e = !1)
                : ((su = e = !0),
                  (2 === r || 9 === r || 3 === r || 6 === r) &&
                    null !== (r = rs.current) &&
                    13 === r.tag &&
                    (r.flags |= 16384)),
              ec(t, e))
            : Ju(t);
        }
        function Ju(e) {
          var t = e;
          do {
            if (32768 & t.flags) return void ec(t, su);
            e = t.return;
            var n = nl(t.alternate, t, cu);
            if (null !== n) return void (ru = n);
            if (null !== (t = t.sibling)) return void (ru = t);
            ru = t = e;
          } while (null !== t);
          0 === du && (du = 5);
        }
        function ec(e, t) {
          do {
            var n = rl(e.alternate, e);
            if (null !== n) return (n.flags &= 32767), void (ru = n);
            if (
              (null !== (n = e.return) &&
                ((n.flags |= 32768),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
              !t && null !== (e = e.sibling))
            )
              return void (ru = e);
            ru = e = n;
          } while (null !== e);
          (du = 6), (ru = null);
        }
        function tc(e, t, n, r, a, o, s, l, u) {
          e.cancelPendingCommit = null;
          do {
            ic();
          } while (0 !== Pu);
          if (6 & tu) throw Error(i(327));
          if (null !== t) {
            if (t === e.current) throw Error(i(177));
            if (
              ((o = t.lanes | t.childLanes),
              (function (e, t, n, r, a, o) {
                var i = e.pendingLanes;
                (e.pendingLanes = n),
                  (e.suspendedLanes = 0),
                  (e.pingedLanes = 0),
                  (e.warmLanes = 0),
                  (e.expiredLanes &= n),
                  (e.entangledLanes &= n),
                  (e.errorRecoveryDisabledLanes &= n),
                  (e.shellSuspendCounter = 0);
                var s = e.entanglements,
                  l = e.expirationTimes,
                  u = e.hiddenUpdates;
                for (n = i & ~n; 0 < n; ) {
                  var c = 31 - fe(n),
                    d = 1 << c;
                  (s[c] = 0), (l[c] = -1);
                  var f = u[c];
                  if (null !== f)
                    for (u[c] = null, c = 0; c < f.length; c++) {
                      var p = f[c];
                      null !== p && (p.lane &= -536870913);
                    }
                  n &= ~d;
                }
                0 !== r && Ee(e, r, 0),
                  0 !== o &&
                    0 === a &&
                    0 !== e.tag &&
                    (e.suspendedLanes |= o & ~(i & ~t));
              })(e, n, (o |= Cr), s, l, u),
              e === nu && ((ru = nu = null), (au = 0)),
              (Cu = t),
              (Eu = e),
              (Tu = n),
              (Au = o),
              (Mu = a),
              (Lu = r),
              10256 & t.subtreeFlags || 10256 & t.flags
                ? ((e.callbackNode = null),
                  (e.callbackPriority = 0),
                  X(ae, function () {
                    return sc(), null;
                  }))
                : ((e.callbackNode = null), (e.callbackPriority = 0)),
              (r = !!(13878 & t.flags)),
              13878 & t.subtreeFlags || r)
            ) {
              (r = z.T),
                (z.T = null),
                (a = N.p),
                (N.p = 2),
                (s = tu),
                (tu |= 4);
              try {
                !(function (e, t) {
                  if (((e = e.containerInfo), (ed = Jd), er((e = Jn(e))))) {
                    if ("selectionStart" in e)
                      var n = { start: e.selectionStart, end: e.selectionEnd };
                    else
                      e: {
                        var r =
                          (n =
                            ((n = e.ownerDocument) && n.defaultView) || window)
                            .getSelection && n.getSelection();
                        if (r && 0 !== r.rangeCount) {
                          n = r.anchorNode;
                          var a = r.anchorOffset,
                            o = r.focusNode;
                          r = r.focusOffset;
                          try {
                            n.nodeType, o.nodeType;
                          } catch (e) {
                            n = null;
                            break e;
                          }
                          var s = 0,
                            l = -1,
                            u = -1,
                            c = 0,
                            d = 0,
                            f = e,
                            p = null;
                          t: for (;;) {
                            for (
                              var h;
                              f !== n ||
                                (0 !== a && 3 !== f.nodeType) ||
                                (l = s + a),
                                f !== o ||
                                  (0 !== r && 3 !== f.nodeType) ||
                                  (u = s + r),
                                3 === f.nodeType && (s += f.nodeValue.length),
                                null !== (h = f.firstChild);

                            )
                              (p = f), (f = h);
                            for (;;) {
                              if (f === e) break t;
                              if (
                                (p === n && ++c === a && (l = s),
                                p === o && ++d === r && (u = s),
                                null !== (h = f.nextSibling))
                              )
                                break;
                              p = (f = p).parentNode;
                            }
                            f = h;
                          }
                          n =
                            -1 === l || -1 === u ? null : { start: l, end: u };
                        } else n = null;
                      }
                    n = n || { start: 0, end: 0 };
                  } else n = null;
                  for (
                    td = { focusedElem: e, selectionRange: n }, Jd = !1, Sl = t;
                    null !== Sl;

                  )
                    if (
                      ((e = (t = Sl).child),
                      1024 & t.subtreeFlags && null !== e)
                    )
                      (e.return = t), (Sl = e);
                    else
                      for (; null !== Sl; ) {
                        switch (
                          ((o = (t = Sl).alternate), (e = t.flags), t.tag)
                        ) {
                          case 0:
                          case 11:
                          case 15:
                          case 5:
                          case 26:
                          case 27:
                          case 6:
                          case 4:
                          case 17:
                            break;
                          case 1:
                            if (1024 & e && null !== o) {
                              (e = void 0),
                                (n = t),
                                (a = o.memoizedProps),
                                (o = o.memoizedState),
                                (r = n.stateNode);
                              try {
                                var m = ms(n.type, a, (n.elementType, n.type));
                                (e = r.getSnapshotBeforeUpdate(m, o)),
                                  (r.__reactInternalSnapshotBeforeUpdate = e);
                              } catch (e) {
                                uc(n, n.return, e);
                              }
                            }
                            break;
                          case 3:
                            if (1024 & e)
                              if (
                                9 ===
                                (n = (e = t.stateNode.containerInfo).nodeType)
                              )
                                hd(e);
                              else if (1 === n)
                                switch (e.nodeName) {
                                  case "HEAD":
                                  case "HTML":
                                  case "BODY":
                                    hd(e);
                                    break;
                                  default:
                                    e.textContent = "";
                                }
                            break;
                          default:
                            if (1024 & e) throw Error(i(163));
                        }
                        if (null !== (e = t.sibling)) {
                          (e.return = t.return), (Sl = e);
                          break;
                        }
                        Sl = t.return;
                      }
                })(e, t);
              } finally {
                (tu = s), (N.p = a), (z.T = r);
              }
            }
            (Pu = 1), nc(), rc(), ac();
          }
        }
        function nc() {
          if (1 === Pu) {
            Pu = 0;
            var e = Eu,
              t = Cu,
              n = !!(13878 & t.flags);
            if (13878 & t.subtreeFlags || n) {
              (n = z.T), (z.T = null);
              var r = N.p;
              N.p = 2;
              var a = tu;
              tu |= 4;
              try {
                zl(t, e);
                var o = td,
                  i = Jn(e.containerInfo),
                  s = o.focusedElem,
                  l = o.selectionRange;
                if (
                  i !== s &&
                  s &&
                  s.ownerDocument &&
                  Zn(s.ownerDocument.documentElement, s)
                ) {
                  if (null !== l && er(s)) {
                    var u = l.start,
                      c = l.end;
                    if ((void 0 === c && (c = u), "selectionStart" in s))
                      (s.selectionStart = u),
                        (s.selectionEnd = Math.min(c, s.value.length));
                    else {
                      var d = s.ownerDocument || document,
                        f = (d && d.defaultView) || window;
                      if (f.getSelection) {
                        var p = f.getSelection(),
                          h = s.textContent.length,
                          m = Math.min(l.start, h),
                          y = void 0 === l.end ? m : Math.min(l.end, h);
                        !p.extend && m > y && ((i = y), (y = m), (m = i));
                        var g = Gn(s, m),
                          v = Gn(s, y);
                        if (
                          g &&
                          v &&
                          (1 !== p.rangeCount ||
                            p.anchorNode !== g.node ||
                            p.anchorOffset !== g.offset ||
                            p.focusNode !== v.node ||
                            p.focusOffset !== v.offset)
                        ) {
                          var b = d.createRange();
                          b.setStart(g.node, g.offset),
                            p.removeAllRanges(),
                            m > y
                              ? (p.addRange(b), p.extend(v.node, v.offset))
                              : (b.setEnd(v.node, v.offset), p.addRange(b));
                        }
                      }
                    }
                  }
                  for (d = [], p = s; (p = p.parentNode); )
                    1 === p.nodeType &&
                      d.push({
                        element: p,
                        left: p.scrollLeft,
                        top: p.scrollTop,
                      });
                  for (
                    "function" == typeof s.focus && s.focus(), s = 0;
                    s < d.length;
                    s++
                  ) {
                    var w = d[s];
                    (w.element.scrollLeft = w.left),
                      (w.element.scrollTop = w.top);
                  }
                }
                (Jd = !!ed), (td = ed = null);
              } finally {
                (tu = a), (N.p = r), (z.T = n);
              }
            }
            (e.current = t), (Pu = 2);
          }
        }
        function rc() {
          if (2 === Pu) {
            Pu = 0;
            var e = Eu,
              t = Cu,
              n = !!(8772 & t.flags);
            if (8772 & t.subtreeFlags || n) {
              (n = z.T), (z.T = null);
              var r = N.p;
              N.p = 2;
              var a = tu;
              tu |= 4;
              try {
                xl(e, t.alternate, t);
              } finally {
                (tu = a), (N.p = r), (z.T = n);
              }
            }
            Pu = 3;
          }
        }
        function ac() {
          if (4 === Pu || 3 === Pu) {
            (Pu = 0), J();
            var e = Eu,
              t = Cu,
              n = Tu,
              r = Lu;
            10256 & t.subtreeFlags || 10256 & t.flags
              ? (Pu = 5)
              : ((Pu = 0), (Cu = Eu = null), oc(e, e.pendingLanes));
            var a = e.pendingLanes;
            if (
              (0 === a && (xu = null),
              Ae(n),
              (t = t.stateNode),
              ce && "function" == typeof ce.onCommitFiberRoot)
            )
              try {
                ce.onCommitFiberRoot(ue, t, void 0, !(128 & ~t.current.flags));
              } catch (e) {}
            if (null !== r) {
              (t = z.T), (a = N.p), (N.p = 2), (z.T = null);
              try {
                for (var o = e.onRecoverableError, i = 0; i < r.length; i++) {
                  var s = r[i];
                  o(s.value, { componentStack: s.stack });
                }
              } finally {
                (z.T = t), (N.p = a);
              }
            }
            3 & Tu && ic(),
              kc(e),
              (a = e.pendingLanes),
              4194090 & n && 42 & a
                ? e === Ru
                  ? Du++
                  : ((Du = 0), (Ru = e))
                : (Du = 0),
              Sc(0, !1);
          }
        }
        function oc(e, t) {
          0 == (e.pooledCacheLanes &= t) &&
            null != (t = e.pooledCache) &&
            ((e.pooledCache = null), za(t));
        }
        function ic(e) {
          return nc(), rc(), ac(), sc();
        }
        function sc() {
          if (5 !== Pu) return !1;
          var e = Eu,
            t = Au;
          Au = 0;
          var n = Ae(Tu),
            r = z.T,
            a = N.p;
          try {
            (N.p = 32 > n ? 32 : n), (z.T = null), (n = Mu), (Mu = null);
            var o = Eu,
              s = Tu;
            if (((Pu = 0), (Cu = Eu = null), (Tu = 0), 6 & tu))
              throw Error(i(331));
            var l = tu;
            if (
              ((tu |= 4),
              Xl(o.current),
              Bl(o, o.current, s, n),
              (tu = l),
              Sc(0, !1),
              ce && "function" == typeof ce.onPostCommitFiberRoot)
            )
              try {
                ce.onPostCommitFiberRoot(ue, o);
              } catch (e) {}
            return !0;
          } finally {
            (N.p = a), (z.T = r), oc(e, t);
          }
        }
        function lc(e, t, n) {
          (t = xr(n, t)),
            null !== (e = ao(e, (t = Ss(e.stateNode, t, 2)), 2)) &&
              (Pe(e, 2), kc(e));
        }
        function uc(e, t, n) {
          if (3 === e.tag) lc(e, e, n);
          else
            for (; null !== t; ) {
              if (3 === t.tag) {
                lc(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  "function" == typeof t.type.getDerivedStateFromError ||
                  ("function" == typeof r.componentDidCatch &&
                    (null === xu || !xu.has(r)))
                ) {
                  (e = xr(n, e)),
                    null !== (r = ao(t, (n = xs(2)), 2)) &&
                      (Ps(n, r, t, e), Pe(r, 2), kc(r));
                  break;
                }
              }
              t = t.return;
            }
        }
        function cc(e, t, n) {
          var r = e.pingCache;
          if (null === r) {
            r = e.pingCache = new eu();
            var a = new Set();
            r.set(t, a);
          } else void 0 === (a = r.get(t)) && ((a = new Set()), r.set(t, a));
          a.has(n) ||
            ((uu = !0), a.add(n), (e = dc.bind(null, e, t, n)), t.then(e, e));
        }
        function dc(e, t, n) {
          var r = e.pingCache;
          null !== r && r.delete(t),
            (e.pingedLanes |= e.suspendedLanes & n),
            (e.warmLanes &= ~n),
            nu === e &&
              (au & n) === n &&
              (4 === du ||
              (3 === du && (62914560 & au) === au && 300 > ee() - wu)
                ? !(2 & tu) && Bu(e, 0)
                : (hu |= n),
              yu === au && (yu = 0)),
            kc(e);
        }
        function fc(e, t) {
          0 === t && (t = Se()), null !== (e = Lr(e, t)) && (Pe(e, t), kc(e));
        }
        function pc(e) {
          var t = e.memoizedState,
            n = 0;
          null !== t && (n = t.retryLane), fc(e, n);
        }
        function hc(e, t) {
          var n = 0;
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                a = e.memoizedState;
              null !== a && (n = a.retryLane);
              break;
            case 19:
              r = e.stateNode;
              break;
            case 22:
              r = e.stateNode._retryCache;
              break;
            default:
              throw Error(i(314));
          }
          null !== r && r.delete(t), fc(e, n);
        }
        var mc = null,
          yc = null,
          gc = !1,
          vc = !1,
          bc = !1,
          wc = 0;
        function kc(e) {
          e !== yc &&
            null === e.next &&
            (null === yc ? (mc = yc = e) : (yc = yc.next = e)),
            (vc = !0),
            gc ||
              ((gc = !0),
              cd(function () {
                6 & tu ? X(ne, xc) : Pc();
              }));
        }
        function Sc(e, t) {
          if (!bc && vc) {
            bc = !0;
            do {
              for (var n = !1, r = mc; null !== r; ) {
                if (!t)
                  if (0 !== e) {
                    var a = r.pendingLanes;
                    if (0 === a) var o = 0;
                    else {
                      var i = r.suspendedLanes,
                        s = r.pingedLanes;
                      (o = (1 << (31 - fe(42 | e) + 1)) - 1),
                        (o =
                          201326741 & (o &= a & ~(i & ~s))
                            ? (201326741 & o) | 1
                            : o
                            ? 2 | o
                            : 0);
                    }
                    0 !== o && ((n = !0), Tc(r, o));
                  } else
                    (o = au),
                      !(
                        3 &
                        (o = ve(
                          r,
                          r === nu ? o : 0,
                          null !== r.cancelPendingCommit ||
                            -1 !== r.timeoutHandle
                        ))
                      ) ||
                        be(r, o) ||
                        ((n = !0), Tc(r, o));
                r = r.next;
              }
            } while (n);
            bc = !1;
          }
        }
        function xc() {
          Pc();
        }
        function Pc() {
          vc = gc = !1;
          var e,
            t = 0;
          0 !== wc &&
            (((e = window.event) && "popstate" === e.type
              ? e !== id && ((id = e), !0)
              : ((id = null), !1)) && (t = wc),
            (wc = 0));
          for (var n = ee(), r = null, a = mc; null !== a; ) {
            var o = a.next,
              i = Ec(a, n);
            0 === i
              ? ((a.next = null),
                null === r ? (mc = o) : (r.next = o),
                null === o && (yc = r))
              : ((r = a), (0 !== t || 3 & i) && (vc = !0)),
              (a = o);
          }
          Sc(t, !1);
        }
        function Ec(e, t) {
          for (
            var n = e.suspendedLanes,
              r = e.pingedLanes,
              a = e.expirationTimes,
              o = -62914561 & e.pendingLanes;
            0 < o;

          ) {
            var i = 31 - fe(o),
              s = 1 << i,
              l = a[i];
            -1 === l
              ? (s & n && !(s & r)) || (a[i] = we(s, t))
              : l <= t && (e.expiredLanes |= s),
              (o &= ~s);
          }
          if (
            ((n = au),
            (n = ve(
              e,
              e === (t = nu) ? n : 0,
              null !== e.cancelPendingCommit || -1 !== e.timeoutHandle
            )),
            (r = e.callbackNode),
            0 === n ||
              (e === t && (2 === ou || 9 === ou)) ||
              null !== e.cancelPendingCommit)
          )
            return (
              null !== r && null !== r && G(r),
              (e.callbackNode = null),
              (e.callbackPriority = 0)
            );
          if (!(3 & n) || be(e, n)) {
            if ((t = n & -n) === e.callbackPriority) return t;
            switch ((null !== r && G(r), Ae(n))) {
              case 2:
              case 8:
                n = re;
                break;
              case 32:
              default:
                n = ae;
                break;
              case 268435456:
                n = ie;
            }
            return (
              (r = Cc.bind(null, e)),
              (n = X(n, r)),
              (e.callbackPriority = t),
              (e.callbackNode = n),
              t
            );
          }
          return (
            null !== r && null !== r && G(r),
            (e.callbackPriority = 2),
            (e.callbackNode = null),
            2
          );
        }
        function Cc(e, t) {
          if (0 !== Pu && 5 !== Pu)
            return (e.callbackNode = null), (e.callbackPriority = 0), null;
          var n = e.callbackNode;
          if (ic() && e.callbackNode !== n) return null;
          var r = au;
          return 0 ===
            (r = ve(
              e,
              e === nu ? r : 0,
              null !== e.cancelPendingCommit || -1 !== e.timeoutHandle
            ))
            ? null
            : (Ou(e, r, t),
              Ec(e, ee()),
              null != e.callbackNode && e.callbackNode === n
                ? Cc.bind(null, e)
                : null);
        }
        function Tc(e, t) {
          if (ic()) return null;
          Ou(e, t, !0);
        }
        function Ac() {
          return 0 === wc && (wc = ke()), wc;
        }
        function Mc(e) {
          return null == e || "symbol" == typeof e || "boolean" == typeof e
            ? null
            : "function" == typeof e
            ? e
            : At("" + e);
        }
        function Lc(e, t) {
          var n = t.ownerDocument.createElement("input");
          return (
            (n.name = t.name),
            (n.value = t.value),
            e.id && n.setAttribute("form", e.id),
            t.parentNode.insertBefore(n, t),
            (e = new FormData(e)),
            n.parentNode.removeChild(n),
            e
          );
        }
        for (var Dc = 0; Dc < wr.length; Dc++) {
          var Rc = wr[Dc];
          kr(Rc.toLowerCase(), "on" + (Rc[0].toUpperCase() + Rc.slice(1)));
        }
        kr(fr, "onAnimationEnd"),
          kr(pr, "onAnimationIteration"),
          kr(hr, "onAnimationStart"),
          kr("dblclick", "onDoubleClick"),
          kr("focusin", "onFocus"),
          kr("focusout", "onBlur"),
          kr(mr, "onTransitionRun"),
          kr(yr, "onTransitionStart"),
          kr(gr, "onTransitionCancel"),
          kr(vr, "onTransitionEnd"),
          Ke("onMouseEnter", ["mouseout", "mouseover"]),
          Ke("onMouseLeave", ["mouseout", "mouseover"]),
          Ke("onPointerEnter", ["pointerout", "pointerover"]),
          Ke("onPointerLeave", ["pointerout", "pointerover"]),
          Ye(
            "onChange",
            "change click focusin focusout input keydown keyup selectionchange".split(
              " "
            )
          ),
          Ye(
            "onSelect",
            "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
              " "
            )
          ),
          Ye("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste",
          ]),
          Ye(
            "onCompositionEnd",
            "compositionend focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          Ye(
            "onCompositionStart",
            "compositionstart focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          Ye(
            "onCompositionUpdate",
            "compositionupdate focusout keydown keypress keyup mousedown".split(
              " "
            )
          );
        var zc =
            "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
              " "
            ),
          Nc = new Set(
            "beforetoggle cancel close invalid load scroll scrollend toggle"
              .split(" ")
              .concat(zc)
          );
        function Fc(e, t) {
          t = !!(4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              a = r.event;
            r = r.listeners;
            e: {
              var o = void 0;
              if (t)
                for (var i = r.length - 1; 0 <= i; i--) {
                  var s = r[i],
                    l = s.instance,
                    u = s.currentTarget;
                  if (((s = s.listener), l !== o && a.isPropagationStopped()))
                    break e;
                  (o = s), (a.currentTarget = u);
                  try {
                    o(a);
                  } catch (e) {
                    ys(e);
                  }
                  (a.currentTarget = null), (o = l);
                }
              else
                for (i = 0; i < r.length; i++) {
                  if (
                    ((l = (s = r[i]).instance),
                    (u = s.currentTarget),
                    (s = s.listener),
                    l !== o && a.isPropagationStopped())
                  )
                    break e;
                  (o = s), (a.currentTarget = u);
                  try {
                    o(a);
                  } catch (e) {
                    ys(e);
                  }
                  (a.currentTarget = null), (o = l);
                }
            }
          }
        }
        function Oc(e, t) {
          var n = t[Ne];
          void 0 === n && (n = t[Ne] = new Set());
          var r = e + "__bubble";
          n.has(r) || (jc(t, e, 2, !1), n.add(r));
        }
        function _c(e, t, n) {
          var r = 0;
          t && (r |= 4), jc(n, e, r, t);
        }
        var Ic = "_reactListening" + Math.random().toString(36).slice(2);
        function Vc(e) {
          if (!e[Ic]) {
            (e[Ic] = !0),
              $e.forEach(function (t) {
                "selectionchange" !== t &&
                  (Nc.has(t) || _c(t, !1, e), _c(t, !0, e));
              });
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Ic] || ((t[Ic] = !0), _c("selectionchange", !1, t));
          }
        }
        function jc(e, t, n, r) {
          switch (sf(t)) {
            case 2:
              var a = ef;
              break;
            case 8:
              a = tf;
              break;
            default:
              a = nf;
          }
          (n = a.bind(null, t, n, e)),
            (a = void 0),
            !It ||
              ("touchstart" !== t && "touchmove" !== t && "wheel" !== t) ||
              (a = !0),
            r
              ? void 0 !== a
                ? e.addEventListener(t, n, { capture: !0, passive: a })
                : e.addEventListener(t, n, !0)
              : void 0 !== a
              ? e.addEventListener(t, n, { passive: a })
              : e.addEventListener(t, n, !1);
        }
        function Uc(e, t, n, r, a) {
          var o = r;
          if (!(1 & t || 2 & t || null === r))
            e: for (;;) {
              if (null === r) return;
              var i = r.tag;
              if (3 === i || 4 === i) {
                var l = r.stateNode.containerInfo;
                if (l === a) break;
                if (4 === i)
                  for (i = r.return; null !== i; ) {
                    var u = i.tag;
                    if ((3 === u || 4 === u) && i.stateNode.containerInfo === a)
                      return;
                    i = i.return;
                  }
                for (; null !== l; ) {
                  if (null === (i = je(l))) return;
                  if (5 === (u = i.tag) || 6 === u || 26 === u || 27 === u) {
                    r = o = i;
                    continue e;
                  }
                  l = l.parentNode;
                }
              }
              r = r.return;
            }
          Ft(function () {
            var r = o,
              a = Lt(n),
              i = [];
            e: {
              var l = br.get(e);
              if (void 0 !== l) {
                var u = Zt,
                  c = e;
                switch (e) {
                  case "keypress":
                    if (0 === Ht(n)) break e;
                  case "keydown":
                  case "keyup":
                    u = hn;
                    break;
                  case "focusin":
                    (c = "focus"), (u = an);
                    break;
                  case "focusout":
                    (c = "blur"), (u = an);
                    break;
                  case "beforeblur":
                  case "afterblur":
                    u = an;
                    break;
                  case "click":
                    if (2 === n.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    u = nn;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    u = rn;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    u = yn;
                    break;
                  case fr:
                  case pr:
                  case hr:
                    u = on;
                    break;
                  case vr:
                    u = gn;
                    break;
                  case "scroll":
                  case "scrollend":
                    u = en;
                    break;
                  case "wheel":
                    u = vn;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    u = sn;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    u = mn;
                    break;
                  case "toggle":
                  case "beforetoggle":
                    u = bn;
                }
                var d = !!(4 & t),
                  f = !d && ("scroll" === e || "scrollend" === e),
                  p = d ? (null !== l ? l + "Capture" : null) : l;
                d = [];
                for (var h, m = r; null !== m; ) {
                  var y = m;
                  if (
                    ((h = y.stateNode),
                    (5 !== (y = y.tag) && 26 !== y && 27 !== y) ||
                      null === h ||
                      null === p ||
                      (null != (y = Ot(m, p)) && d.push(Bc(m, y, h))),
                    f)
                  )
                    break;
                  m = m.return;
                }
                0 < d.length &&
                  ((l = new u(l, c, null, n, a)),
                  i.push({ event: l, listeners: d }));
              }
            }
            if (!(7 & t)) {
              if (
                ((u = "mouseout" === e || "pointerout" === e),
                (!(l = "mouseover" === e || "pointerover" === e) ||
                  n === Mt ||
                  !(c = n.relatedTarget || n.fromElement) ||
                  (!je(c) && !c[ze])) &&
                  (u || l) &&
                  ((l =
                    a.window === a
                      ? a
                      : (l = a.ownerDocument)
                      ? l.defaultView || l.parentWindow
                      : window),
                  u
                    ? ((u = r),
                      null !==
                        (c = (c = n.relatedTarget || n.toElement)
                          ? je(c)
                          : null) &&
                        ((f = s(c)),
                        (d = c.tag),
                        c !== f || (5 !== d && 27 !== d && 6 !== d)) &&
                        (c = null))
                    : ((u = null), (c = r)),
                  u !== c))
              ) {
                if (
                  ((d = nn),
                  (y = "onMouseLeave"),
                  (p = "onMouseEnter"),
                  (m = "mouse"),
                  ("pointerout" !== e && "pointerover" !== e) ||
                    ((d = mn),
                    (y = "onPointerLeave"),
                    (p = "onPointerEnter"),
                    (m = "pointer")),
                  (f = null == u ? l : Be(u)),
                  (h = null == c ? l : Be(c)),
                  ((l = new d(y, m + "leave", u, n, a)).target = f),
                  (l.relatedTarget = h),
                  (y = null),
                  je(a) === r &&
                    (((d = new d(p, m + "enter", c, n, a)).target = h),
                    (d.relatedTarget = f),
                    (y = d)),
                  (f = y),
                  u && c)
                )
                  e: {
                    for (p = c, m = 0, h = d = u; h; h = Hc(h)) m++;
                    for (h = 0, y = p; y; y = Hc(y)) h++;
                    for (; 0 < m - h; ) (d = Hc(d)), m--;
                    for (; 0 < h - m; ) (p = Hc(p)), h--;
                    for (; m--; ) {
                      if (d === p || (null !== p && d === p.alternate)) break e;
                      (d = Hc(d)), (p = Hc(p));
                    }
                    d = null;
                  }
                else d = null;
                null !== u && $c(i, l, u, d, !1),
                  null !== c && null !== f && $c(i, f, c, d, !0);
              }
              if (
                "select" ===
                  (u =
                    (l = r ? Be(r) : window).nodeName &&
                    l.nodeName.toLowerCase()) ||
                ("input" === u && "file" === l.type)
              )
                var g = _n;
              else if (Dn(l))
                if (In) g = Yn;
                else {
                  g = $n;
                  var v = Hn;
                }
              else
                !(u = l.nodeName) ||
                "input" !== u.toLowerCase() ||
                ("checkbox" !== l.type && "radio" !== l.type)
                  ? r && Et(r.elementType) && (g = _n)
                  : (g = qn);
              switch (
                (g && (g = g(e, r))
                  ? Rn(i, g, n, a)
                  : (v && v(e, l, r),
                    "focusout" === e &&
                      r &&
                      "number" === l.type &&
                      null != r.memoizedProps.value &&
                      gt(l, "number", l.value)),
                (v = r ? Be(r) : window),
                e)
              ) {
                case "focusin":
                  (Dn(v) || "true" === v.contentEditable) &&
                    ((nr = v), (rr = r), (ar = null));
                  break;
                case "focusout":
                  ar = rr = nr = null;
                  break;
                case "mousedown":
                  or = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  (or = !1), ir(i, n, a);
                  break;
                case "selectionchange":
                  if (tr) break;
                case "keydown":
                case "keyup":
                  ir(i, n, a);
              }
              var b;
              if (kn)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var w = "onCompositionStart";
                      break e;
                    case "compositionend":
                      w = "onCompositionEnd";
                      break e;
                    case "compositionupdate":
                      w = "onCompositionUpdate";
                      break e;
                  }
                  w = void 0;
                }
              else
                Mn
                  ? Tn(e, n) && (w = "onCompositionEnd")
                  : "keydown" === e &&
                    229 === n.keyCode &&
                    (w = "onCompositionStart");
              w &&
                (Pn &&
                  "ko" !== n.locale &&
                  (Mn || "onCompositionStart" !== w
                    ? "onCompositionEnd" === w && Mn && (b = Wt())
                    : ((Ut = "value" in (jt = a) ? jt.value : jt.textContent),
                      (Mn = !0))),
                0 < (v = Wc(r, w)).length &&
                  ((w = new ln(w, e, null, n, a)),
                  i.push({ event: w, listeners: v }),
                  (b || null !== (b = An(n))) && (w.data = b))),
                (b = xn
                  ? (function (e, t) {
                      switch (e) {
                        case "compositionend":
                          return An(t);
                        case "keypress":
                          return 32 !== t.which ? null : ((Cn = !0), En);
                        case "textInput":
                          return (e = t.data) === En && Cn ? null : e;
                        default:
                          return null;
                      }
                    })(e, n)
                  : (function (e, t) {
                      if (Mn)
                        return "compositionend" === e || (!kn && Tn(e, t))
                          ? ((e = Wt()), (Bt = Ut = jt = null), (Mn = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                        default:
                          return null;
                        case "keypress":
                          if (
                            !(t.ctrlKey || t.altKey || t.metaKey) ||
                            (t.ctrlKey && t.altKey)
                          ) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case "compositionend":
                          return Pn && "ko" !== t.locale ? null : t.data;
                      }
                    })(e, n)) &&
                  0 < (w = Wc(r, "onBeforeInput")).length &&
                  ((v = new ln("onBeforeInput", "beforeinput", null, n, a)),
                  i.push({ event: v, listeners: w }),
                  (v.data = b)),
                (function (e, t, n, r, a) {
                  if ("submit" === t && n && n.stateNode === a) {
                    var o = Mc((a[Re] || null).action),
                      i = r.submitter;
                    i &&
                      null !==
                        (t = (t = i[Re] || null)
                          ? Mc(t.formAction)
                          : i.getAttribute("formAction")) &&
                      ((o = t), (i = null));
                    var s = new Zt("action", "action", null, r, a);
                    e.push({
                      event: s,
                      listeners: [
                        {
                          instance: null,
                          listener: function () {
                            if (r.defaultPrevented) {
                              if (0 !== wc) {
                                var e = i ? Lc(a, i) : new FormData(a);
                                Li(
                                  n,
                                  {
                                    pending: !0,
                                    data: e,
                                    method: a.method,
                                    action: o,
                                  },
                                  null,
                                  e
                                );
                              }
                            } else
                              "function" == typeof o &&
                                (s.preventDefault(),
                                (e = i ? Lc(a, i) : new FormData(a)),
                                Li(
                                  n,
                                  {
                                    pending: !0,
                                    data: e,
                                    method: a.method,
                                    action: o,
                                  },
                                  o,
                                  e
                                ));
                          },
                          currentTarget: a,
                        },
                      ],
                    });
                  }
                })(i, e, r, n, a);
            }
            Fc(i, t);
          });
        }
        function Bc(e, t, n) {
          return { instance: e, listener: t, currentTarget: n };
        }
        function Wc(e, t) {
          for (var n = t + "Capture", r = []; null !== e; ) {
            var a = e,
              o = a.stateNode;
            if (
              ((5 !== (a = a.tag) && 26 !== a && 27 !== a) ||
                null === o ||
                (null != (a = Ot(e, n)) && r.unshift(Bc(e, a, o)),
                null != (a = Ot(e, t)) && r.push(Bc(e, a, o))),
              3 === e.tag)
            )
              return r;
            e = e.return;
          }
          return [];
        }
        function Hc(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag && 27 !== e.tag);
          return e || null;
        }
        function $c(e, t, n, r, a) {
          for (var o = t._reactName, i = []; null !== n && n !== r; ) {
            var s = n,
              l = s.alternate,
              u = s.stateNode;
            if (((s = s.tag), null !== l && l === r)) break;
            (5 !== s && 26 !== s && 27 !== s) ||
              null === u ||
              ((l = u),
              a
                ? null != (u = Ot(n, o)) && i.unshift(Bc(n, u, l))
                : a || (null != (u = Ot(n, o)) && i.push(Bc(n, u, l)))),
              (n = n.return);
          }
          0 !== i.length && e.push({ event: t, listeners: i });
        }
        var qc = /\r\n?/g,
          Yc = /\u0000|\uFFFD/g;
        function Kc(e) {
          return ("string" == typeof e ? e : "" + e)
            .replace(qc, "\n")
            .replace(Yc, "");
        }
        function Qc(e, t) {
          return (t = Kc(t)), Kc(e) === t;
        }
        function Xc() {}
        function Gc(e, t, n, r, a, o) {
          switch (n) {
            case "children":
              "string" == typeof r
                ? "body" === t || ("textarea" === t && "" === r) || kt(e, r)
                : ("number" == typeof r || "bigint" == typeof r) &&
                  "body" !== t &&
                  kt(e, "" + r);
              break;
            case "className":
              tt(e, "class", r);
              break;
            case "tabIndex":
              tt(e, "tabindex", r);
              break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
              tt(e, n, r);
              break;
            case "style":
              Pt(e, r, o);
              break;
            case "data":
              if ("object" !== t) {
                tt(e, "data", r);
                break;
              }
            case "src":
            case "href":
              if ("" === r && ("a" !== t || "href" !== n)) {
                e.removeAttribute(n);
                break;
              }
              if (
                null == r ||
                "function" == typeof r ||
                "symbol" == typeof r ||
                "boolean" == typeof r
              ) {
                e.removeAttribute(n);
                break;
              }
              (r = At("" + r)), e.setAttribute(n, r);
              break;
            case "action":
            case "formAction":
              if ("function" == typeof r) {
                e.setAttribute(
                  n,
                  "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                );
                break;
              }
              if (
                ("function" == typeof o &&
                  ("formAction" === n
                    ? ("input" !== t && Gc(e, t, "name", a.name, a, null),
                      Gc(e, t, "formEncType", a.formEncType, a, null),
                      Gc(e, t, "formMethod", a.formMethod, a, null),
                      Gc(e, t, "formTarget", a.formTarget, a, null))
                    : (Gc(e, t, "encType", a.encType, a, null),
                      Gc(e, t, "method", a.method, a, null),
                      Gc(e, t, "target", a.target, a, null))),
                null == r || "symbol" == typeof r || "boolean" == typeof r)
              ) {
                e.removeAttribute(n);
                break;
              }
              (r = At("" + r)), e.setAttribute(n, r);
              break;
            case "onClick":
              null != r && (e.onclick = Xc);
              break;
            case "onScroll":
              null != r && Oc("scroll", e);
              break;
            case "onScrollEnd":
              null != r && Oc("scrollend", e);
              break;
            case "dangerouslySetInnerHTML":
              if (null != r) {
                if ("object" != typeof r || !("__html" in r))
                  throw Error(i(61));
                if (null != (n = r.__html)) {
                  if (null != a.children) throw Error(i(60));
                  e.innerHTML = n;
                }
              }
              break;
            case "multiple":
              e.multiple = r && "function" != typeof r && "symbol" != typeof r;
              break;
            case "muted":
              e.muted = r && "function" != typeof r && "symbol" != typeof r;
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
            case "autoFocus":
              break;
            case "xlinkHref":
              if (
                null == r ||
                "function" == typeof r ||
                "boolean" == typeof r ||
                "symbol" == typeof r
              ) {
                e.removeAttribute("xlink:href");
                break;
              }
              (n = At("" + r)),
                e.setAttributeNS(
                  "http://www.w3.org/1999/xlink",
                  "xlink:href",
                  n
                );
              break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
              null != r && "function" != typeof r && "symbol" != typeof r
                ? e.setAttribute(n, "" + r)
                : e.removeAttribute(n);
              break;
            case "inert":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
              r && "function" != typeof r && "symbol" != typeof r
                ? e.setAttribute(n, "")
                : e.removeAttribute(n);
              break;
            case "capture":
            case "download":
              !0 === r
                ? e.setAttribute(n, "")
                : !1 !== r &&
                  null != r &&
                  "function" != typeof r &&
                  "symbol" != typeof r
                ? e.setAttribute(n, r)
                : e.removeAttribute(n);
              break;
            case "cols":
            case "rows":
            case "size":
            case "span":
              null != r &&
              "function" != typeof r &&
              "symbol" != typeof r &&
              !isNaN(r) &&
              1 <= r
                ? e.setAttribute(n, r)
                : e.removeAttribute(n);
              break;
            case "rowSpan":
            case "start":
              null == r ||
              "function" == typeof r ||
              "symbol" == typeof r ||
              isNaN(r)
                ? e.removeAttribute(n)
                : e.setAttribute(n, r);
              break;
            case "popover":
              Oc("beforetoggle", e), Oc("toggle", e), et(e, "popover", r);
              break;
            case "xlinkActuate":
              nt(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
              break;
            case "xlinkArcrole":
              nt(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
              break;
            case "xlinkRole":
              nt(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
              break;
            case "xlinkShow":
              nt(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
              break;
            case "xlinkTitle":
              nt(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
              break;
            case "xlinkType":
              nt(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
              break;
            case "xmlBase":
              nt(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
              break;
            case "xmlLang":
              nt(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
              break;
            case "xmlSpace":
              nt(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
              break;
            case "is":
              et(e, "is", r);
              break;
            case "innerText":
            case "textContent":
              break;
            default:
              (!(2 < n.length) ||
                ("o" !== n[0] && "O" !== n[0]) ||
                ("n" !== n[1] && "N" !== n[1])) &&
                et(e, (n = Ct.get(n) || n), r);
          }
        }
        function Zc(e, t, n, r, a, o) {
          switch (n) {
            case "style":
              Pt(e, r, o);
              break;
            case "dangerouslySetInnerHTML":
              if (null != r) {
                if ("object" != typeof r || !("__html" in r))
                  throw Error(i(61));
                if (null != (n = r.__html)) {
                  if (null != a.children) throw Error(i(60));
                  e.innerHTML = n;
                }
              }
              break;
            case "children":
              "string" == typeof r
                ? kt(e, r)
                : ("number" == typeof r || "bigint" == typeof r) &&
                  kt(e, "" + r);
              break;
            case "onScroll":
              null != r && Oc("scroll", e);
              break;
            case "onScrollEnd":
              null != r && Oc("scrollend", e);
              break;
            case "onClick":
              null != r && (e.onclick = Xc);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
            case "innerText":
            case "textContent":
              break;
            default:
              qe.hasOwnProperty(n) ||
                ("o" !== n[0] ||
                "n" !== n[1] ||
                ((a = n.endsWith("Capture")),
                (t = n.slice(2, a ? n.length - 7 : void 0)),
                "function" ==
                  typeof (o = null != (o = e[Re] || null) ? o[n] : null) &&
                  e.removeEventListener(t, o, a),
                "function" != typeof r)
                  ? n in e
                    ? (e[n] = r)
                    : !0 === r
                    ? e.setAttribute(n, "")
                    : et(e, n, r)
                  : ("function" != typeof o &&
                      null !== o &&
                      (n in e
                        ? (e[n] = null)
                        : e.hasAttribute(n) && e.removeAttribute(n)),
                    e.addEventListener(t, r, a)));
          }
        }
        function Jc(e, t, n) {
          switch (t) {
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
              break;
            case "img":
              Oc("error", e), Oc("load", e);
              var r,
                a = !1,
                o = !1;
              for (r in n)
                if (n.hasOwnProperty(r)) {
                  var s = n[r];
                  if (null != s)
                    switch (r) {
                      case "src":
                        a = !0;
                        break;
                      case "srcSet":
                        o = !0;
                        break;
                      case "children":
                      case "dangerouslySetInnerHTML":
                        throw Error(i(137, t));
                      default:
                        Gc(e, t, r, s, n, null);
                    }
                }
              return (
                o && Gc(e, t, "srcSet", n.srcSet, n, null),
                void (a && Gc(e, t, "src", n.src, n, null))
              );
            case "input":
              Oc("invalid", e);
              var l = (r = s = o = null),
                u = null,
                c = null;
              for (a in n)
                if (n.hasOwnProperty(a)) {
                  var d = n[a];
                  if (null != d)
                    switch (a) {
                      case "name":
                        o = d;
                        break;
                      case "type":
                        s = d;
                        break;
                      case "checked":
                        u = d;
                        break;
                      case "defaultChecked":
                        c = d;
                        break;
                      case "value":
                        r = d;
                        break;
                      case "defaultValue":
                        l = d;
                        break;
                      case "children":
                      case "dangerouslySetInnerHTML":
                        if (null != d) throw Error(i(137, t));
                        break;
                      default:
                        Gc(e, t, a, d, n, null);
                    }
                }
              return yt(e, r, l, u, c, s, o, !1), void ct(e);
            case "select":
              for (o in (Oc("invalid", e), (a = s = r = null), n))
                if (n.hasOwnProperty(o) && null != (l = n[o]))
                  switch (o) {
                    case "value":
                      r = l;
                      break;
                    case "defaultValue":
                      s = l;
                      break;
                    case "multiple":
                      a = l;
                    default:
                      Gc(e, t, o, l, n, null);
                  }
              return (
                (t = r),
                (n = s),
                (e.multiple = !!a),
                void (null != t
                  ? vt(e, !!a, t, !1)
                  : null != n && vt(e, !!a, n, !0))
              );
            case "textarea":
              for (s in (Oc("invalid", e), (r = o = a = null), n))
                if (n.hasOwnProperty(s) && null != (l = n[s]))
                  switch (s) {
                    case "value":
                      a = l;
                      break;
                    case "defaultValue":
                      o = l;
                      break;
                    case "children":
                      r = l;
                      break;
                    case "dangerouslySetInnerHTML":
                      if (null != l) throw Error(i(91));
                      break;
                    default:
                      Gc(e, t, s, l, n, null);
                  }
              return wt(e, a, o, r), void ct(e);
            case "option":
              for (u in n)
                n.hasOwnProperty(u) &&
                  null != (a = n[u]) &&
                  ("selected" === u
                    ? (e.selected =
                        a && "function" != typeof a && "symbol" != typeof a)
                    : Gc(e, t, u, a, n, null));
              return;
            case "dialog":
              Oc("beforetoggle", e),
                Oc("toggle", e),
                Oc("cancel", e),
                Oc("close", e);
              break;
            case "iframe":
            case "object":
              Oc("load", e);
              break;
            case "video":
            case "audio":
              for (a = 0; a < zc.length; a++) Oc(zc[a], e);
              break;
            case "image":
              Oc("error", e), Oc("load", e);
              break;
            case "details":
              Oc("toggle", e);
              break;
            case "embed":
            case "source":
            case "link":
              Oc("error", e), Oc("load", e);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
              for (c in n)
                if (n.hasOwnProperty(c) && null != (a = n[c]))
                  switch (c) {
                    case "children":
                    case "dangerouslySetInnerHTML":
                      throw Error(i(137, t));
                    default:
                      Gc(e, t, c, a, n, null);
                  }
              return;
            default:
              if (Et(t)) {
                for (d in n)
                  n.hasOwnProperty(d) &&
                    void 0 !== (a = n[d]) &&
                    Zc(e, t, d, a, n, void 0);
                return;
              }
          }
          for (l in n)
            n.hasOwnProperty(l) &&
              null != (a = n[l]) &&
              Gc(e, t, l, a, n, null);
        }
        var ed = null,
          td = null;
        function nd(e) {
          return 9 === e.nodeType ? e : e.ownerDocument;
        }
        function rd(e) {
          switch (e) {
            case "http://www.w3.org/2000/svg":
              return 1;
            case "http://www.w3.org/1998/Math/MathML":
              return 2;
            default:
              return 0;
          }
        }
        function ad(e, t) {
          if (0 === e)
            switch (t) {
              case "svg":
                return 1;
              case "math":
                return 2;
              default:
                return 0;
            }
          return 1 === e && "foreignObject" === t ? 0 : e;
        }
        function od(e, t) {
          return (
            "textarea" === e ||
            "noscript" === e ||
            "string" == typeof t.children ||
            "number" == typeof t.children ||
            "bigint" == typeof t.children ||
            ("object" == typeof t.dangerouslySetInnerHTML &&
              null !== t.dangerouslySetInnerHTML &&
              null != t.dangerouslySetInnerHTML.__html)
          );
        }
        var id = null,
          sd = "function" == typeof setTimeout ? setTimeout : void 0,
          ld = "function" == typeof clearTimeout ? clearTimeout : void 0,
          ud = "function" == typeof Promise ? Promise : void 0,
          cd =
            "function" == typeof queueMicrotask
              ? queueMicrotask
              : void 0 !== ud
              ? function (e) {
                  return ud.resolve(null).then(e).catch(dd);
                }
              : sd;
        function dd(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function fd(e) {
          return "head" === e;
        }
        function pd(e, t) {
          var n = t,
            r = 0,
            a = 0;
          do {
            var o = n.nextSibling;
            if ((e.removeChild(n), o && 8 === o.nodeType))
              if ("/$" === (n = o.data)) {
                if (0 < r && 8 > r) {
                  n = r;
                  var i = e.ownerDocument;
                  if (
                    (1 & n && wd(i.documentElement), 2 & n && wd(i.body), 4 & n)
                  )
                    for (wd((n = i.head)), i = n.firstChild; i; ) {
                      var s = i.nextSibling,
                        l = i.nodeName;
                      i[Ie] ||
                        "SCRIPT" === l ||
                        "STYLE" === l ||
                        ("LINK" === l &&
                          "stylesheet" === i.rel.toLowerCase()) ||
                        n.removeChild(i),
                        (i = s);
                    }
                }
                if (0 === a) return e.removeChild(o), void Ef(t);
                a--;
              } else
                "$" === n || "$?" === n || "$!" === n
                  ? a++
                  : (r = n.charCodeAt(0) - 48);
            else r = 0;
            n = o;
          } while (n);
          Ef(t);
        }
        function hd(e) {
          var t = e.firstChild;
          for (t && 10 === t.nodeType && (t = t.nextSibling); t; ) {
            var n = t;
            switch (((t = t.nextSibling), n.nodeName)) {
              case "HTML":
              case "HEAD":
              case "BODY":
                hd(n), Ve(n);
                continue;
              case "SCRIPT":
              case "STYLE":
                continue;
              case "LINK":
                if ("stylesheet" === n.rel.toLowerCase()) continue;
            }
            e.removeChild(n);
          }
        }
        function md(e) {
          return (
            "$!" === e.data ||
            ("$?" === e.data && "complete" === e.ownerDocument.readyState)
          );
        }
        function yd(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
              if (
                "$" === (t = e.data) ||
                "$!" === t ||
                "$?" === t ||
                "F!" === t ||
                "F" === t
              )
                break;
              if ("/$" === t) return null;
            }
          }
          return e;
        }
        var gd = null;
        function vd(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("$" === n || "$!" === n || "$?" === n) {
                if (0 === t) return e;
                t--;
              } else "/$" === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        function bd(e, t, n) {
          switch (((t = nd(n)), e)) {
            case "html":
              if (!(e = t.documentElement)) throw Error(i(452));
              return e;
            case "head":
              if (!(e = t.head)) throw Error(i(453));
              return e;
            case "body":
              if (!(e = t.body)) throw Error(i(454));
              return e;
            default:
              throw Error(i(451));
          }
        }
        function wd(e) {
          for (var t = e.attributes; t.length; ) e.removeAttributeNode(t[0]);
          Ve(e);
        }
        var kd = new Map(),
          Sd = new Set();
        function xd(e) {
          return "function" == typeof e.getRootNode
            ? e.getRootNode()
            : 9 === e.nodeType
            ? e
            : e.ownerDocument;
        }
        var Pd = N.d;
        N.d = {
          f: function () {
            var e = Pd.f(),
              t = ju();
            return e || t;
          },
          r: function (e) {
            var t = Ue(e);
            null !== t && 5 === t.tag && "form" === t.type ? Ri(t) : Pd.r(e);
          },
          D: function (e) {
            Pd.D(e), Cd("dns-prefetch", e, null);
          },
          C: function (e, t) {
            Pd.C(e, t), Cd("preconnect", e, t);
          },
          L: function (e, t, n) {
            Pd.L(e, t, n);
            var r = Ed;
            if (r && e && t) {
              var a = 'link[rel="preload"][as="' + ht(t) + '"]';
              "image" === t && n && n.imageSrcSet
                ? ((a += '[imagesrcset="' + ht(n.imageSrcSet) + '"]'),
                  "string" == typeof n.imageSizes &&
                    (a += '[imagesizes="' + ht(n.imageSizes) + '"]'))
                : (a += '[href="' + ht(e) + '"]');
              var o = a;
              switch (t) {
                case "style":
                  o = Ad(e);
                  break;
                case "script":
                  o = Dd(e);
              }
              kd.has(o) ||
                ((e = d(
                  {
                    rel: "preload",
                    href: "image" === t && n && n.imageSrcSet ? void 0 : e,
                    as: t,
                  },
                  n
                )),
                kd.set(o, e),
                null !== r.querySelector(a) ||
                  ("style" === t && r.querySelector(Md(o))) ||
                  ("script" === t && r.querySelector(Rd(o))) ||
                  (Jc((t = r.createElement("link")), "link", e),
                  He(t),
                  r.head.appendChild(t)));
            }
          },
          m: function (e, t) {
            Pd.m(e, t);
            var n = Ed;
            if (n && e) {
              var r = t && "string" == typeof t.as ? t.as : "script",
                a =
                  'link[rel="modulepreload"][as="' +
                  ht(r) +
                  '"][href="' +
                  ht(e) +
                  '"]',
                o = a;
              switch (r) {
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                  o = Dd(e);
              }
              if (
                !kd.has(o) &&
                ((e = d({ rel: "modulepreload", href: e }, t)),
                kd.set(o, e),
                null === n.querySelector(a))
              ) {
                switch (r) {
                  case "audioworklet":
                  case "paintworklet":
                  case "serviceworker":
                  case "sharedworker":
                  case "worker":
                  case "script":
                    if (n.querySelector(Rd(o))) return;
                }
                Jc((r = n.createElement("link")), "link", e),
                  He(r),
                  n.head.appendChild(r);
              }
            }
          },
          X: function (e, t) {
            Pd.X(e, t);
            var n = Ed;
            if (n && e) {
              var r = We(n).hoistableScripts,
                a = Dd(e),
                o = r.get(a);
              o ||
                ((o = n.querySelector(Rd(a))) ||
                  ((e = d({ src: e, async: !0 }, t)),
                  (t = kd.get(a)) && Od(e, t),
                  He((o = n.createElement("script"))),
                  Jc(o, "link", e),
                  n.head.appendChild(o)),
                (o = { type: "script", instance: o, count: 1, state: null }),
                r.set(a, o));
            }
          },
          S: function (e, t, n) {
            Pd.S(e, t, n);
            var r = Ed;
            if (r && e) {
              var a = We(r).hoistableStyles,
                o = Ad(e);
              t = t || "default";
              var i = a.get(o);
              if (!i) {
                var s = { loading: 0, preload: null };
                if ((i = r.querySelector(Md(o)))) s.loading = 5;
                else {
                  (e = d(
                    { rel: "stylesheet", href: e, "data-precedence": t },
                    n
                  )),
                    (n = kd.get(o)) && Fd(e, n);
                  var l = (i = r.createElement("link"));
                  He(l),
                    Jc(l, "link", e),
                    (l._p = new Promise(function (e, t) {
                      (l.onload = e), (l.onerror = t);
                    })),
                    l.addEventListener("load", function () {
                      s.loading |= 1;
                    }),
                    l.addEventListener("error", function () {
                      s.loading |= 2;
                    }),
                    (s.loading |= 4),
                    Nd(i, t, r);
                }
                (i = { type: "stylesheet", instance: i, count: 1, state: s }),
                  a.set(o, i);
              }
            }
          },
          M: function (e, t) {
            Pd.M(e, t);
            var n = Ed;
            if (n && e) {
              var r = We(n).hoistableScripts,
                a = Dd(e),
                o = r.get(a);
              o ||
                ((o = n.querySelector(Rd(a))) ||
                  ((e = d({ src: e, async: !0, type: "module" }, t)),
                  (t = kd.get(a)) && Od(e, t),
                  He((o = n.createElement("script"))),
                  Jc(o, "link", e),
                  n.head.appendChild(o)),
                (o = { type: "script", instance: o, count: 1, state: null }),
                r.set(a, o));
            }
          },
        };
        var Ed = "undefined" == typeof document ? null : document;
        function Cd(e, t, n) {
          var r = Ed;
          if (r && "string" == typeof t && t) {
            var a = ht(t);
            (a = 'link[rel="' + e + '"][href="' + a + '"]'),
              "string" == typeof n && (a += '[crossorigin="' + n + '"]'),
              Sd.has(a) ||
                (Sd.add(a),
                (e = { rel: e, crossOrigin: n, href: t }),
                null === r.querySelector(a) &&
                  (Jc((t = r.createElement("link")), "link", e),
                  He(t),
                  r.head.appendChild(t)));
          }
        }
        function Td(e, t, n, r) {
          var a,
            o,
            s,
            l,
            u = (u = W.current) ? xd(u) : null;
          if (!u) throw Error(i(446));
          switch (e) {
            case "meta":
            case "title":
              return null;
            case "style":
              return "string" == typeof n.precedence &&
                "string" == typeof n.href
                ? ((t = Ad(n.href)),
                  (r = (n = We(u).hoistableStyles).get(t)) ||
                    ((r = {
                      type: "style",
                      instance: null,
                      count: 0,
                      state: null,
                    }),
                    n.set(t, r)),
                  r)
                : { type: "void", instance: null, count: 0, state: null };
            case "link":
              if (
                "stylesheet" === n.rel &&
                "string" == typeof n.href &&
                "string" == typeof n.precedence
              ) {
                e = Ad(n.href);
                var c = We(u).hoistableStyles,
                  d = c.get(e);
                if (
                  (d ||
                    ((u = u.ownerDocument || u),
                    (d = {
                      type: "stylesheet",
                      instance: null,
                      count: 0,
                      state: { loading: 0, preload: null },
                    }),
                    c.set(e, d),
                    (c = u.querySelector(Md(e))) &&
                      !c._p &&
                      ((d.instance = c), (d.state.loading = 5)),
                    kd.has(e) ||
                      ((n = {
                        rel: "preload",
                        as: "style",
                        href: n.href,
                        crossOrigin: n.crossOrigin,
                        integrity: n.integrity,
                        media: n.media,
                        hrefLang: n.hrefLang,
                        referrerPolicy: n.referrerPolicy,
                      }),
                      kd.set(e, n),
                      c ||
                        ((a = u),
                        (o = e),
                        (s = n),
                        (l = d.state),
                        a.querySelector(
                          'link[rel="preload"][as="style"][' + o + "]"
                        )
                          ? (l.loading = 1)
                          : ((o = a.createElement("link")),
                            (l.preload = o),
                            o.addEventListener("load", function () {
                              return (l.loading |= 1);
                            }),
                            o.addEventListener("error", function () {
                              return (l.loading |= 2);
                            }),
                            Jc(o, "link", s),
                            He(o),
                            a.head.appendChild(o))))),
                  t && null === r)
                )
                  throw Error(i(528, ""));
                return d;
              }
              if (t && null !== r) throw Error(i(529, ""));
              return null;
            case "script":
              return (
                (t = n.async),
                "string" == typeof (n = n.src) &&
                t &&
                "function" != typeof t &&
                "symbol" != typeof t
                  ? ((t = Dd(n)),
                    (r = (n = We(u).hoistableScripts).get(t)) ||
                      ((r = {
                        type: "script",
                        instance: null,
                        count: 0,
                        state: null,
                      }),
                      n.set(t, r)),
                    r)
                  : { type: "void", instance: null, count: 0, state: null }
              );
            default:
              throw Error(i(444, e));
          }
        }
        function Ad(e) {
          return 'href="' + ht(e) + '"';
        }
        function Md(e) {
          return 'link[rel="stylesheet"][' + e + "]";
        }
        function Ld(e) {
          return d({}, e, {
            "data-precedence": e.precedence,
            precedence: null,
          });
        }
        function Dd(e) {
          return '[src="' + ht(e) + '"]';
        }
        function Rd(e) {
          return "script[async]" + e;
        }
        function zd(e, t, n) {
          if ((t.count++, null === t.instance))
            switch (t.type) {
              case "style":
                var r = e.querySelector(
                  'style[data-href~="' + ht(n.href) + '"]'
                );
                if (r) return (t.instance = r), He(r), r;
                var a = d({}, n, {
                  "data-href": n.href,
                  "data-precedence": n.precedence,
                  href: null,
                  precedence: null,
                });
                return (
                  He((r = (e.ownerDocument || e).createElement("style"))),
                  Jc(r, "style", a),
                  Nd(r, n.precedence, e),
                  (t.instance = r)
                );
              case "stylesheet":
                a = Ad(n.href);
                var o = e.querySelector(Md(a));
                if (o)
                  return (t.state.loading |= 4), (t.instance = o), He(o), o;
                (r = Ld(n)),
                  (a = kd.get(a)) && Fd(r, a),
                  He((o = (e.ownerDocument || e).createElement("link")));
                var s = o;
                return (
                  (s._p = new Promise(function (e, t) {
                    (s.onload = e), (s.onerror = t);
                  })),
                  Jc(o, "link", r),
                  (t.state.loading |= 4),
                  Nd(o, n.precedence, e),
                  (t.instance = o)
                );
              case "script":
                return (
                  (o = Dd(n.src)),
                  (a = e.querySelector(Rd(o)))
                    ? ((t.instance = a), He(a), a)
                    : ((r = n),
                      (a = kd.get(o)) && Od((r = d({}, n)), a),
                      He(
                        (a = (e = e.ownerDocument || e).createElement("script"))
                      ),
                      Jc(a, "link", r),
                      e.head.appendChild(a),
                      (t.instance = a))
                );
              case "void":
                return null;
              default:
                throw Error(i(443, t.type));
            }
          else
            "stylesheet" === t.type &&
              !(4 & t.state.loading) &&
              ((r = t.instance),
              (t.state.loading |= 4),
              Nd(r, n.precedence, e));
          return t.instance;
        }
        function Nd(e, t, n) {
          for (
            var r = n.querySelectorAll(
                'link[rel="stylesheet"][data-precedence],style[data-precedence]'
              ),
              a = r.length ? r[r.length - 1] : null,
              o = a,
              i = 0;
            i < r.length;
            i++
          ) {
            var s = r[i];
            if (s.dataset.precedence === t) o = s;
            else if (o !== a) break;
          }
          o
            ? o.parentNode.insertBefore(e, o.nextSibling)
            : (t = 9 === n.nodeType ? n.head : n).insertBefore(e, t.firstChild);
        }
        function Fd(e, t) {
          null == e.crossOrigin && (e.crossOrigin = t.crossOrigin),
            null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy),
            null == e.title && (e.title = t.title);
        }
        function Od(e, t) {
          null == e.crossOrigin && (e.crossOrigin = t.crossOrigin),
            null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy),
            null == e.integrity && (e.integrity = t.integrity);
        }
        var _d = null;
        function Id(e, t, n) {
          if (null === _d) {
            var r = new Map(),
              a = (_d = new Map());
            a.set(n, r);
          } else (r = (a = _d).get(n)) || ((r = new Map()), a.set(n, r));
          if (r.has(e)) return r;
          for (
            r.set(e, null), n = n.getElementsByTagName(e), a = 0;
            a < n.length;
            a++
          ) {
            var o = n[a];
            if (
              !(
                o[Ie] ||
                o[De] ||
                ("link" === e && "stylesheet" === o.getAttribute("rel"))
              ) &&
              "http://www.w3.org/2000/svg" !== o.namespaceURI
            ) {
              var i = o.getAttribute(t) || "";
              i = e + i;
              var s = r.get(i);
              s ? s.push(o) : r.set(i, [o]);
            }
          }
          return r;
        }
        function Vd(e, t, n) {
          (e = e.ownerDocument || e).head.insertBefore(
            n,
            "title" === t ? e.querySelector("head > title") : null
          );
        }
        function jd(e) {
          return !!("stylesheet" !== e.type || 3 & e.state.loading);
        }
        var Ud = null;
        function Bd() {}
        function Wd() {
          if ((this.count--, 0 === this.count))
            if (this.stylesheets) $d(this, this.stylesheets);
            else if (this.unsuspend) {
              var e = this.unsuspend;
              (this.unsuspend = null), e();
            }
        }
        var Hd = null;
        function $d(e, t) {
          (e.stylesheets = null),
            null !== e.unsuspend &&
              (e.count++,
              (Hd = new Map()),
              t.forEach(qd, e),
              (Hd = null),
              Wd.call(e));
        }
        function qd(e, t) {
          if (!(4 & t.state.loading)) {
            var n = Hd.get(e);
            if (n) var r = n.get(null);
            else {
              (n = new Map()), Hd.set(e, n);
              for (
                var a = e.querySelectorAll(
                    "link[data-precedence],style[data-precedence]"
                  ),
                  o = 0;
                o < a.length;
                o++
              ) {
                var i = a[o];
                ("LINK" !== i.nodeName &&
                  "not all" === i.getAttribute("media")) ||
                  (n.set(i.dataset.precedence, i), (r = i));
              }
              r && n.set(null, r);
            }
            (i = (a = t.instance).getAttribute("data-precedence")),
              (o = n.get(i) || r) === r && n.set(null, a),
              n.set(i, a),
              this.count++,
              (r = Wd.bind(this)),
              a.addEventListener("load", r),
              a.addEventListener("error", r),
              o
                ? o.parentNode.insertBefore(a, o.nextSibling)
                : (e = 9 === e.nodeType ? e.head : e).insertBefore(
                    a,
                    e.firstChild
                  ),
              (t.state.loading |= 4);
          }
        }
        var Yd = {
          $$typeof: w,
          Provider: null,
          Consumer: null,
          _currentValue: F,
          _currentValue2: F,
          _threadCount: 0,
        };
        function Kd(e, t, n, r, a, o, i, s) {
          (this.tag = 1),
            (this.containerInfo = e),
            (this.pingCache = this.current = this.pendingChildren = null),
            (this.timeoutHandle = -1),
            (this.callbackNode =
              this.next =
              this.pendingContext =
              this.context =
              this.cancelPendingCommit =
                null),
            (this.callbackPriority = 0),
            (this.expirationTimes = xe(-1)),
            (this.entangledLanes =
              this.shellSuspendCounter =
              this.errorRecoveryDisabledLanes =
              this.expiredLanes =
              this.warmLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = xe(0)),
            (this.hiddenUpdates = xe(null)),
            (this.identifierPrefix = r),
            (this.onUncaughtError = a),
            (this.onCaughtError = o),
            (this.onRecoverableError = i),
            (this.pooledCache = null),
            (this.pooledCacheLanes = 0),
            (this.formState = s),
            (this.incompleteTransitions = new Map());
        }
        function Qd(e, t, n, r, a, o) {
          (a = (function (e) {
            return e ? (e = zr) : zr;
          })(a)),
            null === r.context ? (r.context = a) : (r.pendingContext = a),
            ((r = ro(t)).payload = { element: n }),
            null !== (o = void 0 === o ? null : o) && (r.callback = o),
            null !== (n = ao(e, r, t)) && (Fu(n, 0, t), oo(n, e, t));
        }
        function Xd(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function Gd(e, t) {
          Xd(e, t), (e = e.alternate) && Xd(e, t);
        }
        function Zd(e) {
          if (13 === e.tag) {
            var t = Lr(e, 67108864);
            null !== t && Fu(t, 0, 67108864), Gd(e, 67108864);
          }
        }
        var Jd = !0;
        function ef(e, t, n, r) {
          var a = z.T;
          z.T = null;
          var o = N.p;
          try {
            (N.p = 2), nf(e, t, n, r);
          } finally {
            (N.p = o), (z.T = a);
          }
        }
        function tf(e, t, n, r) {
          var a = z.T;
          z.T = null;
          var o = N.p;
          try {
            (N.p = 8), nf(e, t, n, r);
          } finally {
            (N.p = o), (z.T = a);
          }
        }
        function nf(e, t, n, r) {
          if (Jd) {
            var a = rf(r);
            if (null === a) Uc(e, t, r, af, n), yf(e, r);
            else if (
              (function (e, t, n, r, a) {
                switch (t) {
                  case "focusin":
                    return (uf = gf(uf, e, t, n, r, a)), !0;
                  case "dragenter":
                    return (cf = gf(cf, e, t, n, r, a)), !0;
                  case "mouseover":
                    return (df = gf(df, e, t, n, r, a)), !0;
                  case "pointerover":
                    var o = a.pointerId;
                    return ff.set(o, gf(ff.get(o) || null, e, t, n, r, a)), !0;
                  case "gotpointercapture":
                    return (
                      (o = a.pointerId),
                      pf.set(o, gf(pf.get(o) || null, e, t, n, r, a)),
                      !0
                    );
                }
                return !1;
              })(a, e, t, n, r)
            )
              r.stopPropagation();
            else if ((yf(e, r), 4 & t && -1 < mf.indexOf(e))) {
              for (; null !== a; ) {
                var o = Ue(a);
                if (null !== o)
                  switch (o.tag) {
                    case 3:
                      if (
                        (o = o.stateNode).current.memoizedState.isDehydrated
                      ) {
                        var i = ge(o.pendingLanes);
                        if (0 !== i) {
                          var s = o;
                          for (
                            s.pendingLanes |= 2, s.entangledLanes |= 2;
                            i;

                          ) {
                            var l = 1 << (31 - fe(i));
                            (s.entanglements[1] |= l), (i &= ~l);
                          }
                          kc(o), !(6 & tu) && ((ku = ee() + 500), Sc(0, !1));
                        }
                      }
                      break;
                    case 13:
                      null !== (s = Lr(o, 2)) && Fu(s, 0, 2), ju(), Gd(o, 2);
                  }
                if ((null === (o = rf(r)) && Uc(e, t, r, af, n), o === a))
                  break;
                a = o;
              }
              null !== a && r.stopPropagation();
            } else Uc(e, t, r, null, n);
          }
        }
        function rf(e) {
          return of((e = Lt(e)));
        }
        var af = null;
        function of(e) {
          if (((af = null), null !== (e = je(e)))) {
            var t = s(e);
            if (null === t) e = null;
            else {
              var n = t.tag;
              if (13 === n) {
                if (null !== (e = l(t))) return e;
                e = null;
              } else if (3 === n) {
                if (t.stateNode.current.memoizedState.isDehydrated)
                  return 3 === t.tag ? t.stateNode.containerInfo : null;
                e = null;
              } else t !== e && (e = null);
            }
          }
          return (af = e), null;
        }
        function sf(e) {
          switch (e) {
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
              return 2;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
              return 8;
            case "message":
              switch (te()) {
                case ne:
                  return 2;
                case re:
                  return 8;
                case ae:
                case oe:
                  return 32;
                case ie:
                  return 268435456;
                default:
                  return 32;
              }
            default:
              return 32;
          }
        }
        var lf = !1,
          uf = null,
          cf = null,
          df = null,
          ff = new Map(),
          pf = new Map(),
          hf = [],
          mf =
            "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
              " "
            );
        function yf(e, t) {
          switch (e) {
            case "focusin":
            case "focusout":
              uf = null;
              break;
            case "dragenter":
            case "dragleave":
              cf = null;
              break;
            case "mouseover":
            case "mouseout":
              df = null;
              break;
            case "pointerover":
            case "pointerout":
              ff.delete(t.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              pf.delete(t.pointerId);
          }
        }
        function gf(e, t, n, r, a, o) {
          return null === e || e.nativeEvent !== o
            ? ((e = {
                blockedOn: t,
                domEventName: n,
                eventSystemFlags: r,
                nativeEvent: o,
                targetContainers: [a],
              }),
              null !== t && null !== (t = Ue(t)) && Zd(t),
              e)
            : ((e.eventSystemFlags |= r),
              (t = e.targetContainers),
              null !== a && -1 === t.indexOf(a) && t.push(a),
              e);
        }
        function vf(e) {
          var t = je(e.target);
          if (null !== t) {
            var n = s(t);
            if (null !== n)
              if (13 === (t = n.tag)) {
                if (null !== (t = l(n)))
                  return (
                    (e.blockedOn = t),
                    void (function (e) {
                      var t = N.p;
                      try {
                        return (
                          (N.p = e),
                          (function () {
                            if (13 === n.tag) {
                              var e = zu();
                              e = Te(e);
                              var t = Lr(n, e);
                              null !== t && Fu(t, 0, e), Gd(n, e);
                            }
                          })()
                        );
                      } finally {
                        N.p = t;
                      }
                    })(e.priority)
                  );
              } else if (
                3 === t &&
                n.stateNode.current.memoizedState.isDehydrated
              )
                return void (e.blockedOn =
                  3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function bf(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var n = rf(e.nativeEvent);
            if (null !== n)
              return null !== (t = Ue(n)) && Zd(t), (e.blockedOn = n), !1;
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            (Mt = r), n.target.dispatchEvent(r), (Mt = null), t.shift();
          }
          return !0;
        }
        function wf(e, t, n) {
          bf(e) && n.delete(t);
        }
        function kf() {
          (lf = !1),
            null !== uf && bf(uf) && (uf = null),
            null !== cf && bf(cf) && (cf = null),
            null !== df && bf(df) && (df = null),
            ff.forEach(wf),
            pf.forEach(wf);
        }
        function Sf(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            lf ||
              ((lf = !0),
              r.unstable_scheduleCallback(r.unstable_NormalPriority, kf)));
        }
        var xf = null;
        function Pf(e) {
          xf !== e &&
            ((xf = e),
            r.unstable_scheduleCallback(r.unstable_NormalPriority, function () {
              xf === e && (xf = null);
              for (var t = 0; t < e.length; t += 3) {
                var n = e[t],
                  r = e[t + 1],
                  a = e[t + 2];
                if ("function" != typeof r) {
                  if (null === of(r || n)) continue;
                  break;
                }
                var o = Ue(n);
                null !== o &&
                  (e.splice(t, 3),
                  (t -= 3),
                  Li(
                    o,
                    { pending: !0, data: a, method: n.method, action: r },
                    r,
                    a
                  ));
              }
            }));
        }
        function Ef(e) {
          function t(t) {
            return Sf(t, e);
          }
          null !== uf && Sf(uf, e),
            null !== cf && Sf(cf, e),
            null !== df && Sf(df, e),
            ff.forEach(t),
            pf.forEach(t);
          for (var n = 0; n < hf.length; n++) {
            var r = hf[n];
            r.blockedOn === e && (r.blockedOn = null);
          }
          for (; 0 < hf.length && null === (n = hf[0]).blockedOn; )
            vf(n), null === n.blockedOn && hf.shift();
          if (null != (n = (e.ownerDocument || e).$$reactFormReplay))
            for (r = 0; r < n.length; r += 3) {
              var a = n[r],
                o = n[r + 1],
                i = a[Re] || null;
              if ("function" == typeof o) i || Pf(n);
              else if (i) {
                var s = null;
                if (o && o.hasAttribute("formAction")) {
                  if (((a = o), (i = o[Re] || null))) s = i.formAction;
                  else if (null !== of(a)) continue;
                } else s = i.action;
                "function" == typeof s
                  ? (n[r + 1] = s)
                  : (n.splice(r, 3), (r -= 3)),
                  Pf(n);
              }
            }
        }
        function Cf(e) {
          this._internalRoot = e;
        }
        function Tf(e) {
          this._internalRoot = e;
        }
        (Tf.prototype.render = Cf.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (null === t) throw Error(i(409));
            Qd(t.current, zu(), e, t, null, null);
          }),
          (Tf.prototype.unmount = Cf.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (null !== e) {
                this._internalRoot = null;
                var t = e.containerInfo;
                Qd(e.current, 2, null, e, null, null), ju(), (t[ze] = null);
              }
            }),
          (Tf.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
              var t = Me();
              e = { blockedOn: null, target: e, priority: t };
              for (
                var n = 0;
                n < hf.length && 0 !== t && t < hf[n].priority;
                n++
              );
              hf.splice(n, 0, e), 0 === n && vf(e);
            }
          });
        var Af = a.version;
        if ("19.1.0" !== Af) throw Error(i(527, Af, "19.1.0"));
        N.findDOMNode = function (e) {
          var t = e._reactInternals;
          if (void 0 === t) {
            if ("function" == typeof e.render) throw Error(i(188));
            throw ((e = Object.keys(e).join(",")), Error(i(268, e)));
          }
          return (
            (e = (function (e) {
              var t = e.alternate;
              if (!t) {
                if (null === (t = s(e))) throw Error(i(188));
                return t !== e ? null : e;
              }
              for (var n = e, r = t; ; ) {
                var a = n.return;
                if (null === a) break;
                var o = a.alternate;
                if (null === o) {
                  if (null !== (r = a.return)) {
                    n = r;
                    continue;
                  }
                  break;
                }
                if (a.child === o.child) {
                  for (o = a.child; o; ) {
                    if (o === n) return u(a), e;
                    if (o === r) return u(a), t;
                    o = o.sibling;
                  }
                  throw Error(i(188));
                }
                if (n.return !== r.return) (n = a), (r = o);
                else {
                  for (var l = !1, c = a.child; c; ) {
                    if (c === n) {
                      (l = !0), (n = a), (r = o);
                      break;
                    }
                    if (c === r) {
                      (l = !0), (r = a), (n = o);
                      break;
                    }
                    c = c.sibling;
                  }
                  if (!l) {
                    for (c = o.child; c; ) {
                      if (c === n) {
                        (l = !0), (n = o), (r = a);
                        break;
                      }
                      if (c === r) {
                        (l = !0), (r = o), (n = a);
                        break;
                      }
                      c = c.sibling;
                    }
                    if (!l) throw Error(i(189));
                  }
                }
                if (n.alternate !== r) throw Error(i(190));
              }
              if (3 !== n.tag) throw Error(i(188));
              return n.stateNode.current === n ? e : t;
            })(t)),
            null === (e = null !== e ? c(e) : null) ? null : e.stateNode
          );
        };
        var Mf = {
          bundleType: 0,
          version: "19.1.0",
          rendererPackageName: "react-dom",
          currentDispatcherRef: z,
          reconcilerVersion: "19.1.0",
        };
        if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var Lf = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!Lf.isDisabled && Lf.supportsFiber)
            try {
              (ue = Lf.inject(Mf)), (ce = Lf);
            } catch (e) {}
        }
        t.createRoot = function (e, t) {
          if (
            !(n = e) ||
            (1 !== n.nodeType && 9 !== n.nodeType && 11 !== n.nodeType)
          )
            throw Error(i(299));
          var n,
            r = !1,
            a = "",
            o = gs,
            s = vs,
            l = bs;
          return (
            null != t &&
              (!0 === t.unstable_strictMode && (r = !0),
              void 0 !== t.identifierPrefix && (a = t.identifierPrefix),
              void 0 !== t.onUncaughtError && (o = t.onUncaughtError),
              void 0 !== t.onCaughtError && (s = t.onCaughtError),
              void 0 !== t.onRecoverableError && (l = t.onRecoverableError),
              void 0 !== t.unstable_transitionCallbacks &&
                t.unstable_transitionCallbacks),
            (t = (function (e, t, n, r, a, o, i, s, l, u, c, d) {
              return (
                (e = new Kd(e, t, n, i, s, l, u, d)),
                (t = 1),
                !0 === o && (t |= 24),
                (o = Fr(3, null, null, t)),
                (e.current = o),
                (o.stateNode = e),
                (t = Ra()).refCount++,
                (e.pooledCache = t),
                t.refCount++,
                (o.memoizedState = { element: r, isDehydrated: n, cache: t }),
                to(o),
                e
              );
            })(e, 1, !1, null, 0, r, a, o, s, l, 0, null)),
            (e[ze] = t.current),
            Vc(e),
            new Cf(t)
          );
        };
      },
      338: (e, t, n) => {
        !(function e() {
          if (
            "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (e) {
              console.error(e);
            }
        })(),
          (e.exports = n(247));
      },
      477: (e, t) => {
        function n(e, t) {
          var n = e.length;
          e.push(t);
          e: for (; 0 < n; ) {
            var r = (n - 1) >>> 1,
              a = e[r];
            if (!(0 < o(a, t))) break e;
            (e[r] = t), (e[n] = a), (n = r);
          }
        }
        function r(e) {
          return 0 === e.length ? null : e[0];
        }
        function a(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, a = e.length, i = a >>> 1; r < i; ) {
              var s = 2 * (r + 1) - 1,
                l = e[s],
                u = s + 1,
                c = e[u];
              if (0 > o(l, n))
                u < a && 0 > o(c, l)
                  ? ((e[r] = c), (e[u] = n), (r = u))
                  : ((e[r] = l), (e[s] = n), (r = s));
              else {
                if (!(u < a && 0 > o(c, n))) break e;
                (e[r] = c), (e[u] = n), (r = u);
              }
            }
          }
          return t;
        }
        function o(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if (
          ((t.unstable_now = void 0),
          "object" == typeof performance &&
            "function" == typeof performance.now)
        ) {
          var i = performance;
          t.unstable_now = function () {
            return i.now();
          };
        } else {
          var s = Date,
            l = s.now();
          t.unstable_now = function () {
            return s.now() - l;
          };
        }
        var u = [],
          c = [],
          d = 1,
          f = null,
          p = 3,
          h = !1,
          m = !1,
          y = !1,
          g = !1,
          v = "function" == typeof setTimeout ? setTimeout : null,
          b = "function" == typeof clearTimeout ? clearTimeout : null,
          w = "undefined" != typeof setImmediate ? setImmediate : null;
        function k(e) {
          for (var t = r(c); null !== t; ) {
            if (null === t.callback) a(c);
            else {
              if (!(t.startTime <= e)) break;
              a(c), (t.sortIndex = t.expirationTime), n(u, t);
            }
            t = r(c);
          }
        }
        function S(e) {
          if (((y = !1), k(e), !m))
            if (null !== r(u)) (m = !0), P || ((P = !0), x());
            else {
              var t = r(c);
              null !== t && R(S, t.startTime - e);
            }
        }
        var x,
          P = !1,
          E = -1,
          C = 5,
          T = -1;
        function A() {
          return !(!g && t.unstable_now() - T < C);
        }
        function M() {
          if (((g = !1), P)) {
            var e = t.unstable_now();
            T = e;
            var n = !0;
            try {
              e: {
                (m = !1), y && ((y = !1), b(E), (E = -1)), (h = !0);
                var o = p;
                try {
                  t: {
                    for (
                      k(e), f = r(u);
                      null !== f && !(f.expirationTime > e && A());

                    ) {
                      var i = f.callback;
                      if ("function" == typeof i) {
                        (f.callback = null), (p = f.priorityLevel);
                        var s = i(f.expirationTime <= e);
                        if (((e = t.unstable_now()), "function" == typeof s)) {
                          (f.callback = s), k(e), (n = !0);
                          break t;
                        }
                        f === r(u) && a(u), k(e);
                      } else a(u);
                      f = r(u);
                    }
                    if (null !== f) n = !0;
                    else {
                      var l = r(c);
                      null !== l && R(S, l.startTime - e), (n = !1);
                    }
                  }
                  break e;
                } finally {
                  (f = null), (p = o), (h = !1);
                }
                n = void 0;
              }
            } finally {
              n ? x() : (P = !1);
            }
          }
        }
        if ("function" == typeof w)
          x = function () {
            w(M);
          };
        else if ("undefined" != typeof MessageChannel) {
          var L = new MessageChannel(),
            D = L.port2;
          (L.port1.onmessage = M),
            (x = function () {
              D.postMessage(null);
            });
        } else
          x = function () {
            v(M, 0);
          };
        function R(e, n) {
          E = v(function () {
            e(t.unstable_now());
          }, n);
        }
        (t.unstable_IdlePriority = 5),
          (t.unstable_ImmediatePriority = 1),
          (t.unstable_LowPriority = 4),
          (t.unstable_NormalPriority = 3),
          (t.unstable_Profiling = null),
          (t.unstable_UserBlockingPriority = 2),
          (t.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                )
              : (C = 0 < e ? Math.floor(1e3 / e) : 5);
          }),
          (t.unstable_getCurrentPriorityLevel = function () {
            return p;
          }),
          (t.unstable_next = function (e) {
            switch (p) {
              case 1:
              case 2:
              case 3:
                var t = 3;
                break;
              default:
                t = p;
            }
            var n = p;
            p = t;
            try {
              return e();
            } finally {
              p = n;
            }
          }),
          (t.unstable_requestPaint = function () {
            g = !0;
          }),
          (t.unstable_runWithPriority = function (e, t) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var n = p;
            p = e;
            try {
              return t();
            } finally {
              p = n;
            }
          }),
          (t.unstable_scheduleCallback = function (e, a, o) {
            var i = t.unstable_now();
            switch (
              ((o =
                "object" == typeof o &&
                null !== o &&
                "number" == typeof (o = o.delay) &&
                0 < o
                  ? i + o
                  : i),
              e)
            ) {
              case 1:
                var s = -1;
                break;
              case 2:
                s = 250;
                break;
              case 5:
                s = 1073741823;
                break;
              case 4:
                s = 1e4;
                break;
              default:
                s = 5e3;
            }
            return (
              (e = {
                id: d++,
                callback: a,
                priorityLevel: e,
                startTime: o,
                expirationTime: (s = o + s),
                sortIndex: -1,
              }),
              o > i
                ? ((e.sortIndex = o),
                  n(c, e),
                  null === r(u) &&
                    e === r(c) &&
                    (y ? (b(E), (E = -1)) : (y = !0), R(S, o - i)))
                : ((e.sortIndex = s),
                  n(u, e),
                  m || h || ((m = !0), P || ((P = !0), x()))),
              e
            );
          }),
          (t.unstable_shouldYield = A),
          (t.unstable_wrapCallback = function (e) {
            var t = p;
            return function () {
              var n = p;
              p = t;
              try {
                return e.apply(this, arguments);
              } finally {
                p = n;
              }
            };
          });
      },
      540: (e, t, n) => {
        e.exports = n(869);
      },
      698: (e, t) => {
        var n = Symbol.for("react.transitional.element");
        function r(e, t, r) {
          var a = null;
          if (
            (void 0 !== r && (a = "" + r),
            void 0 !== t.key && (a = "" + t.key),
            "key" in t)
          )
            for (var o in ((r = {}), t)) "key" !== o && (r[o] = t[o]);
          else r = t;
          return (
            (t = r.ref),
            {
              $$typeof: n,
              type: e,
              key: a,
              ref: void 0 !== t ? t : null,
              props: r,
            }
          );
        }
        Symbol.for("react.fragment"), (t.jsx = r), (t.jsxs = r);
      },
      848: (e, t, n) => {
        e.exports = n(698);
      },
      869: (e, t) => {
        var n = Symbol.for("react.transitional.element"),
          r = Symbol.for("react.portal"),
          a = Symbol.for("react.fragment"),
          o = Symbol.for("react.strict_mode"),
          i = Symbol.for("react.profiler"),
          s = Symbol.for("react.consumer"),
          l = Symbol.for("react.context"),
          u = Symbol.for("react.forward_ref"),
          c = Symbol.for("react.suspense"),
          d = Symbol.for("react.memo"),
          f = Symbol.for("react.lazy"),
          p = Symbol.iterator,
          h = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          m = Object.assign,
          y = {};
        function g(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = y),
            (this.updater = n || h);
        }
        function v() {}
        function b(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = y),
            (this.updater = n || h);
        }
        (g.prototype.isReactComponent = {}),
          (g.prototype.setState = function (e, t) {
            if ("object" != typeof e && "function" != typeof e && null != e)
              throw Error(
                "takes an object of state variables to update or a function which returns an object of state variables."
              );
            this.updater.enqueueSetState(this, e, t, "setState");
          }),
          (g.prototype.forceUpdate = function (e) {
            this.updater.enqueueForceUpdate(this, e, "forceUpdate");
          }),
          (v.prototype = g.prototype);
        var w = (b.prototype = new v());
        (w.constructor = b), m(w, g.prototype), (w.isPureReactComponent = !0);
        var k = Array.isArray,
          S = { H: null, A: null, T: null, S: null, V: null },
          x = Object.prototype.hasOwnProperty;
        function P(e, t, r, a, o, i) {
          return (
            (r = i.ref),
            {
              $$typeof: n,
              type: e,
              key: t,
              ref: void 0 !== r ? r : null,
              props: i,
            }
          );
        }
        function E(e) {
          return "object" == typeof e && null !== e && e.$$typeof === n;
        }
        var C = /\/+/g;
        function T(e, t) {
          return "object" == typeof e && null !== e && null != e.key
            ? ((n = "" + e.key),
              (r = { "=": "=0", ":": "=2" }),
              "$" +
                n.replace(/[=:]/g, function (e) {
                  return r[e];
                }))
            : t.toString(36);
          var n, r;
        }
        function A() {}
        function M(e, t, a, o, i) {
          var s = typeof e;
          ("undefined" !== s && "boolean" !== s) || (e = null);
          var l,
            u,
            c = !1;
          if (null === e) c = !0;
          else
            switch (s) {
              case "bigint":
              case "string":
              case "number":
                c = !0;
                break;
              case "object":
                switch (e.$$typeof) {
                  case n:
                  case r:
                    c = !0;
                    break;
                  case f:
                    return M((c = e._init)(e._payload), t, a, o, i);
                }
            }
          if (c)
            return (
              (i = i(e)),
              (c = "" === o ? "." + T(e, 0) : o),
              k(i)
                ? ((a = ""),
                  null != c && (a = c.replace(C, "$&/") + "/"),
                  M(i, t, a, "", function (e) {
                    return e;
                  }))
                : null != i &&
                  (E(i) &&
                    ((l = i),
                    (u =
                      a +
                      (null == i.key || (e && e.key === i.key)
                        ? ""
                        : ("" + i.key).replace(C, "$&/") + "/") +
                      c),
                    (i = P(l.type, u, void 0, 0, 0, l.props))),
                  t.push(i)),
              1
            );
          c = 0;
          var d,
            h = "" === o ? "." : o + ":";
          if (k(e))
            for (var m = 0; m < e.length; m++)
              c += M((o = e[m]), t, a, (s = h + T(o, m)), i);
          else if (
            "function" ==
            typeof (m =
              null === (d = e) || "object" != typeof d
                ? null
                : "function" == typeof (d = (p && d[p]) || d["@@iterator"])
                ? d
                : null)
          )
            for (e = m.call(e), m = 0; !(o = e.next()).done; )
              c += M((o = o.value), t, a, (s = h + T(o, m++)), i);
          else if ("object" === s) {
            if ("function" == typeof e.then)
              return M(
                (function (e) {
                  switch (e.status) {
                    case "fulfilled":
                      return e.value;
                    case "rejected":
                      throw e.reason;
                    default:
                      switch (
                        ("string" == typeof e.status
                          ? e.then(A, A)
                          : ((e.status = "pending"),
                            e.then(
                              function (t) {
                                "pending" === e.status &&
                                  ((e.status = "fulfilled"), (e.value = t));
                              },
                              function (t) {
                                "pending" === e.status &&
                                  ((e.status = "rejected"), (e.reason = t));
                              }
                            )),
                        e.status)
                      ) {
                        case "fulfilled":
                          return e.value;
                        case "rejected":
                          throw e.reason;
                      }
                  }
                  throw e;
                })(e),
                t,
                a,
                o,
                i
              );
            throw (
              ((t = String(e)),
              Error(
                "Objects are not valid as a React child (found: " +
                  ("[object Object]" === t
                    ? "object with keys {" + Object.keys(e).join(", ") + "}"
                    : t) +
                  "). If you meant to render a collection of children, use an array instead."
              ))
            );
          }
          return c;
        }
        function L(e, t, n) {
          if (null == e) return e;
          var r = [],
            a = 0;
          return (
            M(e, r, "", "", function (e) {
              return t.call(n, e, a++);
            }),
            r
          );
        }
        function D(e) {
          if (-1 === e._status) {
            var t = e._result;
            (t = t()).then(
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 1), (e._result = t));
              },
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 2), (e._result = t));
              }
            ),
              -1 === e._status && ((e._status = 0), (e._result = t));
          }
          if (1 === e._status) return e._result.default;
          throw e._result;
        }
        var R =
          "function" == typeof reportError
            ? reportError
            : function (e) {
                if (
                  "object" == typeof window &&
                  "function" == typeof window.ErrorEvent
                ) {
                  var t = new window.ErrorEvent("error", {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      "object" == typeof e &&
                      null !== e &&
                      "string" == typeof e.message
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  "object" == typeof process &&
                  "function" == typeof process.emit
                )
                  return void process.emit("uncaughtException", e);
                console.error(e);
              };
        function z() {}
        (t.Children = {
          map: L,
          forEach: function (e, t, n) {
            L(
              e,
              function () {
                t.apply(this, arguments);
              },
              n
            );
          },
          count: function (e) {
            var t = 0;
            return (
              L(e, function () {
                t++;
              }),
              t
            );
          },
          toArray: function (e) {
            return (
              L(e, function (e) {
                return e;
              }) || []
            );
          },
          only: function (e) {
            if (!E(e))
              throw Error(
                "React.Children.only expected to receive a single React element child."
              );
            return e;
          },
        }),
          (t.Component = g),
          (t.Fragment = a),
          (t.Profiler = i),
          (t.PureComponent = b),
          (t.StrictMode = o),
          (t.Suspense = c),
          (t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
            S),
          (t.__COMPILER_RUNTIME = {
            __proto__: null,
            c: function (e) {
              return S.H.useMemoCache(e);
            },
          }),
          (t.cache = function (e) {
            return function () {
              return e.apply(null, arguments);
            };
          }),
          (t.cloneElement = function (e, t, n) {
            if (null == e)
              throw Error(
                "The argument must be a React element, but you passed " +
                  e +
                  "."
              );
            var r = m({}, e.props),
              a = e.key;
            if (null != t)
              for (o in (t.ref, void 0 !== t.key && (a = "" + t.key), t))
                !x.call(t, o) ||
                  "key" === o ||
                  "__self" === o ||
                  "__source" === o ||
                  ("ref" === o && void 0 === t.ref) ||
                  (r[o] = t[o]);
            var o = arguments.length - 2;
            if (1 === o) r.children = n;
            else if (1 < o) {
              for (var i = Array(o), s = 0; s < o; s++) i[s] = arguments[s + 2];
              r.children = i;
            }
            return P(e.type, a, void 0, 0, 0, r);
          }),
          (t.createContext = function (e) {
            return (
              ((e = {
                $$typeof: l,
                _currentValue: e,
                _currentValue2: e,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
              }).Provider = e),
              (e.Consumer = { $$typeof: s, _context: e }),
              e
            );
          }),
          (t.createElement = function (e, t, n) {
            var r,
              a = {},
              o = null;
            if (null != t)
              for (r in (void 0 !== t.key && (o = "" + t.key), t))
                x.call(t, r) &&
                  "key" !== r &&
                  "__self" !== r &&
                  "__source" !== r &&
                  (a[r] = t[r]);
            var i = arguments.length - 2;
            if (1 === i) a.children = n;
            else if (1 < i) {
              for (var s = Array(i), l = 0; l < i; l++) s[l] = arguments[l + 2];
              a.children = s;
            }
            if (e && e.defaultProps)
              for (r in (i = e.defaultProps)) void 0 === a[r] && (a[r] = i[r]);
            return P(e, o, void 0, 0, 0, a);
          }),
          (t.createRef = function () {
            return { current: null };
          }),
          (t.forwardRef = function (e) {
            return { $$typeof: u, render: e };
          }),
          (t.isValidElement = E),
          (t.lazy = function (e) {
            return {
              $$typeof: f,
              _payload: { _status: -1, _result: e },
              _init: D,
            };
          }),
          (t.memo = function (e, t) {
            return { $$typeof: d, type: e, compare: void 0 === t ? null : t };
          }),
          (t.startTransition = function (e) {
            var t = S.T,
              n = {};
            S.T = n;
            try {
              var r = e(),
                a = S.S;
              null !== a && a(n, r),
                "object" == typeof r &&
                  null !== r &&
                  "function" == typeof r.then &&
                  r.then(z, R);
            } catch (e) {
              R(e);
            } finally {
              S.T = t;
            }
          }),
          (t.unstable_useCacheRefresh = function () {
            return S.H.useCacheRefresh();
          }),
          (t.use = function (e) {
            return S.H.use(e);
          }),
          (t.useActionState = function (e, t, n) {
            return S.H.useActionState(e, t, n);
          }),
          (t.useCallback = function (e, t) {
            return S.H.useCallback(e, t);
          }),
          (t.useContext = function (e) {
            return S.H.useContext(e);
          }),
          (t.useDebugValue = function () {}),
          (t.useDeferredValue = function (e, t) {
            return S.H.useDeferredValue(e, t);
          }),
          (t.useEffect = function (e, t, n) {
            var r = S.H;
            if ("function" == typeof n)
              throw Error(
                "useEffect CRUD overload is not enabled in this build of React."
              );
            return r.useEffect(e, t);
          }),
          (t.useId = function () {
            return S.H.useId();
          }),
          (t.useImperativeHandle = function (e, t, n) {
            return S.H.useImperativeHandle(e, t, n);
          }),
          (t.useInsertionEffect = function (e, t) {
            return S.H.useInsertionEffect(e, t);
          }),
          (t.useLayoutEffect = function (e, t) {
            return S.H.useLayoutEffect(e, t);
          }),
          (t.useMemo = function (e, t) {
            return S.H.useMemo(e, t);
          }),
          (t.useOptimistic = function (e, t) {
            return S.H.useOptimistic(e, t);
          }),
          (t.useReducer = function (e, t, n) {
            return S.H.useReducer(e, t, n);
          }),
          (t.useRef = function (e) {
            return S.H.useRef(e);
          }),
          (t.useState = function (e) {
            return S.H.useState(e);
          }),
          (t.useSyncExternalStore = function (e, t, n) {
            return S.H.useSyncExternalStore(e, t, n);
          }),
          (t.useTransition = function () {
            return S.H.useTransition();
          }),
          (t.version = "19.1.0");
      },
      961: (e, t, n) => {
        !(function e() {
          if (
            "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (e) {
              console.error(e);
            }
        })(),
          (e.exports = n(221));
      },
      982: (e, t, n) => {
        e.exports = n(477);
      },
    },
    t = {};
  function n(r) {
    var a = t[r];
    if (void 0 !== a) return a.exports;
    var o = (t[r] = { exports: {} });
    return e[r](o, o.exports, n), o.exports;
  }
  var r = n(540),
    a = n(338);
  function o(e) {
    if ("undefined" == typeof Proxy) return e;
    const t = new Map();
    return new Proxy((...t) => e(...t), {
      get: (n, r) =>
        "create" === r ? e : (t.has(r) || t.set(r, e(r)), t.get(r)),
    });
  }
  function i(e) {
    return null !== e && "object" == typeof e && "function" == typeof e.start;
  }
  function s(e) {
    const t = [{}, {}];
    return (
      e?.values.forEach((e, n) => {
        (t[0][n] = e.get()), (t[1][n] = e.getVelocity());
      }),
      t
    );
  }
  function l(e, t, n, r) {
    if ("function" == typeof t) {
      const [a, o] = s(r);
      t = t(void 0 !== n ? n : e.custom, a, o);
    }
    if (
      ("string" == typeof t && (t = e.variants && e.variants[t]),
      "function" == typeof t)
    ) {
      const [a, o] = s(r);
      t = t(void 0 !== n ? n : e.custom, a, o);
    }
    return t;
  }
  function u(e, t, n) {
    const r = e.getProps();
    return l(r, t, void 0 !== n ? n : r.custom, e);
  }
  const c = (e) => Array.isArray(e),
    d = [
      "setup",
      "read",
      "resolveKeyframes",
      "preUpdate",
      "update",
      "preRender",
      "render",
      "postRender",
    ],
    f = { value: null, addProjectionMetrics: null },
    p = {};
  function h(e, t) {
    let n = !1,
      r = !0;
    const a = { delta: 0, timestamp: 0, isProcessing: !1 },
      o = () => (n = !0),
      i = d.reduce(
        (e, n) => (
          (e[n] = (function (e, t) {
            let n = new Set(),
              r = new Set(),
              a = !1,
              o = !1;
            const i = new WeakSet();
            let s = { delta: 0, timestamp: 0, isProcessing: !1 },
              l = 0;
            function u(t) {
              i.has(t) && (c.schedule(t), e()), l++, t(s);
            }
            const c = {
              schedule: (e, t = !1, o = !1) => {
                const s = o && a ? n : r;
                return t && i.add(e), s.has(e) || s.add(e), e;
              },
              cancel: (e) => {
                r.delete(e), i.delete(e);
              },
              process: (e) => {
                (s = e),
                  a
                    ? (o = !0)
                    : ((a = !0),
                      ([n, r] = [r, n]),
                      n.forEach(u),
                      t && f.value && f.value.frameloop[t].push(l),
                      (l = 0),
                      n.clear(),
                      (a = !1),
                      o && ((o = !1), c.process(e)));
              },
            };
            return c;
          })(o, t ? n : void 0)),
          e
        ),
        {}
      ),
      {
        setup: s,
        read: l,
        resolveKeyframes: u,
        preUpdate: c,
        update: h,
        preRender: m,
        render: y,
        postRender: g,
      } = i,
      v = () => {
        const o = p.useManualTiming ? a.timestamp : performance.now();
        (n = !1),
          p.useManualTiming ||
            (a.delta = r
              ? 1e3 / 60
              : Math.max(Math.min(o - a.timestamp, 40), 1)),
          (a.timestamp = o),
          (a.isProcessing = !0),
          s.process(a),
          l.process(a),
          u.process(a),
          c.process(a),
          h.process(a),
          m.process(a),
          y.process(a),
          g.process(a),
          (a.isProcessing = !1),
          n && t && ((r = !1), e(v));
      };
    return {
      schedule: d.reduce((t, o) => {
        const s = i[o];
        return (
          (t[o] = (t, o = !1, i = !1) => (
            n || ((n = !0), (r = !0), a.isProcessing || e(v)),
            s.schedule(t, o, i)
          )),
          t
        );
      }, {}),
      cancel: (e) => {
        for (let t = 0; t < d.length; t++) i[d[t]].cancel(e);
      },
      state: a,
      steps: i,
    };
  }
  const m = (e) => e,
    {
      schedule: y,
      cancel: g,
      state: v,
      steps: b,
    } = h(
      "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : m,
      !0
    );
  let w;
  function k() {
    w = void 0;
  }
  const S = {
    now: () => (
      void 0 === w &&
        S.set(
          v.isProcessing || p.useManualTiming ? v.timestamp : performance.now()
        ),
      w
    ),
    set: (e) => {
      (w = e), queueMicrotask(k);
    },
  };
  function x(e, t) {
    -1 === e.indexOf(t) && e.push(t);
  }
  function P(e, t) {
    const n = e.indexOf(t);
    n > -1 && e.splice(n, 1);
  }
  class E {
    constructor() {
      this.subscriptions = [];
    }
    add(e) {
      return x(this.subscriptions, e), () => P(this.subscriptions, e);
    }
    notify(e, t, n) {
      const r = this.subscriptions.length;
      if (r)
        if (1 === r) this.subscriptions[0](e, t, n);
        else
          for (let a = 0; a < r; a++) {
            const r = this.subscriptions[a];
            r && r(e, t, n);
          }
    }
    getSize() {
      return this.subscriptions.length;
    }
    clear() {
      this.subscriptions.length = 0;
    }
  }
  function C(e, t) {
    return t ? e * (1e3 / t) : 0;
  }
  const T = { current: void 0 };
  class A {
    constructor(e, t = {}) {
      (this.version = "__VERSION__"),
        (this.canTrackVelocity = null),
        (this.events = {}),
        (this.updateAndNotify = (e, t = !0) => {
          const n = S.now();
          this.updatedAt !== n && this.setPrevFrameValue(),
            (this.prev = this.current),
            this.setCurrent(e),
            this.current !== this.prev &&
              this.events.change?.notify(this.current),
            t && this.events.renderRequest?.notify(this.current);
        }),
        (this.hasAnimated = !1),
        this.setCurrent(e),
        (this.owner = t.owner);
    }
    setCurrent(e) {
      var t;
      (this.current = e),
        (this.updatedAt = S.now()),
        null === this.canTrackVelocity &&
          void 0 !== e &&
          (this.canTrackVelocity = ((t = this.current), !isNaN(parseFloat(t))));
    }
    setPrevFrameValue(e = this.current) {
      (this.prevFrameValue = e), (this.prevUpdatedAt = this.updatedAt);
    }
    onChange(e) {
      return this.on("change", e);
    }
    on(e, t) {
      this.events[e] || (this.events[e] = new E());
      const n = this.events[e].add(t);
      return "change" === e
        ? () => {
            n(),
              y.read(() => {
                this.events.change.getSize() || this.stop();
              });
          }
        : n;
    }
    clearListeners() {
      for (const e in this.events) this.events[e].clear();
    }
    attach(e, t) {
      (this.passiveEffect = e), (this.stopPassiveEffect = t);
    }
    set(e, t = !0) {
      t && this.passiveEffect
        ? this.passiveEffect(e, this.updateAndNotify)
        : this.updateAndNotify(e, t);
    }
    setWithVelocity(e, t, n) {
      this.set(t),
        (this.prev = void 0),
        (this.prevFrameValue = e),
        (this.prevUpdatedAt = this.updatedAt - n);
    }
    jump(e, t = !0) {
      this.updateAndNotify(e),
        (this.prev = e),
        (this.prevUpdatedAt = this.prevFrameValue = void 0),
        t && this.stop(),
        this.stopPassiveEffect && this.stopPassiveEffect();
    }
    get() {
      return T.current && T.current.push(this), this.current;
    }
    getPrevious() {
      return this.prev;
    }
    getVelocity() {
      const e = S.now();
      if (
        !this.canTrackVelocity ||
        void 0 === this.prevFrameValue ||
        e - this.updatedAt > 30
      )
        return 0;
      const t = Math.min(this.updatedAt - this.prevUpdatedAt, 30);
      return C(parseFloat(this.current) - parseFloat(this.prevFrameValue), t);
    }
    start(e) {
      return (
        this.stop(),
        new Promise((t) => {
          (this.hasAnimated = !0),
            (this.animation = e(t)),
            this.events.animationStart && this.events.animationStart.notify();
        }).then(() => {
          this.events.animationComplete &&
            this.events.animationComplete.notify(),
            this.clearAnimation();
        })
      );
    }
    stop() {
      this.animation &&
        (this.animation.stop(),
        this.events.animationCancel && this.events.animationCancel.notify()),
        this.clearAnimation();
    }
    isAnimating() {
      return !!this.animation;
    }
    clearAnimation() {
      delete this.animation;
    }
    destroy() {
      this.events.destroy?.notify(),
        this.clearListeners(),
        this.stop(),
        this.stopPassiveEffect && this.stopPassiveEffect();
    }
  }
  function M(e, t) {
    return new A(e, t);
  }
  function L(e, t, n) {
    e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, M(n));
  }
  const D = (e) => Boolean(e && e.getVelocity);
  function R(e, t) {
    const n = e.getValue("willChange");
    if (((r = n), Boolean(D(r) && r.add))) return n.add(t);
    if (!n && p.WillChange) {
      const n = new p.WillChange("auto");
      e.addValue("willChange", n), n.add(t);
    }
    var r;
  }
  const z = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(),
    N = "data-" + z("framerAppearId");
  function F(e) {
    return e.props[N];
  }
  const O = (e) => null !== e,
    _ = [
      "transformPerspective",
      "x",
      "y",
      "z",
      "translateX",
      "translateY",
      "translateZ",
      "scale",
      "scaleX",
      "scaleY",
      "rotate",
      "rotateX",
      "rotateY",
      "rotateZ",
      "skew",
      "skewX",
      "skewY",
    ],
    I = (() => new Set(_))(),
    V = { type: "spring", stiffness: 500, damping: 25, restSpeed: 10 },
    j = { type: "keyframes", duration: 0.8 },
    U = { type: "keyframes", ease: [0.25, 0.1, 0.35, 1], duration: 0.3 };
  function B(e, t) {
    return e?.[t] ?? e?.default ?? e;
  }
  const W = (e) => 1e3 * e,
    H = (e) => e / 1e3,
    $ = { layout: 0, mainThread: 0, waapi: 0 },
    q = (e) => (t) => "string" == typeof t && t.startsWith(e),
    Y = q("--"),
    K = q("var(--"),
    Q = (e) => !!K(e) && X.test(e.split("/*")[0].trim()),
    X =
      /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu,
    G = (e, t, n) => (n > t ? t : n < e ? e : n),
    Z = {
      test: (e) => "number" == typeof e,
      parse: parseFloat,
      transform: (e) => e,
    },
    J = { ...Z, transform: (e) => G(0, 1, e) },
    ee = { ...Z, default: 1 },
    te = (e) => Math.round(1e5 * e) / 1e5,
    ne = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu,
    re =
      /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
    ae = (e, t) => (n) =>
      Boolean(
        ("string" == typeof n && re.test(n) && n.startsWith(e)) ||
          (t &&
            !(function (e) {
              return null == e;
            })(n) &&
            Object.prototype.hasOwnProperty.call(n, t))
      ),
    oe = (e, t, n) => (r) => {
      if ("string" != typeof r) return r;
      const [a, o, i, s] = r.match(ne);
      return {
        [e]: parseFloat(a),
        [t]: parseFloat(o),
        [n]: parseFloat(i),
        alpha: void 0 !== s ? parseFloat(s) : 1,
      };
    },
    ie = { ...Z, transform: (e) => Math.round(((e) => G(0, 255, e))(e)) },
    se = {
      test: ae("rgb", "red"),
      parse: oe("red", "green", "blue"),
      transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) =>
        "rgba(" +
        ie.transform(e) +
        ", " +
        ie.transform(t) +
        ", " +
        ie.transform(n) +
        ", " +
        te(J.transform(r)) +
        ")",
    },
    le = {
      test: ae("#"),
      parse: function (e) {
        let t = "",
          n = "",
          r = "",
          a = "";
        return (
          e.length > 5
            ? ((t = e.substring(1, 3)),
              (n = e.substring(3, 5)),
              (r = e.substring(5, 7)),
              (a = e.substring(7, 9)))
            : ((t = e.substring(1, 2)),
              (n = e.substring(2, 3)),
              (r = e.substring(3, 4)),
              (a = e.substring(4, 5)),
              (t += t),
              (n += n),
              (r += r),
              (a += a)),
          {
            red: parseInt(t, 16),
            green: parseInt(n, 16),
            blue: parseInt(r, 16),
            alpha: a ? parseInt(a, 16) / 255 : 1,
          }
        );
      },
      transform: se.transform,
    },
    ue = (e) => ({
      test: (t) =>
        "string" == typeof t && t.endsWith(e) && 1 === t.split(" ").length,
      parse: parseFloat,
      transform: (t) => `${t}${e}`,
    }),
    ce = ue("deg"),
    de = ue("%"),
    fe = ue("px"),
    pe = ue("vh"),
    he = ue("vw"),
    me = (() => ({
      ...de,
      parse: (e) => de.parse(e) / 100,
      transform: (e) => de.transform(100 * e),
    }))(),
    ye = {
      test: ae("hsl", "hue"),
      parse: oe("hue", "saturation", "lightness"),
      transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) =>
        "hsla(" +
        Math.round(e) +
        ", " +
        de.transform(te(t)) +
        ", " +
        de.transform(te(n)) +
        ", " +
        te(J.transform(r)) +
        ")",
    },
    ge = {
      test: (e) => se.test(e) || le.test(e) || ye.test(e),
      parse: (e) =>
        se.test(e) ? se.parse(e) : ye.test(e) ? ye.parse(e) : le.parse(e),
      transform: (e) =>
        "string" == typeof e
          ? e
          : e.hasOwnProperty("red")
          ? se.transform(e)
          : ye.transform(e),
    },
    ve =
      /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu,
    be = "number",
    we = "color",
    ke =
      /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
  function Se(e) {
    const t = e.toString(),
      n = [],
      r = { color: [], number: [], var: [] },
      a = [];
    let o = 0;
    const i = t
      .replace(
        ke,
        (e) => (
          ge.test(e)
            ? (r.color.push(o), a.push(we), n.push(ge.parse(e)))
            : e.startsWith("var(")
            ? (r.var.push(o), a.push("var"), n.push(e))
            : (r.number.push(o), a.push(be), n.push(parseFloat(e))),
          ++o,
          "${}"
        )
      )
      .split("${}");
    return { values: n, split: i, indexes: r, types: a };
  }
  function xe(e) {
    return Se(e).values;
  }
  function Pe(e) {
    const { split: t, types: n } = Se(e),
      r = t.length;
    return (e) => {
      let a = "";
      for (let o = 0; o < r; o++)
        if (((a += t[o]), void 0 !== e[o])) {
          const t = n[o];
          a += t === be ? te(e[o]) : t === we ? ge.transform(e[o]) : e[o];
        }
      return a;
    };
  }
  const Ee = (e) => ("number" == typeof e ? 0 : e),
    Ce = {
      test: function (e) {
        return (
          isNaN(e) &&
          "string" == typeof e &&
          (e.match(ne)?.length || 0) + (e.match(ve)?.length || 0) > 0
        );
      },
      parse: xe,
      createTransformer: Pe,
      getAnimatableNone: function (e) {
        const t = xe(e);
        return Pe(e)(t.map(Ee));
      },
    };
  function Te(e, t, n) {
    return (
      n < 0 && (n += 1),
      n > 1 && (n -= 1),
      n < 1 / 6
        ? e + 6 * (t - e) * n
        : n < 0.5
        ? t
        : n < 2 / 3
        ? e + (t - e) * (2 / 3 - n) * 6
        : e
    );
  }
  function Ae(e, t) {
    return (n) => (n > 0 ? t : e);
  }
  const Me = (e, t, n) => e + (t - e) * n,
    Le = (e, t, n) => {
      const r = e * e,
        a = n * (t * t - r) + r;
      return a < 0 ? 0 : Math.sqrt(a);
    },
    De = [le, se, ye];
  function Re(e) {
    const t = ((n = e), De.find((e) => e.test(n)));
    var n;
    if ((Boolean(t), !Boolean(t))) return !1;
    let r = t.parse(e);
    return (
      t === ye &&
        (r = (function ({ hue: e, saturation: t, lightness: n, alpha: r }) {
          (e /= 360), (n /= 100);
          let a = 0,
            o = 0,
            i = 0;
          if ((t /= 100)) {
            const r = n < 0.5 ? n * (1 + t) : n + t - n * t,
              s = 2 * n - r;
            (a = Te(s, r, e + 1 / 3)),
              (o = Te(s, r, e)),
              (i = Te(s, r, e - 1 / 3));
          } else a = o = i = n;
          return {
            red: Math.round(255 * a),
            green: Math.round(255 * o),
            blue: Math.round(255 * i),
            alpha: r,
          };
        })(r)),
      r
    );
  }
  const ze = (e, t) => {
      const n = Re(e),
        r = Re(t);
      if (!n || !r) return Ae(e, t);
      const a = { ...n };
      return (e) => (
        (a.red = Le(n.red, r.red, e)),
        (a.green = Le(n.green, r.green, e)),
        (a.blue = Le(n.blue, r.blue, e)),
        (a.alpha = Me(n.alpha, r.alpha, e)),
        se.transform(a)
      );
    },
    Ne = new Set(["none", "hidden"]),
    Fe = (e, t) => (n) => t(e(n)),
    Oe = (...e) => e.reduce(Fe);
  function _e(e, t) {
    return (n) => Me(e, t, n);
  }
  function Ie(e) {
    return "number" == typeof e
      ? _e
      : "string" == typeof e
      ? Q(e)
        ? Ae
        : ge.test(e)
        ? ze
        : Ue
      : Array.isArray(e)
      ? Ve
      : "object" == typeof e
      ? ge.test(e)
        ? ze
        : je
      : Ae;
  }
  function Ve(e, t) {
    const n = [...e],
      r = n.length,
      a = e.map((e, n) => Ie(e)(e, t[n]));
    return (e) => {
      for (let t = 0; t < r; t++) n[t] = a[t](e);
      return n;
    };
  }
  function je(e, t) {
    const n = { ...e, ...t },
      r = {};
    for (const a in n)
      void 0 !== e[a] && void 0 !== t[a] && (r[a] = Ie(e[a])(e[a], t[a]));
    return (e) => {
      for (const t in r) n[t] = r[t](e);
      return n;
    };
  }
  const Ue = (e, t) => {
    const n = Ce.createTransformer(t),
      r = Se(e),
      a = Se(t);
    return r.indexes.var.length === a.indexes.var.length &&
      r.indexes.color.length === a.indexes.color.length &&
      r.indexes.number.length >= a.indexes.number.length
      ? (Ne.has(e) && !a.values.length) || (Ne.has(t) && !r.values.length)
        ? (function (e, t) {
            return Ne.has(e)
              ? (n) => (n <= 0 ? e : t)
              : (n) => (n >= 1 ? t : e);
          })(e, t)
        : Oe(
            Ve(
              (function (e, t) {
                const n = [],
                  r = { color: 0, var: 0, number: 0 };
                for (let a = 0; a < t.values.length; a++) {
                  const o = t.types[a],
                    i = e.indexes[o][r[o]],
                    s = e.values[i] ?? 0;
                  (n[a] = s), r[o]++;
                }
                return n;
              })(r, a),
              a.values
            ),
            n
          )
      : Ae(e, t);
  };
  function Be(e, t, n) {
    return "number" == typeof e && "number" == typeof t && "number" == typeof n
      ? Me(e, t, n)
      : Ie(e)(e, t);
  }
  const We = (e) => {
      const t = ({ timestamp: t }) => e(t);
      return {
        start: () => y.update(t, !0),
        stop: () => g(t),
        now: () => (v.isProcessing ? v.timestamp : S.now()),
      };
    },
    He = (e, t, n = 10) => {
      let r = "";
      const a = Math.max(Math.round(t / n), 2);
      for (let t = 0; t < a; t++) r += e(t / (a - 1)) + ", ";
      return `linear(${r.substring(0, r.length - 2)})`;
    },
    $e = 2e4;
  function qe(e) {
    let t = 0,
      n = e.next(t);
    for (; !n.done && t < $e; ) (t += 50), (n = e.next(t));
    return t >= $e ? 1 / 0 : t;
  }
  function Ye(e, t, n) {
    const r = Math.max(t - 5, 0);
    return C(n - e(r), t - r);
  }
  const Ke = 0.01,
    Qe = 2,
    Xe = 0.005,
    Ge = 0.5;
  const Ze = 12;
  function Je(e, t) {
    return e * Math.sqrt(1 - t * t);
  }
  const et = ["duration", "bounce"],
    tt = ["stiffness", "damping", "mass"];
  function nt(e, t) {
    return t.some((t) => void 0 !== e[t]);
  }
  function rt(e = 0.3, t = 0.3) {
    const n =
      "object" != typeof e
        ? { visualDuration: e, keyframes: [0, 1], bounce: t }
        : e;
    let { restSpeed: r, restDelta: a } = n;
    const o = n.keyframes[0],
      i = n.keyframes[n.keyframes.length - 1],
      s = { done: !1, value: o },
      {
        stiffness: l,
        damping: u,
        mass: c,
        duration: d,
        velocity: f,
        isResolvedFromDuration: p,
      } = (function (e) {
        let t = {
          velocity: 0,
          stiffness: 100,
          damping: 10,
          mass: 1,
          isResolvedFromDuration: !1,
          ...e,
        };
        if (!nt(e, tt) && nt(e, et))
          if (e.visualDuration) {
            const n = e.visualDuration,
              r = (2 * Math.PI) / (1.2 * n),
              a = r * r,
              o = 2 * G(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(a);
            t = { ...t, mass: 1, stiffness: a, damping: o };
          } else {
            const n = (function ({
              duration: e = 800,
              bounce: t = 0.3,
              velocity: n = 0,
              mass: r = 1,
            }) {
              let a, o;
              W(10);
              let i = 1 - t;
              (i = G(0.05, 1, i)),
                (e = G(0.01, 10, H(e))),
                i < 1
                  ? ((a = (t) => {
                      const r = t * i,
                        a = r * e;
                      return 0.001 - ((r - n) / Je(t, i)) * Math.exp(-a);
                    }),
                    (o = (t) => {
                      const r = t * i * e,
                        o = r * n + n,
                        s = Math.pow(i, 2) * Math.pow(t, 2) * e,
                        l = Math.exp(-r),
                        u = Je(Math.pow(t, 2), i);
                      return ((0.001 - a(t) > 0 ? -1 : 1) * ((o - s) * l)) / u;
                    }))
                  : ((a = (t) => Math.exp(-t * e) * ((t - n) * e + 1) - 0.001),
                    (o = (t) => Math.exp(-t * e) * (e * e * (n - t))));
              const s = (function (e, t, n) {
                let r = n;
                for (let n = 1; n < Ze; n++) r -= e(r) / t(r);
                return r;
              })(a, o, 5 / e);
              if (((e = W(e)), isNaN(s)))
                return { stiffness: 100, damping: 10, duration: e };
              {
                const t = Math.pow(s, 2) * r;
                return {
                  stiffness: t,
                  damping: 2 * i * Math.sqrt(r * t),
                  duration: e,
                };
              }
            })(e);
            (t = { ...t, ...n, mass: 1 }), (t.isResolvedFromDuration = !0);
          }
        return t;
      })({ ...n, velocity: -H(n.velocity || 0) }),
      h = f || 0,
      m = u / (2 * Math.sqrt(l * c)),
      y = i - o,
      g = H(Math.sqrt(l / c)),
      v = Math.abs(y) < 5;
    let b;
    if ((r || (r = v ? Ke : Qe), a || (a = v ? Xe : Ge), m < 1)) {
      const e = Je(g, m);
      b = (t) => {
        const n = Math.exp(-m * g * t);
        return (
          i -
          n * (((h + m * g * y) / e) * Math.sin(e * t) + y * Math.cos(e * t))
        );
      };
    } else if (1 === m) b = (e) => i - Math.exp(-g * e) * (y + (h + g * y) * e);
    else {
      const e = g * Math.sqrt(m * m - 1);
      b = (t) => {
        const n = Math.exp(-m * g * t),
          r = Math.min(e * t, 300);
        return (
          i - (n * ((h + m * g * y) * Math.sinh(r) + e * y * Math.cosh(r))) / e
        );
      };
    }
    const w = {
      calculatedDuration: (p && d) || null,
      next: (e) => {
        const t = b(e);
        if (p) s.done = e >= d;
        else {
          let n = 0 === e ? h : 0;
          m < 1 && (n = 0 === e ? W(h) : Ye(b, e, t));
          const o = Math.abs(n) <= r,
            l = Math.abs(i - t) <= a;
          s.done = o && l;
        }
        return (s.value = s.done ? i : t), s;
      },
      toString: () => {
        const e = Math.min(qe(w), $e),
          t = He((t) => w.next(e * t).value, e, 30);
        return e + "ms " + t;
      },
      toTransition: () => {},
    };
    return w;
  }
  function at({
    keyframes: e,
    velocity: t = 0,
    power: n = 0.8,
    timeConstant: r = 325,
    bounceDamping: a = 10,
    bounceStiffness: o = 500,
    modifyTarget: i,
    min: s,
    max: l,
    restDelta: u = 0.5,
    restSpeed: c,
  }) {
    const d = e[0],
      f = { done: !1, value: d },
      p = (e) =>
        void 0 === s
          ? l
          : void 0 === l || Math.abs(s - e) < Math.abs(l - e)
          ? s
          : l;
    let h = n * t;
    const m = d + h,
      y = void 0 === i ? m : i(m);
    y !== m && (h = y - d);
    const g = (e) => -h * Math.exp(-e / r),
      v = (e) => y + g(e),
      b = (e) => {
        const t = g(e),
          n = v(e);
        (f.done = Math.abs(t) <= u), (f.value = f.done ? y : n);
      };
    let w, k;
    const S = (e) => {
      var t;
      (t = f.value),
        ((void 0 !== s && t < s) || (void 0 !== l && t > l)) &&
          ((w = e),
          (k = rt({
            keyframes: [f.value, p(f.value)],
            velocity: Ye(v, e, f.value),
            damping: a,
            stiffness: o,
            restDelta: u,
            restSpeed: c,
          })));
    };
    return (
      S(0),
      {
        calculatedDuration: null,
        next: (e) => {
          let t = !1;
          return (
            k || void 0 !== w || ((t = !0), b(e), S(e)),
            void 0 !== w && e >= w ? k.next(e - w) : (!t && b(e), f)
          );
        },
      }
    );
  }
  rt.applyToOptions = (e) => {
    const t = (function (e, t = 100, n) {
      const r = n({ ...e, keyframes: [0, t] }),
        a = Math.min(qe(r), $e);
      return {
        type: "keyframes",
        ease: (e) => r.next(a * e).value / t,
        duration: H(a),
      };
    })(e, 100, rt);
    return (
      (e.ease = t.ease), (e.duration = W(t.duration)), (e.type = "keyframes"), e
    );
  };
  const ot = (e, t, n) => {
    const r = t - e;
    return 0 === r ? 1 : (n - e) / r;
  };
  const it = (e, t, n) =>
    (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e;
  function st(e, t, n, r) {
    if (e === t && n === r) return m;
    return (a) =>
      0 === a || 1 === a
        ? a
        : it(
            (function (e, t, n, r, a) {
              let o,
                i,
                s = 0;
              do {
                (i = t + (n - t) / 2),
                  (o = it(i, r, a) - e),
                  o > 0 ? (n = i) : (t = i);
              } while (Math.abs(o) > 1e-7 && ++s < 12);
              return i;
            })(a, 0, 1, e, n),
            t,
            r
          );
  }
  const lt = st(0.42, 0, 1, 1),
    ut = st(0, 0, 0.58, 1),
    ct = st(0.42, 0, 0.58, 1),
    dt = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2,
    ft = (e) => (t) => 1 - e(1 - t),
    pt = st(0.33, 1.53, 0.69, 0.99),
    ht = ft(pt),
    mt = dt(ht),
    yt = (e) =>
      (e *= 2) < 1 ? 0.5 * ht(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))),
    gt = (e) => 1 - Math.sin(Math.acos(e)),
    vt = ft(gt),
    bt = dt(gt),
    wt = (e) => Array.isArray(e) && "number" == typeof e[0],
    kt = {
      linear: m,
      easeIn: lt,
      easeInOut: ct,
      easeOut: ut,
      circIn: gt,
      circInOut: bt,
      circOut: vt,
      backIn: ht,
      backInOut: mt,
      backOut: pt,
      anticipate: yt,
    },
    St = (e) => {
      if (wt(e)) {
        e.length;
        const [t, n, r, a] = e;
        return st(t, n, r, a);
      }
      return "string" == typeof e ? kt[e] : e;
    };
  function xt({
    duration: e = 300,
    keyframes: t,
    times: n,
    ease: r = "easeInOut",
  }) {
    const a = ((e) => Array.isArray(e) && "number" != typeof e[0])(r)
        ? r.map(St)
        : St(r),
      o = { done: !1, value: t[0] },
      i = (function (e, t) {
        return e.map((e) => e * t);
      })(
        n && n.length === t.length
          ? n
          : (function (e) {
              const t = [0];
              return (
                (function (e, t) {
                  const n = e[e.length - 1];
                  for (let r = 1; r <= t; r++) {
                    const a = ot(0, t, r);
                    e.push(Me(n, 1, a));
                  }
                })(t, e.length - 1),
                t
              );
            })(t),
        e
      ),
      s = (function (e, t, { clamp: n = !0, ease: r, mixer: a } = {}) {
        const o = e.length;
        if ((t.length, 1 === o)) return () => t[0];
        if (2 === o && t[0] === t[1]) return () => t[1];
        const i = e[0] === e[1];
        e[0] > e[o - 1] && ((e = [...e].reverse()), (t = [...t].reverse()));
        const s = (function (e, t, n) {
            const r = [],
              a = n || p.mix || Be,
              o = e.length - 1;
            for (let n = 0; n < o; n++) {
              let o = a(e[n], e[n + 1]);
              if (t) {
                const e = Array.isArray(t) ? t[n] || m : t;
                o = Oe(e, o);
              }
              r.push(o);
            }
            return r;
          })(t, r, a),
          l = s.length,
          u = (n) => {
            if (i && n < e[0]) return t[0];
            let r = 0;
            if (l > 1) for (; r < e.length - 2 && !(n < e[r + 1]); r++);
            const a = ot(e[r], e[r + 1], n);
            return s[r](a);
          };
        return n ? (t) => u(G(e[0], e[o - 1], t)) : u;
      })(i, t, {
        ease: Array.isArray(a)
          ? a
          : ((l = t), (u = a), l.map(() => u || ct).splice(0, l.length - 1)),
      });
    var l, u;
    return {
      calculatedDuration: e,
      next: (t) => ((o.value = s(t)), (o.done = t >= e), o),
    };
  }
  const Pt = (e) => null !== e;
  function Et(e, { repeat: t, repeatType: n = "loop" }, r, a = 1) {
    const o = e.filter(Pt),
      i = a < 0 || (t && "loop" !== n && t % 2 == 1) ? 0 : o.length - 1;
    return i && void 0 !== r ? r : o[i];
  }
  const Ct = { decay: at, inertia: at, tween: xt, keyframes: xt, spring: rt };
  function Tt(e) {
    "string" == typeof e.type && (e.type = Ct[e.type]);
  }
  class At {
    constructor() {
      (this.count = 0), this.updateFinished();
    }
    get finished() {
      return this._finished;
    }
    updateFinished() {
      this.count++,
        (this._finished = new Promise((e) => {
          this.resolve = e;
        }));
    }
    notifyFinished() {
      this.resolve();
    }
    then(e, t) {
      return this.finished.then(e, t);
    }
  }
  const Mt = (e) => e / 100;
  class Lt extends At {
    constructor(e) {
      super(),
        (this.state = "idle"),
        (this.startTime = null),
        (this.isStopped = !1),
        (this.currentTime = 0),
        (this.holdTime = null),
        (this.playbackSpeed = 1),
        (this.stop = () => {
          const { motionValue: e } = this.options;
          if (
            (e && e.updatedAt !== S.now() && this.tick(S.now()),
            (this.isStopped = !0),
            "idle" === this.state)
          )
            return;
          this.teardown();
          const { onStop: t } = this.options;
          t && t();
        }),
        $.mainThread++,
        (this.options = e),
        this.initAnimation(),
        this.play(),
        !1 === e.autoplay && this.pause();
    }
    initAnimation() {
      const { options: e } = this;
      Tt(e);
      const {
        type: t = xt,
        repeat: n = 0,
        repeatDelay: r = 0,
        repeatType: a,
        velocity: o = 0,
      } = e;
      let { keyframes: i } = e;
      const s = t || xt;
      s !== xt &&
        "number" != typeof i[0] &&
        ((this.mixKeyframes = Oe(Mt, Be(i[0], i[1]))), (i = [0, 100]));
      const l = s({ ...e, keyframes: i });
      "mirror" === a &&
        (this.mirroredGenerator = s({
          ...e,
          keyframes: [...i].reverse(),
          velocity: -o,
        })),
        null === l.calculatedDuration && (l.calculatedDuration = qe(l));
      const { calculatedDuration: u } = l;
      (this.calculatedDuration = u),
        (this.resolvedDuration = u + r),
        (this.totalDuration = this.resolvedDuration * (n + 1) - r),
        (this.generator = l);
    }
    updateTime(e) {
      const t = Math.round(e - this.startTime) * this.playbackSpeed;
      null !== this.holdTime
        ? (this.currentTime = this.holdTime)
        : (this.currentTime = t);
    }
    tick(e, t = !1) {
      const {
        generator: n,
        totalDuration: r,
        mixKeyframes: a,
        mirroredGenerator: o,
        resolvedDuration: i,
        calculatedDuration: s,
      } = this;
      if (null === this.startTime) return n.next(0);
      const {
        delay: l = 0,
        keyframes: u,
        repeat: c,
        repeatType: d,
        repeatDelay: f,
        type: p,
        onUpdate: h,
        finalKeyframe: m,
      } = this.options;
      this.speed > 0
        ? (this.startTime = Math.min(this.startTime, e))
        : this.speed < 0 &&
          (this.startTime = Math.min(e - r / this.speed, this.startTime)),
        t ? (this.currentTime = e) : this.updateTime(e);
      const y = this.currentTime - l * (this.playbackSpeed >= 0 ? 1 : -1),
        g = this.playbackSpeed >= 0 ? y < 0 : y > r;
      (this.currentTime = Math.max(y, 0)),
        "finished" === this.state &&
          null === this.holdTime &&
          (this.currentTime = r);
      let v = this.currentTime,
        b = n;
      if (c) {
        const e = Math.min(this.currentTime, r) / i;
        let t = Math.floor(e),
          n = e % 1;
        !n && e >= 1 && (n = 1),
          1 === n && t--,
          (t = Math.min(t, c + 1)),
          Boolean(t % 2) &&
            ("reverse" === d
              ? ((n = 1 - n), f && (n -= f / i))
              : "mirror" === d && (b = o)),
          (v = G(0, 1, n) * i);
      }
      const w = g ? { done: !1, value: u[0] } : b.next(v);
      a && (w.value = a(w.value));
      let { done: k } = w;
      g ||
        null === s ||
        (k =
          this.playbackSpeed >= 0
            ? this.currentTime >= r
            : this.currentTime <= 0);
      const S =
        null === this.holdTime &&
        ("finished" === this.state || ("running" === this.state && k));
      return (
        S && p !== at && (w.value = Et(u, this.options, m, this.speed)),
        h && h(w.value),
        S && this.finish(),
        w
      );
    }
    then(e, t) {
      return this.finished.then(e, t);
    }
    get duration() {
      return H(this.calculatedDuration);
    }
    get time() {
      return H(this.currentTime);
    }
    set time(e) {
      (e = W(e)),
        (this.currentTime = e),
        null === this.startTime ||
        null !== this.holdTime ||
        0 === this.playbackSpeed
          ? (this.holdTime = e)
          : this.driver &&
            (this.startTime = this.driver.now() - e / this.playbackSpeed);
    }
    get speed() {
      return this.playbackSpeed;
    }
    set speed(e) {
      this.updateTime(S.now());
      const t = this.playbackSpeed !== e;
      (this.playbackSpeed = e), t && (this.time = H(this.currentTime));
    }
    play() {
      if (this.isStopped) return;
      const { driver: e = We, onPlay: t, startTime: n } = this.options;
      this.driver || (this.driver = e((e) => this.tick(e))), t && t();
      const r = this.driver.now();
      "finished" === this.state
        ? (this.updateFinished(), (this.startTime = r))
        : null !== this.holdTime
        ? (this.startTime = r - this.holdTime)
        : this.startTime || (this.startTime = n ?? r),
        "finished" === this.state &&
          this.speed < 0 &&
          (this.startTime += this.calculatedDuration),
        (this.holdTime = null),
        (this.state = "running"),
        this.driver.start();
    }
    pause() {
      (this.state = "paused"),
        this.updateTime(S.now()),
        (this.holdTime = this.currentTime);
    }
    complete() {
      "running" !== this.state && this.play(),
        (this.state = "finished"),
        (this.holdTime = null);
    }
    finish() {
      this.teardown(), (this.state = "finished");
      const { onComplete: e } = this.options;
      e && e();
    }
    cancel() {
      (this.holdTime = null),
        (this.startTime = 0),
        this.tick(0),
        this.teardown();
    }
    teardown() {
      this.notifyFinished(),
        (this.state = "idle"),
        this.stopDriver(),
        (this.startTime = this.holdTime = null),
        $.mainThread--;
    }
    stopDriver() {
      this.driver && (this.driver.stop(), (this.driver = void 0));
    }
    sample(e) {
      return (this.startTime = 0), this.tick(e, !0);
    }
    attachTimeline(e) {
      return (
        this.options.allowFlatten &&
          ((this.options.type = "keyframes"),
          (this.options.ease = "linear"),
          this.initAnimation()),
        e.observe(this)
      );
    }
  }
  const Dt = (e) => (180 * e) / Math.PI,
    Rt = (e) => {
      const t = Dt(Math.atan2(e[1], e[0]));
      return Nt(t);
    },
    zt = {
      x: 4,
      y: 5,
      translateX: 4,
      translateY: 5,
      scaleX: 0,
      scaleY: 3,
      scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
      rotate: Rt,
      rotateZ: Rt,
      skewX: (e) => Dt(Math.atan(e[1])),
      skewY: (e) => Dt(Math.atan(e[2])),
      skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2,
    },
    Nt = (e) => ((e %= 360) < 0 && (e += 360), e),
    Ft = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]),
    Ot = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]),
    _t = {
      x: 12,
      y: 13,
      z: 14,
      translateX: 12,
      translateY: 13,
      translateZ: 14,
      scaleX: Ft,
      scaleY: Ot,
      scale: (e) => (Ft(e) + Ot(e)) / 2,
      rotateX: (e) => Nt(Dt(Math.atan2(e[6], e[5]))),
      rotateY: (e) => Nt(Dt(Math.atan2(-e[2], e[0]))),
      rotateZ: Rt,
      rotate: Rt,
      skewX: (e) => Dt(Math.atan(e[4])),
      skewY: (e) => Dt(Math.atan(e[1])),
      skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2,
    };
  function It(e) {
    return e.includes("scale") ? 1 : 0;
  }
  function Vt(e, t) {
    if (!e || "none" === e) return It(t);
    const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let r, a;
    if (n) (r = _t), (a = n);
    else {
      const t = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
      (r = zt), (a = t);
    }
    if (!a) return It(t);
    const o = r[t],
      i = a[1].split(",").map(jt);
    return "function" == typeof o ? o(i) : i[o];
  }
  function jt(e) {
    return parseFloat(e.trim());
  }
  const Ut = (e) => e === Z || e === fe,
    Bt = new Set(["x", "y", "z"]),
    Wt = _.filter((e) => !Bt.has(e)),
    Ht = {
      width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) =>
        e.max - e.min - parseFloat(t) - parseFloat(n),
      height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) =>
        e.max - e.min - parseFloat(t) - parseFloat(n),
      top: (e, { top: t }) => parseFloat(t),
      left: (e, { left: t }) => parseFloat(t),
      bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
      right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
      x: (e, { transform: t }) => Vt(t, "x"),
      y: (e, { transform: t }) => Vt(t, "y"),
    };
  (Ht.translateX = Ht.x), (Ht.translateY = Ht.y);
  const $t = new Set();
  let qt = !1,
    Yt = !1,
    Kt = !1;
  function Qt() {
    if (Yt) {
      const e = Array.from($t).filter((e) => e.needsMeasurement),
        t = new Set(e.map((e) => e.element)),
        n = new Map();
      t.forEach((e) => {
        const t = (function (e) {
          const t = [];
          return (
            Wt.forEach((n) => {
              const r = e.getValue(n);
              void 0 !== r &&
                (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
            }),
            t
          );
        })(e);
        t.length && (n.set(e, t), e.render());
      }),
        e.forEach((e) => e.measureInitialState()),
        t.forEach((e) => {
          e.render();
          const t = n.get(e);
          t &&
            t.forEach(([t, n]) => {
              e.getValue(t)?.set(n);
            });
        }),
        e.forEach((e) => e.measureEndState()),
        e.forEach((e) => {
          void 0 !== e.suspendedScrollY &&
            window.scrollTo(0, e.suspendedScrollY);
        });
    }
    (Yt = !1), (qt = !1), $t.forEach((e) => e.complete(Kt)), $t.clear();
  }
  function Xt() {
    $t.forEach((e) => {
      e.readKeyframes(), e.needsMeasurement && (Yt = !0);
    });
  }
  class Gt {
    constructor(e, t, n, r, a, o = !1) {
      (this.isComplete = !1),
        (this.isAsync = !1),
        (this.needsMeasurement = !1),
        (this.isScheduled = !1),
        (this.unresolvedKeyframes = [...e]),
        (this.onComplete = t),
        (this.name = n),
        (this.motionValue = r),
        (this.element = a),
        (this.isAsync = o);
    }
    scheduleResolve() {
      (this.isScheduled = !0),
        this.isAsync
          ? ($t.add(this),
            qt || ((qt = !0), y.read(Xt), y.resolveKeyframes(Qt)))
          : (this.readKeyframes(), this.complete());
    }
    readKeyframes() {
      const {
        unresolvedKeyframes: e,
        name: t,
        element: n,
        motionValue: r,
      } = this;
      if (null === e[0]) {
        const a = r?.get(),
          o = e[e.length - 1];
        if (void 0 !== a) e[0] = a;
        else if (n && t) {
          const r = n.readValue(t, o);
          null != r && (e[0] = r);
        }
        void 0 === e[0] && (e[0] = o), r && void 0 === a && r.set(e[0]);
      }
      !(function (e) {
        for (let t = 1; t < e.length; t++) e[t] ?? (e[t] = e[t - 1]);
      })(e);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(e = !1) {
      (this.isComplete = !0),
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e),
        $t.delete(this);
    }
    cancel() {
      this.isComplete || ((this.isScheduled = !1), $t.delete(this));
    }
    resume() {
      this.isComplete || this.scheduleResolve();
    }
  }
  function Zt(e) {
    let t;
    return () => (void 0 === t && (t = e()), t);
  }
  const Jt = Zt(() => void 0 !== window.ScrollTimeline),
    en = {};
  function tn(e, t) {
    const n = Zt(e);
    return () => en[t] ?? n();
  }
  const nn = tn(() => {
      try {
        document
          .createElement("div")
          .animate({ opacity: 0 }, { easing: "linear(0, 1)" });
      } catch (e) {
        return !1;
      }
      return !0;
    }, "linearEasing"),
    rn = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`,
    an = {
      linear: "linear",
      ease: "ease",
      easeIn: "ease-in",
      easeOut: "ease-out",
      easeInOut: "ease-in-out",
      circIn: rn([0, 0.65, 0.55, 1]),
      circOut: rn([0.55, 0, 1, 0.45]),
      backIn: rn([0.31, 0.01, 0.66, -0.59]),
      backOut: rn([0.33, 1.53, 0.69, 0.99]),
    };
  function on(e, t) {
    return e
      ? "function" == typeof e
        ? nn()
          ? He(e, t)
          : "ease-out"
        : wt(e)
        ? rn(e)
        : Array.isArray(e)
        ? e.map((e) => on(e, t) || an.easeOut)
        : an[e]
      : void 0;
  }
  function sn(
    e,
    t,
    n,
    {
      delay: r = 0,
      duration: a = 300,
      repeat: o = 0,
      repeatType: i = "loop",
      ease: s = "easeOut",
      times: l,
    } = {},
    u = void 0
  ) {
    const c = { [t]: n };
    l && (c.offset = l);
    const d = on(s, a);
    Array.isArray(d) && (c.easing = d), f.value && $.waapi++;
    const p = {
      delay: r,
      duration: a,
      easing: Array.isArray(d) ? "linear" : d,
      fill: "both",
      iterations: o + 1,
      direction: "reverse" === i ? "alternate" : "normal",
    };
    u && (p.pseudoElement = u);
    const h = e.animate(c, p);
    return (
      f.value &&
        h.finished.finally(() => {
          $.waapi--;
        }),
      h
    );
  }
  function ln(e) {
    return "function" == typeof e && "applyToOptions" in e;
  }
  class un extends At {
    constructor(e) {
      if ((super(), (this.finishedTime = null), (this.isStopped = !1), !e))
        return;
      const {
        element: t,
        name: n,
        keyframes: r,
        pseudoElement: a,
        allowFlatten: o = !1,
        finalKeyframe: i,
        onComplete: s,
      } = e;
      (this.isPseudoElement = Boolean(a)),
        (this.allowFlatten = o),
        (this.options = e),
        e.type;
      const l = (function ({ type: e, ...t }) {
        return ln(e) && nn()
          ? e.applyToOptions(t)
          : (t.duration ?? (t.duration = 300),
            t.ease ?? (t.ease = "easeOut"),
            t);
      })(e);
      (this.animation = sn(t, n, r, l, a)),
        !1 === l.autoplay && this.animation.pause(),
        (this.animation.onfinish = () => {
          if (((this.finishedTime = this.time), !a)) {
            const e = Et(r, this.options, i, this.speed);
            this.updateMotionValue
              ? this.updateMotionValue(e)
              : (function (e, t, n) {
                  ((e) => e.startsWith("--"))(t)
                    ? e.style.setProperty(t, n)
                    : (e.style[t] = n);
                })(t, n, e),
              this.animation.cancel();
          }
          s?.(), this.notifyFinished();
        }),
        (this.animation.oncancel = () => this.notifyFinished());
    }
    play() {
      this.isStopped ||
        (this.animation.play(),
        "finished" === this.state && this.updateFinished());
    }
    pause() {
      this.animation.pause();
    }
    complete() {
      this.animation.finish?.();
    }
    cancel() {
      try {
        this.animation.cancel();
      } catch (e) {}
    }
    stop() {
      if (this.isStopped) return;
      this.isStopped = !0;
      const { state: e } = this;
      "idle" !== e &&
        "finished" !== e &&
        (this.updateMotionValue
          ? this.updateMotionValue()
          : this.commitStyles(),
        this.isPseudoElement || this.cancel());
    }
    commitStyles() {
      this.isPseudoElement || this.animation.commitStyles?.();
    }
    get duration() {
      const e = this.animation.effect?.getComputedTiming?.().duration || 0;
      return H(Number(e));
    }
    get time() {
      return H(Number(this.animation.currentTime) || 0);
    }
    set time(e) {
      (this.finishedTime = null), (this.animation.currentTime = W(e));
    }
    get speed() {
      return this.animation.playbackRate;
    }
    set speed(e) {
      e < 0 && (this.finishedTime = null), (this.animation.playbackRate = e);
    }
    get state() {
      return null !== this.finishedTime ? "finished" : this.animation.playState;
    }
    get startTime() {
      return Number(this.animation.startTime);
    }
    set startTime(e) {
      this.animation.startTime = e;
    }
    attachTimeline({ timeline: e, observe: t }) {
      return (
        this.allowFlatten &&
          this.animation.effect?.updateTiming({ easing: "linear" }),
        (this.animation.onfinish = null),
        e && Jt() ? ((this.animation.timeline = e), m) : t(this)
      );
    }
  }
  const cn = { anticipate: yt, backInOut: mt, circInOut: bt };
  class dn extends un {
    constructor(e) {
      var t;
      "string" == typeof (t = e).ease && t.ease in cn && (t.ease = cn[t.ease]),
        Tt(e),
        super(e),
        e.startTime && (this.startTime = e.startTime),
        (this.options = e);
    }
    updateMotionValue(e) {
      const {
        motionValue: t,
        onUpdate: n,
        onComplete: r,
        element: a,
        ...o
      } = this.options;
      if (!t) return;
      if (void 0 !== e) return void t.set(e);
      const i = new Lt({ ...o, autoplay: !1 }),
        s = W(this.finishedTime ?? this.time);
      t.setWithVelocity(i.sample(s - 10).value, i.sample(s).value, 10),
        i.stop();
    }
  }
  const fn = (e, t) =>
      !(
        "zIndex" === t ||
        ("number" != typeof e &&
          !Array.isArray(e) &&
          ("string" != typeof e ||
            (!Ce.test(e) && "0" !== e) ||
            e.startsWith("url(")))
      ),
    pn = new Set(["opacity", "clipPath", "filter", "transform"]),
    hn = Zt(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
  class mn extends At {
    constructor({
      autoplay: e = !0,
      delay: t = 0,
      type: n = "keyframes",
      repeat: r = 0,
      repeatDelay: a = 0,
      repeatType: o = "loop",
      keyframes: i,
      name: s,
      motionValue: l,
      element: u,
      ...c
    }) {
      super(),
        (this.stop = () => {
          this._animation
            ? (this._animation.stop(), this.stopTimeline?.())
            : this.keyframeResolver?.cancel();
        }),
        (this.createdAt = S.now());
      const d = {
          autoplay: e,
          delay: t,
          type: n,
          repeat: r,
          repeatDelay: a,
          repeatType: o,
          name: s,
          motionValue: l,
          element: u,
          ...c,
        },
        f = u?.KeyframeResolver || Gt;
      (this.keyframeResolver = new f(
        i,
        (e, t, n) => this.onKeyframesResolved(e, t, d, !n),
        s,
        l,
        u
      )),
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(e, t, n, r) {
      this.keyframeResolver = void 0;
      const {
        name: a,
        type: o,
        velocity: i,
        delay: s,
        isHandoff: l,
        onUpdate: u,
      } = n;
      (this.resolvedAt = S.now()),
        (function (e, t, n, r) {
          const a = e[0];
          if (null === a) return !1;
          if ("display" === t || "visibility" === t) return !0;
          const o = e[e.length - 1],
            i = fn(a, t),
            s = fn(o, t);
          return (
            !(!i || !s) &&
            ((function (e) {
              const t = e[0];
              if (1 === e.length) return !0;
              for (let n = 0; n < e.length; n++) if (e[n] !== t) return !0;
            })(e) ||
              (("spring" === n || ln(n)) && r))
          );
        })(e, a, o, i) ||
          ((!p.instantAnimations && s) || u?.(Et(e, n, t)),
          (e[0] = e[e.length - 1]),
          (n.duration = 0),
          (n.repeat = 0));
      const c = {
          startTime: r
            ? this.resolvedAt && this.resolvedAt - this.createdAt > 40
              ? this.resolvedAt
              : this.createdAt
            : void 0,
          finalKeyframe: t,
          ...n,
          keyframes: e,
        },
        d =
          !l &&
          (function (e) {
            const {
              motionValue: t,
              name: n,
              repeatDelay: r,
              repeatType: a,
              damping: o,
              type: i,
            } = e;
            if (!(t && t.owner && t.owner.current instanceof HTMLElement))
              return !1;
            const { onUpdate: s, transformTemplate: l } = t.owner.getProps();
            return (
              hn() &&
              n &&
              pn.has(n) &&
              ("transform" !== n || !l) &&
              !s &&
              !r &&
              "mirror" !== a &&
              0 !== o &&
              "inertia" !== i
            );
          })(c)
            ? new dn({ ...c, element: c.motionValue.owner.current })
            : new Lt(c);
      d.finished.then(() => this.notifyFinished()).catch(m),
        this.pendingTimeline &&
          ((this.stopTimeline = d.attachTimeline(this.pendingTimeline)),
          (this.pendingTimeline = void 0)),
        (this._animation = d);
    }
    get finished() {
      return this._animation ? this.animation.finished : this._finished;
    }
    then(e, t) {
      return this.finished.finally(e).then(() => {});
    }
    get animation() {
      return (
        this._animation || ((Kt = !0), Xt(), Qt(), (Kt = !1)), this._animation
      );
    }
    get duration() {
      return this.animation.duration;
    }
    get time() {
      return this.animation.time;
    }
    set time(e) {
      this.animation.time = e;
    }
    get speed() {
      return this.animation.speed;
    }
    get state() {
      return this.animation.state;
    }
    set speed(e) {
      this.animation.speed = e;
    }
    get startTime() {
      return this.animation.startTime;
    }
    attachTimeline(e) {
      return (
        this._animation
          ? (this.stopTimeline = this.animation.attachTimeline(e))
          : (this.pendingTimeline = e),
        () => this.stop()
      );
    }
    play() {
      this.animation.play();
    }
    pause() {
      this.animation.pause();
    }
    complete() {
      this.animation.complete();
    }
    cancel() {
      this.animation.cancel();
    }
  }
  const yn =
      (e, t, n, r = {}, a, o) =>
      (i) => {
        const s = B(r, e) || {},
          l = s.delay || r.delay || 0;
        let { elapsed: u = 0 } = r;
        u -= W(l);
        const c = {
          keyframes: Array.isArray(n) ? n : [null, n],
          ease: "easeOut",
          velocity: t.getVelocity(),
          ...s,
          delay: -u,
          onUpdate: (e) => {
            t.set(e), s.onUpdate && s.onUpdate(e);
          },
          onComplete: () => {
            i(), s.onComplete && s.onComplete();
          },
          name: e,
          motionValue: t,
          element: o ? void 0 : a,
        };
        (function ({
          when: e,
          delay: t,
          delayChildren: n,
          staggerChildren: r,
          staggerDirection: a,
          repeat: o,
          repeatType: i,
          repeatDelay: s,
          from: l,
          elapsed: u,
          ...c
        }) {
          return !!Object.keys(c).length;
        })(s) ||
          Object.assign(
            c,
            ((e, { keyframes: t }) =>
              t.length > 2
                ? j
                : I.has(e)
                ? e.startsWith("scale")
                  ? {
                      type: "spring",
                      stiffness: 550,
                      damping: 0 === t[1] ? 2 * Math.sqrt(550) : 30,
                      restSpeed: 10,
                    }
                  : V
                : U)(e, c)
          ),
          c.duration && (c.duration = W(c.duration)),
          c.repeatDelay && (c.repeatDelay = W(c.repeatDelay)),
          void 0 !== c.from && (c.keyframes[0] = c.from);
        let d = !1;
        if (
          ((!1 === c.type || (0 === c.duration && !c.repeatDelay)) &&
            ((c.duration = 0), 0 === c.delay && (d = !0)),
          (p.instantAnimations || p.skipAnimations) &&
            ((d = !0), (c.duration = 0), (c.delay = 0)),
          (c.allowFlatten = !s.type && !s.ease),
          d && !o && void 0 !== t.get())
        ) {
          const e = (function (e, { repeat: t, repeatType: n = "loop" }, r) {
            const a = e.filter(O),
              o = t && "loop" !== n && t % 2 == 1 ? 0 : a.length - 1;
            return o && void 0 !== r ? r : a[o];
          })(c.keyframes, s);
          if (void 0 !== e)
            return void y.update(() => {
              c.onUpdate(e), c.onComplete();
            });
        }
        return new mn(c);
      },
    gn = new Set(["width", "height", "top", "left", "right", "bottom", ..._]);
  function vn({ protectedKeys: e, needsAnimating: t }, n) {
    const r = e.hasOwnProperty(n) && !0 !== t[n];
    return (t[n] = !1), r;
  }
  function bn(e, t, { delay: n = 0, transitionOverride: r, type: a } = {}) {
    let {
      transition: o = e.getDefaultTransition(),
      transitionEnd: i,
      ...s
    } = t;
    r && (o = r);
    const l = [],
      d = a && e.animationState && e.animationState.getState()[a];
    for (const t in s) {
      const r = e.getValue(t, e.latestValues[t] ?? null),
        a = s[t];
      if (void 0 === a || (d && vn(d, t))) continue;
      const i = { delay: n, ...B(o || {}, t) },
        u = r.get();
      if (
        void 0 !== u &&
        !r.isAnimating &&
        !Array.isArray(a) &&
        a === u &&
        !i.velocity
      )
        continue;
      let c = !1;
      if (window.MotionHandoffAnimation) {
        const n = F(e);
        if (n) {
          const e = window.MotionHandoffAnimation(n, t, y);
          null !== e && ((i.startTime = e), (c = !0));
        }
      }
      R(e, t),
        r.start(
          yn(
            t,
            r,
            a,
            e.shouldReduceMotion && gn.has(t) ? { type: !1 } : i,
            e,
            c
          )
        );
      const f = r.animation;
      f && l.push(f);
    }
    return (
      i &&
        Promise.all(l).then(() => {
          y.update(() => {
            i &&
              (function (e, t) {
                const n = u(e, t);
                let {
                  transitionEnd: r = {},
                  transition: a = {},
                  ...o
                } = n || {};
                o = { ...o, ...r };
                for (const t in o)
                  L(e, t, ((i = o[t]), c(i) ? i[i.length - 1] || 0 : i));
                var i;
              })(e, i);
          });
        }),
      l
    );
  }
  function wn(e, t, n = {}) {
    const r = u(e, t, "exit" === n.type ? e.presenceContext?.custom : void 0);
    let { transition: a = e.getDefaultTransition() || {} } = r || {};
    n.transitionOverride && (a = n.transitionOverride);
    const o = r ? () => Promise.all(bn(e, r, n)) : () => Promise.resolve(),
      i =
        e.variantChildren && e.variantChildren.size
          ? (r = 0) => {
              const {
                delayChildren: o = 0,
                staggerChildren: i,
                staggerDirection: s,
              } = a;
              return (function (e, t, n = 0, r = 0, a = 1, o) {
                const i = [],
                  s = (e.variantChildren.size - 1) * r,
                  l = 1 === a ? (e = 0) => e * r : (e = 0) => s - e * r;
                return (
                  Array.from(e.variantChildren)
                    .sort(kn)
                    .forEach((e, r) => {
                      e.notify("AnimationStart", t),
                        i.push(
                          wn(e, t, { ...o, delay: n + l(r) }).then(() =>
                            e.notify("AnimationComplete", t)
                          )
                        );
                    }),
                  Promise.all(i)
                );
              })(e, t, o + r, i, s, n);
            }
          : () => Promise.resolve(),
      { when: s } = a;
    if (s) {
      const [e, t] = "beforeChildren" === s ? [o, i] : [i, o];
      return e().then(() => t());
    }
    return Promise.all([o(), i(n.delay)]);
  }
  function kn(e, t) {
    return e.sortNodePosition(t);
  }
  function Sn(e, t) {
    if (!Array.isArray(t)) return !1;
    const n = t.length;
    if (n !== e.length) return !1;
    for (let r = 0; r < n; r++) if (t[r] !== e[r]) return !1;
    return !0;
  }
  function xn(e) {
    return "string" == typeof e || Array.isArray(e);
  }
  const Pn = [
      "animate",
      "whileInView",
      "whileFocus",
      "whileHover",
      "whileTap",
      "whileDrag",
      "exit",
    ],
    En = ["initial", ...Pn],
    Cn = En.length;
  function Tn(e) {
    if (!e) return;
    if (!e.isControllingVariants) {
      const t = (e.parent && Tn(e.parent)) || {};
      return void 0 !== e.props.initial && (t.initial = e.props.initial), t;
    }
    const t = {};
    for (let n = 0; n < Cn; n++) {
      const r = En[n],
        a = e.props[r];
      (xn(a) || !1 === a) && (t[r] = a);
    }
    return t;
  }
  const An = [...Pn].reverse(),
    Mn = Pn.length;
  function Ln(e) {
    let t = (function (e) {
        return (t) =>
          Promise.all(
            t.map(({ animation: t, options: n }) =>
              (function (e, t, n = {}) {
                let r;
                if ((e.notify("AnimationStart", t), Array.isArray(t))) {
                  const a = t.map((t) => wn(e, t, n));
                  r = Promise.all(a);
                } else if ("string" == typeof t) r = wn(e, t, n);
                else {
                  const a = "function" == typeof t ? u(e, t, n.custom) : t;
                  r = Promise.all(bn(e, a, n));
                }
                return r.then(() => {
                  e.notify("AnimationComplete", t);
                });
              })(e, t, n)
            )
          );
      })(e),
      n = Rn(),
      r = !0;
    const a = (t) => (n, r) => {
      const a = u(e, r, "exit" === t ? e.presenceContext?.custom : void 0);
      if (a) {
        const { transition: e, transitionEnd: t, ...r } = a;
        n = { ...n, ...r, ...t };
      }
      return n;
    };
    function o(o) {
      const { props: s } = e,
        l = Tn(e.parent) || {},
        d = [],
        f = new Set();
      let p = {},
        h = 1 / 0;
      for (let t = 0; t < Mn; t++) {
        const u = An[t],
          g = n[u],
          v = void 0 !== s[u] ? s[u] : l[u],
          b = xn(v),
          w = u === o ? g.isActive : null;
        !1 === w && (h = t);
        let k = v === l[u] && v !== s[u] && b;
        if (
          (k && r && e.manuallyAnimateOnMount && (k = !1),
          (g.protectedKeys = { ...p }),
          (!g.isActive && null === w) ||
            (!v && !g.prevProp) ||
            i(v) ||
            "boolean" == typeof v)
        )
          continue;
        const S =
          ((m = g.prevProp),
          "string" == typeof (y = v)
            ? y !== m
            : !!Array.isArray(y) && !Sn(y, m));
        let x = S || (u === o && g.isActive && !k && b) || (t > h && b),
          P = !1;
        const E = Array.isArray(v) ? v : [v];
        let C = E.reduce(a(u), {});
        !1 === w && (C = {});
        const { prevResolvedValues: T = {} } = g,
          A = { ...T, ...C },
          M = (t) => {
            (x = !0),
              f.has(t) && ((P = !0), f.delete(t)),
              (g.needsAnimating[t] = !0);
            const n = e.getValue(t);
            n && (n.liveStyle = !1);
          };
        for (const e in A) {
          const t = C[e],
            n = T[e];
          if (p.hasOwnProperty(e)) continue;
          let r = !1;
          (r = c(t) && c(n) ? !Sn(t, n) : t !== n),
            r
              ? null != t
                ? M(e)
                : f.add(e)
              : void 0 !== t && f.has(e)
              ? M(e)
              : (g.protectedKeys[e] = !0);
        }
        (g.prevProp = v),
          (g.prevResolvedValues = C),
          g.isActive && (p = { ...p, ...C }),
          r && e.blockInitialAnimation && (x = !1),
          x &&
            (!k || !S || P) &&
            d.push(...E.map((e) => ({ animation: e, options: { type: u } })));
      }
      var m, y;
      if (f.size) {
        const t = {};
        if ("boolean" != typeof s.initial) {
          const n = u(e, Array.isArray(s.initial) ? s.initial[0] : s.initial);
          n && n.transition && (t.transition = n.transition);
        }
        f.forEach((n) => {
          const r = e.getBaseTarget(n),
            a = e.getValue(n);
          a && (a.liveStyle = !0), (t[n] = r ?? null);
        }),
          d.push({ animation: t });
      }
      let g = Boolean(d.length);
      return (
        !r ||
          (!1 !== s.initial && s.initial !== s.animate) ||
          e.manuallyAnimateOnMount ||
          (g = !1),
        (r = !1),
        g ? t(d) : Promise.resolve()
      );
    }
    return {
      animateChanges: o,
      setActive: function (t, r) {
        if (n[t].isActive === r) return Promise.resolve();
        e.variantChildren?.forEach((e) => e.animationState?.setActive(t, r)),
          (n[t].isActive = r);
        const a = o(t);
        for (const e in n) n[e].protectedKeys = {};
        return a;
      },
      setAnimateFunction: function (n) {
        t = n(e);
      },
      getState: () => n,
      reset: () => {
        (n = Rn()), (r = !0);
      },
    };
  }
  function Dn(e = !1) {
    return {
      isActive: e,
      protectedKeys: {},
      needsAnimating: {},
      prevResolvedValues: {},
    };
  }
  function Rn() {
    return {
      animate: Dn(!0),
      whileInView: Dn(),
      whileHover: Dn(),
      whileTap: Dn(),
      whileDrag: Dn(),
      whileFocus: Dn(),
      exit: Dn(),
    };
  }
  class zn {
    constructor(e) {
      (this.isMounted = !1), (this.node = e);
    }
    update() {}
  }
  let Nn = 0;
  const Fn = {
    animation: {
      Feature: class extends zn {
        constructor(e) {
          super(e), e.animationState || (e.animationState = Ln(e));
        }
        updateAnimationControlsSubscription() {
          const { animate: e } = this.node.getProps();
          i(e) && (this.unmountControls = e.subscribe(this.node));
        }
        mount() {
          this.updateAnimationControlsSubscription();
        }
        update() {
          const { animate: e } = this.node.getProps(),
            { animate: t } = this.node.prevProps || {};
          e !== t && this.updateAnimationControlsSubscription();
        }
        unmount() {
          this.node.animationState.reset(), this.unmountControls?.();
        }
      },
    },
    exit: {
      Feature: class extends zn {
        constructor() {
          super(...arguments), (this.id = Nn++);
        }
        update() {
          if (!this.node.presenceContext) return;
          const { isPresent: e, onExitComplete: t } = this.node.presenceContext,
            { isPresent: n } = this.node.prevPresenceContext || {};
          if (!this.node.animationState || e === n) return;
          const r = this.node.animationState.setActive("exit", !e);
          t &&
            !e &&
            r.then(() => {
              t(this.id);
            });
        }
        mount() {
          const { register: e, onExitComplete: t } =
            this.node.presenceContext || {};
          t && t(this.id), e && (this.unmount = e(this.id));
        }
        unmount() {}
      },
    },
  };
  function On(e, t, n, r = { passive: !0 }) {
    return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
  }
  const _n = (e) =>
    "mouse" === e.pointerType
      ? "number" != typeof e.button || e.button <= 0
      : !1 !== e.isPrimary;
  function In(e) {
    return { point: { x: e.pageX, y: e.pageY } };
  }
  function Vn(e, t, n, r) {
    return On(
      e,
      t,
      (
        (e) => (t) =>
          _n(t) && e(t, In(t))
      )(n),
      r
    );
  }
  function jn({ top: e, left: t, right: n, bottom: r }) {
    return { x: { min: t, max: n }, y: { min: e, max: r } };
  }
  function Un(e) {
    return e.max - e.min;
  }
  function Bn(e, t, n, r = 0.5) {
    (e.origin = r),
      (e.originPoint = Me(t.min, t.max, e.origin)),
      (e.scale = Un(n) / Un(t)),
      (e.translate = Me(n.min, n.max, e.origin) - e.originPoint),
      ((e.scale >= 0.9999 && e.scale <= 1.0001) || isNaN(e.scale)) &&
        (e.scale = 1),
      ((e.translate >= -0.01 && e.translate <= 0.01) || isNaN(e.translate)) &&
        (e.translate = 0);
  }
  function Wn(e, t, n, r) {
    Bn(e.x, t.x, n.x, r ? r.originX : void 0),
      Bn(e.y, t.y, n.y, r ? r.originY : void 0);
  }
  function Hn(e, t, n) {
    (e.min = n.min + t.min), (e.max = e.min + Un(t));
  }
  function $n(e, t, n) {
    (e.min = t.min - n.min), (e.max = e.min + Un(t));
  }
  function qn(e, t, n) {
    $n(e.x, t.x, n.x), $n(e.y, t.y, n.y);
  }
  const Yn = () => ({ x: { min: 0, max: 0 }, y: { min: 0, max: 0 } });
  function Kn(e) {
    return [e("x"), e("y")];
  }
  function Qn(e) {
    return void 0 === e || 1 === e;
  }
  function Xn({ scale: e, scaleX: t, scaleY: n }) {
    return !Qn(e) || !Qn(t) || !Qn(n);
  }
  function Gn(e) {
    return (
      Xn(e) ||
      Zn(e) ||
      e.z ||
      e.rotate ||
      e.rotateX ||
      e.rotateY ||
      e.skewX ||
      e.skewY
    );
  }
  function Zn(e) {
    return Jn(e.x) || Jn(e.y);
  }
  function Jn(e) {
    return e && "0%" !== e;
  }
  function er(e, t, n) {
    return n + t * (e - n);
  }
  function tr(e, t, n, r, a) {
    return void 0 !== a && (e = er(e, a, r)), er(e, n, r) + t;
  }
  function nr(e, t = 0, n = 1, r, a) {
    (e.min = tr(e.min, t, n, r, a)), (e.max = tr(e.max, t, n, r, a));
  }
  function rr(e, { x: t, y: n }) {
    nr(e.x, t.translate, t.scale, t.originPoint),
      nr(e.y, n.translate, n.scale, n.originPoint);
  }
  const ar = 0.999999999999,
    or = 1.0000000000001;
  function ir(e, t) {
    (e.min = e.min + t), (e.max = e.max + t);
  }
  function sr(e, t, n, r, a = 0.5) {
    nr(e, t, n, Me(e.min, e.max, a), r);
  }
  function lr(e, t) {
    sr(e.x, t.x, t.scaleX, t.scale, t.originX),
      sr(e.y, t.y, t.scaleY, t.scale, t.originY);
  }
  function ur(e, t) {
    return jn(
      (function (e, t) {
        if (!t) return e;
        const n = t({ x: e.left, y: e.top }),
          r = t({ x: e.right, y: e.bottom });
        return { top: n.y, left: n.x, bottom: r.y, right: r.x };
      })(e.getBoundingClientRect(), t)
    );
  }
  const cr = ({ current: e }) => (e ? e.ownerDocument.defaultView : null);
  function dr(e) {
    return (
      e &&
      "object" == typeof e &&
      Object.prototype.hasOwnProperty.call(e, "current")
    );
  }
  const fr = (e, t) => Math.abs(e - t);
  class pr {
    constructor(
      e,
      t,
      { transformPagePoint: n, contextWindow: r, dragSnapToOrigin: a = !1 } = {}
    ) {
      if (
        ((this.startEvent = null),
        (this.lastMoveEvent = null),
        (this.lastMoveEventInfo = null),
        (this.handlers = {}),
        (this.contextWindow = window),
        (this.updatePoint = () => {
          if (!this.lastMoveEvent || !this.lastMoveEventInfo) return;
          const e = yr(this.lastMoveEventInfo, this.history),
            t = null !== this.startEvent,
            n =
              (function (e, t) {
                const n = fr(e.x, t.x),
                  r = fr(e.y, t.y);
                return Math.sqrt(n ** 2 + r ** 2);
              })(e.offset, { x: 0, y: 0 }) >= 3;
          if (!t && !n) return;
          const { point: r } = e,
            { timestamp: a } = v;
          this.history.push({ ...r, timestamp: a });
          const { onStart: o, onMove: i } = this.handlers;
          t ||
            (o && o(this.lastMoveEvent, e),
            (this.startEvent = this.lastMoveEvent)),
            i && i(this.lastMoveEvent, e);
        }),
        (this.handlePointerMove = (e, t) => {
          (this.lastMoveEvent = e),
            (this.lastMoveEventInfo = hr(t, this.transformPagePoint)),
            y.update(this.updatePoint, !0);
        }),
        (this.handlePointerUp = (e, t) => {
          this.end();
          const {
            onEnd: n,
            onSessionEnd: r,
            resumeAnimation: a,
          } = this.handlers;
          if (
            (this.dragSnapToOrigin && a && a(),
            !this.lastMoveEvent || !this.lastMoveEventInfo)
          )
            return;
          const o = yr(
            "pointercancel" === e.type
              ? this.lastMoveEventInfo
              : hr(t, this.transformPagePoint),
            this.history
          );
          this.startEvent && n && n(e, o), r && r(e, o);
        }),
        !_n(e))
      )
        return;
      (this.dragSnapToOrigin = a),
        (this.handlers = t),
        (this.transformPagePoint = n),
        (this.contextWindow = r || window);
      const o = hr(In(e), this.transformPagePoint),
        { point: i } = o,
        { timestamp: s } = v;
      this.history = [{ ...i, timestamp: s }];
      const { onSessionStart: l } = t;
      l && l(e, yr(o, this.history)),
        (this.removeListeners = Oe(
          Vn(this.contextWindow, "pointermove", this.handlePointerMove),
          Vn(this.contextWindow, "pointerup", this.handlePointerUp),
          Vn(this.contextWindow, "pointercancel", this.handlePointerUp)
        ));
    }
    updateHandlers(e) {
      this.handlers = e;
    }
    end() {
      this.removeListeners && this.removeListeners(), g(this.updatePoint);
    }
  }
  function hr(e, t) {
    return t ? { point: t(e.point) } : e;
  }
  function mr(e, t) {
    return { x: e.x - t.x, y: e.y - t.y };
  }
  function yr({ point: e }, t) {
    return {
      point: e,
      delta: mr(e, vr(t)),
      offset: mr(e, gr(t)),
      velocity: br(t, 0.1),
    };
  }
  function gr(e) {
    return e[0];
  }
  function vr(e) {
    return e[e.length - 1];
  }
  function br(e, t) {
    if (e.length < 2) return { x: 0, y: 0 };
    let n = e.length - 1,
      r = null;
    const a = vr(e);
    for (; n >= 0 && ((r = e[n]), !(a.timestamp - r.timestamp > W(t))); ) n--;
    if (!r) return { x: 0, y: 0 };
    const o = H(a.timestamp - r.timestamp);
    if (0 === o) return { x: 0, y: 0 };
    const i = { x: (a.x - r.x) / o, y: (a.y - r.y) / o };
    return i.x === 1 / 0 && (i.x = 0), i.y === 1 / 0 && (i.y = 0), i;
  }
  function wr(e, t, n) {
    return {
      min: void 0 !== t ? e.min + t : void 0,
      max: void 0 !== n ? e.max + n - (e.max - e.min) : void 0,
    };
  }
  function kr(e, t) {
    let n = t.min - e.min,
      r = t.max - e.max;
    return (
      t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r }
    );
  }
  const Sr = 0.35;
  function xr(e, t, n) {
    return { min: Pr(e, t), max: Pr(e, n) };
  }
  function Pr(e, t) {
    return "number" == typeof e ? e : e[t] || 0;
  }
  const Er = { x: !1, y: !1 };
  function Cr() {
    return Er.x || Er.y;
  }
  const Tr = new WeakMap();
  class Ar {
    constructor(e) {
      (this.openDragLock = null),
        (this.isDragging = !1),
        (this.currentDirection = null),
        (this.originPoint = { x: 0, y: 0 }),
        (this.constraints = !1),
        (this.hasMutatedConstraints = !1),
        (this.elastic = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }),
        (this.visualElement = e);
    }
    start(e, { snapToCursor: t = !1 } = {}) {
      const { presenceContext: n } = this.visualElement;
      if (n && !1 === n.isPresent) return;
      const { dragSnapToOrigin: r } = this.getProps();
      this.panSession = new pr(
        e,
        {
          onSessionStart: (e) => {
            const { dragSnapToOrigin: n } = this.getProps();
            n ? this.pauseAnimation() : this.stopAnimation(),
              t && this.snapToCursor(In(e).point);
          },
          onStart: (e, t) => {
            const {
              drag: n,
              dragPropagation: r,
              onDragStart: a,
            } = this.getProps();
            if (
              n &&
              !r &&
              (this.openDragLock && this.openDragLock(),
              (this.openDragLock =
                "x" === (o = n) || "y" === o
                  ? Er[o]
                    ? null
                    : ((Er[o] = !0),
                      () => {
                        Er[o] = !1;
                      })
                  : Er.x || Er.y
                  ? null
                  : ((Er.x = Er.y = !0),
                    () => {
                      Er.x = Er.y = !1;
                    })),
              !this.openDragLock)
            )
              return;
            var o;
            (this.isDragging = !0),
              (this.currentDirection = null),
              this.resolveConstraints(),
              this.visualElement.projection &&
                ((this.visualElement.projection.isAnimationBlocked = !0),
                (this.visualElement.projection.target = void 0)),
              Kn((e) => {
                let t = this.getAxisMotionValue(e).get() || 0;
                if (de.test(t)) {
                  const { projection: n } = this.visualElement;
                  if (n && n.layout) {
                    const r = n.layout.layoutBox[e];
                    r && (t = Un(r) * (parseFloat(t) / 100));
                  }
                }
                this.originPoint[e] = t;
              }),
              a && y.postRender(() => a(e, t)),
              R(this.visualElement, "transform");
            const { animationState: i } = this.visualElement;
            i && i.setActive("whileDrag", !0);
          },
          onMove: (e, t) => {
            const {
              dragPropagation: n,
              dragDirectionLock: r,
              onDirectionLock: a,
              onDrag: o,
            } = this.getProps();
            if (!n && !this.openDragLock) return;
            const { offset: i } = t;
            if (r && null === this.currentDirection)
              return (
                (this.currentDirection = (function (e, t = 10) {
                  let n = null;
                  return (
                    Math.abs(e.y) > t
                      ? (n = "y")
                      : Math.abs(e.x) > t && (n = "x"),
                    n
                  );
                })(i)),
                void (
                  null !== this.currentDirection &&
                  a &&
                  a(this.currentDirection)
                )
              );
            this.updateAxis("x", t.point, i),
              this.updateAxis("y", t.point, i),
              this.visualElement.render(),
              o && o(e, t);
          },
          onSessionEnd: (e, t) => this.stop(e, t),
          resumeAnimation: () =>
            Kn(
              (e) =>
                "paused" === this.getAnimationState(e) &&
                this.getAxisMotionValue(e).animation?.play()
            ),
        },
        {
          transformPagePoint: this.visualElement.getTransformPagePoint(),
          dragSnapToOrigin: r,
          contextWindow: cr(this.visualElement),
        }
      );
    }
    stop(e, t) {
      const n = this.isDragging;
      if ((this.cancel(), !n)) return;
      const { velocity: r } = t;
      this.startAnimation(r);
      const { onDragEnd: a } = this.getProps();
      a && y.postRender(() => a(e, t));
    }
    cancel() {
      this.isDragging = !1;
      const { projection: e, animationState: t } = this.visualElement;
      e && (e.isAnimationBlocked = !1),
        this.panSession && this.panSession.end(),
        (this.panSession = void 0);
      const { dragPropagation: n } = this.getProps();
      !n &&
        this.openDragLock &&
        (this.openDragLock(), (this.openDragLock = null)),
        t && t.setActive("whileDrag", !1);
    }
    updateAxis(e, t, n) {
      const { drag: r } = this.getProps();
      if (!n || !Mr(e, r, this.currentDirection)) return;
      const a = this.getAxisMotionValue(e);
      let o = this.originPoint[e] + n[e];
      this.constraints &&
        this.constraints[e] &&
        (o = (function (e, { min: t, max: n }, r) {
          return (
            void 0 !== t && e < t
              ? (e = r ? Me(t, e, r.min) : Math.max(e, t))
              : void 0 !== n &&
                e > n &&
                (e = r ? Me(n, e, r.max) : Math.min(e, n)),
            e
          );
        })(o, this.constraints[e], this.elastic[e])),
        a.set(o);
    }
    resolveConstraints() {
      const { dragConstraints: e, dragElastic: t } = this.getProps(),
        n =
          this.visualElement.projection && !this.visualElement.projection.layout
            ? this.visualElement.projection.measure(!1)
            : this.visualElement.projection?.layout,
        r = this.constraints;
      e && dr(e)
        ? this.constraints || (this.constraints = this.resolveRefConstraints())
        : (this.constraints =
            !(!e || !n) &&
            (function (e, { top: t, left: n, bottom: r, right: a }) {
              return { x: wr(e.x, n, a), y: wr(e.y, t, r) };
            })(n.layoutBox, e)),
        (this.elastic = (function (e = Sr) {
          return (
            !1 === e ? (e = 0) : !0 === e && (e = Sr),
            { x: xr(e, "left", "right"), y: xr(e, "top", "bottom") }
          );
        })(t)),
        r !== this.constraints &&
          n &&
          this.constraints &&
          !this.hasMutatedConstraints &&
          Kn((e) => {
            !1 !== this.constraints &&
              this.getAxisMotionValue(e) &&
              (this.constraints[e] = (function (e, t) {
                const n = {};
                return (
                  void 0 !== t.min && (n.min = t.min - e.min),
                  void 0 !== t.max && (n.max = t.max - e.min),
                  n
                );
              })(n.layoutBox[e], this.constraints[e]));
          });
    }
    resolveRefConstraints() {
      const { dragConstraints: e, onMeasureDragConstraints: t } =
        this.getProps();
      if (!e || !dr(e)) return !1;
      const n = e.current,
        { projection: r } = this.visualElement;
      if (!r || !r.layout) return !1;
      const a = (function (e, t, n) {
        const r = ur(e, n),
          { scroll: a } = t;
        return a && (ir(r.x, a.offset.x), ir(r.y, a.offset.y)), r;
      })(n, r.root, this.visualElement.getTransformPagePoint());
      let o = (function (e, t) {
        return { x: kr(e.x, t.x), y: kr(e.y, t.y) };
      })(r.layout.layoutBox, a);
      if (t) {
        const e = t(
          (function ({ x: e, y: t }) {
            return { top: t.min, right: e.max, bottom: t.max, left: e.min };
          })(o)
        );
        (this.hasMutatedConstraints = !!e), e && (o = jn(e));
      }
      return o;
    }
    startAnimation(e) {
      const {
          drag: t,
          dragMomentum: n,
          dragElastic: r,
          dragTransition: a,
          dragSnapToOrigin: o,
          onDragTransitionEnd: i,
        } = this.getProps(),
        s = this.constraints || {},
        l = Kn((i) => {
          if (!Mr(i, t, this.currentDirection)) return;
          let l = (s && s[i]) || {};
          o && (l = { min: 0, max: 0 });
          const u = r ? 200 : 1e6,
            c = r ? 40 : 1e7,
            d = {
              type: "inertia",
              velocity: n ? e[i] : 0,
              bounceStiffness: u,
              bounceDamping: c,
              timeConstant: 750,
              restDelta: 1,
              restSpeed: 10,
              ...a,
              ...l,
            };
          return this.startAxisValueAnimation(i, d);
        });
      return Promise.all(l).then(i);
    }
    startAxisValueAnimation(e, t) {
      const n = this.getAxisMotionValue(e);
      return (
        R(this.visualElement, e),
        n.start(yn(e, n, 0, t, this.visualElement, !1))
      );
    }
    stopAnimation() {
      Kn((e) => this.getAxisMotionValue(e).stop());
    }
    pauseAnimation() {
      Kn((e) => this.getAxisMotionValue(e).animation?.pause());
    }
    getAnimationState(e) {
      return this.getAxisMotionValue(e).animation?.state;
    }
    getAxisMotionValue(e) {
      const t = `_drag${e.toUpperCase()}`,
        n = this.visualElement.getProps();
      return (
        n[t] ||
        this.visualElement.getValue(e, (n.initial ? n.initial[e] : void 0) || 0)
      );
    }
    snapToCursor(e) {
      Kn((t) => {
        const { drag: n } = this.getProps();
        if (!Mr(t, n, this.currentDirection)) return;
        const { projection: r } = this.visualElement,
          a = this.getAxisMotionValue(t);
        if (r && r.layout) {
          const { min: n, max: o } = r.layout.layoutBox[t];
          a.set(e[t] - Me(n, o, 0.5));
        }
      });
    }
    scalePositionWithinConstraints() {
      if (!this.visualElement.current) return;
      const { drag: e, dragConstraints: t } = this.getProps(),
        { projection: n } = this.visualElement;
      if (!dr(t) || !n || !this.constraints) return;
      this.stopAnimation();
      const r = { x: 0, y: 0 };
      Kn((e) => {
        const t = this.getAxisMotionValue(e);
        if (t && !1 !== this.constraints) {
          const n = t.get();
          r[e] = (function (e, t) {
            let n = 0.5;
            const r = Un(e),
              a = Un(t);
            return (
              a > r
                ? (n = ot(t.min, t.max - r, e.min))
                : r > a && (n = ot(e.min, e.max - a, t.min)),
              G(0, 1, n)
            );
          })({ min: n, max: n }, this.constraints[e]);
        }
      });
      const { transformTemplate: a } = this.visualElement.getProps();
      (this.visualElement.current.style.transform = a ? a({}, "") : "none"),
        n.root && n.root.updateScroll(),
        n.updateLayout(),
        this.resolveConstraints(),
        Kn((t) => {
          if (!Mr(t, e, null)) return;
          const n = this.getAxisMotionValue(t),
            { min: a, max: o } = this.constraints[t];
          n.set(Me(a, o, r[t]));
        });
    }
    addListeners() {
      if (!this.visualElement.current) return;
      Tr.set(this.visualElement, this);
      const e = Vn(this.visualElement.current, "pointerdown", (e) => {
          const { drag: t, dragListener: n = !0 } = this.getProps();
          t && n && this.start(e);
        }),
        t = () => {
          const { dragConstraints: e } = this.getProps();
          dr(e) &&
            e.current &&
            (this.constraints = this.resolveRefConstraints());
        },
        { projection: n } = this.visualElement,
        r = n.addEventListener("measure", t);
      n && !n.layout && (n.root && n.root.updateScroll(), n.updateLayout()),
        y.read(t);
      const a = On(window, "resize", () =>
          this.scalePositionWithinConstraints()
        ),
        o = n.addEventListener(
          "didUpdate",
          ({ delta: e, hasLayoutChanged: t }) => {
            this.isDragging &&
              t &&
              (Kn((t) => {
                const n = this.getAxisMotionValue(t);
                n &&
                  ((this.originPoint[t] += e[t].translate),
                  n.set(n.get() + e[t].translate));
              }),
              this.visualElement.render());
          }
        );
      return () => {
        a(), e(), r(), o && o();
      };
    }
    getProps() {
      const e = this.visualElement.getProps(),
        {
          drag: t = !1,
          dragDirectionLock: n = !1,
          dragPropagation: r = !1,
          dragConstraints: a = !1,
          dragElastic: o = Sr,
          dragMomentum: i = !0,
        } = e;
      return {
        ...e,
        drag: t,
        dragDirectionLock: n,
        dragPropagation: r,
        dragConstraints: a,
        dragElastic: o,
        dragMomentum: i,
      };
    }
  }
  function Mr(e, t, n) {
    return !((!0 !== t && t !== e) || (null !== n && n !== e));
  }
  const Lr = (e) => (t, n) => {
    e && y.postRender(() => e(t, n));
  };
  var Dr = n(848);
  const Rr = (0, r.createContext)(null),
    zr = (0, r.createContext)({}),
    Nr = (0, r.createContext)({}),
    Fr = { hasAnimatedSinceResize: !0, hasEverUpdated: !1 };
  function Or(e, t) {
    return t.max === t.min ? 0 : (e / (t.max - t.min)) * 100;
  }
  const _r = {
      correct: (e, t) => {
        if (!t.target) return e;
        if ("string" == typeof e) {
          if (!fe.test(e)) return e;
          e = parseFloat(e);
        }
        return `${Or(e, t.target.x)}% ${Or(e, t.target.y)}%`;
      },
    },
    Ir = {
      correct: (e, { treeScale: t, projectionDelta: n }) => {
        const r = e,
          a = Ce.parse(e);
        if (a.length > 5) return r;
        const o = Ce.createTransformer(e),
          i = "number" != typeof a[0] ? 1 : 0,
          s = n.x.scale * t.x,
          l = n.y.scale * t.y;
        (a[0 + i] /= s), (a[1 + i] /= l);
        const u = Me(s, l, 0.5);
        return (
          "number" == typeof a[2 + i] && (a[2 + i] /= u),
          "number" == typeof a[3 + i] && (a[3 + i] /= u),
          o(a)
        );
      },
    },
    Vr = {},
    { schedule: jr, cancel: Ur } = h(queueMicrotask, !1);
  class Br extends r.Component {
    componentDidMount() {
      const {
          visualElement: e,
          layoutGroup: t,
          switchLayoutGroup: n,
          layoutId: r,
        } = this.props,
        { projection: a } = e;
      !(function (e) {
        for (const t in e) (Vr[t] = e[t]), Y(t) && (Vr[t].isCSSVariable = !0);
      })(Hr),
        a &&
          (t.group && t.group.add(a),
          n && n.register && r && n.register(a),
          a.root.didUpdate(),
          a.addEventListener("animationComplete", () => {
            this.safeToRemove();
          }),
          a.setOptions({
            ...a.options,
            onExitComplete: () => this.safeToRemove(),
          })),
        (Fr.hasEverUpdated = !0);
    }
    getSnapshotBeforeUpdate(e) {
      const {
          layoutDependency: t,
          visualElement: n,
          drag: r,
          isPresent: a,
        } = this.props,
        o = n.projection;
      return o
        ? ((o.isPresent = a),
          r || e.layoutDependency !== t || void 0 === t || e.isPresent !== a
            ? o.willUpdate()
            : this.safeToRemove(),
          e.isPresent !== a &&
            (a
              ? o.promote()
              : o.relegate() ||
                y.postRender(() => {
                  const e = o.getStack();
                  (e && e.members.length) || this.safeToRemove();
                })),
          null)
        : null;
    }
    componentDidUpdate() {
      const { projection: e } = this.props.visualElement;
      e &&
        (e.root.didUpdate(),
        jr.postRender(() => {
          !e.currentAnimation && e.isLead() && this.safeToRemove();
        }));
    }
    componentWillUnmount() {
      const {
          visualElement: e,
          layoutGroup: t,
          switchLayoutGroup: n,
        } = this.props,
        { projection: r } = e;
      r &&
        (r.scheduleCheckAfterUnmount(),
        t && t.group && t.group.remove(r),
        n && n.deregister && n.deregister(r));
    }
    safeToRemove() {
      const { safeToRemove: e } = this.props;
      e && e();
    }
    render() {
      return null;
    }
  }
  function Wr(e) {
    const [t, n] = (function (e = !0) {
        const t = (0, r.useContext)(Rr);
        if (null === t) return [!0, null];
        const { isPresent: n, onExitComplete: a, register: o } = t,
          i = (0, r.useId)();
        (0, r.useEffect)(() => {
          if (e) return o(i);
        }, [e]);
        const s = (0, r.useCallback)(() => e && a && a(i), [i, a, e]);
        return !n && a ? [!1, s] : [!0];
      })(),
      a = (0, r.useContext)(zr);
    return (0, Dr.jsx)(Br, {
      ...e,
      layoutGroup: a,
      switchLayoutGroup: (0, r.useContext)(Nr),
      isPresent: t,
      safeToRemove: n,
    });
  }
  const Hr = {
      borderRadius: {
        ..._r,
        applyTo: [
          "borderTopLeftRadius",
          "borderTopRightRadius",
          "borderBottomLeftRadius",
          "borderBottomRightRadius",
        ],
      },
      borderTopLeftRadius: _r,
      borderTopRightRadius: _r,
      borderBottomLeftRadius: _r,
      borderBottomRightRadius: _r,
      boxShadow: Ir,
    },
    $r = (e, t) => e.depth - t.depth;
  class qr {
    constructor() {
      (this.children = []), (this.isDirty = !1);
    }
    add(e) {
      x(this.children, e), (this.isDirty = !0);
    }
    remove(e) {
      P(this.children, e), (this.isDirty = !0);
    }
    forEach(e) {
      this.isDirty && this.children.sort($r),
        (this.isDirty = !1),
        this.children.forEach(e);
    }
  }
  function Yr(e) {
    return D(e) ? e.get() : e;
  }
  const Kr = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
    Qr = Kr.length,
    Xr = (e) => ("string" == typeof e ? parseFloat(e) : e),
    Gr = (e) => "number" == typeof e || fe.test(e);
  function Zr(e, t) {
    return void 0 !== e[t] ? e[t] : e.borderRadius;
  }
  const Jr = ta(0, 0.5, vt),
    ea = ta(0.5, 0.95, m);
  function ta(e, t, n) {
    return (r) => (r < e ? 0 : r > t ? 1 : n(ot(e, t, r)));
  }
  function na(e, t) {
    (e.min = t.min), (e.max = t.max);
  }
  function ra(e, t) {
    na(e.x, t.x), na(e.y, t.y);
  }
  function aa(e, t) {
    (e.translate = t.translate),
      (e.scale = t.scale),
      (e.originPoint = t.originPoint),
      (e.origin = t.origin);
  }
  function oa(e, t, n, r, a) {
    return (
      (e = er((e -= t), 1 / n, r)), void 0 !== a && (e = er(e, 1 / a, r)), e
    );
  }
  function ia(e, t, [n, r, a], o, i) {
    !(function (e, t = 0, n = 1, r = 0.5, a, o = e, i = e) {
      if (
        (de.test(t) &&
          ((t = parseFloat(t)), (t = Me(i.min, i.max, t / 100) - i.min)),
        "number" != typeof t)
      )
        return;
      let s = Me(o.min, o.max, r);
      e === o && (s -= t),
        (e.min = oa(e.min, t, n, s, a)),
        (e.max = oa(e.max, t, n, s, a));
    })(e, t[n], t[r], t[a], t.scale, o, i);
  }
  const sa = ["x", "scaleX", "originX"],
    la = ["y", "scaleY", "originY"];
  function ua(e, t, n, r) {
    ia(e.x, t, sa, n ? n.x : void 0, r ? r.x : void 0),
      ia(e.y, t, la, n ? n.y : void 0, r ? r.y : void 0);
  }
  function ca(e) {
    return 0 === e.translate && 1 === e.scale;
  }
  function da(e) {
    return ca(e.x) && ca(e.y);
  }
  function fa(e, t) {
    return e.min === t.min && e.max === t.max;
  }
  function pa(e, t) {
    return (
      Math.round(e.min) === Math.round(t.min) &&
      Math.round(e.max) === Math.round(t.max)
    );
  }
  function ha(e, t) {
    return pa(e.x, t.x) && pa(e.y, t.y);
  }
  function ma(e) {
    return Un(e.x) / Un(e.y);
  }
  function ya(e, t) {
    return (
      e.translate === t.translate &&
      e.scale === t.scale &&
      e.originPoint === t.originPoint
    );
  }
  class ga {
    constructor() {
      this.members = [];
    }
    add(e) {
      x(this.members, e), e.scheduleRender();
    }
    remove(e) {
      if (
        (P(this.members, e),
        e === this.prevLead && (this.prevLead = void 0),
        e === this.lead)
      ) {
        const e = this.members[this.members.length - 1];
        e && this.promote(e);
      }
    }
    relegate(e) {
      const t = this.members.findIndex((t) => e === t);
      if (0 === t) return !1;
      let n;
      for (let e = t; e >= 0; e--) {
        const t = this.members[e];
        if (!1 !== t.isPresent) {
          n = t;
          break;
        }
      }
      return !!n && (this.promote(n), !0);
    }
    promote(e, t) {
      const n = this.lead;
      if (e !== n && ((this.prevLead = n), (this.lead = e), e.show(), n)) {
        n.instance && n.scheduleRender(),
          e.scheduleRender(),
          (e.resumeFrom = n),
          t && (e.resumeFrom.preserveOpacity = !0),
          n.snapshot &&
            ((e.snapshot = n.snapshot),
            (e.snapshot.latestValues = n.animationValues || n.latestValues)),
          e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
        const { crossfade: r } = e.options;
        !1 === r && n.hide();
      }
    }
    exitAnimationComplete() {
      this.members.forEach((e) => {
        const { options: t, resumingFrom: n } = e;
        t.onExitComplete && t.onExitComplete(),
          n && n.options.onExitComplete && n.options.onExitComplete();
      });
    }
    scheduleRender() {
      this.members.forEach((e) => {
        e.instance && e.scheduleRender(!1);
      });
    }
    removeLeadSnapshot() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }
  }
  const va = { nodes: 0, calculatedTargetDeltas: 0, calculatedProjections: 0 },
    ba = ["", "X", "Y", "Z"],
    wa = { visibility: "hidden" };
  let ka = 0;
  function Sa(e, t, n, r) {
    const { latestValues: a } = t;
    a[e] && ((n[e] = a[e]), t.setStaticValue(e, 0), r && (r[e] = 0));
  }
  function xa(e) {
    if (((e.hasCheckedOptimisedAppear = !0), e.root === e)) return;
    const { visualElement: t } = e.options;
    if (!t) return;
    const n = F(t);
    if (window.MotionHasOptimisedAnimation(n, "transform")) {
      const { layout: t, layoutId: r } = e.options;
      window.MotionCancelOptimisedAnimation(n, "transform", y, !(t || r));
    }
    const { parent: r } = e;
    r && !r.hasCheckedOptimisedAppear && xa(r);
  }
  function Pa({
    attachResizeListener: e,
    defaultParent: t,
    measureScroll: n,
    checkIsScrollRoot: r,
    resetTransform: a,
  }) {
    return class {
      constructor(e = {}, n = t?.()) {
        (this.id = ka++),
          (this.animationId = 0),
          (this.children = new Set()),
          (this.options = {}),
          (this.isTreeAnimating = !1),
          (this.isAnimationBlocked = !1),
          (this.isLayoutDirty = !1),
          (this.isProjectionDirty = !1),
          (this.isSharedProjectionDirty = !1),
          (this.isTransformDirty = !1),
          (this.updateManuallyBlocked = !1),
          (this.updateBlockedByResize = !1),
          (this.isUpdating = !1),
          (this.isSVG = !1),
          (this.needsReset = !1),
          (this.shouldResetTransform = !1),
          (this.hasCheckedOptimisedAppear = !1),
          (this.treeScale = { x: 1, y: 1 }),
          (this.eventHandlers = new Map()),
          (this.hasTreeAnimated = !1),
          (this.updateScheduled = !1),
          (this.scheduleUpdate = () => this.update()),
          (this.projectionUpdateScheduled = !1),
          (this.checkUpdateFailed = () => {
            this.isUpdating &&
              ((this.isUpdating = !1), this.clearAllSnapshots());
          }),
          (this.updateProjection = () => {
            (this.projectionUpdateScheduled = !1),
              f.value &&
                (va.nodes =
                  va.calculatedTargetDeltas =
                  va.calculatedProjections =
                    0),
              this.nodes.forEach(Ta),
              this.nodes.forEach(Na),
              this.nodes.forEach(Fa),
              this.nodes.forEach(Aa),
              f.addProjectionMetrics && f.addProjectionMetrics(va);
          }),
          (this.resolvedRelativeTargetAt = 0),
          (this.hasProjected = !1),
          (this.isVisible = !0),
          (this.animationProgress = 0),
          (this.sharedNodes = new Map()),
          (this.latestValues = e),
          (this.root = n ? n.root || n : this),
          (this.path = n ? [...n.path, n] : []),
          (this.parent = n),
          (this.depth = n ? n.depth + 1 : 0);
        for (let e = 0; e < this.path.length; e++)
          this.path[e].shouldResetTransform = !0;
        this.root === this && (this.nodes = new qr());
      }
      addEventListener(e, t) {
        return (
          this.eventHandlers.has(e) || this.eventHandlers.set(e, new E()),
          this.eventHandlers.get(e).add(t)
        );
      }
      notifyListeners(e, ...t) {
        const n = this.eventHandlers.get(e);
        n && n.notify(...t);
      }
      hasListeners(e) {
        return this.eventHandlers.has(e);
      }
      mount(t, n = this.root.hasTreeAnimated) {
        if (this.instance) return;
        var r;
        (this.isSVG = (r = t) instanceof SVGElement && "svg" !== r.tagName),
          (this.instance = t);
        const { layoutId: a, layout: o, visualElement: i } = this.options;
        if (
          (i && !i.current && i.mount(t),
          this.root.nodes.add(this),
          this.parent && this.parent.children.add(this),
          n && (o || a) && (this.isLayoutDirty = !0),
          e)
        ) {
          let n;
          const r = () => (this.root.updateBlockedByResize = !1);
          e(t, () => {
            (this.root.updateBlockedByResize = !0),
              n && n(),
              (n = (function (e, t) {
                const n = S.now(),
                  r = ({ timestamp: a }) => {
                    const o = a - n;
                    o >= t && (g(r), e(o - t));
                  };
                return y.setup(r, !0), () => g(r);
              })(r, 250)),
              Fr.hasAnimatedSinceResize &&
                ((Fr.hasAnimatedSinceResize = !1), this.nodes.forEach(za));
          });
        }
        a && this.root.registerSharedNode(a, this),
          !1 !== this.options.animate &&
            i &&
            (a || o) &&
            this.addEventListener(
              "didUpdate",
              ({
                delta: e,
                hasLayoutChanged: t,
                hasRelativeLayoutChanged: n,
                layout: r,
              }) => {
                if (this.isTreeAnimationBlocked())
                  return (
                    (this.target = void 0), void (this.relativeTarget = void 0)
                  );
                const a =
                    this.options.transition || i.getDefaultTransition() || Ua,
                  { onLayoutAnimationStart: o, onLayoutAnimationComplete: s } =
                    i.getProps(),
                  l = !this.targetLayout || !ha(this.targetLayout, r),
                  u = !t && n;
                if (
                  this.options.layoutRoot ||
                  this.resumeFrom ||
                  u ||
                  (t && (l || !this.currentAnimation))
                ) {
                  this.resumeFrom &&
                    ((this.resumingFrom = this.resumeFrom),
                    (this.resumingFrom.resumingFrom = void 0)),
                    this.setAnimationOrigin(e, u);
                  const t = { ...B(a, "layout"), onPlay: o, onComplete: s };
                  (i.shouldReduceMotion || this.options.layoutRoot) &&
                    ((t.delay = 0), (t.type = !1)),
                    this.startAnimation(t);
                } else
                  t || za(this),
                    this.isLead() &&
                      this.options.onExitComplete &&
                      this.options.onExitComplete();
                this.targetLayout = r;
              }
            );
      }
      unmount() {
        this.options.layoutId && this.willUpdate(),
          this.root.nodes.remove(this);
        const e = this.getStack();
        e && e.remove(this),
          this.parent && this.parent.children.delete(this),
          (this.instance = void 0),
          this.eventHandlers.clear(),
          g(this.updateProjection);
      }
      blockUpdate() {
        this.updateManuallyBlocked = !0;
      }
      unblockUpdate() {
        this.updateManuallyBlocked = !1;
      }
      isUpdateBlocked() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }
      isTreeAnimationBlocked() {
        return (
          this.isAnimationBlocked ||
          (this.parent && this.parent.isTreeAnimationBlocked()) ||
          !1
        );
      }
      startUpdate() {
        this.isUpdateBlocked() ||
          ((this.isUpdating = !0),
          this.nodes && this.nodes.forEach(Oa),
          this.animationId++);
      }
      getTransformTemplate() {
        const { visualElement: e } = this.options;
        return e && e.getProps().transformTemplate;
      }
      willUpdate(e = !0) {
        if (((this.root.hasTreeAnimated = !0), this.root.isUpdateBlocked()))
          return void (
            this.options.onExitComplete && this.options.onExitComplete()
          );
        if (
          (window.MotionCancelOptimisedAnimation &&
            !this.hasCheckedOptimisedAppear &&
            xa(this),
          !this.root.isUpdating && this.root.startUpdate(),
          this.isLayoutDirty)
        )
          return;
        this.isLayoutDirty = !0;
        for (let e = 0; e < this.path.length; e++) {
          const t = this.path[e];
          (t.shouldResetTransform = !0),
            t.updateScroll("snapshot"),
            t.options.layoutRoot && t.willUpdate(!1);
        }
        const { layoutId: t, layout: n } = this.options;
        if (void 0 === t && !n) return;
        const r = this.getTransformTemplate();
        (this.prevTransformTemplateValue = r
          ? r(this.latestValues, "")
          : void 0),
          this.updateSnapshot(),
          e && this.notifyListeners("willUpdate");
      }
      update() {
        if (((this.updateScheduled = !1), this.isUpdateBlocked()))
          return (
            this.unblockUpdate(),
            this.clearAllSnapshots(),
            void this.nodes.forEach(La)
          );
        this.isUpdating || this.nodes.forEach(Da),
          (this.isUpdating = !1),
          this.nodes.forEach(Ra),
          this.nodes.forEach(Ea),
          this.nodes.forEach(Ca),
          this.clearAllSnapshots();
        const e = S.now();
        (v.delta = G(0, 1e3 / 60, e - v.timestamp)),
          (v.timestamp = e),
          (v.isProcessing = !0),
          b.update.process(v),
          b.preRender.process(v),
          b.render.process(v),
          (v.isProcessing = !1);
      }
      didUpdate() {
        this.updateScheduled ||
          ((this.updateScheduled = !0), jr.read(this.scheduleUpdate));
      }
      clearAllSnapshots() {
        this.nodes.forEach(Ma), this.sharedNodes.forEach(_a);
      }
      scheduleUpdateProjection() {
        this.projectionUpdateScheduled ||
          ((this.projectionUpdateScheduled = !0),
          y.preRender(this.updateProjection, !1, !0));
      }
      scheduleCheckAfterUnmount() {
        y.postRender(() => {
          this.isLayoutDirty
            ? this.root.didUpdate()
            : this.root.checkUpdateFailed();
        });
      }
      updateSnapshot() {
        !this.snapshot &&
          this.instance &&
          ((this.snapshot = this.measure()),
          !this.snapshot ||
            Un(this.snapshot.measuredBox.x) ||
            Un(this.snapshot.measuredBox.y) ||
            (this.snapshot = void 0));
      }
      updateLayout() {
        if (!this.instance) return;
        if (
          (this.updateScroll(),
          !(
            (this.options.alwaysMeasureLayout && this.isLead()) ||
            this.isLayoutDirty
          ))
        )
          return;
        if (this.resumeFrom && !this.resumeFrom.instance)
          for (let e = 0; e < this.path.length; e++)
            this.path[e].updateScroll();
        const e = this.layout;
        (this.layout = this.measure(!1)),
          (this.layoutCorrected = {
            x: { min: 0, max: 0 },
            y: { min: 0, max: 0 },
          }),
          (this.isLayoutDirty = !1),
          (this.projectionDelta = void 0),
          this.notifyListeners("measure", this.layout.layoutBox);
        const { visualElement: t } = this.options;
        t &&
          t.notify(
            "LayoutMeasure",
            this.layout.layoutBox,
            e ? e.layoutBox : void 0
          );
      }
      updateScroll(e = "measure") {
        let t = Boolean(this.options.layoutScroll && this.instance);
        if (
          (this.scroll &&
            this.scroll.animationId === this.root.animationId &&
            this.scroll.phase === e &&
            (t = !1),
          t)
        ) {
          const t = r(this.instance);
          this.scroll = {
            animationId: this.root.animationId,
            phase: e,
            isRoot: t,
            offset: n(this.instance),
            wasRoot: this.scroll ? this.scroll.isRoot : t,
          };
        }
      }
      resetTransform() {
        if (!a) return;
        const e =
            this.isLayoutDirty ||
            this.shouldResetTransform ||
            this.options.alwaysMeasureLayout,
          t = this.projectionDelta && !da(this.projectionDelta),
          n = this.getTransformTemplate(),
          r = n ? n(this.latestValues, "") : void 0,
          o = r !== this.prevTransformTemplateValue;
        e &&
          (t || Gn(this.latestValues) || o) &&
          (a(this.instance, r),
          (this.shouldResetTransform = !1),
          this.scheduleRender());
      }
      measure(e = !0) {
        const t = this.measurePageBox();
        let n = this.removeElementScroll(t);
        var r;
        return (
          e && (n = this.removeTransform(n)),
          Ha((r = n).x),
          Ha(r.y),
          {
            animationId: this.root.animationId,
            measuredBox: t,
            layoutBox: n,
            latestValues: {},
            source: this.id,
          }
        );
      }
      measurePageBox() {
        const { visualElement: e } = this.options;
        if (!e) return { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
        const t = e.measureViewportBox();
        if (!this.scroll?.wasRoot && !this.path.some(qa)) {
          const { scroll: e } = this.root;
          e && (ir(t.x, e.offset.x), ir(t.y, e.offset.y));
        }
        return t;
      }
      removeElementScroll(e) {
        const t = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
        if ((ra(t, e), this.scroll?.wasRoot)) return t;
        for (let n = 0; n < this.path.length; n++) {
          const r = this.path[n],
            { scroll: a, options: o } = r;
          r !== this.root &&
            a &&
            o.layoutScroll &&
            (a.wasRoot && ra(t, e), ir(t.x, a.offset.x), ir(t.y, a.offset.y));
        }
        return t;
      }
      applyTransform(e, t = !1) {
        const n = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
        ra(n, e);
        for (let e = 0; e < this.path.length; e++) {
          const r = this.path[e];
          !t &&
            r.options.layoutScroll &&
            r.scroll &&
            r !== r.root &&
            lr(n, { x: -r.scroll.offset.x, y: -r.scroll.offset.y }),
            Gn(r.latestValues) && lr(n, r.latestValues);
        }
        return Gn(this.latestValues) && lr(n, this.latestValues), n;
      }
      removeTransform(e) {
        const t = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
        ra(t, e);
        for (let e = 0; e < this.path.length; e++) {
          const n = this.path[e];
          if (!n.instance) continue;
          if (!Gn(n.latestValues)) continue;
          Xn(n.latestValues) && n.updateSnapshot();
          const r = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
          ra(r, n.measurePageBox()),
            ua(
              t,
              n.latestValues,
              n.snapshot ? n.snapshot.layoutBox : void 0,
              r
            );
        }
        return Gn(this.latestValues) && ua(t, this.latestValues), t;
      }
      setTargetDelta(e) {
        (this.targetDelta = e),
          this.root.scheduleUpdateProjection(),
          (this.isProjectionDirty = !0);
      }
      setOptions(e) {
        this.options = {
          ...this.options,
          ...e,
          crossfade: void 0 === e.crossfade || e.crossfade,
        };
      }
      clearMeasurements() {
        (this.scroll = void 0),
          (this.layout = void 0),
          (this.snapshot = void 0),
          (this.prevTransformTemplateValue = void 0),
          (this.targetDelta = void 0),
          (this.target = void 0),
          (this.isLayoutDirty = !1);
      }
      forceRelativeParentToResolveTarget() {
        this.relativeParent &&
          this.relativeParent.resolvedRelativeTargetAt !== v.timestamp &&
          this.relativeParent.resolveTargetDelta(!0);
      }
      resolveTargetDelta(e = !1) {
        const t = this.getLead();
        this.isProjectionDirty ||
          (this.isProjectionDirty = t.isProjectionDirty),
          this.isTransformDirty || (this.isTransformDirty = t.isTransformDirty),
          this.isSharedProjectionDirty ||
            (this.isSharedProjectionDirty = t.isSharedProjectionDirty);
        const n = Boolean(this.resumingFrom) || this !== t;
        if (
          !(
            e ||
            (n && this.isSharedProjectionDirty) ||
            this.isProjectionDirty ||
            this.parent?.isProjectionDirty ||
            this.attemptToResolveRelativeTarget ||
            this.root.updateBlockedByResize
          )
        )
          return;
        const { layout: r, layoutId: a } = this.options;
        if (this.layout && (r || a)) {
          if (
            ((this.resolvedRelativeTargetAt = v.timestamp),
            !this.targetDelta && !this.relativeTarget)
          ) {
            const e = this.getClosestProjectingParent();
            e && e.layout && 1 !== this.animationProgress
              ? ((this.relativeParent = e),
                this.forceRelativeParentToResolveTarget(),
                (this.relativeTarget = {
                  x: { min: 0, max: 0 },
                  y: { min: 0, max: 0 },
                }),
                (this.relativeTargetOrigin = {
                  x: { min: 0, max: 0 },
                  y: { min: 0, max: 0 },
                }),
                qn(
                  this.relativeTargetOrigin,
                  this.layout.layoutBox,
                  e.layout.layoutBox
                ),
                ra(this.relativeTarget, this.relativeTargetOrigin))
              : (this.relativeParent = this.relativeTarget = void 0);
          }
          if (this.relativeTarget || this.targetDelta) {
            var o, i, s;
            if (
              (this.target ||
                ((this.target = {
                  x: { min: 0, max: 0 },
                  y: { min: 0, max: 0 },
                }),
                (this.targetWithTransforms = {
                  x: { min: 0, max: 0 },
                  y: { min: 0, max: 0 },
                })),
              this.relativeTarget &&
              this.relativeTargetOrigin &&
              this.relativeParent &&
              this.relativeParent.target
                ? (this.forceRelativeParentToResolveTarget(),
                  (o = this.target),
                  (i = this.relativeTarget),
                  (s = this.relativeParent.target),
                  Hn(o.x, i.x, s.x),
                  Hn(o.y, i.y, s.y))
                : this.targetDelta
                ? (Boolean(this.resumingFrom)
                    ? (this.target = this.applyTransform(this.layout.layoutBox))
                    : ra(this.target, this.layout.layoutBox),
                  rr(this.target, this.targetDelta))
                : ra(this.target, this.layout.layoutBox),
              this.attemptToResolveRelativeTarget)
            ) {
              this.attemptToResolveRelativeTarget = !1;
              const e = this.getClosestProjectingParent();
              e &&
              Boolean(e.resumingFrom) === Boolean(this.resumingFrom) &&
              !e.options.layoutScroll &&
              e.target &&
              1 !== this.animationProgress
                ? ((this.relativeParent = e),
                  this.forceRelativeParentToResolveTarget(),
                  (this.relativeTarget = {
                    x: { min: 0, max: 0 },
                    y: { min: 0, max: 0 },
                  }),
                  (this.relativeTargetOrigin = {
                    x: { min: 0, max: 0 },
                    y: { min: 0, max: 0 },
                  }),
                  qn(this.relativeTargetOrigin, this.target, e.target),
                  ra(this.relativeTarget, this.relativeTargetOrigin))
                : (this.relativeParent = this.relativeTarget = void 0);
            }
            f.value && va.calculatedTargetDeltas++;
          }
        }
      }
      getClosestProjectingParent() {
        if (
          this.parent &&
          !Xn(this.parent.latestValues) &&
          !Zn(this.parent.latestValues)
        )
          return this.parent.isProjecting()
            ? this.parent
            : this.parent.getClosestProjectingParent();
      }
      isProjecting() {
        return Boolean(
          (this.relativeTarget ||
            this.targetDelta ||
            this.options.layoutRoot) &&
            this.layout
        );
      }
      calcProjection() {
        const e = this.getLead(),
          t = Boolean(this.resumingFrom) || this !== e;
        let n = !0;
        if (
          ((this.isProjectionDirty || this.parent?.isProjectionDirty) &&
            (n = !1),
          t &&
            (this.isSharedProjectionDirty || this.isTransformDirty) &&
            (n = !1),
          this.resolvedRelativeTargetAt === v.timestamp && (n = !1),
          n)
        )
          return;
        const { layout: r, layoutId: a } = this.options;
        if (
          ((this.isTreeAnimating = Boolean(
            (this.parent && this.parent.isTreeAnimating) ||
              this.currentAnimation ||
              this.pendingAnimation
          )),
          this.isTreeAnimating ||
            (this.targetDelta = this.relativeTarget = void 0),
          !this.layout || (!r && !a))
        )
          return;
        ra(this.layoutCorrected, this.layout.layoutBox);
        const o = this.treeScale.x,
          i = this.treeScale.y;
        !(function (e, t, n, r = !1) {
          const a = n.length;
          if (!a) return;
          let o, i;
          t.x = t.y = 1;
          for (let s = 0; s < a; s++) {
            (o = n[s]), (i = o.projectionDelta);
            const { visualElement: a } = o.options;
            (a && a.props.style && "contents" === a.props.style.display) ||
              (r &&
                o.options.layoutScroll &&
                o.scroll &&
                o !== o.root &&
                lr(e, { x: -o.scroll.offset.x, y: -o.scroll.offset.y }),
              i && ((t.x *= i.x.scale), (t.y *= i.y.scale), rr(e, i)),
              r && Gn(o.latestValues) && lr(e, o.latestValues));
          }
          t.x < or && t.x > ar && (t.x = 1), t.y < or && t.y > ar && (t.y = 1);
        })(this.layoutCorrected, this.treeScale, this.path, t),
          !e.layout ||
            e.target ||
            (1 === this.treeScale.x && 1 === this.treeScale.y) ||
            ((e.target = e.layout.layoutBox),
            (e.targetWithTransforms = {
              x: { min: 0, max: 0 },
              y: { min: 0, max: 0 },
            }));
        const { target: s } = e;
        s
          ? (this.projectionDelta && this.prevProjectionDelta
              ? (aa(this.prevProjectionDelta.x, this.projectionDelta.x),
                aa(this.prevProjectionDelta.y, this.projectionDelta.y))
              : this.createProjectionDeltas(),
            Wn(
              this.projectionDelta,
              this.layoutCorrected,
              s,
              this.latestValues
            ),
            (this.treeScale.x === o &&
              this.treeScale.y === i &&
              ya(this.projectionDelta.x, this.prevProjectionDelta.x) &&
              ya(this.projectionDelta.y, this.prevProjectionDelta.y)) ||
              ((this.hasProjected = !0),
              this.scheduleRender(),
              this.notifyListeners("projectionUpdate", s)),
            f.value && va.calculatedProjections++)
          : this.prevProjectionDelta &&
            (this.createProjectionDeltas(), this.scheduleRender());
      }
      hide() {
        this.isVisible = !1;
      }
      show() {
        this.isVisible = !0;
      }
      scheduleRender(e = !0) {
        if ((this.options.visualElement?.scheduleRender(), e)) {
          const e = this.getStack();
          e && e.scheduleRender();
        }
        this.resumingFrom &&
          !this.resumingFrom.instance &&
          (this.resumingFrom = void 0);
      }
      createProjectionDeltas() {
        (this.prevProjectionDelta = {
          x: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
          y: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
        }),
          (this.projectionDelta = {
            x: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
            y: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
          }),
          (this.projectionDeltaWithTransform = {
            x: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
            y: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
          });
      }
      setAnimationOrigin(e, t = !1) {
        const n = this.snapshot,
          r = n ? n.latestValues : {},
          a = { ...this.latestValues },
          o = {
            x: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
            y: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
          };
        (this.relativeParent && this.relativeParent.options.layoutRoot) ||
          (this.relativeTarget = this.relativeTargetOrigin = void 0),
          (this.attemptToResolveRelativeTarget = !t);
        const i = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } },
          s =
            (n ? n.source : void 0) !==
            (this.layout ? this.layout.source : void 0),
          l = this.getStack(),
          u = !l || l.members.length <= 1,
          c = Boolean(
            s && !u && !0 === this.options.crossfade && !this.path.some(ja)
          );
        let d;
        (this.animationProgress = 0),
          (this.mixTargetDelta = (t) => {
            const n = t / 1e3;
            var l, f, p, h, m, y;
            Ia(o.x, e.x, n),
              Ia(o.y, e.y, n),
              this.setTargetDelta(o),
              this.relativeTarget &&
                this.relativeTargetOrigin &&
                this.layout &&
                this.relativeParent &&
                this.relativeParent.layout &&
                (qn(
                  i,
                  this.layout.layoutBox,
                  this.relativeParent.layout.layoutBox
                ),
                (p = this.relativeTarget),
                (h = this.relativeTargetOrigin),
                (m = i),
                (y = n),
                Va(p.x, h.x, m.x, y),
                Va(p.y, h.y, m.y, y),
                d &&
                  ((l = this.relativeTarget),
                  (f = d),
                  fa(l.x, f.x) && fa(l.y, f.y)) &&
                  (this.isProjectionDirty = !1),
                d || (d = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }),
                ra(d, this.relativeTarget)),
              s &&
                ((this.animationValues = a),
                (function (e, t, n, r, a, o) {
                  a
                    ? ((e.opacity = Me(0, n.opacity ?? 1, Jr(r))),
                      (e.opacityExit = Me(t.opacity ?? 1, 0, ea(r))))
                    : o && (e.opacity = Me(t.opacity ?? 1, n.opacity ?? 1, r));
                  for (let a = 0; a < Qr; a++) {
                    const o = `border${Kr[a]}Radius`;
                    let i = Zr(t, o),
                      s = Zr(n, o);
                    (void 0 === i && void 0 === s) ||
                      (i || (i = 0),
                      s || (s = 0),
                      0 === i || 0 === s || Gr(i) === Gr(s)
                        ? ((e[o] = Math.max(Me(Xr(i), Xr(s), r), 0)),
                          (de.test(s) || de.test(i)) && (e[o] += "%"))
                        : (e[o] = s));
                  }
                  (t.rotate || n.rotate) &&
                    (e.rotate = Me(t.rotate || 0, n.rotate || 0, r));
                })(a, r, this.latestValues, n, c, u)),
              this.root.scheduleUpdateProjection(),
              this.scheduleRender(),
              (this.animationProgress = n);
          }),
          this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
      }
      startAnimation(e) {
        this.notifyListeners("animationStart"),
          this.currentAnimation && this.currentAnimation.stop(),
          this.resumingFrom &&
            this.resumingFrom.currentAnimation &&
            this.resumingFrom.currentAnimation.stop(),
          this.pendingAnimation &&
            (g(this.pendingAnimation), (this.pendingAnimation = void 0)),
          (this.pendingAnimation = y.update(() => {
            (Fr.hasAnimatedSinceResize = !0),
              $.layout++,
              (this.currentAnimation = (function (e, t, n) {
                const r = D(0) ? 0 : M(0);
                return r.start(yn("", r, 1e3, n)), r.animation;
              })(0, 0, {
                ...e,
                onUpdate: (t) => {
                  this.mixTargetDelta(t), e.onUpdate && e.onUpdate(t);
                },
                onStop: () => {
                  $.layout--;
                },
                onComplete: () => {
                  $.layout--,
                    e.onComplete && e.onComplete(),
                    this.completeAnimation();
                },
              })),
              this.resumingFrom &&
                (this.resumingFrom.currentAnimation = this.currentAnimation),
              (this.pendingAnimation = void 0);
          }));
      }
      completeAnimation() {
        this.resumingFrom &&
          ((this.resumingFrom.currentAnimation = void 0),
          (this.resumingFrom.preserveOpacity = void 0));
        const e = this.getStack();
        e && e.exitAnimationComplete(),
          (this.resumingFrom =
            this.currentAnimation =
            this.animationValues =
              void 0),
          this.notifyListeners("animationComplete");
      }
      finishAnimation() {
        this.currentAnimation &&
          (this.mixTargetDelta && this.mixTargetDelta(1e3),
          this.currentAnimation.stop()),
          this.completeAnimation();
      }
      applyTransformsToTarget() {
        const e = this.getLead();
        let {
          targetWithTransforms: t,
          target: n,
          layout: r,
          latestValues: a,
        } = e;
        if (t && n && r) {
          if (
            this !== e &&
            this.layout &&
            r &&
            $a(this.options.animationType, this.layout.layoutBox, r.layoutBox)
          ) {
            n = this.target || { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
            const t = Un(this.layout.layoutBox.x);
            (n.x.min = e.target.x.min), (n.x.max = n.x.min + t);
            const r = Un(this.layout.layoutBox.y);
            (n.y.min = e.target.y.min), (n.y.max = n.y.min + r);
          }
          ra(t, n),
            lr(t, a),
            Wn(this.projectionDeltaWithTransform, this.layoutCorrected, t, a);
        }
      }
      registerSharedNode(e, t) {
        this.sharedNodes.has(e) || this.sharedNodes.set(e, new ga()),
          this.sharedNodes.get(e).add(t);
        const n = t.options.initialPromotionConfig;
        t.promote({
          transition: n ? n.transition : void 0,
          preserveFollowOpacity:
            n && n.shouldPreserveFollowOpacity
              ? n.shouldPreserveFollowOpacity(t)
              : void 0,
        });
      }
      isLead() {
        const e = this.getStack();
        return !e || e.lead === this;
      }
      getLead() {
        const { layoutId: e } = this.options;
        return (e && this.getStack()?.lead) || this;
      }
      getPrevLead() {
        const { layoutId: e } = this.options;
        return e ? this.getStack()?.prevLead : void 0;
      }
      getStack() {
        const { layoutId: e } = this.options;
        if (e) return this.root.sharedNodes.get(e);
      }
      promote({ needsReset: e, transition: t, preserveFollowOpacity: n } = {}) {
        const r = this.getStack();
        r && r.promote(this, n),
          e && ((this.projectionDelta = void 0), (this.needsReset = !0)),
          t && this.setOptions({ transition: t });
      }
      relegate() {
        const e = this.getStack();
        return !!e && e.relegate(this);
      }
      resetSkewAndRotation() {
        const { visualElement: e } = this.options;
        if (!e) return;
        let t = !1;
        const { latestValues: n } = e;
        if (
          ((n.z ||
            n.rotate ||
            n.rotateX ||
            n.rotateY ||
            n.rotateZ ||
            n.skewX ||
            n.skewY) &&
            (t = !0),
          !t)
        )
          return;
        const r = {};
        n.z && Sa("z", e, r, this.animationValues);
        for (let t = 0; t < ba.length; t++)
          Sa(`rotate${ba[t]}`, e, r, this.animationValues),
            Sa(`skew${ba[t]}`, e, r, this.animationValues);
        e.render();
        for (const t in r)
          e.setStaticValue(t, r[t]),
            this.animationValues && (this.animationValues[t] = r[t]);
        e.scheduleRender();
      }
      getProjectionStyles(e) {
        if (!this.instance || this.isSVG) return;
        if (!this.isVisible) return wa;
        const t = { visibility: "" },
          n = this.getTransformTemplate();
        if (this.needsReset)
          return (
            (this.needsReset = !1),
            (t.opacity = ""),
            (t.pointerEvents = Yr(e?.pointerEvents) || ""),
            (t.transform = n ? n(this.latestValues, "") : "none"),
            t
          );
        const r = this.getLead();
        if (!this.projectionDelta || !this.layout || !r.target) {
          const t = {};
          return (
            this.options.layoutId &&
              ((t.opacity =
                void 0 !== this.latestValues.opacity
                  ? this.latestValues.opacity
                  : 1),
              (t.pointerEvents = Yr(e?.pointerEvents) || "")),
            this.hasProjected &&
              !Gn(this.latestValues) &&
              ((t.transform = n ? n({}, "") : "none"),
              (this.hasProjected = !1)),
            t
          );
        }
        const a = r.animationValues || r.latestValues;
        this.applyTransformsToTarget(),
          (t.transform = (function (e, t, n) {
            let r = "";
            const a = e.x.translate / t.x,
              o = e.y.translate / t.y,
              i = n?.z || 0;
            if (
              ((a || o || i) && (r = `translate3d(${a}px, ${o}px, ${i}px) `),
              (1 === t.x && 1 === t.y) ||
                (r += `scale(${1 / t.x}, ${1 / t.y}) `),
              n)
            ) {
              const {
                transformPerspective: e,
                rotate: t,
                rotateX: a,
                rotateY: o,
                skewX: i,
                skewY: s,
              } = n;
              e && (r = `perspective(${e}px) ${r}`),
                t && (r += `rotate(${t}deg) `),
                a && (r += `rotateX(${a}deg) `),
                o && (r += `rotateY(${o}deg) `),
                i && (r += `skewX(${i}deg) `),
                s && (r += `skewY(${s}deg) `);
            }
            const s = e.x.scale * t.x,
              l = e.y.scale * t.y;
            return (
              (1 === s && 1 === l) || (r += `scale(${s}, ${l})`), r || "none"
            );
          })(this.projectionDeltaWithTransform, this.treeScale, a)),
          n && (t.transform = n(a, t.transform));
        const { x: o, y: i } = this.projectionDelta;
        (t.transformOrigin = `${100 * o.origin}% ${100 * i.origin}% 0`),
          r.animationValues
            ? (t.opacity =
                r === this
                  ? a.opacity ?? this.latestValues.opacity ?? 1
                  : this.preserveOpacity
                  ? this.latestValues.opacity
                  : a.opacityExit)
            : (t.opacity =
                r === this
                  ? void 0 !== a.opacity
                    ? a.opacity
                    : ""
                  : void 0 !== a.opacityExit
                  ? a.opacityExit
                  : 0);
        for (const e in Vr) {
          if (void 0 === a[e]) continue;
          const { correct: n, applyTo: o, isCSSVariable: i } = Vr[e],
            s = "none" === t.transform ? a[e] : n(a[e], r);
          if (o) {
            const e = o.length;
            for (let n = 0; n < e; n++) t[o[n]] = s;
          } else
            i
              ? (this.options.visualElement.renderState.vars[e] = s)
              : (t[e] = s);
        }
        return (
          this.options.layoutId &&
            (t.pointerEvents =
              r === this ? Yr(e?.pointerEvents) || "" : "none"),
          t
        );
      }
      clearSnapshot() {
        this.resumeFrom = this.snapshot = void 0;
      }
      resetTree() {
        this.root.nodes.forEach((e) => e.currentAnimation?.stop()),
          this.root.nodes.forEach(La),
          this.root.sharedNodes.clear();
      }
    };
  }
  function Ea(e) {
    e.updateLayout();
  }
  function Ca(e) {
    const t = e.resumeFrom?.snapshot || e.snapshot;
    if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
      const { layoutBox: n, measuredBox: r } = e.layout,
        { animationType: a } = e.options,
        o = t.source !== e.layout.source;
      "size" === a
        ? Kn((e) => {
            const r = o ? t.measuredBox[e] : t.layoutBox[e],
              a = Un(r);
            (r.min = n[e].min), (r.max = r.min + a);
          })
        : $a(a, t.layoutBox, n) &&
          Kn((r) => {
            const a = o ? t.measuredBox[r] : t.layoutBox[r],
              i = Un(n[r]);
            (a.max = a.min + i),
              e.relativeTarget &&
                !e.currentAnimation &&
                ((e.isProjectionDirty = !0),
                (e.relativeTarget[r].max = e.relativeTarget[r].min + i));
          });
      const i = {
        x: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
        y: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
      };
      Wn(i, n, t.layoutBox);
      const s = {
        x: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
        y: { translate: 0, scale: 1, origin: 0, originPoint: 0 },
      };
      o ? Wn(s, e.applyTransform(r, !0), t.measuredBox) : Wn(s, n, t.layoutBox);
      const l = !da(i);
      let u = !1;
      if (!e.resumeFrom) {
        const r = e.getClosestProjectingParent();
        if (r && !r.resumeFrom) {
          const { snapshot: a, layout: o } = r;
          if (a && o) {
            const i = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
            qn(i, t.layoutBox, a.layoutBox);
            const s = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
            qn(s, n, o.layoutBox),
              ha(i, s) || (u = !0),
              r.options.layoutRoot &&
                ((e.relativeTarget = s),
                (e.relativeTargetOrigin = i),
                (e.relativeParent = r));
          }
        }
      }
      e.notifyListeners("didUpdate", {
        layout: n,
        snapshot: t,
        delta: s,
        layoutDelta: i,
        hasLayoutChanged: l,
        hasRelativeLayoutChanged: u,
      });
    } else if (e.isLead()) {
      const { onExitComplete: t } = e.options;
      t && t();
    }
    e.options.transition = void 0;
  }
  function Ta(e) {
    f.value && va.nodes++,
      e.parent &&
        (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty),
        e.isSharedProjectionDirty ||
          (e.isSharedProjectionDirty = Boolean(
            e.isProjectionDirty ||
              e.parent.isProjectionDirty ||
              e.parent.isSharedProjectionDirty
          )),
        e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
  }
  function Aa(e) {
    e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
  }
  function Ma(e) {
    e.clearSnapshot();
  }
  function La(e) {
    e.clearMeasurements();
  }
  function Da(e) {
    e.isLayoutDirty = !1;
  }
  function Ra(e) {
    const { visualElement: t } = e.options;
    t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"),
      e.resetTransform();
  }
  function za(e) {
    e.finishAnimation(),
      (e.targetDelta = e.relativeTarget = e.target = void 0),
      (e.isProjectionDirty = !0);
  }
  function Na(e) {
    e.resolveTargetDelta();
  }
  function Fa(e) {
    e.calcProjection();
  }
  function Oa(e) {
    e.resetSkewAndRotation();
  }
  function _a(e) {
    e.removeLeadSnapshot();
  }
  function Ia(e, t, n) {
    (e.translate = Me(t.translate, 0, n)),
      (e.scale = Me(t.scale, 1, n)),
      (e.origin = t.origin),
      (e.originPoint = t.originPoint);
  }
  function Va(e, t, n, r) {
    (e.min = Me(t.min, n.min, r)), (e.max = Me(t.max, n.max, r));
  }
  function ja(e) {
    return e.animationValues && void 0 !== e.animationValues.opacityExit;
  }
  const Ua = { duration: 0.45, ease: [0.4, 0, 0.1, 1] },
    Ba = (e) =>
      "undefined" != typeof navigator &&
      navigator.userAgent &&
      navigator.userAgent.toLowerCase().includes(e),
    Wa = Ba("applewebkit/") && !Ba("chrome/") ? Math.round : m;
  function Ha(e) {
    (e.min = Wa(e.min)), (e.max = Wa(e.max));
  }
  function $a(e, t, n) {
    return (
      "position" === e ||
      ("preserve-aspect" === e &&
        ((r = ma(t)), (a = ma(n)), !(Math.abs(r - a) <= 0.2)))
    );
    var r, a;
  }
  function qa(e) {
    return e !== e.root && e.scroll?.wasRoot;
  }
  const Ya = Pa({
      attachResizeListener: (e, t) => On(e, "resize", t),
      measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
      }),
      checkIsScrollRoot: () => !0,
    }),
    Ka = { current: void 0 },
    Qa = Pa({
      measureScroll: (e) => ({ x: e.scrollLeft, y: e.scrollTop }),
      defaultParent: () => {
        if (!Ka.current) {
          const e = new Ya({});
          e.mount(window), e.setOptions({ layoutScroll: !0 }), (Ka.current = e);
        }
        return Ka.current;
      },
      resetTransform: (e, t) => {
        e.style.transform = void 0 !== t ? t : "none";
      },
      checkIsScrollRoot: (e) =>
        Boolean("fixed" === window.getComputedStyle(e).position),
    }),
    Xa = {
      pan: {
        Feature: class extends zn {
          constructor() {
            super(...arguments), (this.removePointerDownListener = m);
          }
          onPointerDown(e) {
            this.session = new pr(e, this.createPanHandlers(), {
              transformPagePoint: this.node.getTransformPagePoint(),
              contextWindow: cr(this.node),
            });
          }
          createPanHandlers() {
            const {
              onPanSessionStart: e,
              onPanStart: t,
              onPan: n,
              onPanEnd: r,
            } = this.node.getProps();
            return {
              onSessionStart: Lr(e),
              onStart: Lr(t),
              onMove: n,
              onEnd: (e, t) => {
                delete this.session, r && y.postRender(() => r(e, t));
              },
            };
          }
          mount() {
            this.removePointerDownListener = Vn(
              this.node.current,
              "pointerdown",
              (e) => this.onPointerDown(e)
            );
          }
          update() {
            this.session &&
              this.session.updateHandlers(this.createPanHandlers());
          }
          unmount() {
            this.removePointerDownListener(),
              this.session && this.session.end();
          }
        },
      },
      drag: {
        Feature: class extends zn {
          constructor(e) {
            super(e),
              (this.removeGroupControls = m),
              (this.removeListeners = m),
              (this.controls = new Ar(e));
          }
          mount() {
            const { dragControls: e } = this.node.getProps();
            e && (this.removeGroupControls = e.subscribe(this.controls)),
              (this.removeListeners = this.controls.addListeners() || m);
          }
          unmount() {
            this.removeGroupControls(), this.removeListeners();
          }
        },
        ProjectionNode: Qa,
        MeasureLayout: Wr,
      },
    };
  function Ga(e, t) {
    const n = (function (e) {
        if (e instanceof EventTarget) return [e];
        if ("string" == typeof e) {
          let t = document;
          const n = t.querySelectorAll(e);
          return n ? Array.from(n) : [];
        }
        return Array.from(e);
      })(e),
      r = new AbortController();
    return [n, { passive: !0, ...t, signal: r.signal }, () => r.abort()];
  }
  function Za(e) {
    return !("touch" === e.pointerType || Cr());
  }
  function Ja(e, t, n) {
    const { props: r } = e;
    e.animationState &&
      r.whileHover &&
      e.animationState.setActive("whileHover", "Start" === n);
    const a = r["onHover" + n];
    a && y.postRender(() => a(t, In(t)));
  }
  const eo = (e, t) => !!t && (e === t || eo(e, t.parentElement)),
    to = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]),
    no = new WeakSet();
  function ro(e) {
    return (t) => {
      "Enter" === t.key && e(t);
    };
  }
  function ao(e, t) {
    e.dispatchEvent(
      new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 })
    );
  }
  function oo(e) {
    return _n(e) && !Cr();
  }
  function io(e, t, n) {
    const { props: r } = e;
    if (e.current instanceof HTMLButtonElement && e.current.disabled) return;
    e.animationState &&
      r.whileTap &&
      e.animationState.setActive("whileTap", "Start" === n);
    const a = r["onTap" + ("End" === n ? "" : n)];
    a && y.postRender(() => a(t, In(t)));
  }
  const so = new WeakMap(),
    lo = new WeakMap(),
    uo = (e) => {
      const t = so.get(e.target);
      t && t(e);
    },
    co = (e) => {
      e.forEach(uo);
    };
  const fo = { some: 0, all: 1 },
    po = {
      inView: {
        Feature: class extends zn {
          constructor() {
            super(...arguments),
              (this.hasEnteredView = !1),
              (this.isInView = !1);
          }
          startObserver() {
            this.unmount();
            const { viewport: e = {} } = this.node.getProps(),
              { root: t, margin: n, amount: r = "some", once: a } = e,
              o = {
                root: t ? t.current : void 0,
                rootMargin: n,
                threshold: "number" == typeof r ? r : fo[r],
              };
            return (function (e, t, n) {
              const r = (function ({ root: e, ...t }) {
                const n = e || document;
                lo.has(n) || lo.set(n, {});
                const r = lo.get(n),
                  a = JSON.stringify(t);
                return (
                  r[a] ||
                    (r[a] = new IntersectionObserver(co, { root: e, ...t })),
                  r[a]
                );
              })(t);
              return (
                so.set(e, n),
                r.observe(e),
                () => {
                  so.delete(e), r.unobserve(e);
                }
              );
            })(this.node.current, o, (e) => {
              const { isIntersecting: t } = e;
              if (this.isInView === t) return;
              if (((this.isInView = t), a && !t && this.hasEnteredView)) return;
              t && (this.hasEnteredView = !0),
                this.node.animationState &&
                  this.node.animationState.setActive("whileInView", t);
              const { onViewportEnter: n, onViewportLeave: r } =
                  this.node.getProps(),
                o = t ? n : r;
              o && o(e);
            });
          }
          mount() {
            this.startObserver();
          }
          update() {
            if ("undefined" == typeof IntersectionObserver) return;
            const { props: e, prevProps: t } = this.node;
            ["amount", "margin", "root"].some(
              (function ({ viewport: e = {} }, { viewport: t = {} } = {}) {
                return (n) => e[n] !== t[n];
              })(e, t)
            ) && this.startObserver();
          }
          unmount() {}
        },
      },
      tap: {
        Feature: class extends zn {
          mount() {
            const { current: e } = this.node;
            e &&
              (this.unmount = (function (e, t, n = {}) {
                const [r, a, o] = Ga(e, n),
                  i = (e) => {
                    const r = e.currentTarget;
                    if (!oo(e) || no.has(r)) return;
                    no.add(r);
                    const o = t(r, e),
                      i = (e, t) => {
                        window.removeEventListener("pointerup", s),
                          window.removeEventListener("pointercancel", l),
                          oo(e) &&
                            no.has(r) &&
                            (no.delete(r),
                            "function" == typeof o && o(e, { success: t }));
                      },
                      s = (e) => {
                        i(
                          e,
                          r === window ||
                            r === document ||
                            n.useGlobalTarget ||
                            eo(r, e.target)
                        );
                      },
                      l = (e) => {
                        i(e, !1);
                      };
                    window.addEventListener("pointerup", s, a),
                      window.addEventListener("pointercancel", l, a);
                  };
                return (
                  r.forEach((e) => {
                    var t;
                    (n.useGlobalTarget ? window : e).addEventListener(
                      "pointerdown",
                      i,
                      a
                    ),
                      e instanceof HTMLElement &&
                        (e.addEventListener("focus", (e) =>
                          ((e, t) => {
                            const n = e.currentTarget;
                            if (!n) return;
                            const r = ro(() => {
                              if (no.has(n)) return;
                              ao(n, "down");
                              const e = ro(() => {
                                ao(n, "up");
                              });
                              n.addEventListener("keyup", e, t),
                                n.addEventListener(
                                  "blur",
                                  () => ao(n, "cancel"),
                                  t
                                );
                            });
                            n.addEventListener("keydown", r, t),
                              n.addEventListener(
                                "blur",
                                () => n.removeEventListener("keydown", r),
                                t
                              );
                          })(e, a)
                        ),
                        (t = e),
                        to.has(t.tagName) ||
                          -1 !== t.tabIndex ||
                          e.hasAttribute("tabindex") ||
                          (e.tabIndex = 0));
                  }),
                  o
                );
              })(
                e,
                (e, t) => (
                  io(this.node, t, "Start"),
                  (e, { success: t }) => io(this.node, e, t ? "End" : "Cancel")
                ),
                { useGlobalTarget: this.node.props.globalTapTarget }
              ));
          }
          unmount() {}
        },
      },
      focus: {
        Feature: class extends zn {
          constructor() {
            super(...arguments), (this.isActive = !1);
          }
          onFocus() {
            let e = !1;
            try {
              e = this.node.current.matches(":focus-visible");
            } catch (t) {
              e = !0;
            }
            e &&
              this.node.animationState &&
              (this.node.animationState.setActive("whileFocus", !0),
              (this.isActive = !0));
          }
          onBlur() {
            this.isActive &&
              this.node.animationState &&
              (this.node.animationState.setActive("whileFocus", !1),
              (this.isActive = !1));
          }
          mount() {
            this.unmount = Oe(
              On(this.node.current, "focus", () => this.onFocus()),
              On(this.node.current, "blur", () => this.onBlur())
            );
          }
          unmount() {}
        },
      },
      hover: {
        Feature: class extends zn {
          mount() {
            const { current: e } = this.node;
            e &&
              (this.unmount = (function (e, t, n = {}) {
                const [r, a, o] = Ga(e, n),
                  i = (e) => {
                    if (!Za(e)) return;
                    const { target: n } = e,
                      r = t(n, e);
                    if ("function" != typeof r || !n) return;
                    const o = (e) => {
                      Za(e) && (r(e), n.removeEventListener("pointerleave", o));
                    };
                    n.addEventListener("pointerleave", o, a);
                  };
                return (
                  r.forEach((e) => {
                    e.addEventListener("pointerenter", i, a);
                  }),
                  o
                );
              })(
                e,
                (e, t) => (
                  Ja(this.node, t, "Start"), (e) => Ja(this.node, e, "End")
                )
              ));
          }
          unmount() {}
        },
      },
    },
    ho = { layout: { ProjectionNode: Qa, MeasureLayout: Wr } },
    mo = (0, r.createContext)({ strict: !1 }),
    yo = (0, r.createContext)({
      transformPagePoint: (e) => e,
      isStatic: !1,
      reducedMotion: "never",
    }),
    go = (0, r.createContext)({});
  function vo(e) {
    return i(e.animate) || En.some((t) => xn(e[t]));
  }
  function bo(e) {
    return Boolean(vo(e) || e.variants);
  }
  function wo(e) {
    return Array.isArray(e) ? e.join(" ") : e;
  }
  const ko = "undefined" != typeof window,
    So = {
      animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag",
      ],
      exit: ["exit"],
      drag: ["drag", "dragControls"],
      focus: ["whileFocus"],
      hover: ["whileHover", "onHoverStart", "onHoverEnd"],
      tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
      pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
      inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
      layout: ["layout", "layoutId"],
    },
    xo = {};
  for (const e in So) xo[e] = { isEnabled: (t) => So[e].some((e) => !!t[e]) };
  const Po = Symbol.for("motionComponentSymbol");
  function Eo(e, t, n) {
    return (0, r.useCallback)(
      (r) => {
        r && e.onMount && e.onMount(r),
          t && (r ? t.mount(r) : t.unmount()),
          n && ("function" == typeof n ? n(r) : dr(n) && (n.current = r));
      },
      [t]
    );
  }
  const Co = ko ? r.useLayoutEffect : r.useEffect;
  function To(e, t, n, a, o) {
    const { visualElement: i } = (0, r.useContext)(go),
      s = (0, r.useContext)(mo),
      l = (0, r.useContext)(Rr),
      u = (0, r.useContext)(yo).reducedMotion,
      c = (0, r.useRef)(null);
    (a = a || s.renderer),
      !c.current &&
        a &&
        (c.current = a(e, {
          visualState: t,
          parent: i,
          props: n,
          presenceContext: l,
          blockInitialAnimation: !!l && !1 === l.initial,
          reducedMotionConfig: u,
        }));
    const d = c.current,
      f = (0, r.useContext)(Nr);
    !d ||
      d.projection ||
      !o ||
      ("html" !== d.type && "svg" !== d.type) ||
      (function (e, t, n, r) {
        const {
          layoutId: a,
          layout: o,
          drag: i,
          dragConstraints: s,
          layoutScroll: l,
          layoutRoot: u,
          layoutCrossfade: c,
        } = t;
        (e.projection = new n(
          e.latestValues,
          t["data-framer-portal-id"] ? void 0 : Ao(e.parent)
        )),
          e.projection.setOptions({
            layoutId: a,
            layout: o,
            alwaysMeasureLayout: Boolean(i) || (s && dr(s)),
            visualElement: e,
            animationType: "string" == typeof o ? o : "both",
            initialPromotionConfig: r,
            crossfade: c,
            layoutScroll: l,
            layoutRoot: u,
          });
      })(c.current, n, o, f);
    const p = (0, r.useRef)(!1);
    (0, r.useInsertionEffect)(() => {
      d && p.current && d.update(n, l);
    });
    const h = n[N],
      m = (0, r.useRef)(
        Boolean(h) &&
          !window.MotionHandoffIsComplete?.(h) &&
          window.MotionHasOptimisedAnimation?.(h)
      );
    return (
      Co(() => {
        d &&
          ((p.current = !0),
          (window.MotionIsMounted = !0),
          d.updateFeatures(),
          jr.render(d.render),
          m.current && d.animationState && d.animationState.animateChanges());
      }),
      (0, r.useEffect)(() => {
        d &&
          (!m.current && d.animationState && d.animationState.animateChanges(),
          m.current &&
            (queueMicrotask(() => {
              window.MotionHandoffMarkAsComplete?.(h);
            }),
            (m.current = !1)));
      }),
      d
    );
  }
  function Ao(e) {
    if (e)
      return !1 !== e.options.allowProjection ? e.projection : Ao(e.parent);
  }
  function Mo({
    preloadedFeatures: e,
    createVisualElement: t,
    useRender: n,
    useVisualState: a,
    Component: o,
  }) {
    function i(e, i) {
      let s;
      const l = { ...(0, r.useContext)(yo), ...e, layoutId: Lo(e) },
        { isStatic: u } = l,
        c = (function (e) {
          const { initial: t, animate: n } = (function (e, t) {
            if (vo(e)) {
              const { initial: t, animate: n } = e;
              return {
                initial: !1 === t || xn(t) ? t : void 0,
                animate: xn(n) ? n : void 0,
              };
            }
            return !1 !== e.inherit ? t : {};
          })(e, (0, r.useContext)(go));
          return (0, r.useMemo)(
            () => ({ initial: t, animate: n }),
            [wo(t), wo(n)]
          );
        })(e),
        d = a(e, u);
      if (!u && ko) {
        (0, r.useContext)(mo).strict;
        const e = (function (e) {
          const { drag: t, layout: n } = xo;
          if (!t && !n) return {};
          const r = { ...t, ...n };
          return {
            MeasureLayout:
              t?.isEnabled(e) || n?.isEnabled(e) ? r.MeasureLayout : void 0,
            ProjectionNode: r.ProjectionNode,
          };
        })(l);
        (s = e.MeasureLayout),
          (c.visualElement = To(o, d, l, t, e.ProjectionNode));
      }
      return (0, Dr.jsxs)(go.Provider, {
        value: c,
        children: [
          s && c.visualElement
            ? (0, Dr.jsx)(s, { visualElement: c.visualElement, ...l })
            : null,
          n(o, e, Eo(d, c.visualElement, i), d, u, c.visualElement),
        ],
      });
    }
    e &&
      (function (e) {
        for (const t in e) xo[t] = { ...xo[t], ...e[t] };
      })(e),
      (i.displayName = `motion.${
        "string" == typeof o ? o : `create(${o.displayName ?? o.name ?? ""})`
      }`);
    const s = (0, r.forwardRef)(i);
    return (s[Po] = o), s;
  }
  function Lo({ layoutId: e }) {
    const t = (0, r.useContext)(zr).id;
    return t && void 0 !== e ? t + "-" + e : e;
  }
  function Do(e, { layout: t, layoutId: n }) {
    return (
      I.has(e) ||
      e.startsWith("origin") ||
      ((t || void 0 !== n) && (!!Vr[e] || "opacity" === e))
    );
  }
  const Ro = (e, t) => (t && "number" == typeof e ? t.transform(e) : e),
    zo = { ...Z, transform: Math.round },
    No = {
      borderWidth: fe,
      borderTopWidth: fe,
      borderRightWidth: fe,
      borderBottomWidth: fe,
      borderLeftWidth: fe,
      borderRadius: fe,
      radius: fe,
      borderTopLeftRadius: fe,
      borderTopRightRadius: fe,
      borderBottomRightRadius: fe,
      borderBottomLeftRadius: fe,
      width: fe,
      maxWidth: fe,
      height: fe,
      maxHeight: fe,
      top: fe,
      right: fe,
      bottom: fe,
      left: fe,
      padding: fe,
      paddingTop: fe,
      paddingRight: fe,
      paddingBottom: fe,
      paddingLeft: fe,
      margin: fe,
      marginTop: fe,
      marginRight: fe,
      marginBottom: fe,
      marginLeft: fe,
      backgroundPositionX: fe,
      backgroundPositionY: fe,
      rotate: ce,
      rotateX: ce,
      rotateY: ce,
      rotateZ: ce,
      scale: ee,
      scaleX: ee,
      scaleY: ee,
      scaleZ: ee,
      skew: ce,
      skewX: ce,
      skewY: ce,
      distance: fe,
      translateX: fe,
      translateY: fe,
      translateZ: fe,
      x: fe,
      y: fe,
      z: fe,
      perspective: fe,
      transformPerspective: fe,
      opacity: J,
      originX: me,
      originY: me,
      originZ: fe,
      zIndex: zo,
      fillOpacity: J,
      strokeOpacity: J,
      numOctaves: zo,
    },
    Fo = {
      x: "translateX",
      y: "translateY",
      z: "translateZ",
      transformPerspective: "perspective",
    },
    Oo = _.length;
  function _o(e, t, n) {
    const { style: r, vars: a, transformOrigin: o } = e;
    let i = !1,
      s = !1;
    for (const e in t) {
      const n = t[e];
      if (I.has(e)) i = !0;
      else if (Y(e)) a[e] = n;
      else {
        const t = Ro(n, No[e]);
        e.startsWith("origin") ? ((s = !0), (o[e] = t)) : (r[e] = t);
      }
    }
    if (
      (t.transform ||
        (i || n
          ? (r.transform = (function (e, t, n) {
              let r = "",
                a = !0;
              for (let o = 0; o < Oo; o++) {
                const i = _[o],
                  s = e[i];
                if (void 0 === s) continue;
                let l = !0;
                if (
                  ((l =
                    "number" == typeof s
                      ? s === (i.startsWith("scale") ? 1 : 0)
                      : 0 === parseFloat(s)),
                  !l || n)
                ) {
                  const e = Ro(s, No[i]);
                  l || ((a = !1), (r += `${Fo[i] || i}(${e}) `)),
                    n && (t[i] = e);
                }
              }
              return (
                (r = r.trim()),
                n ? (r = n(t, a ? "" : r)) : a && (r = "none"),
                r
              );
            })(t, e.transform, n))
          : r.transform && (r.transform = "none")),
      s)
    ) {
      const { originX: e = "50%", originY: t = "50%", originZ: n = 0 } = o;
      r.transformOrigin = `${e} ${t} ${n}`;
    }
  }
  function Io(e, t, n) {
    for (const r in t) D(t[r]) || Do(r, n) || (e[r] = t[r]);
  }
  function Vo(e, t) {
    const n = {},
      a = (function (e, t) {
        const n = {};
        return (
          Io(n, e.style || {}, e),
          Object.assign(
            n,
            (function ({ transformTemplate: e }, t) {
              return (0, r.useMemo)(() => {
                const n = {
                  style: {},
                  transform: {},
                  transformOrigin: {},
                  vars: {},
                };
                return _o(n, t, e), Object.assign({}, n.vars, n.style);
              }, [t]);
            })(e, t)
          ),
          n
        );
      })(e, t);
    return (
      e.drag &&
        !1 !== e.dragListener &&
        ((n.draggable = !1),
        (a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none"),
        (a.touchAction =
          !0 === e.drag ? "none" : "pan-" + ("x" === e.drag ? "y" : "x"))),
      void 0 === e.tabIndex &&
        (e.onTap || e.onTapStart || e.whileTap) &&
        (n.tabIndex = 0),
      (n.style = a),
      n
    );
  }
  const jo = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport",
  ]);
  function Uo(e) {
    return (
      e.startsWith("while") ||
      (e.startsWith("drag") && "draggable" !== e) ||
      e.startsWith("layout") ||
      e.startsWith("onTap") ||
      e.startsWith("onPan") ||
      e.startsWith("onLayout") ||
      jo.has(e)
    );
  }
  let Bo = (e) => !Uo(e);
  function Wo(e) {
    e && (Bo = (t) => (t.startsWith("on") ? !Uo(t) : e(t)));
  }
  try {
    Wo(require("@emotion/is-prop-valid").default);
  } catch {}
  const Ho = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view",
  ];
  function $o(e) {
    return (
      "string" == typeof e &&
      !e.includes("-") &&
      !!(Ho.indexOf(e) > -1 || /[A-Z]/u.test(e))
    );
  }
  const qo = { offset: "stroke-dashoffset", array: "stroke-dasharray" },
    Yo = { offset: "strokeDashoffset", array: "strokeDasharray" };
  function Ko(
    e,
    {
      attrX: t,
      attrY: n,
      attrScale: r,
      pathLength: a,
      pathSpacing: o = 1,
      pathOffset: i = 0,
      ...s
    },
    l,
    u
  ) {
    if ((_o(e, s, u), l))
      return void (e.style.viewBox && (e.attrs.viewBox = e.style.viewBox));
    (e.attrs = e.style), (e.style = {});
    const { attrs: c, style: d } = e;
    c.transform && ((d.transform = c.transform), delete c.transform),
      (d.transform || c.transformOrigin) &&
        ((d.transformOrigin = c.transformOrigin ?? "50% 50%"),
        delete c.transformOrigin),
      d.transform && ((d.transformBox = "fill-box"), delete c.transformBox),
      void 0 !== t && (c.x = t),
      void 0 !== n && (c.y = n),
      void 0 !== r && (c.scale = r),
      void 0 !== a &&
        (function (e, t, n = 1, r = 0, a = !0) {
          e.pathLength = 1;
          const o = a ? qo : Yo;
          e[o.offset] = fe.transform(-r);
          const i = fe.transform(t),
            s = fe.transform(n);
          e[o.array] = `${i} ${s}`;
        })(c, a, o, i, !1);
  }
  const Qo = (e) => "string" == typeof e && "svg" === e.toLowerCase();
  function Xo(e, t, n, a) {
    const o = (0, r.useMemo)(() => {
      const n = {
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {},
        attrs: {},
      };
      return (
        Ko(n, t, Qo(a), e.transformTemplate),
        { ...n.attrs, style: { ...n.style } }
      );
    }, [t]);
    if (e.style) {
      const t = {};
      Io(t, e.style, e), (o.style = { ...t, ...o.style });
    }
    return o;
  }
  function Go(e = !1) {
    return (t, n, a, { latestValues: o }, i) => {
      const s = ($o(t) ? Xo : Vo)(n, o, i, t),
        l = (function (e, t, n) {
          const r = {};
          for (const a in e)
            ("values" === a && "object" == typeof e.values) ||
              ((Bo(a) ||
                (!0 === n && Uo(a)) ||
                (!t && !Uo(a)) ||
                (e.draggable && a.startsWith("onDrag"))) &&
                (r[a] = e[a]));
          return r;
        })(n, "string" == typeof t, e),
        u = t !== r.Fragment ? { ...l, ...s, ref: a } : {},
        { children: c } = n,
        d = (0, r.useMemo)(() => (D(c) ? c.get() : c), [c]);
      return (0, r.createElement)(t, { ...u, children: d });
    };
  }
  function Zo(e) {
    const t = (0, r.useRef)(null);
    return null === t.current && (t.current = e()), t.current;
  }
  const Jo = (e) => (t, n) => {
    const a = (0, r.useContext)(go),
      o = (0, r.useContext)(Rr),
      i = () =>
        (function (
          { scrapeMotionValuesFromProps: e, createRenderState: t },
          n,
          r,
          a
        ) {
          return { latestValues: ei(n, r, a, e), renderState: t() };
        })(e, t, a, o);
    return n ? i() : Zo(i);
  };
  function ei(e, t, n, r) {
    const a = {},
      o = r(e, {});
    for (const e in o) a[e] = Yr(o[e]);
    let { initial: s, animate: u } = e;
    const c = vo(e),
      d = bo(e);
    t &&
      d &&
      !c &&
      !1 !== e.inherit &&
      (void 0 === s && (s = t.initial), void 0 === u && (u = t.animate));
    let f = !!n && !1 === n.initial;
    f = f || !1 === s;
    const p = f ? u : s;
    if (p && "boolean" != typeof p && !i(p)) {
      const t = Array.isArray(p) ? p : [p];
      for (let n = 0; n < t.length; n++) {
        const r = l(e, t[n]);
        if (r) {
          const { transitionEnd: e, transition: t, ...n } = r;
          for (const e in n) {
            let t = n[e];
            Array.isArray(t) && (t = t[f ? t.length - 1 : 0]),
              null !== t && (a[e] = t);
          }
          for (const t in e) a[t] = e[t];
        }
      }
    }
    return a;
  }
  function ti(e, t, n) {
    const { style: r } = e,
      a = {};
    for (const o in r)
      (D(r[o]) ||
        (t.style && D(t.style[o])) ||
        Do(o, e) ||
        void 0 !== n?.getValue(o)?.liveStyle) &&
        (a[o] = r[o]);
    return a;
  }
  const ni = {
    useVisualState: Jo({
      scrapeMotionValuesFromProps: ti,
      createRenderState: () => ({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {},
      }),
    }),
  };
  function ri(e, t, n) {
    const r = ti(e, t, n);
    for (const n in e)
      (D(e[n]) || D(t[n])) &&
        (r[
          -1 !== _.indexOf(n)
            ? "attr" + n.charAt(0).toUpperCase() + n.substring(1)
            : n
        ] = e[n]);
    return r;
  }
  const ai = {
    useVisualState: Jo({
      scrapeMotionValuesFromProps: ri,
      createRenderState: () => ({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {},
        attrs: {},
      }),
    }),
  };
  function oi(e, t) {
    return function (
      n,
      { forwardMotionProps: r } = { forwardMotionProps: !1 }
    ) {
      return Mo({
        ...($o(n) ? ai : ni),
        preloadedFeatures: e,
        useRender: Go(r),
        createVisualElement: t,
        Component: n,
      });
    };
  }
  const ii = { current: null },
    si = { current: !1 },
    li = new WeakMap(),
    ui = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e),
    ci = (e) => /^0[^.\s]+$/u.test(e),
    di = (e) => (t) => t.test(e),
    fi = [
      Z,
      fe,
      de,
      ce,
      he,
      pe,
      { test: (e) => "auto" === e, parse: (e) => e },
    ],
    pi = (e) => fi.find(di(e)),
    hi = [...fi, ge, Ce],
    mi = new Set(["brightness", "contrast", "saturate", "opacity"]);
  function yi(e) {
    const [t, n] = e.slice(0, -1).split("(");
    if ("drop-shadow" === t) return e;
    const [r] = n.match(ne) || [];
    if (!r) return e;
    const a = n.replace(r, "");
    let o = mi.has(t) ? 1 : 0;
    return r !== n && (o *= 100), t + "(" + o + a + ")";
  }
  const gi = /\b([a-z-]*)\(.*?\)/gu,
    vi = {
      ...Ce,
      getAnimatableNone: (e) => {
        const t = e.match(gi);
        return t ? t.map(yi).join(" ") : e;
      },
    },
    bi = {
      ...No,
      color: ge,
      backgroundColor: ge,
      outlineColor: ge,
      fill: ge,
      stroke: ge,
      borderColor: ge,
      borderTopColor: ge,
      borderRightColor: ge,
      borderBottomColor: ge,
      borderLeftColor: ge,
      filter: vi,
      WebkitFilter: vi,
    },
    wi = (e) => bi[e];
  function ki(e, t) {
    let n = wi(e);
    return (
      n !== vi && (n = Ce),
      n.getAnimatableNone ? n.getAnimatableNone(t) : void 0
    );
  }
  const Si = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete",
  ];
  class xi {
    scrapeMotionValuesFromProps(e, t, n) {
      return {};
    }
    constructor(
      {
        parent: e,
        props: t,
        presenceContext: n,
        reducedMotionConfig: r,
        blockInitialAnimation: a,
        visualState: o,
      },
      i = {}
    ) {
      (this.current = null),
        (this.children = new Set()),
        (this.isVariantNode = !1),
        (this.isControllingVariants = !1),
        (this.shouldReduceMotion = null),
        (this.values = new Map()),
        (this.KeyframeResolver = Gt),
        (this.features = {}),
        (this.valueSubscriptions = new Map()),
        (this.prevMotionValues = {}),
        (this.events = {}),
        (this.propEventSubscriptions = {}),
        (this.notifyUpdate = () => this.notify("Update", this.latestValues)),
        (this.render = () => {
          this.current &&
            (this.triggerBuild(),
            this.renderInstance(
              this.current,
              this.renderState,
              this.props.style,
              this.projection
            ));
        }),
        (this.renderScheduledAt = 0),
        (this.scheduleRender = () => {
          const e = S.now();
          this.renderScheduledAt < e &&
            ((this.renderScheduledAt = e), y.render(this.render, !1, !0));
        });
      const { latestValues: s, renderState: l } = o;
      (this.latestValues = s),
        (this.baseTarget = { ...s }),
        (this.initialValues = t.initial ? { ...s } : {}),
        (this.renderState = l),
        (this.parent = e),
        (this.props = t),
        (this.presenceContext = n),
        (this.depth = e ? e.depth + 1 : 0),
        (this.reducedMotionConfig = r),
        (this.options = i),
        (this.blockInitialAnimation = Boolean(a)),
        (this.isControllingVariants = vo(t)),
        (this.isVariantNode = bo(t)),
        this.isVariantNode && (this.variantChildren = new Set()),
        (this.manuallyAnimateOnMount = Boolean(e && e.current));
      const { willChange: u, ...c } = this.scrapeMotionValuesFromProps(
        t,
        {},
        this
      );
      for (const e in c) {
        const t = c[e];
        void 0 !== s[e] && D(t) && t.set(s[e], !1);
      }
    }
    mount(e) {
      (this.current = e),
        li.set(e, this),
        this.projection &&
          !this.projection.instance &&
          this.projection.mount(e),
        this.parent &&
          this.isVariantNode &&
          !this.isControllingVariants &&
          (this.removeFromVariantTree = this.parent.addVariantChild(this)),
        this.values.forEach((e, t) => this.bindToMotionValue(t, e)),
        si.current ||
          (function () {
            if (((si.current = !0), ko))
              if (window.matchMedia) {
                const e = window.matchMedia("(prefers-reduced-motion)"),
                  t = () => (ii.current = e.matches);
                e.addListener(t), t();
              } else ii.current = !1;
          })(),
        (this.shouldReduceMotion =
          "never" !== this.reducedMotionConfig &&
          ("always" === this.reducedMotionConfig || ii.current)),
        this.parent && this.parent.children.add(this),
        this.update(this.props, this.presenceContext);
    }
    unmount() {
      this.projection && this.projection.unmount(),
        (this.projection = void 0),
        g(this.notifyUpdate),
        g(this.render),
        this.valueSubscriptions.forEach((e) => e()),
        this.valueSubscriptions.clear(),
        this.removeFromVariantTree && this.removeFromVariantTree(),
        this.parent && this.parent.children.delete(this);
      for (const e in this.events) this.events[e].clear();
      for (const e in this.features) {
        const t = this.features[e];
        t && (t.unmount(), (t.isMounted = !1));
      }
      this.current = null;
    }
    bindToMotionValue(e, t) {
      this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
      const n = I.has(e);
      n && this.onBindTransform && this.onBindTransform();
      const r = t.on("change", (t) => {
          (this.latestValues[e] = t),
            this.props.onUpdate && y.preRender(this.notifyUpdate),
            n && this.projection && (this.projection.isTransformDirty = !0);
        }),
        a = t.on("renderRequest", this.scheduleRender);
      let o;
      window.MotionCheckAppearSync &&
        (o = window.MotionCheckAppearSync(this, e, t)),
        this.valueSubscriptions.set(e, () => {
          r(), a(), o && o(), t.owner && t.stop();
        });
    }
    sortNodePosition(e) {
      return this.current &&
        this.sortInstanceNodePosition &&
        this.type === e.type
        ? this.sortInstanceNodePosition(this.current, e.current)
        : 0;
    }
    updateFeatures() {
      let e = "animation";
      for (e in xo) {
        const t = xo[e];
        if (!t) continue;
        const { isEnabled: n, Feature: r } = t;
        if (
          (!this.features[e] &&
            r &&
            n(this.props) &&
            (this.features[e] = new r(this)),
          this.features[e])
        ) {
          const t = this.features[e];
          t.isMounted ? t.update() : (t.mount(), (t.isMounted = !0));
        }
      }
    }
    triggerBuild() {
      this.build(this.renderState, this.latestValues, this.props);
    }
    measureViewportBox() {
      return this.current
        ? this.measureInstanceViewportBox(this.current, this.props)
        : { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
    }
    getStaticValue(e) {
      return this.latestValues[e];
    }
    setStaticValue(e, t) {
      this.latestValues[e] = t;
    }
    update(e, t) {
      (e.transformTemplate || this.props.transformTemplate) &&
        this.scheduleRender(),
        (this.prevProps = this.props),
        (this.props = e),
        (this.prevPresenceContext = this.presenceContext),
        (this.presenceContext = t);
      for (let t = 0; t < Si.length; t++) {
        const n = Si[t];
        this.propEventSubscriptions[n] &&
          (this.propEventSubscriptions[n](),
          delete this.propEventSubscriptions[n]);
        const r = e["on" + n];
        r && (this.propEventSubscriptions[n] = this.on(n, r));
      }
      (this.prevMotionValues = (function (e, t, n) {
        for (const r in t) {
          const a = t[r],
            o = n[r];
          if (D(a)) e.addValue(r, a);
          else if (D(o)) e.addValue(r, M(a, { owner: e }));
          else if (o !== a)
            if (e.hasValue(r)) {
              const t = e.getValue(r);
              !0 === t.liveStyle ? t.jump(a) : t.hasAnimated || t.set(a);
            } else {
              const t = e.getStaticValue(r);
              e.addValue(r, M(void 0 !== t ? t : a, { owner: e }));
            }
        }
        for (const r in n) void 0 === t[r] && e.removeValue(r);
        return t;
      })(
        this,
        this.scrapeMotionValuesFromProps(e, this.prevProps, this),
        this.prevMotionValues
      )),
        this.handleChildMotionValue && this.handleChildMotionValue();
    }
    getProps() {
      return this.props;
    }
    getVariant(e) {
      return this.props.variants ? this.props.variants[e] : void 0;
    }
    getDefaultTransition() {
      return this.props.transition;
    }
    getTransformPagePoint() {
      return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
      return this.isVariantNode
        ? this
        : this.parent
        ? this.parent.getClosestVariantNode()
        : void 0;
    }
    addVariantChild(e) {
      const t = this.getClosestVariantNode();
      if (t)
        return (
          t.variantChildren && t.variantChildren.add(e),
          () => t.variantChildren.delete(e)
        );
    }
    addValue(e, t) {
      const n = this.values.get(e);
      t !== n &&
        (n && this.removeValue(e),
        this.bindToMotionValue(e, t),
        this.values.set(e, t),
        (this.latestValues[e] = t.get()));
    }
    removeValue(e) {
      this.values.delete(e);
      const t = this.valueSubscriptions.get(e);
      t && (t(), this.valueSubscriptions.delete(e)),
        delete this.latestValues[e],
        this.removeValueFromRenderState(e, this.renderState);
    }
    hasValue(e) {
      return this.values.has(e);
    }
    getValue(e, t) {
      if (this.props.values && this.props.values[e])
        return this.props.values[e];
      let n = this.values.get(e);
      return (
        void 0 === n &&
          void 0 !== t &&
          ((n = M(null === t ? void 0 : t, { owner: this })),
          this.addValue(e, n)),
        n
      );
    }
    readValue(e, t) {
      let n =
        void 0 === this.latestValues[e] && this.current
          ? this.getBaseTargetFromProps(this.props, e) ??
            this.readValueFromInstance(this.current, e, this.options)
          : this.latestValues[e];
      var r;
      return (
        null != n &&
          ("string" == typeof n && (ui(n) || ci(n))
            ? (n = parseFloat(n))
            : ((r = n), !hi.find(di(r)) && Ce.test(t) && (n = ki(e, t))),
          this.setBaseTarget(e, D(n) ? n.get() : n)),
        D(n) ? n.get() : n
      );
    }
    setBaseTarget(e, t) {
      this.baseTarget[e] = t;
    }
    getBaseTarget(e) {
      const { initial: t } = this.props;
      let n;
      if ("string" == typeof t || "object" == typeof t) {
        const r = l(this.props, t, this.presenceContext?.custom);
        r && (n = r[e]);
      }
      if (t && void 0 !== n) return n;
      const r = this.getBaseTargetFromProps(this.props, e);
      return void 0 === r || D(r)
        ? void 0 !== this.initialValues[e] && void 0 === n
          ? void 0
          : this.baseTarget[e]
        : r;
    }
    on(e, t) {
      return (
        this.events[e] || (this.events[e] = new E()), this.events[e].add(t)
      );
    }
    notify(e, ...t) {
      this.events[e] && this.events[e].notify(...t);
    }
  }
  const Pi = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
  function Ei(e, t, n = 1) {
    const [r, a] = (function (e) {
      const t = Pi.exec(e);
      if (!t) return [,];
      const [, n, r, a] = t;
      return [`--${n ?? r}`, a];
    })(e);
    if (!r) return;
    const o = window.getComputedStyle(t).getPropertyValue(r);
    if (o) {
      const e = o.trim();
      return ui(e) ? parseFloat(e) : e;
    }
    return Q(a) ? Ei(a, t, n + 1) : a;
  }
  const Ci = new Set(["auto", "none", "0"]);
  class Ti extends Gt {
    constructor(e, t, n, r, a) {
      super(e, t, n, r, a, !0);
    }
    readKeyframes() {
      const { unresolvedKeyframes: e, element: t, name: n } = this;
      if (!t || !t.current) return;
      super.readKeyframes();
      for (let n = 0; n < e.length; n++) {
        let r = e[n];
        if ("string" == typeof r && ((r = r.trim()), Q(r))) {
          const a = Ei(r, t.current);
          void 0 !== a && (e[n] = a),
            n === e.length - 1 && (this.finalKeyframe = r);
        }
      }
      if ((this.resolveNoneKeyframes(), !gn.has(n) || 2 !== e.length)) return;
      const [r, a] = e,
        o = pi(r),
        i = pi(a);
      if (o !== i)
        if (Ut(o) && Ut(i))
          for (let t = 0; t < e.length; t++) {
            const n = e[t];
            "string" == typeof n && (e[t] = parseFloat(n));
          }
        else this.needsMeasurement = !0;
    }
    resolveNoneKeyframes() {
      const { unresolvedKeyframes: e, name: t } = this,
        n = [];
      for (let t = 0; t < e.length; t++)
        (null === e[t] ||
          ("number" == typeof (r = e[t])
            ? 0 === r
            : null === r || "none" === r || "0" === r || ci(r))) &&
          n.push(t);
      var r;
      n.length &&
        (function (e, t, n) {
          let r,
            a = 0;
          for (; a < e.length && !r; ) {
            const t = e[a];
            "string" == typeof t &&
              !Ci.has(t) &&
              Se(t).values.length &&
              (r = e[a]),
              a++;
          }
          if (r && n) for (const a of t) e[a] = ki(n, r);
        })(e, n, t);
    }
    measureInitialState() {
      const { element: e, unresolvedKeyframes: t, name: n } = this;
      if (!e || !e.current) return;
      "height" === n && (this.suspendedScrollY = window.pageYOffset),
        (this.measuredOrigin = Ht[n](
          e.measureViewportBox(),
          window.getComputedStyle(e.current)
        )),
        (t[0] = this.measuredOrigin);
      const r = t[t.length - 1];
      void 0 !== r && e.getValue(n, r).jump(r, !1);
    }
    measureEndState() {
      const { element: e, name: t, unresolvedKeyframes: n } = this;
      if (!e || !e.current) return;
      const r = e.getValue(t);
      r && r.jump(this.measuredOrigin, !1);
      const a = n.length - 1,
        o = n[a];
      (n[a] = Ht[t](
        e.measureViewportBox(),
        window.getComputedStyle(e.current)
      )),
        null !== o && void 0 === this.finalKeyframe && (this.finalKeyframe = o),
        this.removedTransforms?.length &&
          this.removedTransforms.forEach(([t, n]) => {
            e.getValue(t).set(n);
          }),
        this.resolveNoneKeyframes();
    }
  }
  class Ai extends xi {
    constructor() {
      super(...arguments), (this.KeyframeResolver = Ti);
    }
    sortInstanceNodePosition(e, t) {
      return 2 & e.compareDocumentPosition(t) ? 1 : -1;
    }
    getBaseTargetFromProps(e, t) {
      return e.style ? e.style[t] : void 0;
    }
    removeValueFromRenderState(e, { vars: t, style: n }) {
      delete t[e], delete n[e];
    }
    handleChildMotionValue() {
      this.childSubscription &&
        (this.childSubscription(), delete this.childSubscription);
      const { children: e } = this.props;
      D(e) &&
        (this.childSubscription = e.on("change", (e) => {
          this.current && (this.current.textContent = `${e}`);
        }));
    }
  }
  function Mi(e, { style: t, vars: n }, r, a) {
    Object.assign(e.style, t, a && a.getProjectionStyles(r));
    for (const t in n) e.style.setProperty(t, n[t]);
  }
  class Li extends Ai {
    constructor() {
      super(...arguments), (this.type = "html"), (this.renderInstance = Mi);
    }
    readValueFromInstance(e, t) {
      if (I.has(t))
        return ((e, t) => {
          const { transform: n = "none" } = getComputedStyle(e);
          return Vt(n, t);
        })(e, t);
      {
        const r = ((n = e), window.getComputedStyle(n)),
          a = (Y(t) ? r.getPropertyValue(t) : r[t]) || 0;
        return "string" == typeof a ? a.trim() : a;
      }
      var n;
    }
    measureInstanceViewportBox(e, { transformPagePoint: t }) {
      return ur(e, t);
    }
    build(e, t, n) {
      _o(e, t, n.transformTemplate);
    }
    scrapeMotionValuesFromProps(e, t, n) {
      return ti(e, t, n);
    }
  }
  const Di = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
  ]);
  class Ri extends Ai {
    constructor() {
      super(...arguments),
        (this.type = "svg"),
        (this.isSVGTag = !1),
        (this.measureInstanceViewportBox = Yn);
    }
    getBaseTargetFromProps(e, t) {
      return e[t];
    }
    readValueFromInstance(e, t) {
      if (I.has(t)) {
        const e = wi(t);
        return (e && e.default) || 0;
      }
      return (t = Di.has(t) ? t : z(t)), e.getAttribute(t);
    }
    scrapeMotionValuesFromProps(e, t, n) {
      return ri(e, t, n);
    }
    build(e, t, n) {
      Ko(e, t, this.isSVGTag, n.transformTemplate);
    }
    renderInstance(e, t, n, r) {
      !(function (e, t, n, r) {
        Mi(e, t, void 0, r);
        for (const n in t.attrs)
          e.setAttribute(Di.has(n) ? n : z(n), t.attrs[n]);
      })(e, t, 0, r);
    }
    mount(e) {
      (this.isSVGTag = Qo(e.tagName)), super.mount(e);
    }
  }
  const zi = o(
    oi({ ...Fn, ...po, ...Xa, ...ho }, (e, t) =>
      $o(e) ? new Ri(t) : new Li(t, { allowProjection: e !== r.Fragment })
    )
  );
  function Ni({ children: e, isValidProp: t, ...n }) {
    t && Wo(t),
      ((n = { ...(0, r.useContext)(yo), ...n }).isStatic = Zo(
        () => n.isStatic
      ));
    const a = (0, r.useMemo)(
      () => n,
      [JSON.stringify(n.transition), n.transformPagePoint, n.reducedMotion]
    );
    return (0, Dr.jsx)(yo.Provider, { value: a, children: e });
  }
  const Fi = JSON.parse(
    '[{"title":"General","items":[{"title":"How do I contact Peppermayo?","content":"<p>We\'re here to help! You can contact us via chat.</p><p>If you need to make an urgent change to your order, please submit a request <a href=\'/pages/order-change\'>here</a>.</p>"},{"title":"How do I apply to collaborate with Peppermayo?","content":"<p>Applications to collaborate with Peppermayo can be submitted <a href=\'https://peppermayo.grin.live/collabs\'>here!</a> If you are successful, a member of our PR team will contact you directly.</p>"},{"title":"What website should I use?","content":"<p>We are super excited to have five websites to shop from for our customers.</p><p>For local currencies, merchandise and customer service, we highly recommend you use the local website to shop!</p><p><a href=\'https://peppermayo.com/\'>Click here if you\'re shopping from Australia and everywhere else.</a></p><p><a href=\'https://peppermayo.co.uk/\'>Click here if you\'re shopping from the United Kingdom.</a></p><p><a href=\'https://us.peppermayo.com/\'>Click here if you\'re shopping from the United States.</a></p><p><a href=\'https://peppermayo.eu/\'>Click here if you\'re shopping from the European Union.</a></p><p><a href=\'https://peppermayo.ca/\'>Click here if you\'re shopping from Canada.</a></p>"}]},{"title":"Order Issues","items":[{"title":"Can I change my shipping address?","content":"<p>If you have entered the incorrect shipping address at checkout, please submit an Urgent Order Change Form <a href=\'/pages/order-change\'>here</a>.</p><p>This form will allow you to provide details of the correct shipping address for your order. Our team works diligently to ensure all urgent order change forms are accepted and actioned as quickly as possible.</p><p><strong>However, please note that if your order has already been shipped we are unable to make any adjustments to the shipping address.</strong> In this instance, we recommend reaching out directly to the carrier.</p>"},{"title":"Can I edit or cancel my order?","content":"<p>Our Peppermayo warehouse team work to pick, pack and ship your orders as quickly as possible!</p><p>If your order was placed no more than 12 hours prior and has not yet been shipped, please immediately submit an <a href=\'/pages/order-change\'>Urgent Order Change Form</a> to update or cancel your order. There is no need to contact the Peppermayo customer service team separately, the team will reach out to you directly if more information is required.</p><p>Once the form is completed, both our customer service and warehouse teams will be alerted and your order will be placed on hold. Please note that while we try our best, we cannot guarantee the change request form will be actioned before your order is shipped.</p><p>If your order has already been shipped with a tracking number, unfortunately, we are unable to change or cancel your order. In this instance, you can submit a return or exchange request here. Please note that all orders are subject to our standard <a href=\'/pages/returns-policy\'>returns policy</a>.</p>"},{"title":"Why haven\'t I received an order confirmation?","content":"<p>If you haven’t received your order confirmation email, please ensure you check your spam folder. If Peppermayo emails have been marked as spam, please update Peppermayo as a \'safe\' sender to ensure this doesn\'t reoccur with future orders.</p><p>You can sign in or create an account <a href=\'/account/login\'>here</a> to view your order history, tracking details and more.</p><p>If your order confirmation or order history cannot be located, please <a href=\'/pages/contact-us\'>contact us</a>.</p>"},{"title":"Why was my order returned-to-sender by the carrier?","content":"<p>Your Peppermayo order may be returned to our Sydney warehouse if:</p><ol><li>The carrier is unable to deliver the package due to an invalid address.</li><li>The package is not picked up in time from the post office after a failed delivery.</li><li>The carrier is not able to contact the receiver to organise a redelivery (DHL).</li><li>The carrier is not contacted by the receiver to organise a redelivery (USPS).</li><li>The package is refused by the sender.</li><li>Duties and taxes are refused to be paid.</li></ol><p>Unfortunately, couriers do not prioritise return-to-sender parcels and we are unable to intercept them during the delivery process. This means it may take up to 4 months to be returned to our warehouse from the carrier.</p><p>If your order is returned to our warehouse, we can offer:</p><ol><li>A store credit or;</li><li>A replacement of the order if the items are available.</li></ol><p>To process a refund of the order, the parcel must be received by our depot first. Until the order is received, we are unable to process a refund.</p><p><strong>Please note shipping fees are non-refundable and a returned-to-sender fee may be applied.</strong></p>"},{"title":"I received the wrong product, what should I do?","content":"<p>Our Customer Happiness Team are here to help!</p><p>Please <a href=\'/pages/contact-us\'>contact us</a> with your order number, details of the incorrect items you received and the items you were supposed to receive. We\'ll amend this for you as soon as possible!</p>"},{"title":"I received a faulty product, how do I return it?","content":"<p>We are so sorry to hear you have received a faulty product! We want to amend this for you as soon as possible.</p><p>If you believe the damage is a manufacturing fault, please use our live chat.</p><p>Please note manufacturing faults do not include loose threads, mismatched prints or general wear-and-tear as these are considered natural occurrences within reason.</p>"}]},{"title":"Returns & Exchanges","items":[{"title":"How do I submit a return?","content":"<p>We will only accept returns that have been submitted via our <a href=\'/pages/start-a-return\'>returns portal</a>.</p><ul><li>For our AU, US and UK customers, we will provide you with a pre-paid return label when you request a return using our portal.</li><li>If you are returning from anywhere else in the world, you are required to cover the cost of return shipping. We strongly recommend you use a tracked postage service when returning your order.</li><li>If a requested item is out of stock at the time your return is processed, we will issue you with store credit.</li></ul><p>Please <a href=\'/pages/contact-us\'>contact us</a> if you believe you have received an item with a manufacturing fault, or have received the incorrect item.</p>"},{"title":"What return & exchange options are available?","content":"<p>We have made returning and exchanging your item(s) as easy as possible!</p><p>For our AU, US and UK customers, we provide pre-paid labels via email, once your return request has been processed through our <a href=\'/pages/start-a-return\'>returns portal</a>.</p><p>For all other international orders, we are unable to provide a pre-paid label at this time. Therefore, the return shipping cost is to be covered by the customer.</p><p>Return & Exchange fees applicable for your location:</p><div class=\'help-centre-table-wrap\'><table><thead><tr><th>Location</th><th>Pre-Paid Label</th><th>Exchange Processing Fee</th><th>Store Credit Processing Fee</th><th>Refund Processing Fee</th></tr></thead><tbody><tr><td>Australia</td><td>Yes</td><td>Free</td><td>Free</td><td>AU$15.95</td></tr><tr><td>New Zealand</td><td>No</td><td>Free<br></td><td>Free</td><td>NZ$15.95</td></tr><tr><td>United States</td><td>Yes</td><td>US$5.00</td><td>US$5.00</td><td>US$18.00</td></tr><tr><td>United Kingdom</td><td>Yes</td><td>£5.00</td><td>£5.00</td><td>£8.00</td></tr><tr><td>Canada</td><td>No</td><td>CA$8.00</td><td>CA$8.00</td><td>CA$27.00</td></tr><tr><td>Rest of the World</td><td>No</td><td>Free</td><td>Free</td><td>AU$10.00</td></tr></tbody></table></div><p>If a requested item is out of stock at the time your return is processed, we will issue you with a store credit.</p><p>You can find the full details of our return policy <a href=\'/pages/returns-policy\'>here</a>.</p>"},{"title":"What is the returns policy?","content":"<p>We understand that sometimes your order may not be quite right, that\'s why we\'ve made returns and exchanges as easy as 1, 2, 3!</p><p>We offer change-of-mind returns within 30 days for an Exchange, Store Credit, or Refund.</p><p>Your item(s) must meet the following criteria to be approved for return:</p><ul><li>Be a full-priced item, this included full-priced items purchased using a discount code. Items marked as final sale or under our sale tab are not eligible for return or exchange.</li><li>Be unworn, unwashed, original tags still attached and in original packaging.</li><li>No smell of perfume, body odour, deodorant or washing powder.</li><li>Be free of makeup or fake tan marks.</li><li>Shoes must be in the original shoebox. (If received with shoebox) Postage labels must not be attached to the original box.</li><li>Due to strict hygiene policies, Cosmetics, Hair Products, Masks, Underwear & Earrings cannot be returned.</li><li>Swimwear must be returned with the hygiene seal intact.</li><li>We will only accept returned item(s) that have been submitted through our <a href=\'/pages/start-a-return\'>returns portal</a>.</li></ul><p>You can find the full details of our return policy <a href=\'/pages/returns-policy\'>here</a>.</p>"},{"title":"How do I print my pre-paid returns label?","content":"<p>You can download and print your return label via the \'Print Label\' button at the bottom of the page.</p><p>For Australian returns, once you have received your return label via email, your local post office can print and attach the return label to your package.</p><p>For all United States and New Zealand returns, unfortunately, you will need to print and attach the return label to the package yourself.</p>"},{"title":"I didn\'t receive my return label, what should I do?","content":"<p>If you haven\'t received your return label after submitting your return through our <a href=\'/pages/start-a-return\'>returns portal</a>, please ensure your email address is correct and you have checked your spam/junk folder.</p><p>If your returns label email still cannot be found, please <a href=\'/pages/contact-us\'>contact us</a>.</p>"},{"title":"What items are ineligible for return?","content":"<p>The following items are NOT eligible for return or exchange:</p><ul><li>Items marked as Sale</li><li>Cosmetics</li><li>Hair Products</li><li>Underwear</li><li>Earrings</li><li>Masks</li><li>Gift Cards</li></ul><p>If you believe you have received a sale item with a manufacturing fault, please <a href=\'/pages/contact-us\'>contact us</a> so we can amend this for you as soon as possible.</p>"},{"title":"When will my return be processed?","content":"<p>Orders from Australia, the United States and New Zealand, which are returned for a store credit or exchange, are processed when the pre-paid label is scanned as <strong>In Transit</strong> by the Postal Service.</p><p>Australia and New Zealand orders that are returned for a refund will be processed when your return is scanned as <strong>Delivered</strong> to our Sydney warehouse.</p><p>United States orders that are returned for a refund will be processed when your return is scanned as <strong>Delivered</strong> to our Los Angeles Depot.</p><p>For all other orders, it can take up to 21 days to reach our Sydney warehouse for processing. We aim to get your returns processed as quickly as possible, with a full return resolution within 3 working days of delivery.</p>"},{"title":"When will my refund be processed?","content":"<p>Once your return is scanned as <strong>delivered</strong>, your refund will be processed within 1-3 business days to the original payment method.</p>"},{"title":"How do I package my return?","content":"<p>You can repackage your items in our 100% compostable mailers and attach your pre-paid label on top of the existing label, ensuring no part of the original shipping label is visible.</p><p>If you have disposed of the original package, you can also use any postal satchel or box from your local post office.</p><p>If you are returning shoes, please do not attach the shipping label directly to the shoe boxes.</p>"},{"title":"Do you have a physical store I can visit?","content":"<p>Peppermayo is exclusively online! If your order isn\'t quite right and you need to request a return or exchange, you can submit a request <a href=\'/pages/start-a-return\'>here</a>.</p>"},{"title":"Do you still offer $10 bonus credit for Shop Now?","content":"<p>Sorry, unfortunately, we no longer offer the $10 Bonus Credit for Show Now due to an upgrade of our Returns Portal functionality.</p>"}]},{"title":"Products & Sizing","items":[{"title":"What is Pre-Order?","content":"<p>A pre-order style is a product currently unavailable in our warehouse, that we allow our customers to purchase in advance. If you purchase a pre-order style, we will dispatch your order when the stock arrives at our Peppermayo warehouse.</p><p>The estimated arrival time is displayed above the product description. This estimate is subject to change should delivery delays occur.</p><p>If your order contains both pre-order and in-stock products, we will ship all available items immediately, and ship any pre-order styles once they have arrived at our warehouse.</p><p>Should you wish to cancel your pre-order before it is shipped, please <a href=\'/pages/contact-us\'>contact us</a>.</p>"},{"title":"How do I find the best size & fit for me?","content":"<p>We understand how confusing choosing the right size can be. Below are our sizing resources available to help you select the best size and fit for your body shape.</p><p><strong>Size Guide:</strong><br />Our <a href=\'/pages/sizing\'>size guide</a> provides measurements and conversions for AU, US and EU sizes. We recommend using this as a general reference as some styles may differ in their fit due to the design and material.</p><p><strong>Product Reviews:</strong><br />At the bottom of any product page, you will find reviews from verified Peppermayo customers. Important details including photos, material, fit and size purchased are often provided.</p><p><strong>Model Sizing:</strong><br />All our models wear Australian sizes! In each product description, you will see notes on their height and which size they\'re wearing, which is usually a size AU 8 (US 4). To learn about sizing conversions, our size guide is also available on each product page.</p>"},{"title":"How often do you restock styles?","content":"<p>We regularly restock our most popular styles! To ensure you don\'t miss out on your size in the next product restock, make sure you sign up for \'Back In Stock\' notifications on the product page.</p>"},{"title":"Can I purchase a gift card?","content":"<p>Give the gift of choice with a Peppermayo E-Gift Card! All gift cards are delivered via email and contain instructions to redeem at checkout. There are no additional processing fees for gift cards.</p><p>E-Gift Cards can be purchased <a href=\'/products/e-gift-cards\'>here</a> and are valid for 12 months from the date of purchase.</p><p>Please note that all gift card sales are final and non-refundable.</p>"},{"title":"How do I submit a product review?","content":"<p>You will automatically receive an email request to submit a review for each new product after placing an order. We encourage all customers to include as much information as possible when describing the fit, material, colour, and sizing to help future Peppermayo customers find the best styles for their body shape!</p>"},{"title":"Are your products sustainable?","content":"<p>Peppermayo\'s mission is to continuously take strides to make a positive impact and offset our negative impact in areas where we can improve.</p><p>You can read more in-depth about our sustainability initiatives <a href=\'/pages/sustainability\'>here</a>.</p>"}]},{"title":"Shipping & Delivery","items":[{"title":"Where is my order?","content":"<p>Once you’ve placed your order, you’ll receive a confirmation email from us shortly after.</p><p>When your order has been shipped, you’ll receive another email with your courier tracking information. You can also track your order <a href=\'/pages/order-tracking\'>here</a>!</p><p>If you have not received your order one week after receiving the tracking notification, we highly recommend contacting the courier company.</p><p>If you have not received your order confirmation or tracking email, please <a href=\'/pages/contact-us\'>contact us</a>!</p>"},{"title":"How do I track my order?","content":"<p>Once your order has been shipped, you will receive an email with tracking information. You can also track your order <a href=\'/pages/order-tracking\'>here</a>!</p><p>If you have any questions regarding the estimated delivery timeframe of your order, we highly recommend contacting the courier company.</p><p>If you haven’t received your order tracking email, please <a href=\'/pages/contact-us\'>contact us</a>!</p>"},{"title":"What are the delivery timeframes?","content":"<p>Delivery timeframes for your location can be found on our <a href=\'/pages/delivery\'>Shipping & Delivery</a> page and begin once the carrier receives and <strong>scans the parcel into their system</strong>.</p>"},{"title":"When will my order ship?","content":"<p>We ship orders Monday to Friday (excluding NSW public holidays) from our Sydney warehouse.</p><p>If you place your order with Same Day Shipping before 2 pm AEST, your order should be shipped the same day.</p><p>For all other orders, our warehouse team aims to dispatch within 1 business day.</p><p>Please allow an extra 48 hours for sale periods and Mondays.</p>"},{"title":"What if I’m not home to receive my delivery?","content":"<p>Your order will be left in a safe place at the courier\'s discretion. If they cannot locate a safe place, you’ll be notified via email or you may receive a collection card in your mailbox with details for collecting your order from your local post office.</p><p>Please note if your order is not picked up from the post office within the specified time frame, it will be returned to our warehouse.</p><p>A signature may be required by some couriers depending on location or if the parcel cannot be left in a safe place.</p><p>Still have questions? <a href=\'/pages/contact-us\'>Contact us</a> and we\'ll happily help you out.</p>"},{"title":"My tracking says delivered but I have not received it, what should I do?","content":"<p>If your order has been marked as delivered but you cannot locate it, we highly recommend checking around your property as couriers may leave the parcel in a safe location if no one is home.</p><p>We recommend checking the following locations:</p><ul><li>the letterbox</li><li>around the front of your home</li><li>behind bins, pot plants or fences.</li></ul><p>If there is no sign of your parcel around your home, we also recommend checking with other members of your household, neighbours, receptionists, and building managers in case they have the parcel for safekeeping.</p><p>If you are still unable to locate the parcel we recommend reaching out directly to the carrier for assistance, as they may have delivered it to a local post office.</p><p>Still not able to locate your parcel? Please <a href=\'/pages/contact-us\'>contact us</a> and we will be able to investigate further!</p>"},{"title":"Why have I not received my Same Day shipping tracking?","content":"<p>Same Day shipping orders placed <strong>before</strong> 2 pm AEST will be shipped within the same business day.</p><p>Tracking details will be emailed to you between 3:30-5:30 pm AEST and delivery is between 6-9 pm AEST. Please note that someone will need to be available to accept and sign for the package.</p><p>If you have selected Same Day shipping after the 2 pm cut-off, your order will be sent the following business day.</p>"},{"title":"Does DHL Express deliver to PO boxes?","content":"<p>Unfortunately, DHL Express does not accept deliveries to PO boxes.</p><p>If you have accidentally entered a PO box address you will be able to use the DHL On Demand Delivery (ODD) Service to redirect your package to a new address.</p><p>To read more about DHL\'s ODD service please <a href=\'https://www.ondemand.dhl.com/\'>click here</a>.</p>"},{"title":"Do you ship worldwide?","content":"<p>Yes, we ship worldwide from our Sydney warehouse! <a href=\'/pages/delivery\'>Click here</a> to view the delivery options for your location.</p>"},{"title":"Will I be charged duties and tax for deliveries to Canada?","content":"<p>The Canadian Border Services Agency is very strict and your order will likely attract Canadian duties and/or taxes.</p><p>For information on the Canadian duties and/or taxes you may receive on your order, please <a href=\'https://www.cbsa-asfc.gc.ca/import/postal-postale/dtytx-drttx-eng.html\'>click here</a>.</p><p>If payment for additional fees is required, you will be contacted by your local customs authority or the courier once the parcel reaches the destination country. For more information, please contact the Canadian Border Services Agency directly by <a href=\'https://www.cbsa-asfc.gc.ca/contact/menu-eng.html\'>clicking here</a>.</p><p>Please note that if you do not wish to pay the customs fees, you may refuse the payment. Once refused, your parcel will begin to return to our Sydney warehouse. Once your order is received, an AUD$20 fee will be deducted, which goes directly to our carrier, along with the shipping cost paid when placing the order.</p>"},{"title":"Will I be charged duties and tax outside of Australia?","content":"<p>Customs fees and import taxes are determined by each country\'s local customs authority. Unfortunately, these fees are out of our control and are the responsibility of the customer.</p><p>If payment of additional fees is required, you will be contacted by your local customs authority or the courier once the parcel reaches the destination country.</p><p>Please note that if you do not wish to pay the customs fees, you may refuse the payment. Once refused, your parcel will begin to return to our Sydney warehouse. Once your order is received, an AUD$20 fee will be deducted, which goes directly to our carrier, along with the shipping cost paid when placing the order.</p>"}]},{"title":"Payment & Store Credit","items":[{"title":"How do I use my store credit?","content":"<p>Once your store credit has been processed, you will receive an email with a unique code that is redeemable at the checkout in the discount code section. You will also be able to access your store credit within your Peppermayo account!</p><p><strong>To view your available store credit:</strong><br /><a href=\'/account/login\'>Login to My Account</a> > Store Credit & Rewards<br />You can see your code, balance and expiry dates here!</p><p>The best part is, our store credits have no expiry day so you will be able to use the store credit whenever you need it!</p>"},{"title":"What payment types do you accept?","content":"<p>We have a range of payment options available including Visa, Mastercard, Amex, Paypal, Shop Pay, Apple Pay, & Google Pay.</p><p>We also Afterpay, Zip & Klarna for our AU, US, CA & UK customers.</p>"},{"title":"What is Klarna?","content":"<p>For more information on Klarna, please view our FAQ <a href=\'/pages/klarna-faqs\'>here</a>.</p>"}]}]'
  );
  function Oi(e, t) {
    return (
      (function (e) {
        if (Array.isArray(e)) return e;
      })(e) ||
      (function (e, t) {
        var n =
          null == e
            ? null
            : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
              e["@@iterator"];
        if (null != n) {
          var r,
            a,
            o,
            i,
            s = [],
            l = !0,
            u = !1;
          try {
            if (((o = (n = n.call(e)).next), 0 === t)) {
              if (Object(n) !== n) return;
              l = !1;
            } else
              for (
                ;
                !(l = (r = o.call(n)).done) &&
                (s.push(r.value), s.length !== t);
                l = !0
              );
          } catch (e) {
            (u = !0), (a = e);
          } finally {
            try {
              if (!l && null != n.return && ((i = n.return()), Object(i) !== i))
                return;
            } finally {
              if (u) throw a;
            }
          }
          return s;
        }
      })(e, t) ||
      (function (e, t) {
        if (e) {
          if ("string" == typeof e) return _i(e, t);
          var n = {}.toString.call(e).slice(8, -1);
          return (
            "Object" === n && e.constructor && (n = e.constructor.name),
            "Map" === n || "Set" === n
              ? Array.from(e)
              : "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              ? _i(e, t)
              : void 0
          );
        }
      })(e, t) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      })()
    );
  }
  function _i(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  var Ii = document.createElement("style");
  Ii.appendChild(
    document.createTextNode(
      '\n  .help-centre-header {\n    font-size: 2rem;\n    margin-bottom: 3rem;\n    text-align: center;\n  }\n\n  .help-centre-buttons {\n    display: grid;\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n    row-gap: 1rem;\n    column-gap: 1.5rem;\n  }\n\n  .help-centre-arrow {\n    fill: #AFAFAF;\n  }\n\n  .react-help-centre-container {\n    margin-top: 50px;\n  }\n\n  .help-button {\n    background: #FFFFFF;\n    border: 1px solid #D8D8D8;\n    border-radius: 0.5rem;\n    font-size: 1rem;\n    padding: 1rem;\n    text-align: left;\n    font-weight: bold;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .help-centre-modal {\n    background: #FFFFFF;\n    position: fixed;\n    top: 10%;\n    left: 50%;\n    max-height: 80%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    width: calc(100% - 30px);\n    max-width: 600px;\n    transform: translateX(-50%);\n    z-index: 20000;\n    padding: 3rem 2rem 1rem 2rem;\n    border-radius: 0.5rem;\n    display: flex;\n    flex-direction: column;\n    font-size: 1rem;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n\n    button {\n      position: absolute;\n      right: 0.3rem;\n      top: 0.3rem;\n      width: 3rem;\n      height: 3rem;\n    }\n\n    .help-centre-modal__title {\n      margin-bottom: 1rem;\n      font-size: 1.5rem;\n    }\n\n    .help-centre-modal__scroll-icon {\n      position: sticky;\n      bottom: -1rem;\n      left: 0;\n      right: 0;\n      background: linear-gradient(to top, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0));\n      display: flex;\n      justify-content: center;\n      padding: 0;\n      width: calc(100% + 4rem);\n      transform: translateX(-2rem);\n      font-size: 0.6rem;\n      text-transform: uppercase;\n      font-weight: 600;\n      align-items: center;\n      line-height: 1;\n      padding-top: 1.5rem;\n\n      svg {\n        transform: scale(0.8);\n      }\n    }\n\n    p:not(:has(+ ul)), ul {\n      margin-bottom: 1rem;\n    }\n\n    li {\n      list-style: inside;\n\n      a {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .help-centre-modal-bg {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    z-index: 10000;\n  }\n\n  .help-centre-faqs {\n    display: flex;\n    gap: 5rem;\n    flex-direction: column;\n  }\n\n  .help-centre-faqs-header {\n    font-size: 2rem;\n    margin: 4rem 0 2rem 0;\n  }\n\n  .help-centre-faqs-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    align-items: flex-start;\n  }\n\n  .help-centre-faqs-button {\n    font-size: 1rem;\n    text-align: left;\n    font-weight: bold;\n    position: relative;\n    overflow: hidden;\n  }\n\n  .help-centre-faqs-button::before {\n    content: "";\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: #D8D8D8;\n    position: absolute;\n    bottom: 0;\n    transition: all 0.15s ease-in-out;\n    transform: translateX(-100%);\n  }\n\n  .help-centre-faqs-button:hover.help-centre-faqs-button::before {\n    transform: translateX(0);\n    transition: all 0.3s ease-in-out;\n  }\n\n  .help-centre-faqs-accordions {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n  }\n\n  .help-centre-faqs-accordion__title {\n    font-size: 1.25rem;\n  }\n\n  .help-centre-faqs-accordion-button {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 1rem 0;\n    border-top: 1px solid #D8D8D8;\n    text-align: left;\n\n    svg {\n      fill: #AFAFAF;\n    }\n  }\n\n  .help-centre-faqs-accordion-title {\n    margin-bottom: 0;\n  }\n\n  .help-centre-faqs-accordion-content {\n    height: 0;\n    overflow: hidden;\n    \n    p, p:last-child {\n      margin-bottom: 1rem;\n    }\n\n    ul li {\n      list-style: inside;\n    }\n\n    ol li {\n      list-style: auto;\n    }\n\n    table {\n      margin-bottom: 1rem;\n      width: 100%;\n      border-collapse: collapse;\n    }\n\n    .help-centre-table-wrap {\n      display: block;\n      width: 100%;\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n\n      th, td {\n        // white-space: nowrap;\n        padding: 0.6rem 0.6rem 0.6rem 0;\n      }\n    }\n\n    table th {\n      font-size: 0.8rem;\n    }\n\n    li {\n      a {\n        text-decoration: underline;\n      }\n    }\n\n    ul {\n      margin-bottom: 1rem;\n    }\n  }\n\n  .help-centre-gorgias-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    margin: 1rem 0;\n  }\n\n  .help-centre-gorgias-button {\n    background: #FFFFFF;\n    border: 1px solid #D8D8D8;\n    border-radius: 0.5rem;\n    font-size: 1rem;\n    padding: 1rem;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    flex: 1;\n  }\n\n  @media (min-width: 768px) {\n    .help-centre-buttons {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    .react-help-centre-container {\n      margin: 100px auto 0 auto;\n      max-width: 1200px;\n    }\n\n    .help-centre-faqs {\n      flex-direction: row;\n    }\n\n    .help-centre-faqs-header {\n      margin: 4rem 0 2rem 0;\n    }\n\n    .help-centre-gorgias-buttons {\n      flex-direction: row;\n    }\n  }\n'
    )
  ),
    document.head.appendChild(Ii);
  var Vi = function (e) {
      var t = e.title,
        n = e.clickEvent;
      return r.createElement(
        "button",
        { className: "help-button", onClick: n },
        t,
        r.createElement(
          "svg",
          {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            facing: "right",
            className: "help-centre-arrow",
          },
          r.createElement("path", {
            d: "M9.29006 15.8805L13.1701 12.0005L9.29006 8.12047C8.90006 7.73047 8.90006 7.10047 9.29006 6.71047C9.68006 6.32047 10.3101 6.32047 10.7001 6.71047L15.2901 11.3005C15.6801 11.6905 15.6801 12.3205 15.2901 12.7105L10.7001 17.3005C10.3101 17.6905 9.68006 17.6905 9.29006 17.3005C8.91006 16.9105 8.90006 16.2705 9.29006 15.8805Z",
          })
        )
      );
    },
    ji = function (e) {
      var t = e.modalTitle,
        n = e.modalContent,
        a = e.closeModal,
        o = e.modalContainerRef,
        i = e.modalScrollIcon;
      return r.createElement(
        r.Fragment,
        null,
        r.createElement(
          zi.div,
          {
            className: "help-centre-modal",
            initial: { opacity: 0, transform: "translateX(-50%) scale(0)" },
            animate: { opacity: 1, transform: "translateX(-50%) scale(1)" },
            transition: {
              duration: 0.4,
              transform: { type: "spring", visualDuration: 0.4, bounce: 0.2 },
            },
            ref: o,
          },
          r.createElement(
            "button",
            { onClick: a },
            r.createElement(
              "svg",
              {
                fill: "#161616",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
              },
              r.createElement("path", {
                d: "M18.2997 5.70973C17.9097 5.31973 17.2797 5.31973 16.8897 5.70973L11.9997 10.5897L7.10973 5.69973C6.71973 5.30973 6.08973 5.30973 5.69973 5.69973C5.30973 6.08973 5.30973 6.71973 5.69973 7.10973L10.5897 11.9997L5.69973 16.8897C5.30973 17.2797 5.30973 17.9097 5.69973 18.2997C6.08973 18.6897 6.71973 18.6897 7.10973 18.2997L11.9997 13.4097L16.8897 18.2997C17.2797 18.6897 17.9097 18.6897 18.2997 18.2997C18.6897 17.9097 18.6897 17.2797 18.2997 16.8897L13.4097 11.9997L18.2997 7.10973C18.6797 6.72973 18.6797 6.08973 18.2997 5.70973Z",
              })
            )
          ),
          t &&
            r.createElement("h3", { className: "help-centre-modal__title" }, t),
          n &&
            r.createElement("div", { dangerouslySetInnerHTML: { __html: n } }),
          i &&
            r.createElement(
              "div",
              {
                className: "help-centre-modal__scroll-icon",
                "aria-hidden": "true",
              },
              r.createElement("div", null, "Scroll"),
              r.createElement(
                "svg",
                { width: "26", height: "26", viewBox: "0 0 24 24" },
                r.createElement("path", {
                  d: "m7 9.293 1.146-1.147a.5.5 0 1 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L6 9.293V3.707L4.854 4.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 1 1-.708.708L7 3.707v5.586Zm7 .207v2.547a1.415 1.415 0 0 1-2.32 1.087l-.924-.77A1.572 1.572 0 0 0 9.75 12a.693.693 0 0 0-.625.393l-.035.074a.797.797 0 0 0 .104.854l4.414 5.32A3.758 3.758 0 0 0 16.5 20a4.5 4.5 0 0 0 4.5-4.5v-4a.5.5 0 1 0-1 0v1a.5.5 0 1 1-1 0v-2a.5.5 0 1 0-1 0v2a.5.5 0 1 1-1 0v-8a.5.5 0 1 0-1 0v8a.5.5 0 1 1-1 0v-7a.5.5 0 1 0-1 0v4Zm-1 0v-4a1.5 1.5 0 0 1 2.053-1.395A1.5 1.5 0 0 1 18 4.5v4.585a1.5 1.5 0 0 1 1.947 1.02A1.5 1.5 0 0 1 22 11.5v4a5.5 5.5 0 0 1-5.5 5.5 4.758 4.758 0 0 1-3.662-1.72l-4.413-5.32a1.797 1.797 0 0 1-.236-1.927l.035-.074A1.693 1.693 0 0 1 9.75 11c.602 0 1.184.21 1.646.596l.924.77a.415.415 0 0 0 .68-.319V9.5Z",
                })
              )
            )
        ),
        r.createElement(zi.div, {
          className: "help-centre-modal-bg",
          onClick: a,
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          transition: { duration: 0.2 },
        })
      );
    },
    Ui = [
      {
        title: "Pre-Order",
        modalContent:
          '<p>A pre-order style is a product currently unavailable in our warehouse, that we allow our customers to purchase in advance. If you purchase a pre-order style, we will dispatch your order when the stock arrives at our Peppermayo warehouse.</p><p>The estimated arrival time is displayed above the product description. This estimate is subject to change should delivery delays occur.</p><p>If your order contains both pre-order and in-stock products, we will ship all available items immediately, and ship any pre-order styles once they have arrived at our warehouse.</p><p>Should you wish to cancel your pre-order before it is shipped, please <a href="/pages/contact-us">contact us</a></p>',
      },
      {
        title: "Urgent Order Change and Cancellation",
        modalContent:
          '<p>If your order was placed no more than 12 hours prior and has not yet been shipped, please immediately submit an <a href="/pages/order-change">Urgent Order Change</a> to update or cancel your order. There is no need to contact the Peppermayo customer service team separately, the team will reach out to you directly if more information is required.</p><p>If your order has already been shipped with a tracking number, unfortunately, we are unable to change or cancel your order. In this instance, you can submit a return or exchange request <a href="/pages/start-a-return">here</a>. Please note that all orders are subject to our standard <a href="/pages/returns-policy">returns policy</a>.</p>',
      },
      {
        title: "Order Status, Tracking and Delivery",
        modalContent:
          '<p>Once you’ve placed your order, you’ll receive a confirmation email from us shortly after.</p><p>When your order has been shipped, you’ll receive another email with your courier tracking information. You can also track your order <a href="/pages/order-tracking">here</a>!</p><p>Delivery timeframes for your location can be found on our <a href="/pages/delivery">Shipping & Delivery</a> page and begin once the carrier receives and scans the parcel into their system.</p><p>If you have not received your order one week after receiving the tracking notification, we highly recommend contacting the courier company.</p><p>If you have not received your order confirmation or tracking email, please <a href="/pages/contact-us">contact us</a>!</p>',
      },
      {
        title: "Returns Label Instructions",
        modalContent:
          '<p>For our AU, US and UK customers, we provide pre-paid labels via email, once your return request has been processed through our <a href="/pages/start-a-return">returns portal</a>.</p><p><strong>Printing your pre-paid returns label:</strong><br />You can download and print your return label via the "Print Label" button at the bottom of the page.</p><p>For Australian returns, your local post office can print and attach the return label to your package.</p><p>For all United States and New Zealand returns, unfortunately, you will need to print and attach the return label to the package yourself.</p><p><strong>Packaging your return:</strong><br />You may repackage your items in our 100% compostable mailers and attach the return label on top of the existing label, ensuring no part of the original shipping label is visible.</p><p>If you have disposed of the original package, you can also use any postal satchel or box from your local post office.</p><p>If you are returning shoes, please do not attach the shipping label directly to the shoe boxes.</p>',
      },
      {
        title: "Returns Policy",
        modalContent:
          '<p>We offer change-of-mind returns within 30 days for an Exchange, Store Credit, or Refund.</p><p>Your item(s) must meet the following criteria to be approved for return:</p><ul><li>Be a full-priced item, this included full-priced items purchased using a discount code. Items marked as final sale or under our sale tab are not eligible for return or exchange.</li><li>Be unworn, unwashed, original tags still attached and in original packaging.</li><li>No smell of perfume, body odour, deodorant or washing powder.</li><li>Be free of makeup or fake tan marks.</li><li>Shoes must be in the original shoebox. (If received with shoebox) Postage labels must not be attached to the original box.</li><li>Due to strict hygiene policies, Cosmetics, Hair Products, Masks, Underwear & Earrings cannot be returned.</li><li>Swimwear must be returned with the hygiene seal intact.</li><li>We will only accept returned item(s) that have been submitted through our <a href="/pages/start-a-return">returns portal</a>.</li></ul><p>You can find the full details of our return policy <a href="/pages/returns-policy">here</a>.</p>',
      },
      {
        title: "Sizing",
        modalContent:
          '<p>Below are our sizing resources available to help you select the best size and fit for your body shape.</p><p><strong>Size Guide:</strong><br />Our <a href="/pages/sizing">size guide</a> provides measurements and conversions for AU, US and EU sizes. We recommend using this as a general reference as some styles may differ in their fit due to the design and material.</p><p><strong>Product Reviews:</strong><br />At the bottom of any product page, you will find reviews from verified Peppermayo customers. Important details including photos, material, fit and size purchased are often provided.</p><p><strong>Model Sizing:</strong><br />All our models wear Australian sizes! In each product description, you will see notes on their height and which size they\'re wearing, which is usually a size AU 8 (US 4). To learn about sizing conversions, our size guide is also available on each product page.</p>',
      },
    ],
    Bi = [
      { title: "General" },
      { title: "Order Issues" },
      { title: "Returns & Exchanges" },
      { title: "Products & Sizing" },
      { title: "Shipping & Delivery" },
      // { title: "PM Perks Rewards" },
      { title: "Payment & Store Credit" },
    ],
    Wi = { open: { height: "auto" }, closed: { height: 0 } },
    Hi = { open: { rotate: 180 }, closed: { rotate: 0 } };
  function $i() {
    var e = Oi((0, r.useState)(!1), 2),
      t = e[0],
      n = e[1],
      a = Oi((0, r.useState)(null), 2),
      o = a[0],
      i = a[1],
      s = Oi((0, r.useState)(null), 2),
      l = s[0],
      u = s[1],
      c = Oi((0, r.useState)(!1), 2),
      d = c[0],
      f = c[1],
      p = Oi((0, r.useState)(null), 2),
      h = p[0],
      m = p[1],
      y = (0, r.useRef)(null),
      g = (0, r.useRef)([]),
      v = function (e) {
        var t = e.title,
          n = e.index;
        return r.createElement(
          "button",
          {
            className: "help-centre-faqs-button",
            onClick: function () {
              !(function (e) {
                var t = g.current[e];
                if (t) {
                  var n =
                    t.getBoundingClientRect().top + window.pageYOffset - 150;
                  window.scrollTo({ top: n, behavior: "smooth" });
                } else console.warn("No ref found for index: ".concat(e));
              })(n);
            },
          },
          t
        );
      },
      b = function () {
        n(!1), i(null), u(null);
      };
    (0, r.useEffect)(
      function () {
        l && n(!0);
      },
      [l]
    ),
      (0, r.useEffect)(
        function () {
          var e = function (e) {
            ("Escape" !== e.key && "Esc" !== e.key) || b();
          };
          return (
            t && document.addEventListener("keydown", e),
            function () {
              document.removeEventListener("keydown", e);
            }
          );
        },
        [t]
      );
    var w = (0, r.useCallback)(function () {
      var e = y.current;
      if (e) {
        var t = e.scrollHeight > e.clientHeight;
        f(!!t && e.scrollHeight - e.scrollTop > e.clientHeight + 1);
      } else f(!1);
    }, []);
    (0, r.useEffect)(
      function () {
        var e = y.current;
        if (e) {
          w(), f(!0);
          var t = new ResizeObserver(w);
          return (
            t.observe(e),
            function () {
              t.disconnect();
            }
          );
        }
      },
      [w, t]
    );
    var k = function (e) {
      var t = e.title,
        n = e.content,
        a = e.index;
      return r.createElement(
        Ni,
        {
          transition: {
            duration: 0.4,
            height: { type: "spring", visualDuration: 0.4, bounce: 0.3 },
          },
        },
        r.createElement(
          "section",
          { className: "help-centre-faqs-accordion", key: a },
          r.createElement(
            "button",
            {
              "aria-expanded": "false",
              "aria-controls": "accordion-".concat(a),
              id: "accordion-".concat(a, "-button"),
              className: "help-centre-faqs-accordion-button",
              onClick: function () {
                m(h === a ? null : a);
              },
            },
            r.createElement(
              "h5",
              { className: "help-centre-faqs-accordion-title" },
              t
            ),
            r.createElement(
              zi.svg,
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                variants: Hi,
                animate: h === a ? "open" : "closed",
              },
              r.createElement(
                "g",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  transform: "matrix(0 1 -1 0 24 0)",
                },
                r.createElement("path", {
                  d: "M9.29 15.88 13.17 12 9.29 8.12a.996.996 0 1 1 1.41-1.41l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3a.996.996 0 0 1-1.41 0c-.38-.39-.39-1.03 0-1.42Z",
                })
              )
            )
          ),
          r.createElement(zi.div, {
            variants: Wi,
            animate: h === a ? "open" : "closed",
            id: "accordion-".concat(a),
            className: "help-centre-faqs-accordion-content",
            "aria-labelledby": "accordion-".concat(a, "-button"),
            dangerouslySetInnerHTML: { __html: n },
          })
        )
      );
    };
    return r.createElement(
      r.Fragment,
      null,
      r.createElement(
        "h2",
        { className: "help-centre-header" },
        "We're here to help! Search for answers or get in touch."
      ),
      r.createElement(
        "div",
        {
          className: "inside-live-chat",
        },
        r.createElement("h4", null, "Live Chat"),
        r.createElement(
          "span",
          {
            className: "inside-live-chat__status",
          },
          "Online"
        ),
        r.createElement(
          "p",
          {
            className: "inside-live-chat__tag",
            onClick: function () {
              return openChatButtonClick();
            },
          },
          "Want to track your order? Use our live chat!"
        ),
        r.createElement(
          "p",
          null,
          "Our online chat assistant is here to help with all your shopping needs. Whether you're checking on an order, tracking a delivery, or need assistance with sizing and styles, our chat assistant makes it quick and easy to get the answers you need."
        ),
        r.createElement(
          "button",
          {
            id: "openChatButton",
            className: "inside-live-chat__button",
            onClick: function () {
              return openChatButtonClick();
            },
          },
          "Start Live Chat"
        )
      ),
      r.createElement(
        "div",
        { className: "help-centre-buttons" },
        Ui.map(function (e) {
          return r.createElement(Vi, {
            key: e.title,
            title: e.title,
            clickEvent: function () {
              i(e.title), u(e.modalContent);
            },
          });
        })
      ),
      t &&
        r.createElement(ji, {
          modalTitle: o,
          modalContent: l,
          closeModal: b,
          modalContainerRef: y,
          modalScrollIcon: d,
        }),
      r.createElement("h3", { className: "help-centre-faqs-header" }, "FAQs"),
      r.createElement(
        "div",
        { className: "help-centre-faqs" },
        r.createElement(
          "div",
          { className: "help-centre-faqs-buttons" },
          Bi.map(function (e, t) {
            return r.createElement(v, { key: t, title: e.title, index: t });
          })
        ),
        r.createElement(
          "div",
          { className: "help-centre-faqs-accordions" },
          Fi.map(function (e, t) {
            return r.createElement(
              "div",
              {
                key: t,
                ref: function (e) {
                  return (function (e, t) {
                    g.current || (g.current = []), (g.current[t] = e);
                  })(e, t);
                },
              },
              r.createElement(
                "h4",
                { className: "help-centre-faqs-accordion__title" },
                e.title
              ),
              e.items.map(function (e, n) {
                return r.createElement(k, {
                  key: n,
                  title: e.title,
                  content: e.content,
                  index: "".concat(t, "-").concat(n),
                });
              })
            );
          })
        )
      )
    );
  }
  document.addEventListener("DOMContentLoaded", function () {
    var e = document.getElementById("react-help-centre-root");
    e && (0, a.createRoot)(e).render(r.createElement($i, null));
  });
})();
